module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		0: 0
/******/ 	};
/******/
/******/
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 		return __webpack_require__.p + "" + chunkId + ".js"
/******/ 	}
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var promises = [];
/******/
/******/
/******/ 		// JSONP chunk loading for javascript
/******/
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
/******/
/******/ 			// a Promise means "currently loading".
/******/ 			if(installedChunkData) {
/******/ 				promises.push(installedChunkData[2]);
/******/ 			} else {
/******/ 				// setup Promise in chunk cache
/******/ 				var promise = new Promise(function(resolve, reject) {
/******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 				});
/******/ 				promises.push(installedChunkData[2] = promise);
/******/
/******/ 				// start chunk loading
/******/ 				var script = document.createElement('script');
/******/ 				var onScriptComplete;
/******/
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.src = jsonpScriptSrc(chunkId);
/******/
/******/ 				// create error before stack unwound to get useful stacktrace later
/******/ 				var error = new Error();
/******/ 				onScriptComplete = function (event) {
/******/ 					// avoid mem leaks in IE.
/******/ 					script.onerror = script.onload = null;
/******/ 					clearTimeout(timeout);
/******/ 					var chunk = installedChunks[chunkId];
/******/ 					if(chunk !== 0) {
/******/ 						if(chunk) {
/******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 							var realSrc = event && event.target && event.target.src;
/******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 							error.name = 'ChunkLoadError';
/******/ 							error.type = errorType;
/******/ 							error.request = realSrc;
/******/ 							chunk[1](error);
/******/ 						}
/******/ 						installedChunks[chunkId] = undefined;
/******/ 					}
/******/ 				};
/******/ 				var timeout = setTimeout(function(){
/******/ 					onScriptComplete({ type: 'timeout', target: script });
/******/ 				}, 120000);
/******/ 				script.onerror = script.onload = onScriptComplete;
/******/ 				document.head.appendChild(script);
/******/ 			}
/******/ 		}
/******/ 		return Promise.all(promises);
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 169);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@h3-icons/basic");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/input");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/notification");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/icon");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/modal");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/date-picker");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/menu");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/layout");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("lodash/forEach");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("big.js");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/message");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("lodash/debounce");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("lodash/isNil");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("lodash/map");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tree-select");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/spin");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/checkbox");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("v-click-outside-x");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/select");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/radio");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tree");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/breadcrumb");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("lodash/isPlainObject");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/button");

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tabs");

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("lodash/reduce");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("vue-property-decorator");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/collapse");

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/statistic");

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = require("lodash/filter");

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tag");

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/empty");

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/form");

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/timeline");

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/form-model");

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/list");

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/card");

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/steps");

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = require("@vue/babel-helper-vue-jsx-merge-props");

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/dropdown");

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/upload");

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/popconfirm");

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/popover");

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tooltip");

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/progress");

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/pagination");

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/descriptions");

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/calendar");

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/affix");

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/skeleton");

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/icon/style");

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/spin/style");

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/alert");

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = require("interactjs");

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/switch");

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/time-picker");

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/drawer");

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/cascader");

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/avatar");

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/input-number");

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/table");

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/carousel");

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/badge");

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/result");

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/divider");

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/page-header");

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/slider");

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/rate");

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/transfer");

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/auto-complete");

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/comment");

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/row");

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/col");

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/config-provider");

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/icon/style/index.js");

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/checkbox/style");

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = require("lodash/flattenDeep");

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = require("lodash/escapeRegExp");

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = require("@popperjs/core");

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = require("lodash/sortBy");

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = require("element-resize-detector");

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = require("lodash/uniqWith");

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = require("resize-observer-polyfill");

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/alert/style");

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/input/style");

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_combo_box_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_combo_box_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_combo_box_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tabs/style");

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/button/style");

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/dropdown/style");

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/upload/style");

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_icon_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_icon_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_icon_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spin_vue_vue_type_style_index_0_id_3e1f00c8_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spin_vue_vue_type_style_index_0_id_3e1f00c8_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spin_vue_vue_type_style_index_0_id_3e1f00c8_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/input/style/index.js");

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/modal/style/index.js");

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/button/style/index.js");

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/message/style");

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/modal/style");

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/popconfirm/style");

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/popover/style");

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/select/style");

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tooltip/style");

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_upload_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_upload_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_5_2_node_modules_vue_loader_lib_index_js_vue_loader_options_upload_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tree-select/style");

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tag/style");

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/switch/style");

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/radio/style");

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/date-picker/style");

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/time-picker/style");

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/drawer/style");

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/cascader/style");

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/avatar/style");

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/empty/style");

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/form/style");

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/input-number/style");

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/table/style");

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/carousel/style");

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/timeline/style");

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/progress/style");

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/tree/style");

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/menu/style");

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/form-model/style");

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/badge/style");

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/collapse/style");

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/pagination/style");

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/notification/style");

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/result/style");

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/divider/style");

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/descriptions/style");

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/page-header/style");

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/list/style");

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/card/style");

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/slider/style");

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/rate/style");

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/transfer/style");

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/auto-complete/style");

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/calendar/style");

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/statistic/style");

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/affix/style");

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/skeleton/style");

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/comment/style");

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/steps/style");

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/breadcrumb/style");

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/layout/style");

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/row/style");

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/col/style");

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = require("@authine/antd-vue/lib/config-provider/style");

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "H3Alert", function() { return /* reexport */ components_alert; });
__webpack_require__.d(__webpack_exports__, "H3AreaSelect", function() { return /* reexport */ components_area_select; });
__webpack_require__.d(__webpack_exports__, "H3Button", function() { return /* reexport */ components_button; });
__webpack_require__.d(__webpack_exports__, "H3ComboBox", function() { return /* reexport */ components_combo_box; });
__webpack_require__.d(__webpack_exports__, "H3Drag", function() { return /* reexport */ directives_drag; });
__webpack_require__.d(__webpack_exports__, "H3Dropdown", function() { return /* reexport */ components_dropdown; });
__webpack_require__.d(__webpack_exports__, "H3GridLayout", function() { return /* reexport */ grid_layout; });
__webpack_require__.d(__webpack_exports__, "H3HighLight", function() { return /* reexport */ components_high_light; });
__webpack_require__.d(__webpack_exports__, "H3Input", function() { return /* reexport */ input; });
__webpack_require__.d(__webpack_exports__, "H3ImagePreview", function() { return /* reexport */ image_preview; });
__webpack_require__.d(__webpack_exports__, "H3Layout", function() { return /* reexport */ components_layout; });
__webpack_require__.d(__webpack_exports__, "H3ListView", function() { return /* reexport */ components_list_view; });
__webpack_require__.d(__webpack_exports__, "H3Loading", function() { return /* reexport */ components_loading; });
__webpack_require__.d(__webpack_exports__, "H3Location", function() { return /* reexport */ src_components_location; });
__webpack_require__.d(__webpack_exports__, "H3MapModal", function() { return /* reexport */ components_map_modal; });
__webpack_require__.d(__webpack_exports__, "H3Message", function() { return /* reexport */ message; });
__webpack_require__.d(__webpack_exports__, "H3Modal", function() { return /* reexport */ modal; });
__webpack_require__.d(__webpack_exports__, "H3Popconfirm", function() { return /* reexport */ popconfirm; });
__webpack_require__.d(__webpack_exports__, "H3Popover", function() { return /* reexport */ popover; });
__webpack_require__.d(__webpack_exports__, "H3Select", function() { return /* reexport */ components_select; });
__webpack_require__.d(__webpack_exports__, "H3Tabs", function() { return /* reexport */ tabs; });
__webpack_require__.d(__webpack_exports__, "H3TitleGroup", function() { return /* reexport */ components_title_group; });
__webpack_require__.d(__webpack_exports__, "H3Tooltip", function() { return /* reexport */ components_tooltip; });
__webpack_require__.d(__webpack_exports__, "H3TreeSelect", function() { return /* reexport */ tree_select; });
__webpack_require__.d(__webpack_exports__, "H3Upload", function() { return /* reexport */ components_upload; });
__webpack_require__.d(__webpack_exports__, "H3Tag", function() { return /* reexport */ tag; });
__webpack_require__.d(__webpack_exports__, "H3Checkbox", function() { return /* reexport */ components_checkbox; });
__webpack_require__.d(__webpack_exports__, "H3Switch", function() { return /* reexport */ components_switch; });
__webpack_require__.d(__webpack_exports__, "H3Radio", function() { return /* reexport */ components_radio; });
__webpack_require__.d(__webpack_exports__, "H3ConfigProvider", function() { return /* reexport */ config_provider; });
__webpack_require__.d(__webpack_exports__, "H3DatePicker", function() { return /* reexport */ date_picker; });
__webpack_require__.d(__webpack_exports__, "H3TimePicker", function() { return /* reexport */ time_picker; });
__webpack_require__.d(__webpack_exports__, "H3Drawer", function() { return /* reexport */ drawer; });
__webpack_require__.d(__webpack_exports__, "H3Cascader", function() { return /* reexport */ cascader; });
__webpack_require__.d(__webpack_exports__, "H3Steps", function() { return /* reexport */ steps; });
__webpack_require__.d(__webpack_exports__, "H3Row", function() { return /* reexport */ row; });
__webpack_require__.d(__webpack_exports__, "H3Col", function() { return /* reexport */ col; });
__webpack_require__.d(__webpack_exports__, "H3Breadcrumb", function() { return /* reexport */ breadcrumb; });
__webpack_require__.d(__webpack_exports__, "H3Avatar", function() { return /* reexport */ avatar; });
__webpack_require__.d(__webpack_exports__, "H3Empty", function() { return /* reexport */ empty; });
__webpack_require__.d(__webpack_exports__, "H3Form", function() { return /* reexport */ components_form; });
__webpack_require__.d(__webpack_exports__, "H3Icon", function() { return /* reexport */ icon; });
__webpack_require__.d(__webpack_exports__, "H3InputNumber", function() { return /* reexport */ input_number; });
__webpack_require__.d(__webpack_exports__, "H3Table", function() { return /* reexport */ components_table; });
__webpack_require__.d(__webpack_exports__, "H3Carousel", function() { return /* reexport */ carousel; });
__webpack_require__.d(__webpack_exports__, "H3Timeline", function() { return /* reexport */ timeline; });
__webpack_require__.d(__webpack_exports__, "H3Progress", function() { return /* reexport */ components_progress; });
__webpack_require__.d(__webpack_exports__, "H3Tree", function() { return /* reexport */ tree; });
__webpack_require__.d(__webpack_exports__, "H3Menu", function() { return /* reexport */ menu; });
__webpack_require__.d(__webpack_exports__, "H3FormModel", function() { return /* reexport */ form_model; });
__webpack_require__.d(__webpack_exports__, "H3Badge", function() { return /* reexport */ badge; });
__webpack_require__.d(__webpack_exports__, "H3Collapse", function() { return /* reexport */ collapse; });
__webpack_require__.d(__webpack_exports__, "H3Pagination", function() { return /* reexport */ pagination; });
__webpack_require__.d(__webpack_exports__, "H3ADropdown", function() { return /* reexport */ a_dropdown; });
__webpack_require__.d(__webpack_exports__, "H3AUpload", function() { return /* reexport */ a_upload; });
__webpack_require__.d(__webpack_exports__, "H3Notification", function() { return /* reexport */ notification; });
__webpack_require__.d(__webpack_exports__, "H3Result", function() { return /* reexport */ components_result; });
__webpack_require__.d(__webpack_exports__, "H3Divider", function() { return /* reexport */ divider; });
__webpack_require__.d(__webpack_exports__, "H3Descriptions", function() { return /* reexport */ descriptions; });
__webpack_require__.d(__webpack_exports__, "H3PageHeader", function() { return /* reexport */ page_header; });
__webpack_require__.d(__webpack_exports__, "H3List", function() { return /* reexport */ components_list; });
__webpack_require__.d(__webpack_exports__, "H3Card", function() { return /* reexport */ card; });
__webpack_require__.d(__webpack_exports__, "H3Slider", function() { return /* reexport */ slider; });
__webpack_require__.d(__webpack_exports__, "H3Transfer", function() { return /* reexport */ transfer; });
__webpack_require__.d(__webpack_exports__, "H3Rate", function() { return /* reexport */ rate; });
__webpack_require__.d(__webpack_exports__, "H3AutoComplete", function() { return /* reexport */ auto_complete; });
__webpack_require__.d(__webpack_exports__, "H3Calendar", function() { return /* reexport */ calendar; });
__webpack_require__.d(__webpack_exports__, "H3Statistic", function() { return /* reexport */ statistic; });
__webpack_require__.d(__webpack_exports__, "H3Affix", function() { return /* reexport */ affix; });
__webpack_require__.d(__webpack_exports__, "H3Skeleton", function() { return /* reexport */ skeleton; });
__webpack_require__.d(__webpack_exports__, "H3Comment", function() { return /* reexport */ comment; });

// EXTERNAL MODULE: external "@authine/antd-vue/lib/alert/style"
var style_ = __webpack_require__(97);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/alert"
var alert_ = __webpack_require__(53);
var alert_default = /*#__PURE__*/__webpack_require__.n(alert_);

// EXTERNAL MODULE: external "lodash/flattenDeep"
var flattenDeep_ = __webpack_require__(90);
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep_);

// CONCATENATED MODULE: ./src/utils/vnode.ts

var vnode_getChildrenVNode = function getChildrenVNode(vnode, conditionFn) {
  if (vnode) {
    if (Array.isArray(vnode)) {
      return flattenDeep_default()(vnode.map(function (childNode) {
        return getChildrenVNode(childNode, conditionFn);
      }));
    } else if (vnode.children) {
      return vnode.children.filter(conditionFn);
    }
  }

  return [];
};
var convertSlotChildren = function convertSlotChildren(slots, h, names) {
  if (!names.length) {
    return [];
  }

  var children = [];
  names.forEach(function (name) {
    var slotNode = slots[name];

    if (slotNode) {
      children.push(h('template', {
        slot: name
      }, [slotNode]));
    }
  });
  return children;
};
// CONCATENATED MODULE: ./src/utils/object.js
var merge = function merge(target) {
  for (var i = 0, j = arguments.length <= 1 ? 0 : arguments.length - 1; i < j; i++) {
    var source = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var prop in source) {
      if (Object.prototype.hasOwnProperty.call(source, prop)) {
        var value = source[prop];

        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};
var clearUndefined = function clearUndefined(obj) {
  if (!obj || !typeof obj === 'object') return obj;
  var keys = Object.keys(obj);

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val = obj[key];

    if (typeof val === 'undefined') {
      // 如属性值为undefined则将该属性删除
      delete obj[key];
    }
  }

  return obj;
};
// CONCATENATED MODULE: ./src/components/alert/index.js



function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var H3Alert = {
  name: 'H3Alert',
  functional: true,
  inheritAttrs: false,
  props: _extends({}, alert_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-alert' : 'h3-alert';
    var slotContent = slots(); // 作用域插槽
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['icon', 'message', 'description', 'closeText']);
    var children = [slotContent.default].concat(slotChildren);
    return h(alert_default.a, _extends({
      props: props
    }, data), children);
  }
};

H3Alert.install = function (Vue) {
  Vue.component(H3Alert.name, H3Alert);
};

/* harmony default export */ var components_alert = (H3Alert);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/input/style"
var input_style_ = __webpack_require__(98);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/input"
var input_ = __webpack_require__(1);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// CONCATENATED MODULE: ./src/components/input/index.js



function input_extends() { input_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return input_extends.apply(this, arguments); }

var H3Input = {
  name: 'H3Input',
  model: {
    prop: 'value',
    event: 'change.value'
  },
  props: input_extends({}, input_default.a.props, {
    maxLengthTip: {
      type: Boolean,
      default: false
    },
    onlyRead: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number]
    }
  }),
  data: function data() {
    return {
      isFocus: false,
      innerValue: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.innerValue = val;
    }
  },
  methods: {
    fireFocus: function fireFocus() {
      this.isFocus = true;
    },
    fireBlur: function fireBlur() {
      this.isFocus = false;
    },
    fireChange: function fireChange(evt) {
      this.innerValue = evt.target.value;
    },
    renderMaxLengthTip: function renderMaxLengthTip(h) {
      var _this = this;

      return function () {
        var currLength = (_this.value || _this.innerValue || '').length;
        var isOutLimit = currLength >= Math.floor(_this.maxLength * 0.9); // 传入一个空span占位，使得input DOM结构保持一致，这是因为ant-vue Input 在不使用插槽和使用插槽的DOM结构不一样，不保持DOM结构一致会在输入到限制字数提示时出现输入中断情况

        var tip = isOutLimit ? [h('span', {
          class: 'h3-input__tip'
        }, [h('em', {
          class: 'h3-input__tip-curr'
        }, currLength), h('em', {
          class: 'h3-input__tip-split'
        }, '/'), h('em', {
          class: 'h3-input__tip-max'
        }, _this.maxLength)])] : [h('span', {
          class: 'h3-input__tip-holder'
        })];
        var suffix = _this.suffix ? [h('span', {
          class: 'h3-input__suffix-wrap'
        }, _this.suffix)] : _this.$scopedSlots.suffix ? [h('span', {
          class: 'h3-input__suffix-wrap'
        }, _this.$scopedSlots.suffix())] : [];
        return [].concat(tip, suffix);
      };
    },
    focus: function focus() {
      this.$el.tagName === 'INPUT' ? this.$el.focus() : this.$el.querySelector('input').focus();
    },
    blur: function blur() {
      this.$el.tagName === 'INPUT' ? this.$el.blur() : this.$el.querySelector('input').blur();
    }
  },
  render: function render(h) {
    var _this2 = this;

    var $props = this.$props,
        state = this.$data,
        $slots = this.$slots,
        $scopedSlots = this.$scopedSlots,
        $listeners = this.$listeners;

    var props = input_extends({}, $props);

    var listeners = input_extends({}, $listeners);

    var scopedSlots = input_extends({}, $scopedSlots);

    var tipRender = this.maxLength && this.maxLengthTip ? this.renderMaxLengthTip(h) : null;

    if (tipRender) {
      props.suffix = undefined;
      scopedSlots.suffix = tipRender;
    }

    ['focus', 'blur', 'change'].forEach(function (eventName) {
      var method = listeners[eventName];

      listeners[eventName] = function () {
        _this2["fire" + eventName.replace(/^\S/, function (code) {
          return code.toUpperCase();
        })].apply(_this2, arguments);

        method && method.apply(void 0, arguments);
      };
    });
    if (props.onlyRead) props.disabled = true;
    var children = $slots.default;
    return h(input_default.a, {
      class: ['h3-input', {
        'h3-input--disabled': props.disabled,
        'h3-input--focus': state.isFocus,
        'h3-input--onlyread': props.onlyRead
      }],
      props: input_extends({}, props, {
        value: props.value || state.innerValue
      }),
      scopedSlots: scopedSlots,
      on: listeners
    }, [children]);
  }
};

H3Input.install = function (Vue) {
  Vue.component('H3Input', H3Input);
  Vue.component('H3Textarea', input_default.a.TextArea);
  Vue.component('H3InputSearch', input_default.a.Search);
  Vue.component('H3InputGroup', input_default.a.Group);
  Vue.component('H3InputPassword', input_default.a.Password);
};

H3Input.TextArea = input_default.a.TextArea;
H3Input.Search = input_default.a.Search;
H3Input.Group = input_default.a.Group;
H3Input.Password = input_default.a.Password;
/* harmony default export */ var input = (H3Input);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-box.vue?vue&type=template&id=67e0b169&
var combo_boxvue_type_template_id_67e0b169_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.mainCls }, [
    _c(
      "div",
      {
        staticClass: "h3-combo-box__selector",
        on: { click: _vm.toggleSearch }
      },
      [
        _vm._t(
          "default",
          [
            !_vm.multiple
              ? [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSelect,
                          expression: "hasSelect"
                        }
                      ],
                      staticClass: "h3-combo-box__selector-item"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.singleValue &&
                              (_vm.singleValue[_vm.labelKey] ||
                                _vm.singleValue[_vm.valueKey])
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSearch,
                        expression: "showSearch"
                      },
                      { name: "composition", rawName: "v-composition" }
                    ],
                    ref: "search",
                    staticClass: "h3-combo-box__search",
                    style: { width: _vm.searchWidthStyle },
                    attrs: {
                      autocomplete: "off",
                      autocapitalize: "off",
                      autocorrect: "off"
                    },
                    domProps: { value: _vm.keyword },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      blur: _vm.fireSearchBlur,
                      focus: _vm.fireSearchFocus,
                      input: _vm.fireSearchInput
                    }
                  })
                ]
              : [
                  _c(
                    "transition-group",
                    {
                      staticClass: "h3-combo-box__selector-group",
                      attrs: { tag: "div", name: "h3awesome-zoom" },
                      on: {
                        afterEnter: _vm.fireResize,
                        afterLeave: _vm.fireResize
                      }
                    },
                    [
                      _vm._l(_vm.multipleValue, function(item, index) {
                        return _c(
                          "span",
                          {
                            key: item[_vm.valueKey],
                            staticClass: "h3-combo-box__selector-item"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "h3-combo-box__selector-item-content"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item[_vm.labelKey] || item[_vm.valueKey]
                                  )
                                )
                              ]
                            ),
                            !_vm.disabled && !item.disabled
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "h3-combo-box__selector-item-remove",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.fireRemove(item, index)
                                      }
                                    }
                                  },
                                  [_c("a-icon", { attrs: { type: "close" } })],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm.omittedValue.length > 0
                        ? _c(
                            "span",
                            {
                              key: "h3-combo-box__max-tag-placeholder",
                              staticClass: "h3-combo-box__selector-item"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "h3-combo-box__selector-item-content"
                                },
                                [_vm._v(_vm._s(_vm.innerMaxTagPlaceholder))]
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSearch,
                            expression: "showSearch"
                          },
                          { name: "composition", rawName: "v-composition" }
                        ],
                        key: "h3-combo-box__search",
                        ref: "search",
                        staticClass: "h3-combo-box__search",
                        style: { width: _vm.searchWidthStyle },
                        attrs: {
                          autocomplete: "off",
                          autocapitalize: "off",
                          autocorrect: "off"
                        },
                        domProps: { value: _vm.keyword },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          },
                          blur: _vm.fireSearchBlur,
                          focus: _vm.fireSearchFocus,
                          input: _vm.fireSearchInput
                        }
                      })
                    ],
                    2
                  )
                ]
          ],
          { value: _vm.multiple ? _vm.multipleValue : _vm.singleValue }
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasSelect && !_vm.keyword,
                expression: "!hasSelect && !keyword"
              }
            ],
            staticClass: "h3-combo-box__placeholder"
          },
          [_vm._v(_vm._s(_vm.placeholder))]
        )
      ],
      2
    ),
    _c(
      "span",
      {
        staticClass: "h3-combo-box__suffix",
        attrs: { unselectable: "on", "aria-hidden": "true" }
      },
      [
        _vm.allowClear && !_vm.disabled && !!_vm.innerValue.length
          ? _c("icon-cross-circle-fill", {
              staticClass: "h3-combo-box__clear",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.fireClear($event)
                }
              }
            })
          : _vm._e(),
        _vm._t("suffix", [
          _vm.innerShowSuffix
            ? _c("icon-trigon-bottom-fill", {
                staticClass: "h3-combo-box__down"
              })
            : _vm._e()
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
combo_boxvue_type_template_id_67e0b169_render._withStripped = true


// CONCATENATED MODULE: ./src/components/combo-box/combo-box.vue?vue&type=template&id=67e0b169&

// EXTERNAL MODULE: external "@authine/antd-vue/lib/icon/style"
var icon_style_ = __webpack_require__(51);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/icon"
var icon_ = __webpack_require__(3);
var icon_default = /*#__PURE__*/__webpack_require__.n(icon_);

// EXTERNAL MODULE: external "lodash/isPlainObject"
var isPlainObject_ = __webpack_require__(22);
var isPlainObject_default = /*#__PURE__*/__webpack_require__.n(isPlainObject_);

// EXTERNAL MODULE: external "lodash/isNil"
var isNil_ = __webpack_require__(12);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil_);

// EXTERNAL MODULE: external "@h3-icons/basic"
var basic_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/directives/composition.js
/**
 * 该指令是 处理输入框 预输入 触发input事件的情况
 * 增加该指令后可以通过 el._composing 即事件中evt.target._composing 属性来判定是否正在预输入
 */
function handleComposition(evt) {
  if (evt.type === 'compositionstart') {
    evt.target._composing = true;
  }

  if (evt.type === 'compositionend') {
    evt.target._composing = false;
    evt.target.dispatchEvent(new Event('input'));
  }
}

var composition = {
  bind: function bind(el) {
    el.addEventListener('compositionstart', handleComposition);
    el.addEventListener('compositionupdate', handleComposition);
    el.addEventListener('compositionend', handleComposition);
  },
  unbind: function unbind(el) {
    el.removeEventListener('compositionstart', handleComposition);
    el.removeEventListener('compositionupdate', handleComposition);
    el.removeEventListener('compositionend', handleComposition);
  }
};
/* harmony default export */ var directives_composition = (composition);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-box.vue?vue&type=script&lang=js&






/* harmony default export */ var combo_boxvue_type_script_lang_js_ = ({
  name: 'H3ComboBox',
  components: {
    AIcon: icon_default.a,
    IconTrigonBottomFill: basic_["IconTrigonBottomFill"],
    IconCrossCircleFill: basic_["IconCrossCircleFill"]
  },
  directives: {
    composition: directives_composition
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: [Array, String, Number, Object],
      default: function _default() {
        return [];
      }
    },
    showSuffix: {
      type: Boolean,
      default: undefined
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    alias: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: Number
    },
    maxTagPlaceholder: {
      type: Function
    },
    singleLine: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      keyword: '',
      searchFocus: false,
      blurTimer: '',
      searchWidth: 0,
      baseCls: 'h3-combo-box',
      innerMaxTagPlaceholder: '',
      innerValue: []
    };
  },
  computed: {
    searchWidthStyle: function searchWidthStyle() {
      return this.searchWidth > 0 ? this.searchWidth + "px" : '';
    },
    mainCls: function mainCls() {
      var _ref;

      var mode = this.multiple ? 'multiple' : 'single';
      return [this.baseCls, this.baseCls + "--" + mode, (_ref = {}, _ref[this.baseCls + "--suffix"] = this.innerShowSuffix, _ref[this.baseCls + "--clear"] = this.allowClear, _ref[this.baseCls + "--disabled"] = this.disabled, _ref[this.baseCls + "--focused"] = this.focused, _ref[this.baseCls + "--ellipsis"] = this.singleLine, _ref)];
    },
    valueKey: function valueKey() {
      return this.alias && this.alias.value || 'value';
    },
    labelKey: function labelKey() {
      return this.alias && this.alias.label || 'label';
    },
    multipleValue: function multipleValue() {
      return this.maxTagCount ? this.innerValue.slice(0, this.maxTagCount) : this.innerValue;
    },
    omittedValue: function omittedValue() {
      return this.innerValue.length - this.multipleValue.length > 0 ? this.innerValue.slice(this.multipleValue.length) : [];
    },
    singleValue: function singleValue() {
      return this.innerValue[0];
    },
    hasSelect: function hasSelect() {
      return !!this.innerValue.length;
    },
    innerShowSuffix: function innerShowSuffix() {
      return typeof this.showSuffix === 'boolean' ? this.showSuffix : !this.multiple;
    }
  },
  watch: {
    omittedValue: {
      handler: function handler(val) {
        this.getMaxTagPlaceholder(val);
      },
      immediate: true
    },
    value: function value(nVal) {
      var _this = this;

      if (nVal === this.innerValue) {
        return;
      }

      this.$nextTick(function () {
        _this.innerValue = _this.getInnerValue();

        _this.fireResize();
      });
    },
    valueKey: function valueKey() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.innerValue = _this2.getInnerValue();

        _this2.fireResize();
      });
    }
  },
  created: function created() {
    this.innerValue = this.getInnerValue();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.blurTimer);
  },
  methods: {
    getMaxTagPlaceholder: function getMaxTagPlaceholder(omittedValue) {
      if (!omittedValue.length) {
        this.innerMaxTagPlaceholder = '';
        return;
      }

      this.innerMaxTagPlaceholder = this.maxTagPlaceholder && this.maxTagPlaceholder(this.omittedValues) || '';

      if (!this.innerMaxTagPlaceholder) {
        this.innerMaxTagPlaceholder = "+" + this.omittedValue.length + " ...";
      }
    },
    getInnerValue: function getInnerValue() {
      var _this3 = this;

      var temp = Array.isArray(this.value) ? this.value : isNil_default()(this.value) || this.value === '' ? [] : [this.value]; // 空字符串特殊处理

      return temp.filter(function (item) {
        return !isNil_default()(item);
      }).map(function (item) {
        var _ref2;

        return isPlainObject_default()(item) ? item : (_ref2 = {}, _ref2[_this3.valueKey] = item, _ref2);
      });
    },
    fireResize: function fireResize() {
      this.$emit('resize');
    },
    fireClear: function fireClear() {
      this.innerValue = [];
      this.$emit('change', this.innerValue);
      this.fireResize();
    },
    fireRemove: function fireRemove(item, index) {
      this.innerValue.splice(index, 1);
      this.$emit('change', this.innerValue);
      this.$emit('deselect', item, this.innerValue);
    },
    toggleSearch: function toggleSearch() {
      if (!this.showSearch) {
        return;
      }

      if (this.searchFocus) {
        this.searchFocus = false;
        this.$refs.search.blur();
      } else {
        this.$refs.search.focus();
      }
    },
    fireSearchFocus: function fireSearchFocus() {
      this.searchFocus = true;
    },
    fireSearchBlur: function fireSearchBlur() {
      var _this4 = this;

      clearTimeout(this.blurTimer);
      this.blurTimer = setTimeout(function () {
        _this4.searchFocus = false;

        if (_this4.focused) {
          _this4.toggleSearch();
        }
      }, 200);

      if (this.keyword) {
        this.keyword = '';
        this.searchWidth = 0;
        this.$emit('search', this.keyword);
      }
    },
    countStrToBit: function countStrToBit(str) {
      var count = 0;
      var arr = str.split('');
      arr.forEach(function (item) {
        count += Math.ceil(item.charCodeAt().toString(2).length / 8);
      });
      return count;
    },
    fireSearchInput: function fireSearchInput(evt) {
      var keyword = evt.target.value;
      this.keyword = keyword;
      this.searchWidth = this.countStrToBit(this.keyword) * 7 + 8;

      if (evt.target._composing) {
        return;
      }

      this.$emit('search', this.keyword);
    }
  }
});
// CONCATENATED MODULE: ./src/components/combo-box/combo-box.vue?vue&type=script&lang=js&
 /* harmony default export */ var combo_box_combo_boxvue_type_script_lang_js_ = (combo_boxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/combo-box/combo-box.vue?vue&type=style&index=0&lang=less&
var combo_boxvue_type_style_index_0_lang_less_ = __webpack_require__(99);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/combo-box/combo-box.vue






/* normalize component */

var component = normalizeComponent(
  combo_box_combo_boxvue_type_script_lang_js_,
  combo_boxvue_type_template_id_67e0b169_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/combo-box/combo-box.vue"
/* harmony default export */ var combo_box = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-options.vue?vue&type=template&id=3b7f3488&
var combo_optionsvue_type_template_id_3b7f3488_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h3-combo-options", on: { scroll: _vm.fireScroll } },
    [
      _vm.innerAll
        ? _c("h3-combo-item", {
            attrs: {
              multiple: true,
              value: { value: "combo-item-all", label: "全选" },
              checked: _vm.allChecked,
              indeterminate: _vm.allIndeterminate
            },
            on: { change: _vm.fireAllChecked }
          })
        : _vm._e(),
      !_vm.group
        ? _vm._l(_vm.innerData, function(item) {
            return _c("h3-combo-item", {
              key: item[_vm.valueKey],
              attrs: {
                value: item,
                checkable: _vm.checkable,
                checked: item._innerChecked,
                disabled: item.disabled,
                highLightKey: _vm.highLightKey,
                highLightColor: _vm.highLightColor,
                alias: _vm.alias,
                multiple: _vm.multiple
              },
              on: { change: _vm.fireChange },
              scopedSlots: _vm._u(
                [
                  {
                    key: "icon",
                    fn: function() {
                      return [_vm._t("icon")]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          })
        : [
            _vm._l(_vm.innerGroupData, function(groupData, index) {
              return [
                _c(
                  "p",
                  { key: index, staticClass: "h3-combo-options__group" },
                  [
                    _vm._v(
                      "\n        " + _vm._s(groupData.groupName) + "\n      "
                    )
                  ]
                ),
                _vm._l(groupData.items, function(item) {
                  return _c("h3-combo-item", {
                    key: item[_vm.valueKey],
                    attrs: {
                      value: item,
                      checkable: _vm.checkable,
                      checked: item._innerChecked,
                      disabled: item.disabled,
                      highLightKey: _vm.highLightKey,
                      highLightColor: _vm.highLightColor,
                      alias: _vm.alias,
                      multiple: _vm.multiple
                    },
                    on: { change: _vm.fireChange },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function() {
                            return [_vm._t("icon")]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ]
            })
          ]
    ],
    2
  )
}
var combo_optionsvue_type_template_id_3b7f3488_staticRenderFns = []
combo_optionsvue_type_template_id_3b7f3488_render._withStripped = true


// CONCATENATED MODULE: ./src/components/combo-box/combo-options.vue?vue&type=template&id=3b7f3488&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-item.vue?vue&type=template&id=56c7de65&
var combo_itemvue_type_template_id_56c7de65_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.mainCls,
      on: {
        click: function($event) {
          return _vm.fireChange(_vm.value, !_vm.checked)
        }
      }
    },
    [
      _vm.checkable
        ? [
            !_vm.multiple
              ? _c("a-icon", {
                  class: [
                    "h3-combo-item__radio",
                    { "h3-combo-item__radio--checked": _vm.checked }
                  ],
                  attrs: { type: "check" }
                })
              : _c(
                  "span",
                  {
                    class: [
                      "h3-combo-item__checkbox",
                      { "h3-combo-item__checkbox--checked": _vm.checked }
                    ]
                  },
                  [_c("span", { staticClass: "h3-combo-item__checkbox-inner" })]
                )
          ]
        : _vm._e(),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$slots.icon,
              expression: "$slots.icon"
            }
          ],
          staticClass: "h3-combo-item__icon"
        },
        [_vm._t("icon")],
        2
      ),
      _c(
        "span",
        { staticClass: "h3-combo-item__content" },
        [
          _c("h3-high-light", {
            attrs: {
              highLightKey: _vm.highLightKey,
              highLightColor: _vm.highLightColor,
              content: _vm.value[_vm.labelKey]
            }
          }),
          _c("span", { staticClass: "h3-combo-item__extra" }, [
            _vm._v(_vm._s(_vm.value[_vm.extraKey]))
          ])
        ],
        1
      )
    ],
    2
  )
}
var combo_itemvue_type_template_id_56c7de65_staticRenderFns = []
combo_itemvue_type_template_id_56c7de65_render._withStripped = true


// CONCATENATED MODULE: ./src/components/combo-box/combo-item.vue?vue&type=template&id=56c7de65&

// EXTERNAL MODULE: external "@vue/babel-helper-vue-jsx-merge-props"
var babel_helper_vue_jsx_merge_props_ = __webpack_require__(39);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props_);

// EXTERNAL MODULE: external "lodash/escapeRegExp"
var escapeRegExp_ = __webpack_require__(91);
var escapeRegExp_default = /*#__PURE__*/__webpack_require__.n(escapeRegExp_);

// CONCATENATED MODULE: ./src/components/high-light/high-light.tsx


function high_light_extends() { high_light_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return high_light_extends.apply(this, arguments); }



function high_light_merge(replace, item) {
  if (!replace.length) {
    return [item];
  }

  var _item = replace[0],
      _replace = replace.slice(1);

  if (item.end === _item.start) {
    item.end = _item.end;
    return high_light_merge(_replace, item);
  }

  return [item].concat(high_light_merge(_replace, _item));
}

var HighLight = {
  name: 'HighLight',
  functional: true,
  props: {
    needTitle: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    highLightKey: {
      type: String,
      default: ''
    },
    highLightColor: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var props = context.props,
        data = context.data;
    var content = props.content,
        highLightKey = props.highLightKey,
        highLightColor = props.highLightColor,
        needTitle = props.needTitle;
    var highLightStyle = highLightColor ? {
      color: highLightColor
    } : undefined;
    var contentArr = [content];

    if (highLightKey) {
      var replaceReg = new RegExp("(" + escapeRegExp_default()(highLightKey) + ")+", 'g');
      var replace = [];
      content.replace(replaceReg, function (value) {
        replace.push({
          start: arguments.length <= 2 ? undefined : arguments[2],
          end: value.length + (arguments.length <= 2 ? undefined : arguments[2])
        });
        return value;
      });

      if (replace.length > 0) {
        contentArr = [];

        var _replace2 = replace,
            _item = _replace2[0],
            _replace = _replace2.slice(1);

        replace = high_light_merge(_replace, _item);
        replace.forEach(function (item, index) {
          if (index === 0 && item.start > 0) {
            contentArr.push(content.slice(0, item.start));
          }

          contentArr.push(h("span", {
            "class": "h3-high-light__target",
            "style": highLightStyle
          }, [content.slice(item.start, item.end)]));

          if (index + 1 < replace.length) {
            var nextItem = replace[index + 1];

            if (nextItem.start - item.end !== 0) {
              contentArr.push(content.slice(item.end, nextItem.start));
            }
          } else if (item.end < content.length) {
            contentArr.push(content.slice(item.end));
          }
        });
      }
    }

    return h("span", babel_helper_vue_jsx_merge_props_default()([{
      "class": "h3-high-light",
      "attrs": {
        "title": needTitle ? content : ''
      }
    }, high_light_extends({}, data)]), [contentArr.map(function (item) {
      return item;
    })]);
  }
};
/* harmony default export */ var high_light = (HighLight);
// CONCATENATED MODULE: ./src/components/high-light/index.js


high_light.install = function (Vue) {
  Vue.component('H3HighLight', high_light);
};

/* harmony default export */ var components_high_light = (high_light);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-item.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var combo_itemvue_type_script_lang_js_ = ({
  name: 'H3ComboItem',
  components: {
    H3HighLight: components_high_light,
    AIcon: icon_default.a
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    alias: {
      type: Object,
      // value label extra
      default: function _default() {
        return {};
      }
    },
    highLightKey: {
      type: String,
      default: ''
    },
    highLightColor: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: true
    },
    checkable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      baseCls: 'h3-combo-item',
      innerValue: []
    };
  },
  computed: {
    mainCls: function mainCls() {
      var _ref;

      var mode = this.multiple ? 'multiple' : 'single';
      return [this.baseCls, this.baseCls + "--" + mode, (_ref = {}, _ref[this.baseCls + "--ellipsis"] = this.singleLine, _ref[this.baseCls + "--uncheckable"] = !this.checkable, _ref[this.baseCls + "--checked"] = this.checked, _ref[this.baseCls + "--disabled"] = this.disabled, _ref[this.baseCls + "--indeterminate"] = this.indeterminate, _ref)];
    },
    valueKey: function valueKey() {
      return this.alias && this.alias.value || 'value';
    },
    labelKey: function labelKey() {
      return this.alias && this.alias.label || 'label';
    },
    extraKey: function extraKey() {
      return this.alias && this.alias.extra || 'extra';
    }
  },
  methods: {
    fireChange: function fireChange(item, checked) {
      if (this.disabled) {
        return;
      }

      this.$emit('change', item, checked);
    }
  }
});
// CONCATENATED MODULE: ./src/components/combo-box/combo-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var combo_box_combo_itemvue_type_script_lang_js_ = (combo_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/combo-box/combo-item.vue





/* normalize component */

var combo_item_component = normalizeComponent(
  combo_box_combo_itemvue_type_script_lang_js_,
  combo_itemvue_type_template_id_56c7de65_render,
  combo_itemvue_type_template_id_56c7de65_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var combo_item_api; }
combo_item_component.options.__file = "src/components/combo-box/combo-item.vue"
/* harmony default export */ var combo_item = (combo_item_component.exports);
// EXTERNAL MODULE: external "lodash/debounce"
var debounce_ = __webpack_require__(11);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/combo-box/combo-options.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var combo_optionsvue_type_script_lang_js_ = ({
  name: 'H3ComboOptions',
  components: {
    H3ComboItem: combo_item
  },
  model: {
    event: 'change'
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Array, String, Number, Object],
      default: function _default() {
        return [];
      }
    },
    group: {
      type: Boolean,
      default: false
    },
    all: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    alias: {
      type: Object,
      // value label extra disabled
      default: function _default() {
        return {};
      }
    },
    highLightKey: {
      type: String,
      default: ''
    },
    highLightColor: {
      type: String,
      default: ''
    },
    singleLine: {
      type: Boolean,
      default: true
    },
    checkable: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number
    }
  },
  data: function data() {
    return {
      innerValue: []
    };
  },
  computed: {
    valueKey: function valueKey() {
      return this.alias && this.alias.value || 'value';
    },
    labelKey: function labelKey() {
      return this.alias && this.alias.label || 'label';
    },
    extraKey: function extraKey() {
      return this.alias && this.alias.extra || 'extra';
    },
    hasLimit: function hasLimit() {
      return !!(this.limit && this.limit > 0);
    },
    innerAll: function innerAll() {
      return this.multiple && this.all && !this.hasLimit;
    },
    innerGroupData: function innerGroupData() {
      var _this = this;

      var temp = Array.isArray(this.data) ? this.data : [this.data];
      return this.group ? temp.filter(function (item) {
        return !isNil_default()(item);
      }).map(function (item) {
        var groupName = item.groupName,
            items = item.items;

        var _items = items.filter(function (groupItem) {
          return !isNil_default()(groupItem);
        }).map(function (groupItem) {
          var _ref;

          var _item = isPlainObject_default()(groupItem) ? groupItem : (_ref = {}, _ref[_this.valueKey] = groupItem, _ref[_this.labelKey] = groupItem, _ref);

          var selectItem = _this.innerValue.find(function (value) {
            return value[_this.valueKey] === _item[_this.valueKey];
          });

          _item._innerChecked = !!selectItem;

          if (selectItem && typeof selectItem.disabled !== 'undefined') {
            _item.disabled = selectItem.disabled;
          }

          return _item;
        });

        return {
          groupName: groupName,
          items: _items
        };
      }) : [];
    },
    innerData: function innerData() {
      var _this2 = this;

      var temp = Array.isArray(this.data) ? this.data : [this.data];

      if (this.group) {
        return this.innerGroupData.reduce(function (result, item) {
          var items = item.items;
          return [].concat(result, items);
        }, []);
      } else {
        return temp.filter(function (item) {
          return !isNil_default()(item);
        }).map(function (item) {
          var _ref2;

          var _item = isPlainObject_default()(item) ? item : (_ref2 = {}, _ref2[_this2.valueKey] = item, _ref2[_this2.labelKey] = item, _ref2);

          var selectItem = _this2.innerValue.find(function (value) {
            return value[_this2.valueKey] === _item[_this2.valueKey];
          });

          _item._innerChecked = !!selectItem;

          if (selectItem && typeof selectItem.disabled !== 'undefined') {
            _item.disabled = selectItem.disabled;
          }

          return _item;
        });
      }
    },
    allChecked: function allChecked() {
      return this.innerData.every(function (item) {
        return item._innerChecked;
      });
    },
    allIndeterminate: function allIndeterminate() {
      return this.innerData.some(function (item) {
        return item._innerChecked;
      }) && !this.allChecked;
    }
  },
  watch: {
    value: function value(nVal) {
      var _this3 = this;

      if (nVal === this.innerValue) {
        return;
      }

      this.$nextTick(function () {
        _this3.innerValue = _this3.getInnerValue();
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.innerValue = this.getInnerValue();
    this.emitScroll = debounce_default()(function () {
      _this4._emitScroll();
    }, 500, {
      leading: false,
      trailing: true
    });
  },
  methods: {
    fireChange: function fireChange(item) {
      var _this5 = this;

      if (item.disabled) {
        return;
      }

      var checked = !item._innerChecked;

      if (this.multiple && !item._innerChecked && this.hasLimit && this.limit < this.innerValue.length + 1) {
        this.$emit('outLimit', this.limit);
        return;
      }

      if (this.multiple) {
        // 多选
        if (item._innerChecked) {
          var index = this.innerValue.findIndex(function (_item) {
            return _item[_this5.valueKey] === item[_this5.valueKey];
          });
          index !== -1 && this.innerValue.splice(index, 1);
        } else {
          this.innerValue.push(item);
        }
      } else {
        // 单选
        if (item._innerChecked) {
          return; // 单选不能取消
        } else {
          this.innerValue = [item];
        }
      }

      this.$emit('change', this.innerValue, {
        items: [item],
        checked: checked
      });
    },
    fireAllChecked: function fireAllChecked() {
      var _this6 = this;

      var items = [];
      var checked = !this.allChecked;

      if (this.allChecked) {
        var _loop = function _loop(idx) {
          var item = _this6.innerValue[idx];

          var _checked = !!_this6.innerData.find(function (_item) {
            return _item[_this6.valueKey] === item[_this6.valueKey] && !item.disabled;
          });

          var target = _checked ? _this6.innerValue.splice(idx, 1) : [];
          items.push.apply(items, target);
        };

        for (var idx = this.innerValue.length - 1; idx >= 0; idx--) {
          _loop(idx);
        }
      } else {
        var _this$innerValue;

        items.push.apply(items, this.innerData.filter(function (_item) {
          return !_this6.innerValue.find(function (item) {
            return _item[_this6.valueKey] === item[_this6.valueKey];
          }) && !_item.disabled;
        }));

        (_this$innerValue = this.innerValue).push.apply(_this$innerValue, items);
      }

      this.$emit('change', this.innerValue, {
        items: items,
        checked: checked
      });
    },
    getInnerValue: function getInnerValue() {
      var _this7 = this;

      var temp = Array.isArray(this.value) ? this.value : [this.value];
      return temp.filter(function (item) {
        return !isNil_default()(item);
      }).map(function (item) {
        var _ref3;

        return isPlainObject_default()(item) ? item : (_ref3 = {}, _ref3[_this7.valueKey] = item, _ref3);
      });
    },
    fireScroll: function fireScroll(evt) {
      var target = evt.target; // 浏览器缩放时导致无法相等

      if (target.clientHeight + target.scrollTop + 5 >= target.scrollHeight) {
        this.emitScroll();
      }
    },
    emitScroll: function emitScroll() {},
    _emitScroll: function _emitScroll() {
      this.$emit('reached');
    }
  }
});
// CONCATENATED MODULE: ./src/components/combo-box/combo-options.vue?vue&type=script&lang=js&
 /* harmony default export */ var combo_box_combo_optionsvue_type_script_lang_js_ = (combo_optionsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/combo-box/combo-options.vue





/* normalize component */

var combo_options_component = normalizeComponent(
  combo_box_combo_optionsvue_type_script_lang_js_,
  combo_optionsvue_type_template_id_3b7f3488_render,
  combo_optionsvue_type_template_id_3b7f3488_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var combo_options_api; }
combo_options_component.options.__file = "src/components/combo-box/combo-options.vue"
/* harmony default export */ var combo_options = (combo_options_component.exports);
// CONCATENATED MODULE: ./src/components/combo-box/index.js



combo_box.Options = combo_options;
combo_box.Item = combo_item;

combo_box.install = function (Vue) {
  Vue.component('H3ComboBox', combo_box);
  Vue.component('H3ComboOptions', combo_options);
  Vue.component('H3ComboItem', combo_item);
};

/* harmony default export */ var components_combo_box = (combo_box);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/area-select/index.vue?vue&type=template&id=087bdfdf&
var area_selectvue_type_template_id_087bdfdf_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h3-dropdown",
    {
      ref: "dropdown",
      staticClass: "h3-area-select",
      attrs: {
        placement: _vm.placement,
        control: _vm.control,
        controlCls: _vm.controlCls,
        overlayCls: _vm.overlayCls,
        offset: _vm.offset,
        zIndex: _vm.zIndex,
        autoHide: _vm.autoHide,
        appendToBody: _vm.appendToBody,
        getParentContainer: _vm.getParentContainer,
        getBoundaryContainer: _vm.getBoundaryContainer,
        visible: _vm.innerVisible,
        disabled: _vm.disabled
      },
      on: { toggle: _vm.fireToggle, show: _vm.fireShow, hide: _vm.fireHide },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function() {
            return [
              _c(
                "div",
                {
                  ref: "popperRef",
                  staticClass: "h3-area-select__popper",
                  attrs: { tabIndex: "0" },
                  on: {
                    keydown: function($event) {
                      $event.preventDefault()
                      return _vm.onKeypress($event)
                    },
                    click: _vm.focusArea
                  }
                },
                [
                  _vm.isScoped && _vm.tabLen > 1
                    ? _c(
                        "div",
                        { staticClass: "h3-area-select__scoped" },
                        [
                          _c(
                            "h3-button",
                            {
                              staticClass: "h3-area-select__clear",
                              on: { click: _vm.fireClear }
                            },
                            [_vm._v("\n          清空\n        ")]
                          ),
                          _c(
                            "h3-button",
                            {
                              staticClass: "h3-area-select__confirm",
                              attrs: { type: "primary" },
                              on: { click: _vm.hideHandle }
                            },
                            [_vm._v("\n          确定\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "h3-tabs",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab"
                      }
                    },
                    [
                      _vm.tab[0].isShow
                        ? _c(
                            "h3-tab-pane",
                            {
                              key: "1",
                              attrs: {
                                disabled:
                                  _vm.tab[0].disabled ||
                                  !(_vm.province || []).length,
                                tab: "省"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "area" },
                                _vm._l(_vm.province, function(item, index) {
                                  return _c(
                                    "label",
                                    {
                                      key: item.id,
                                      class: {
                                        "double-width": item.name.length > 7
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.provinceClick(item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: item.selected,
                                            selected:
                                              index === _vm.selectedIndex
                                          },
                                          attrs: { title: item.name }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.tab[1].isShow
                        ? _c(
                            "h3-tab-pane",
                            {
                              key: "2",
                              attrs: {
                                disabled:
                                  _vm.tab[1].disabled ||
                                  !(_vm.city || []).length,
                                tab: "市"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "area" },
                                _vm._l(_vm.city, function(item, index) {
                                  return _c(
                                    "label",
                                    {
                                      key: item.id,
                                      class: {
                                        "double-width": item.name.length > 7
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.cityClick(item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: item.selected,
                                            selected:
                                              index === _vm.selectedIndex
                                          },
                                          attrs: { title: item.name }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.tab[2].isShow
                        ? _c(
                            "h3-tab-pane",
                            {
                              key: "3",
                              attrs: {
                                disabled:
                                  _vm.tab[2].disabled ||
                                  !(_vm.town || []).length,
                                tab: "区"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "area" },
                                _vm._l(_vm.town, function(item, index) {
                                  return _c(
                                    "label",
                                    {
                                      key: item.id,
                                      class: {
                                        "double-width": item.name.length > 7
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.townClick(item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: item.selected,
                                            selected:
                                              index === _vm.selectedIndex
                                          },
                                          attrs: { title: item.name }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("h3-combo-box", {
        attrs: {
          value: _vm.labelData,
          placeholder: _vm.placeholder,
          focused: _vm.innerVisible,
          disabled: _vm.disabled,
          allowClear: ""
        },
        on: { resize: _vm.fireResize, change: _vm.fireClear }
      })
    ],
    1
  )
}
var area_selectvue_type_template_id_087bdfdf_staticRenderFns = []
area_selectvue_type_template_id_087bdfdf_render._withStripped = true


// CONCATENATED MODULE: ./src/components/area-select/index.vue?vue&type=template&id=087bdfdf&

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tabs/style"
var tabs_style_ = __webpack_require__(100);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tabs"
var tabs_ = __webpack_require__(24);
var tabs_default = /*#__PURE__*/__webpack_require__.n(tabs_);

// CONCATENATED MODULE: ./src/components/tabs/index.js



function tabs_extends() { tabs_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tabs_extends.apply(this, arguments); }



var H3Tabs = {
  name: 'H3Tabs',
  functional: true,
  inheritAttrs: false,
  model: tabs_default.a.model,
  props: tabs_extends({}, tabs_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-tabs' : 'h3-tabs';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['tabBarExtraContent']);
    var children = [slotContent.default].concat(slotChildren);
    return h(tabs_default.a, tabs_extends({
      props: props
    }, data), children);
  }
};
H3Tabs.TabPane = tabs_default.a.TabPane;

H3Tabs.install = function (Vue) {
  Vue.component(H3Tabs.name, H3Tabs);
  Vue.component('H3TabPane', tabs_default.a.TabPane);
};

/* harmony default export */ var tabs = (H3Tabs);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/button/style"
var button_style_ = __webpack_require__(101);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/button"
var button_ = __webpack_require__(23);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// CONCATENATED MODULE: ./src/components/button/index.js



function button_extends() { button_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return button_extends.apply(this, arguments); }


var H3Button = {
  name: 'H3Button',
  functional: true,
  inheritAttrs: false,
  props: button_extends({}, button_default.a.props),
  render: function render(createElement, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-button' : 'h3-button';
    var slotContent = slots();
    var children = slotContent.default;

    if (children && children.length === 1) {
      var defaultNode = children[0];

      if (defaultNode && defaultNode.text) {
        var text = defaultNode.text.trim();

        if (text.length > 10) {
          defaultNode.text = text.substr(0, 10) + '...';
          data.attrs = data.attrs || {};
          data.attrs.title = text;
        }
      }
    }

    return createElement(button_default.a, button_extends({
      props: props
    }, data), children);
  }
};
H3Button.Group = button_default.a.Group;

H3Button.install = function (Vue) {
  Vue.component(H3Button.name, H3Button);
};

/* harmony default export */ var components_button = (H3Button);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dropdown/index.vue?vue&type=template&id=a683ad38&
var dropdownvue_type_template_id_a683ad38_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.reference,
          expression: "!reference"
        }
      ],
      staticClass: "h3-dropdown"
    },
    [
      _c(
        "div",
        {
          ref: "reference",
          staticClass: "h3-dropdown__reference",
          on: { click: _vm.visibleChange }
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "transition",
        {
          attrs: { name: "h3awesome-transition-drop-" + _vm.popperDirection },
          on: {
            "before-enter": _vm.beforePopperShow,
            "after-enter": _vm.afterPopperShow,
            "before-leave": _vm.beforePopperHide,
            "after-leave": _vm.afterPopperHide
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.popperVisible,
                  expression: "popperVisible"
                }
              ],
              ref: "popper",
              class: "h3-dropdown__popper " + _vm.overlayCls,
              on: {
                mouseenter: _vm.fireContentFocus,
                mouseleave: _vm.fireContentBlur
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.arrow && !_vm.arrowNeedHide,
                    expression: "arrow && !arrowNeedHide"
                  }
                ],
                ref: "arrow",
                staticClass: "h3-dropdown__arrow"
              }),
              _vm._t("content", [
                _c("div", { staticClass: "h3-dropdown__placeholder" }, [
                  _vm._v("\n          内容\n        ")
                ])
              ])
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var dropdownvue_type_template_id_a683ad38_staticRenderFns = []
dropdownvue_type_template_id_a683ad38_render._withStripped = true


// CONCATENATED MODULE: ./src/components/dropdown/index.vue?vue&type=template&id=a683ad38&

// EXTERNAL MODULE: external "v-click-outside-x"
var external_v_click_outside_x_ = __webpack_require__(17);

// EXTERNAL MODULE: external "@popperjs/core"
var core_ = __webpack_require__(92);

// CONCATENATED MODULE: ./src/utils/popper/modifiers.ts
var resetTransformOrigin = {
  name: 'resetTransformOrigin',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['flip', 'checkOverlap'],
  options: {
    transformOrigin: true
  },
  fn: function fn(params) {
    var state = params.state,
        options = params.options;
    var _options$transformOri = options.transformOrigin,
        transformOrigin = _options$transformOri === void 0 ? true : _options$transformOri,
        callbackFn = options.callbackFn;

    if (!transformOrigin) {
      return;
    }

    var _ref = state.modifiersData.checkOverlap || {},
        _ref$isOverlap = _ref.isOverlap,
        isOverlap = _ref$isOverlap === void 0 ? false : _ref$isOverlap;

    var placementMap = {
      top: 'bottom',
      bottom: 'top',
      left: 'right',
      right: 'left'
    };
    var placement = state.placement.split('-')[0];
    var origin = placementMap[placement];

    var _transformOrigin = typeof transformOrigin === 'string' ? transformOrigin : isOverlap ? 'center center' : ['top', 'bottom'].includes(placement) ? "center " + origin : origin + " center";

    state.styles.popper.transformOrigin = _transformOrigin;

    if (callbackFn) {
      var directionMap = {
        top: 'vertical',
        bottom: 'vertical',
        left: 'horizontal',
        right: 'horizontal'
      };
      callbackFn(isOverlap ? 'center' : directionMap[placement], state.placement);
    }
  }
};
var sameWidth = {
  name: 'sameWidth',
  enabled: true,
  requires: ['computeStyles'],
  phase: 'beforeWrite',
  fn: function fn(params) {
    var state = params.state;
    state.styles.popper.width = state.rects.reference.width + "px";
  },
  effect: function effect(params) {
    var state = params.state;
    state.elements.popper.style.width = state.elements.reference.offsetWidth + "px";
    return function () {};
  }
};
var setZIndex = {
  name: 'setZIndex',
  enabled: true,
  requires: ['computeStyles'],
  phase: 'beforeWrite',
  fn: function fn(params) {
    var state = params.state,
        options = params.options;
    var _options$getZIndex = options.getZIndex,
        getZIndex = _options$getZIndex === void 0 ? function () {
      return 1000;
    } : _options$getZIndex;
    state.styles.popper.zIndex = "" + getZIndex();
  }
};
var checkOverlap = {
  name: 'checkOverlap',
  enabled: true,
  phase: 'main',
  requires: ['preventOverflow'],
  fn: function fn(params) {
    var name = params.name,
        state = params.state,
        options = params.options;
    var callbackFn = options.callbackFn;
    var _state$rects = state.rects,
        reference = _state$rects.reference,
        popper = _state$rects.popper;
    var referenceRect = {
      left: reference.x,
      right: reference.x + reference.width,
      top: reference.y,
      bottom: reference.y + reference.height
    };
    var _state$modifiersData$ = state.modifiersData.popperOffsets,
        popperOffsetsX = _state$modifiersData$.x,
        popperOffsetsY = _state$modifiersData$.y;
    var popperX = Math.abs(popperOffsetsX - popper.x) < 1 ? popper.x : popperOffsetsX;
    var popperY = Math.abs(popperOffsetsY - popper.y) < 1 ? popper.y : popperOffsetsY;
    var popperRect = {
      left: popperX,
      right: popperX + popper.width,
      top: popperY,
      bottom: popperY + popper.height
    };
    var isOverlap = !(referenceRect.right <= popperRect.left + 1 || referenceRect.left + 1 >= popperRect.right || referenceRect.bottom <= popperRect.top + 1 || referenceRect.top + 1 >= popperRect.bottom);
    callbackFn && callbackFn(isOverlap);
    state.modifiersData[name] = {
      isOverlap: isOverlap
    };
  }
};
var arrowAutoHide = {
  name: 'arrowAutoHide',
  enabled: true,
  phase: 'write',
  requires: ['checkOverlap'],
  fn: function fn(params) {
    var state = params.state,
        options = params.options;
    var callbackFn = options.callbackFn;
    var elements = state.elements,
        modifiersData = state.modifiersData;
    var arrow = elements.arrow;

    if (arrow) {
      var needHide = modifiersData.checkOverlap.isOverlap || modifiersData.arrow.centerOffset !== 0;
      callbackFn && callbackFn(needHide);
    }
  }
};
var autoHide = {
  name: 'autoHide',
  enabled: true,
  phase: 'main',
  requires: ['hide'],
  fn: function fn(params) {
    var state = params.state,
        options = params.options;
    var callbackFn = options.callbackFn;
    var isReferenceHidden = state.modifiersData.hide.isReferenceHidden;
    callbackFn && callbackFn(isReferenceHidden);
  }
};
// CONCATENATED MODULE: ./src/utils/popper/z-index-manager.ts
var hasInitZIndex = false;
var z_index_manager_zIndex;
var zIndexManager = {
  getZIndex: function getZIndex() {
    return this.zIndex++;
  },
  restoreZIndex: function restoreZIndex() {
    this.zIndex--;
  }
};
Object.defineProperty(zIndexManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      z_index_manager_zIndex = z_index_manager_zIndex || 1500;
      hasInitZIndex = true;
    }

    return z_index_manager_zIndex;
  },
  set: function set(value) {
    z_index_manager_zIndex = value;
  }
});
/* harmony default export */ var z_index_manager = (zIndexManager);
// CONCATENATED MODULE: ./src/utils/popper/index.ts



var FakeElement = typeof Element !== 'undefined' ? Element : Object;
var popper = {
  model: {
    prop: 'visible',
    event: 'toggle'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Function, Array],
      default: function _default() {
        return [0, 0];
      }
    },
    arrow: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      validator: function validator(value) {
        return /^(auto|top|bottom|left|right)(-start|-end)?$/g.test(value);
      },
      default: 'bottom-start'
    },
    transformOrigin: {
      type: [String, Boolean],
      default: true
    },
    zIndex: {
      type: [String, Number]
    },
    strategy: {
      type: String,
      validator: function validator(value) {
        return ['absolute', 'fixed'].includes(value);
      },
      default: 'absolute'
    },
    modifiers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sameWidth: {
      type: Boolean,
      default: false
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    getParentContainer: Function,
    getBoundaryContainer: Function,
    reference: FakeElement
  },
  data: function data() {
    return {
      popperVisible: false,
      popperIsOverlap: false,
      popperInstance: null,
      popperDirection: 'center',
      currentPlacement: '',
      referenceElm: null,
      popperElm: null,
      arrowElm: null,
      arrowNeedHide: false,
      innerZIndex: null,
      beforeShowCallbacks: [],
      afterShowCallbacks: [],
      beforeHideCallbacks: [],
      afterHideCallbacks: []
    };
  },
  watch: {
    visible: {
      handler: function handler(nVal) {
        this.popperVisible = !!nVal;
      },
      immediate: true
    },
    popperVisible: function popperVisible(nVal) {
      this.$emit('toggle', nVal);

      if (nVal) {
        this.showPopper();
        this.$emit('show');
      } else {
        this.hidePopper();
        this.$emit('hide');
      }
    },
    placement: {
      handler: function handler(nVal) {
        this.updatePopper({
          placement: nVal
        });
        var placement = nVal;
        this.popperDirection = placement.startsWith('auto') ? 'center' : placement.startsWith('right') || placement.startsWith('left') ? 'horizontal' : 'vertical';
      },
      immediate: true
    },
    modifiers: function modifiers(nVal) {
      this.updatePopper({
        modifiers: this.getInnerModifiers(nVal)
      });
    }
  },
  deactivated: function deactivated() {
    this.hidePopper(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.hidePopper(true);

    if (this.popperElm && this.popperElm.parentNode) {
      this.popperElm.parentNode.removeChild(this.popperElm);
    }
  },
  methods: {
    getArrowOffset: function getArrowOffset() {
      var offset = [0, 8];

      if (typeof this.offset === 'function') {
        offset = this.offset();
      } else if (Array.isArray(this.offset)) {
        offset = this.offset;
      }

      var _offset = offset,
          skidding = _offset[0],
          distance = _offset[1];
      return !distance ? [skidding, 8] : offset;
    },
    getInnerModifiers: function getInnerModifiers(modifiers) {
      var _this = this;

      var boundary = this.getBoundaryContainer ? this.getBoundaryContainer() : 'clippingParents';
      return [{
        name: 'offset',
        options: {
          offset: this.arrow ? this.getArrowOffset : this.offset
        }
      }, {
        name: 'computeStyles',
        options: {
          gpuAcceleration: false
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: 8,
          boundary: boundary,
          altAxis: true
        }
      }, {
        name: 'flip',
        options: {
          padding: 8,
          boundary: boundary
        }
      }, checkOverlap, {
        name: 'checkOverlap',
        options: {
          callbackFn: function callbackFn(isOverlap) {
            _this.popperIsOverlap = isOverlap;
          }
        }
      }].concat(this.arrow ? [{
        name: 'arrow',
        options: {
          element: this.arrowElm,
          padding: 5
        }
      }, arrowAutoHide, {
        name: 'arrowAutoHide',
        options: {
          callbackFn: function callbackFn(needHide) {
            _this.arrowNeedHide = needHide;
          }
        }
      }] : [], [autoHide, {
        name: 'autoHide',
        options: {
          callbackFn: function callbackFn(isReferenceHidden) {
            if (_this.autoHide && isReferenceHidden) {
              _this.popperVisible = false;
            }
          }
        }
      }, resetTransformOrigin, {
        name: 'resetTransformOrigin',
        options: {
          transformOrigin: this.transformOrigin,
          callbackFn: function callbackFn(direction, placement) {
            _this.popperDirection = direction;
            _this.currentPlacement = placement;
          }
        }
      }], this.sameWidth ? [sameWidth] : [], [setZIndex, {
        name: 'setZIndex',
        options: {
          getZIndex: function getZIndex() {
            var zIndex = _this.zIndex || _this.innerZIndex;

            if (zIndex === null) {
              zIndex = z_index_manager.getZIndex();
              _this.innerZIndex = zIndex;
            }

            return zIndex;
          }
        }
      }], modifiers);
    },
    refreshPopper: function refreshPopper(currPlacement) {
      var _this2 = this;

      if (this.popperInstance) {
        if (currPlacement) {
          this.popperInstance.setOptions({
            placement: this.currentPlacement
          }).then(function () {
            _this2.popperInstance.state.options.placement = _this2.placement;
          });
        } else {
          this.popperInstance.update();
        }
      }
    },
    updatePopper: function updatePopper(opitons) {
      if (this.popperInstance) {
        this.popperInstance.setOptions(opitons);
      }
    },
    showPopper: function showPopper() {
      this.popperElm = this.popperElm || this.$refs.popper;
      this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
      if (!this.popperElm || !this.referenceElm) return;
      this.portalPopper();
      this.arrowElm = this.arrow ? this.$refs.arrow : null;
      this.currentPlacement = this.placement;
      var options = {
        placement: this.placement,
        strategy: this.strategy,
        modifiers: this.getInnerModifiers(this.modifiers)
      };
      this.popperInstance = this.createPopperInstance(this.referenceElm, this.popperElm, options);
    },
    createPopperInstance: function createPopperInstance(referenceElm, popperElm, options) {
      return Object(core_["createPopper"])(referenceElm, popperElm, options);
    },
    portalPopper: function portalPopper() {
      if (typeof this.getParentContainer === 'function') {
        var parentContainer = this.getParentContainer(this.referenceElm.parentNode);

        if (parentContainer && this.popperElm.parentNode !== parentContainer) {
          parentContainer.appendChild(this.popperElm);
        }
      } else if (this.appendToBody) {
        if (this.popperElm.parentNode !== document.body) {
          document.body.appendChild(this.popperElm);
        }
      }
    },
    hidePopper: function hidePopper(immediate) {
      if (immediate === void 0) {
        immediate = false;
      }

      if (this.popperInstance) {
        if (this.innerZIndex !== null) {
          z_index_manager.restoreZIndex();
          this.innerZIndex = null;
        }

        var prevInstance = this.popperInstance;
        this.referenceElm = null;
        this.popperInstance = null;

        if (immediate) {
          prevInstance.destroy();
          prevInstance = null;
          clearTimeout(this.destroyTimer);
        } else {
          this.afterHideCallbacks.push(function () {
            prevInstance.destroy();
            prevInstance = null;
          });
        }
      }
    }
  }
};
/* harmony default export */ var utils_popper = (popper);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dropdown/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var dropdownvue_type_script_lang_js_FakeElement = typeof Element !== 'undefined' ? Element : Object;
/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
  name: 'H3Dropdown',
  mixins: [utils_popper],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: [dropdownvue_type_script_lang_js_FakeElement, Function]
    },
    subTrigger: {
      type: [Boolean, Function],
      default: false
    },
    control: {
      type: Boolean,
      default: false
    },
    controlCls: {
      type: [String, Array]
    },
    overlayCls: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      innerTrigger: null,
      innerToggleTimer: null,
      captureTimer: null,
      popperHidden: false
    };
  },
  computed: {
    innerControlCls: function innerControlCls() {
      return this.controlCls ? Array.isArray(this.controlCls) ? this.controlCls : [this.controlCls] : [];
    }
  },
  watch: {
    disabled: function disabled(nVal) {
      if (!nVal && this.popperVisible) {
        this.popperVisible = false;
      }
    },
    popperVisible: function popperVisible(nVal) {
      var _this = this;

      if (nVal) {
        if (this.referenceElm) {
          this.referenceElm.__CLICK_OUTSIDE_INIT__ = true;
        }

        external_v_click_outside_x_["directive"].bind(this.$el, {
          value: this.handleOutsideCaptureClick,
          modifiers: {
            capture: true
          }
        });
        external_v_click_outside_x_["directive"].bind(this.$el, {
          value: this.handleOutsideClick
        });
        this.afterShowCallbacks.push(function () {
          if (_this.referenceElm) {
            _this.referenceElm.__CLICK_OUTSIDE_INIT__ = false;
          }
        });
      } else {
        external_v_click_outside_x_["directive"].unbind(this.$el, {
          value: this.handleOutsideCaptureClick,
          modifiers: {
            capture: true
          }
        });
        external_v_click_outside_x_["directive"].unbind(this.$el, {
          value: this.handleOutsideClick
        });
      }
    },
    trigger: function trigger(nVal) {
      this.innerTrigger = typeof nVal === 'function' ? nVal() : nVal;
    }
  },
  created: function created() {
    var _this2 = this;

    this.forcePopupAlign = debounce_default()(function (currPlacement) {
      _this2.refreshPopper(currPlacement);
    }, 200, {
      leading: false
    });
  },
  beforeDestroy: function beforeDestroy() {
    external_v_click_outside_x_["directive"].unbind(this.$el, {
      value: this.handleOutsideCaptureClick,
      modifiers: {
        capture: true
      }
    });
    external_v_click_outside_x_["directive"].unbind(this.$el, {
      value: this.handleOutsideClick
    });
  },
  mounted: function mounted() {
    this.innerTrigger = typeof this.trigger === 'function' ? this.trigger() : this.trigger;
  },
  methods: {
    fireContentFocus: function fireContentFocus() {
      this.$emit('contentFocus');
    },
    fireContentBlur: function fireContentBlur() {
      this.$emit('contentBlur');
    },
    forcePopupAlign: function forcePopupAlign() {},
    handleOutsideCaptureClick: function handleOutsideCaptureClick(evt) {
      var _this3 = this;

      // 捕获 stopPropagation 的 click 事件
      if (this.captureTimer) {
        clearTimeout(this.captureTimer);
      }

      this.captureTimer = setTimeout(function () {
        _this3.handleOutsideClick(evt);
      }, 50);
    },
    handleOutsideClick: function handleOutsideClick(evt) {
      clearTimeout(this.captureTimer);

      if (this.popperVisible && this.referenceElm && this.referenceElm.__CLICK_OUTSIDE_INIT__) {
        this.referenceElm.__CLICK_OUTSIDE_INIT__ = false;
        return;
      }

      if (!evt.target.closest('body')) {
        return;
      }

      if (this.control || this.disabled || !this.popperVisible || !this.popperElm || // 包含 evt.target === this.popperElm
      this.popperElm.contains(evt.target) || this.checkControlCls(evt.target)) {
        return;
      }

      this.popperVisible = false;
    },
    checkControlCls: function checkControlCls(elem) {
      return this.innerControlCls.some(function (cls) {
        // https://developer.mozilla.org/zh-CN/docs/Web/API/Element/closest
        return !!elem.closest("." + cls);
      });
    },
    visibleChange: function visibleChange(evt) {
      if (this.disabled || !this.popperVisible && !this.triggerCheck(evt.target)) {
        return;
      }

      this.popperVisible = !this.popperVisible;
    },
    triggerCheck: function triggerCheck(target) {
      if (!this.innerTrigger) {
        return true;
      }

      if (this.innerTrigger.contains(target)) {
        if (typeof this.subTrigger === 'boolean') {
          return this.subTrigger ? this.innerTrigger !== target : true;
        }

        if (typeof this.subTrigger === 'function') {
          return this.subTrigger(this.innerTrigger, target);
        }

        return true;
      } else {
        return false;
      }
    },
    popperToggle: function popperToggle(reference, listeners) {
      var _this4 = this;

      if (listeners === void 0) {
        listeners = {};
      }

      var _listeners = listeners,
          show = _listeners.show,
          hide = _listeners.hide;

      if (this.popperHidden) {
        return;
      }

      if (!reference) {
        hide && this.afterHideCallbacks.push(hide);
        this.popperVisible = false;
        return;
      }

      if (this.popperVisible && (!reference || this.referenceElm === reference)) {
        hide && this.afterHideCallbacks.push(hide);
        this.popperVisible = false;
        return;
      }

      if (this.popperVisible) {
        this.popperHidden = true;
        this.popperVisible = false;
        this.afterHideCallbacks.push(function () {
          show && _this4.beforeShowCallbacks.push(show);
          hide && _this4.afterHideCallbacks.push(hide);
          _this4.referenceElm = reference;
          _this4.popperHidden = false;
          _this4.popperVisible = true;
        });
      } else {
        show && this.beforeShowCallbacks.push(show);
        hide && this.afterHideCallbacks.push(hide);
        this.referenceElm = reference;
        this.popperVisible = true;
      }
    },
    beforePopperShow: function beforePopperShow() {
      var _beforeShowCallbacks = this.beforeShowCallbacks;
      this.beforeShowCallbacks = [];

      _beforeShowCallbacks.forEach(function (fn) {
        fn && fn();
      });
    },
    afterPopperShow: function afterPopperShow() {
      var _afterShowCallbacks = this.afterShowCallbacks;
      this.afterShowCallbacks = [];

      _afterShowCallbacks.forEach(function (fn) {
        fn && fn();
      });
    },
    beforePopperHide: function beforePopperHide() {
      var _beforeHideCallbacks = this.beforeHideCallbacks;
      this.beforeHideCallbacks = [];

      _beforeHideCallbacks.forEach(function (fn) {
        fn && fn();
      });
    },
    afterPopperHide: function afterPopperHide() {
      var _afterHideCallbacks = this.afterHideCallbacks;
      this.afterHideCallbacks = [];

      _afterHideCallbacks.forEach(function (fn) {
        fn && fn();
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/dropdown/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/dropdown/index.vue?vue&type=style&index=0&lang=less&
var dropdownvue_type_style_index_0_lang_less_ = __webpack_require__(102);

// CONCATENATED MODULE: ./src/components/dropdown/index.vue






/* normalize component */

var dropdown_component = normalizeComponent(
  components_dropdownvue_type_script_lang_js_,
  dropdownvue_type_template_id_a683ad38_render,
  dropdownvue_type_template_id_a683ad38_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var dropdown_api; }
dropdown_component.options.__file = "src/components/dropdown/index.vue"
/* harmony default export */ var dropdown = (dropdown_component.exports);
// CONCATENATED MODULE: ./src/components/dropdown/index.js


dropdown.install = function (Vue) {
  Vue.component('H3Dropdown', dropdown);
};

/* harmony default export */ var components_dropdown = (dropdown);
// EXTERNAL MODULE: external "lodash/sortBy"
var sortBy_ = __webpack_require__(93);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy_);

// CONCATENATED MODULE: ./src/utils/cache.ts
var caches = [];
/* harmony default export */ var cache = ({
  get: function get(key) {
    return caches[key] || '';
  },
  set: function set(key, data) {
    caches[key] = data;
  }
});
// CONCATENATED MODULE: ./src/utils/console.js
var log = function log(msg) {
  var wrappedMsg = "%c[awesome-ui:log]%c " + msg;
  console.log(wrappedMsg, 'background-color: #107fff;color:#fff;border-radius: 5px;padding: 3px 5px', '');
};
var warn = function warn(msg) {
  var wrappedMsg = "%c[awesome-ui:warn]%c " + msg;
  console.warn(wrappedMsg, 'background-color: #ff7527;color:#fff;border-radius: 5px;padding: 3px 5px', '');
};
var error = function error(msg) {
  var wrappedMsg = "%c[awesome-ui:error]%c " + msg;
  console.error(wrappedMsg, 'background-color: #ff4384;color:#fff;border-radius: 5px;padding: 3px 5px', '');
};
var deprecate = function deprecate(msg) {
  var wrappedMsg = "%c[awesome-ui:deprecated]%c " + msg;
  console.warn(wrappedMsg, 'background-color: #ff7527;color:#fff;border-radius: 5px;padding: 3px 5px', '');
};
var h3Console = {
  log: log,
  warn: warn,
  error: error,
  deprecate: deprecate
};
/* harmony default export */ var utils_console = (h3Console);
// CONCATENATED MODULE: ./src/utils/index.js
function isThenable(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}
function checkEmpty(val) {
  if (typeof val === 'string') {
    return val.trim() === '';
  }

  return val === null;
}
function handleEmptyValue(value) {
  return checkEmpty(value) ? undefined : Array.isArray(value) ? value.filter(function (item) {
    return !checkEmpty(item);
  }) : value;
} // 判断一个值是否是数组

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
} // 判断一个值是否是对象

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
} // 判断一个值是否是函数

function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
} // 判断一个值是否是字符串

function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
} // 生成随机字符串

var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
function createId(len) {
  if (len === void 0) {
    len = 16;
  }

  var str = '';

  for (var a = 0; a < len; a += 1) {
    str += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return str;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/area-select/index.vue?vue&type=script&lang=js&
function area_selectvue_type_script_lang_js_extends() { area_selectvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return area_selectvue_type_script_lang_js_extends.apply(this, arguments); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var area_selectvue_type_script_lang_js_ = ({
  name: 'H3AreaSelect',
  components: {
    H3Button: components_button,
    H3Tabs: tabs,
    H3ComboBox: components_combo_box,
    H3Dropdown: components_dropdown,
    H3TabPane: tabs.TabPane
  },
  props: {
    format: {
      type: String,
      default: 'P-C-T'
    },
    source: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    isScoped: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      validator: function validator(value) {
        return /^(auto|top|bottom|left|right)(-start|-end)?$/g.test(value);
      },
      default: 'bottom-start'
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    getParentContainer: Function,
    getBoundaryContainer: Function,
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    control: {
      type: Boolean,
      default: false
    },
    controlCls: {
      type: String,
      default: ''
    },
    overlayCls: {
      type: String,
      default: ''
    },
    offset: {
      type: [Function, Array],
      default: function _default() {
        return [0, 0];
      }
    },
    zIndex: {
      type: [String, Number]
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerVisible: false,
      tab: [{
        disabled: true,
        isShow: false
      }, {
        disabled: true,
        isShow: false
      }, {
        disabled: true,
        isShow: false
      }],
      activeTab: '1',
      province: [],
      city: [],
      town: [],
      selectedData: [],
      allDatas: [],
      selectedIndex: -1
    };
  },
  computed: {
    tabLen: function tabLen() {
      return this.format.split('-').length || 3;
    },
    labelData: function labelData() {
      return (this.value || []).map(function (item) {
        var _item = {
          name: item.name
        };

        switch (item.level) {
          case 'province':
            _item.level = 1;
            break;

          case 'city':
            _item.level = 2;
            break;

          case 'district':
            _item.level = 3;
            break;

          case 'street':
            _item.level = 4;
            break;
        }

        return _item;
      }).sort(function (prev, next) {
        return prev.level - next.level;
      }).map(function (item) {
        return item.name;
      }).slice(0, this.tabLen).join(' / ');
    }
  },
  watch: {
    value: function value(nVal) {
      this.selectedData = nVal || [];

      if (this.allDatas) {
        this.initData();
      }
    },
    source: function source() {
      this.getData();
    },
    format: function format() {
      this.setConfig();
    },
    visible: function visible(nVal) {
      this.innerVisible = nVal;
    },
    activeTab: function activeTab() {
      this.focusArea();
      this.selectedIndex = this.getSelectedIndex();
    }
  },
  created: function created() {
    this.setConfig();
  },
  mounted: function mounted() {
    this.selectedData = this.value;
    this.getData();
  },
  methods: {
    fireResize: function fireResize() {
      this.$refs.dropdown.forcePopupAlign();
    },
    getData: function getData() {
      var _this = this;

      var ready = function ready(data) {
        _this.allDatas = data;

        if (data && data.length) {
          cache.set('areaData', data);
        }

        _this.initData();
      };

      var areaData = cache.get('areaData');

      if (!areaData) {
        var source = [];

        if (typeof this.source === 'function') {
          source = this.source();
        } else if (source instanceof Array) {
          source = [].concat(this.source);
        } else {
          utils_console.error('prop:source 应该是 Function 或 Array 类型');
          ready([]);
          return;
        }

        if (isThenable(source)) {
          source.then(function (data) {
            areaData = _this.updateData(data);
            ready(areaData);
          }).catch(function (err) {
            utils_console.error("\u83B7\u53D6\u6570\u636E\u6E90\u5931\u8D25\uFF0C" + err);
          });
        } else if (source instanceof Array) {
          areaData = this.updateData(source);
          ready(areaData);
        } else {
          utils_console.error('prop:source Function 返参错误，返参应该为 Promise 或 Array 类型');
        }
      } else {
        ready(areaData);
      }
    },
    fireShow: function fireShow() {
      this.activeTab = '1';
      this.selectedData = this.value || [];
      this.initData();
      this.$emit('show');
      this.focusArea();
      this.selectedIndex = this.getSelectedIndex();
    },
    fireHide: function fireHide() {
      this.$emit('hide');
    },
    fireToggle: function fireToggle(visible) {
      this.innerVisible = visible;
      this.$emit('toggle', this.innerVisible);
    },
    handleData: function handleData(data, code) {
      var children = [];
      data.forEach(function (item) {
        item.selected = false;

        if (code === item.id) {
          item.selected = true;
          children = item.children || [];
        }
      });
      return children;
    },

    /**
     * 初始化数据
     */
    initData: function initData() {
      var _this2 = this;

      this.province = this.allDatas;
      this.city = [];
      this.town = [];
      var provinceCode = '';
      var cityCode = '';
      var townCode = '';

      if (this.selectedData && this.selectedData.length > 0) {
        this.selectedData.forEach(function (res) {
          switch (res.level) {
            case 'province':
              _this2.tab[0].disabled = false;
              provinceCode = res.id;
              break;

            case 'city':
              _this2.tab[1].disabled = false;
              cityCode = res.id;
              break;

            case 'district':
            case 'street':
              _this2.tab[2].disabled = false;
              townCode = res.id;
              break;
          }
        });
      }

      var city = this.handleData(this.province, provinceCode);

      if (!city.length) {
        return;
      }

      if (city[0].level === 'city') {
        this.city = city;
        this.checkTabDisabled(!!provinceCode, !!cityCode, 1, '2');

        if (cityCode && this.city && this.city.length) {
          this.checkTabDisabled(!!cityCode, !!townCode, 2, '3');
          this.town = this.handleData(this.city, cityCode);
        }

        if (townCode && this.town && this.town.length) {
          this.handleData(this.town, townCode);
        }
      } else if (['district', 'street'].includes(city[0].level)) {
        this.town = city;
        this.checkTabDisabled(!!provinceCode, !!townCode, 2, '3');

        if (townCode && this.town && this.town.length) {
          this.handleData(this.town, townCode);
        }
      }
    },
    checkTabDisabled: function checkTabDisabled(hasPrev, hasCurr, level, activeTab) {
      if (hasPrev && this.tab[level].isShow) {
        this.tab[level].disabled = false;

        if (!hasCurr) {
          this.activeTab = activeTab;
        }
      }
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case 1:
          return 'province';

        case 2:
          return 'city';

        case 3:
          return 'district';

        case 4:
          return 'street';
      }
    },
    updateData: function updateData(data) {
      var _this3 = this;

      // 递归处理数据
      var cacheData = sortBy_default()(data, ['id']);
      var handleData = cacheData.map(function (item) {
        if (item.children) {
          item.children = _this3.updateData(item.children);
        }

        return area_selectvue_type_script_lang_js_extends({}, item, {
          label: item.name,
          value: item.id,
          level: _this3.getLevel(item.level),
          selected: false
        });
      });
      return handleData;
    },

    /**
     * 省选择
     */
    provinceClick: function provinceClick(item) {
      this.selectedData = [];
      this.province.forEach(function (res) {
        res.selected = false;
      });
      item.selected = true;
      this.town = [];
      this.city = []; // 设置值

      this.switchTab(item, 1);
    },

    /**
     * 市选择
     */
    cityClick: function cityClick(item) {
      this.city.forEach(function (res) {
        res.selected = false;
      });
      item.selected = true;
      this.town = []; // 设置值

      this.switchTab(item, 2);
    },

    /**
     * 区选择
     */
    townClick: function townClick(item) {
      this.town.forEach(function (res) {
        res.selected = false;
      });
      item.selected = true;
      this.switchTab(item, 3);
    },

    /**
     * tab 页签切换
     */
    switchTab: function switchTab(items, index) {
      var id = items.id,
          center = items.center,
          level = items.level,
          name = items.name,
          children = items.children;
      this.selectedData = this.selectedData.filter(function (res) {
        return res.level !== level;
      });
      this.selectedData.push({
        id: id,
        name: name,
        center: center,
        level: level,
        adcode: id
      });

      if (!children || children.length === 0 || this.tabLen === index) {
        this.hideHandle();
        return;
      }

      children.forEach(function (res) {
        res.selected = false;
      });
      this.tab[index - 1].disabled = false;
      this.tab[index].disabled = false;

      if (children[0].level === 'city' && this.tabLen > 1) {
        this.city = children;
        this.activeTab = '2';
      } else if (['district', 'street'].includes(children[0].level) && this.tabLen > 2) {
        this.town = children;
        this.activeTab = '3';
      } else {
        this.hideHandle();
      }
    },

    /**
     * 失去焦点，并收起弹窗，展示值
     */
    hideHandle: function hideHandle() {
      this.change();
      this.fireToggle(false);
    },
    fireClear: function fireClear() {
      this.selectedData = [];
      this.initData();
      this.change();
      this.activeTab = '1';
    },

    /**
     * 回调change事件
     */
    change: function change() {
      this.$emit('input', this.selectedData);
      this.$emit('change', this.selectedData);
    },

    /**
     * 控件配置
     */
    setConfig: function setConfig() {
      var length = this.tabLen;
      this.tab.forEach(function (res) {
        length -= 1;
        res.isShow = length >= 0;
      });
    },
    initVal: function initVal(pcaItem) {
      var center = pcaItem.center,
          level = pcaItem.level,
          name = pcaItem.name,
          id = pcaItem.id;
      return {
        id: id,
        name: name,
        center: center,
        level: level,
        adcode: id
      };
    },
    focusArea: function focusArea() {
      var _this4 = this;

      setTimeout(function () {
        var el = _this4.$refs.popperRef;

        if (el) {
          el.focus();
        }
      }, 100);
    },
    onKeypress: function onKeypress(e) {
      var data = [];

      if (this.activeTab === '1') {
        data = this.province;
      } else if (this.activeTab === '2') {
        data = this.city;
      } else if (this.activeTab === '3') {
        data = this.town;
      }

      var len = data.length;
      var keyCode = e.keyCode;

      switch (keyCode) {
        case 38:
          // up
          if (this.selectedIndex - 5 > -1) {
            this.selectedIndex -= 5;
          }

          break;

        case 40:
          // down
          if (this.selectedIndex + 5 < len) {
            this.selectedIndex += 5;
          }

          break;

        case 37:
          // left
          if (this.selectedIndex - 1 > -1) {
            this.selectedIndex -= 1;
          }

          break;

        case 39:
          // right
          if (this.selectedIndex + 1 < len) {
            this.selectedIndex += 1;
          }

          break;

        case 13:
          // enter
          if (this.selectedIndex > -1 && this.selectedIndex < len) {
            if (this.activeTab === '1') {
              this.provinceClick(data[this.selectedIndex]);
            } else if (this.activeTab === '2') {
              this.cityClick(data[this.selectedIndex]);
            } else if (this.activeTab === '3') {
              this.townClick(data[this.selectedIndex]);
            }
          }

          break;

        case 8:
          // backspace
          if (this.activeTab === '2') {
            this.activeTab = '1';
          } else if (this.activeTab === '3') {
            this.activeTab = '2';
          }

          break;

        default:
          break;
      }
    },
    getSelectedIndex: function getSelectedIndex() {
      var data = [];

      if (this.activeTab === '1') {
        data = this.province;
      } else if (this.activeTab === '2') {
        data = this.city;
      } else if (this.activeTab === '3') {
        data = this.town;
      }

      var index = data.findIndex(function (item) {
        return item.selected;
      });

      if (index === -1) {
        index = 0;
      }

      return index;
    }
  }
});
// CONCATENATED MODULE: ./src/components/area-select/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_area_selectvue_type_script_lang_js_ = (area_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/area-select/index.vue?vue&type=style&index=0&lang=less&
var area_selectvue_type_style_index_0_lang_less_ = __webpack_require__(103);

// CONCATENATED MODULE: ./src/components/area-select/index.vue






/* normalize component */

var area_select_component = normalizeComponent(
  components_area_selectvue_type_script_lang_js_,
  area_selectvue_type_template_id_087bdfdf_render,
  area_selectvue_type_template_id_087bdfdf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var area_select_api; }
area_select_component.options.__file = "src/components/area-select/index.vue"
/* harmony default export */ var area_select = (area_select_component.exports);
// CONCATENATED MODULE: ./src/components/area-select/index.js


area_select.install = function (Vue) {
  Vue.component('H3AreaSelect', area_select);
};

/* harmony default export */ var components_area_select = (area_select);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/dropdown/style"
var dropdown_style_ = __webpack_require__(104);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/dropdown"
var dropdown_ = __webpack_require__(40);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown_);

// CONCATENATED MODULE: ./src/components/a-dropdown/index.js



function a_dropdown_extends() { a_dropdown_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return a_dropdown_extends.apply(this, arguments); }



var H3ADropdown = {
  name: 'H3ADropdown',
  functional: true,
  inheritAttrs: false,
  props: a_dropdown_extends({}, dropdown_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-a-dropdown' : 'h3-a-dropdown';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['overlay', 'icon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(dropdown_default.a, a_dropdown_extends({
      props: props
    }, data), children);
  }
};
H3ADropdown.Button = dropdown_default.a.Button;

H3ADropdown.install = function (Vue) {
  Vue.component(H3ADropdown.name, H3ADropdown);
  Vue.component('H3ADropdownButton', H3ADropdown.Button);
};

/* harmony default export */ var a_dropdown = (H3ADropdown);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/upload/style"
var upload_style_ = __webpack_require__(105);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/upload"
var upload_ = __webpack_require__(41);
var upload_default = /*#__PURE__*/__webpack_require__.n(upload_);

// CONCATENATED MODULE: ./src/components/a-upload/index.js



function a_upload_extends() { a_upload_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return a_upload_extends.apply(this, arguments); }


var H3AUpload = {
  name: 'H3AUpload',
  functional: true,
  inheritAttrs: false,
  props: a_upload_extends({}, upload_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-a-upload' : 'h3-a-upload';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var children = slotContent.default;
    return h(upload_default.a, a_upload_extends({
      props: props
    }, data), children);
  }
};
H3AUpload.Dragger = upload_default.a.Dragger;

H3AUpload.install = function (Vue) {
  Vue.component(H3AUpload.name, H3AUpload);
  Vue.component('H3AUploadDragger', H3AUpload.Dragger);
};

/* harmony default export */ var a_upload = (H3AUpload);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid-layout/GridItem.vue?vue&type=template&id=85469632&
var GridItemvue_type_template_id_85469632_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "item",
      staticClass: "vue-grid-item",
      class: _vm.gridItemPrefixCls,
      style: _vm.style,
      attrs: { tabindex: _vm.tabindex },
      on: { focus: _vm.focusItem, blur: _vm.blurItem }
    },
    [
      _vm._t("default"),
      _vm.resizable
        ? _c("span", { ref: "handel", class: [_vm.resizableHandleClass] })
        : _vm._e()
    ],
    2
  )
}
var GridItemvue_type_template_id_85469632_staticRenderFns = []
GridItemvue_type_template_id_85469632_render._withStripped = true


// CONCATENATED MODULE: ./src/components/grid-layout/GridItem.vue?vue&type=template&id=85469632&

// EXTERNAL MODULE: external "interactjs"
var external_interactjs_ = __webpack_require__(54);
var external_interactjs_default = /*#__PURE__*/__webpack_require__.n(external_interactjs_);

// CONCATENATED MODULE: ./src/helpers/utils.ts
function bottom(layout) {
  var max = 0;
  var bottomY;

  for (var i = 0, len = layout.length; i < len; i++) {
    bottomY = layout[i].y + layout[i].h;
    if (bottomY > max) max = bottomY;
  }

  return max;
}
function cloneLayout(layout) {
  var newLayout = Array(layout.length);

  for (var i = 0, len = layout.length; i < len; i++) {
    newLayout[i] = cloneLayoutItem(layout[i]);
  }

  return newLayout;
}
function cloneLayoutItem(layoutItem) {
  return JSON.parse(JSON.stringify(layoutItem));
}
function collides(l1, l2) {
  if (l1 === l2) return false;
  if (l1.x + l1.w <= l2.x) return false;
  if (l1.x >= l2.x + l2.w) return false;
  if (l1.y + l1.h <= l2.y) return false;
  if (l1.y >= l2.y + l2.h) return false;
  return true;
}
function utils_compact(layout, verticalCompact) {
  var compareWith = getStatics(layout);
  var sorted = sortLayoutItemsByRowCol(layout);
  var out = Array(layout.length);

  for (var i = 0, len = sorted.length; i < len; i++) {
    var l = sorted[i];

    if (!l['static']) {
      l = compactItem(compareWith, l, verticalCompact);
      compareWith.push(l);
    }

    out[layout.indexOf(l)] = l;
    l.moved = false;
  }

  return out;
}
function compactItem(compareWith, l, verticalCompact) {
  if (verticalCompact) {
    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
      l.y--;
    }
  }

  var collides;

  while (collides = getFirstCollision(compareWith, l)) {
    l.y = collides.y + collides.h;
  }

  return l;
}
function correctBounds(layout, bounds) {
  var collidesWith = getStatics(layout);

  for (var i = 0, len = layout.length; i < len; i++) {
    var l = layout[i];
    if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;

    if (l.x < 0) {
      l.x = 0;
      l.w = bounds.cols;
    }

    if (!l['static']) collidesWith.push(l);else {
      while (getFirstCollision(collidesWith, l)) {
        l.y++;
      }
    }
  }

  return layout;
}
function getLayoutItem(layout, id) {
  for (var i = 0, len = layout.length; i < len; i++) {
    if (layout[i].i === id) return layout[i];
  }
}
function getFirstCollision(layout, layoutItem) {
  for (var i = 0, len = layout.length; i < len; i++) {
    if (collides(layout[i], layoutItem)) return layout[i];
  }
}
function getAllCollisions(layout, layoutItem) {
  return layout.filter(function (l) {
    return collides(l, layoutItem);
  });
}
function getStatics(layout) {
  return layout.filter(function (l) {
    return l['static'];
  });
}
function moveElement(layout, l, x, y, isUserAction) {
  if (l['static']) return layout;
  var movingUp = y && l.y > y;
  if (typeof x === 'number') l.x = x;
  if (typeof y === 'number') l.y = y;
  l.moved = true;
  var sorted = sortLayoutItemsByRowCol(layout);
  if (movingUp) sorted = sorted.reverse();
  var collisions = getAllCollisions(sorted, l);

  for (var i = 0, len = collisions.length; i < len; i++) {
    var collision = collisions[i];
    if (collision.moved) continue;
    if (l.y > collision.y && l.y - collision.y > collision.h / 4) continue;

    if (collision['static']) {
      layout = moveElementAwayFromCollision(layout, collision, l, isUserAction);
    } else {
      layout = moveElementAwayFromCollision(layout, l, collision, isUserAction);
    }
  }

  return layout;
}
function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction) {
  if (isUserAction) {
    var fakeItem = {
      x: itemToMove.x,
      y: itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: '-1'
    };
    fakeItem.y = Math.max(collidesWith.y - itemToMove.h, 0);

    if (!getFirstCollision(layout, fakeItem)) {
      return moveElement(layout, itemToMove, undefined, fakeItem.y);
    }
  }

  return moveElement(layout, itemToMove, undefined, itemToMove.y + 1);
}
function perc(num) {
  return num * 100 + '%';
}
function setTransform(top, left, width, height) {
  var translate = 'translate3d(' + left + 'px,' + top + 'px, 0)';
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}
function setTransformRtl(top, right, width, height) {
  var translate = 'translate3d(' + right * -1 + 'px,' + top + 'px, 0)';
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}
function setTopLeft(top, left, width, height) {
  return {
    top: top + 'px',
    left: left + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}
function setTopRight(top, right, width, height) {
  return {
    top: top + 'px',
    right: right + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}
function sortLayoutItemsByRowCol(layout) {
  return [].concat(layout).sort(function (a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    }

    return -1;
  });
}
function validateLayout(layout, contextName) {
  contextName = contextName || 'Layout';
  var subProps = ['x', 'y', 'w', 'h'];

  if (!Array.isArray(layout)) {
    throw new Error(contextName + ' must be an array!');
  }

  for (var i = 0, len = layout.length; i < len; i++) {
    var item = layout[i];

    for (var j = 0; j < subProps.length; j++) {
      if (typeof item[subProps[j]] !== 'number') {
        throw new Error('VueGridLayout: ' + contextName + '[' + i + '].' + subProps[j] + ' must be a number!');
      }
    }

    if (item.i && typeof item.i !== 'string') {}

    if (item['static'] !== undefined && typeof item['static'] !== 'boolean') {
      throw new Error('VueGridLayout: ' + contextName + '[' + i + '].static must be a boolean!');
    }
  }
}
function autoBindHandlers(el, fns) {
  fns.forEach(function (key) {
    return el[key] = el[key].bind(el);
  });
}
function createMarkup(obj) {
  var keys = Object.keys(obj);
  if (!keys.length) return '';
  var i;
  var len = keys.length;
  var result = '';

  for (i = 0; i < len; i++) {
    var key = keys[i];
    var val = obj[key];
    result += hyphenate(key) + ':' + addPx(key, val) + ';';
  }

  return result;
}
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};
function addPx(name, value) {
  if (typeof value === 'number' && !IS_UNITLESS[name]) {
    return value + 'px';
  } else {
    return value;
  }
}
var hyphenateRE = /([a-z\d])([A-Z])/g;
function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').toLowerCase();
}
function findItemInArray(array, property, value) {
  for (var i = 0; i < array.length; i++) {
    if (array[i][property] === value) return true;
  }

  return false;
}
function findAndRemove(array, property, value) {
  array.forEach(function (result, index) {
    if (result[property] === value) {
      array.splice(index, 1);
    }
  });
}
// CONCATENATED MODULE: ./src/helpers/draggableUtils.ts
var getControlPosition = function getControlPosition(e) {
  return offsetXYFromParentOf(e);
};
var offsetXYFromParentOf = function offsetXYFromParentOf(evt) {
  var offsetParent = evt.target.offsetParent || document.body;
  var offsetParentRect = evt.offsetParent === document.body ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
  return {
    x: x,
    y: y
  };
};
var createCoreData = function createCoreData(lastX, lastY, x, y) {
  var isStart = !isNum(lastX);

  if (isStart) {
    return {
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    return {
      deltaX: x - lastX,
      deltaY: y - lastY,
      lastX: lastX,
      lastY: lastY,
      x: x,
      y: y
    };
  }
};

function isNum(num) {
  return typeof num === 'number' && !isNaN(num);
}
// CONCATENATED MODULE: ./src/helpers/DOM.ts
var currentDir = 'auto';

function hasDocument() {
  return typeof document !== 'undefined';
}

function hasWindow() {
  return typeof window !== 'undefined';
}

function getDocumentDir() {
  if (!hasDocument()) {
    return currentDir;
  }

  var direction = typeof document.dir !== 'undefined' ? document.dir : document.getElementsByTagName('html')[0].getAttribute('dir');
  return direction;
}
function setDocumentDir(dir) {
  if (!hasDocument) {
    currentDir = dir;
    return;
  }

  var html = document.getElementsByTagName('html')[0];
  html.setAttribute('dir', dir);
}
function addWindowEventListener(evtName, callback) {
  if (!hasWindow) {
    callback();
    return;
  }

  window.addEventListener(evtName, callback);
}
function removeWindowEventListener(evtName, callback) {
  if (!hasWindow) {
    return;
  }

  window.removeEventListener(evtName, callback);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid-layout/GridItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //    var eventBus = require('./eventBus');

/* harmony default export */ var GridItemvue_type_script_lang_js_ = ({
  name: 'GridItem',
  props: {
    /* cols: {
             type: Number,
             required: true
             }, */

    /* containerWidth: {
             type: Number,
             required: true
              },
             rowHeight: {
             type: Number,
             required: true
             },
             margin: {
             type: Array,
             required: true
             },
             maxRows: {
             type: Number,
             required: true
             }, */
    isDraggable: {
      type: Boolean,
      required: false,
      default: null
    },
    isResizable: {
      type: Boolean,
      required: false,
      default: null
    },
    isPlaceholder: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      type: Number
    },

    /* useCssTransforms: {
            type: Boolean,
            required: true
            },
             */
    static: {
      type: Boolean,
      required: false,
      default: false
    },
    minH: {
      type: Number,
      required: false,
      default: 1
    },
    minW: {
      type: Number,
      required: false,
      default: 1
    },
    maxH: {
      type: Number,
      required: false,
      default: Infinity
    },
    maxW: {
      type: Number,
      required: false,
      default: Infinity
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
    w: {
      type: Number,
      required: true
    },
    h: {
      type: Number,
      required: true
    },
    i: {
      type: [Number, String],
      required: true
    },
    dragIgnoreFrom: {
      type: String,
      required: false,
      default: 'a, button'
    },
    dragAllowFrom: {
      type: String,
      required: false,
      default: null
    },
    resizeIgnoreFrom: {
      type: String,
      required: false,
      default: 'a, button'
    },
    handles: {
      type: Array,
      default: function _default() {
        return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
      },
      validator: function validator(val) {
        var s = new Set(['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml']);
        return new Set(val.filter(function (h) {
          return s.has(h);
        })).size === val.length;
      }
    },
    handleActive: {
      type: Boolean,
      default: false
    }
  },
  inject: ['eventBus'],
  data: function data() {
    return {
      cols: 1,
      containerWidth: 100,
      rowHeight: 30,
      margin: [10, 10],
      maxRows: Infinity,
      draggable: null,
      resizable: null,
      useCssTransforms: true,
      isDragging: false,
      dragging: null,
      isResizing: false,
      resizing: null,
      lastX: NaN,
      lastY: NaN,
      lastW: NaN,
      lastH: NaN,
      style: {},
      rtl: false,
      dragEventSet: false,
      resizeEventSet: false,
      previousW: null,
      previousH: null,
      previousX: null,
      previousY: null,
      innerX: this.x,
      innerY: this.y,
      innerW: this.w,
      innerH: this.h,
      activeResize: false
    };
  },
  computed: {
    gridItemPrefixCls: function gridItemPrefixCls() {
      var prefixCls = {
        'vue-resizable': this.resizableAndNotStatic,
        static: this.static,
        resizing: this.isResizing,
        'vue-draggable-dragging': this.isDragging,
        cssTransforms: this.useCssTransforms,
        'render-rtl': this.renderRtl,
        'disable-userselect': this.isDragging,
        'no-touch': this.isAndroid,
        'active-resize': this.draggable && (this.activeResize || this.handleActive)
      };

      if (this.classes.length) {
        this.classes.forEach(function (className) {
          prefixCls[className] = true;
        });
      }

      return prefixCls;
    },
    resizableAndNotStatic: function resizableAndNotStatic() {
      return this.resizable && !this.static;
    },
    isAndroid: function isAndroid() {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('android') !== -1;
    },
    renderRtl: function renderRtl() {
      return this.$parent.isMirrored ? !this.rtl : this.rtl;
    },
    resizableHandleClass: function resizableHandleClass() {
      if (this.renderRtl) {
        return 'vue-resizable-handle vue-rtl-resizable-handle';
      } else {
        return 'vue-resizable-handle';
      }
    }
  },
  watch: {
    isDraggable: function isDraggable() {
      this.draggable = this.isDraggable;
    },
    static: function _static() {
      this.tryMakeDraggable();
      this.tryMakeResizable();
    },
    draggable: function draggable() {
      this.tryMakeDraggable();
    },
    isResizable: function isResizable() {
      this.resizable = this.isResizable;
    },
    resizable: function resizable() {
      this.tryMakeResizable();
    },
    rowHeight: function rowHeight() {
      this.createStyle();
    },
    cols: function cols() {
      this.tryMakeResizable();
      this.createStyle();
    },
    containerWidth: function containerWidth() {
      this.tryMakeResizable();
      this.createStyle();
    },
    x: function x(newVal) {
      this.innerX = newVal;
      this.createStyle();
    },
    y: function y(newVal) {
      this.innerY = newVal;
      this.createStyle();
    },
    h: function h(newVal) {
      this.innerH = newVal;
      this.createStyle();
    },
    w: function w(newVal) {
      this.innerW = newVal;
      this.createStyle();
    },
    renderRtl: function renderRtl() {
      // console.log("### renderRtl");
      this.tryMakeResizable();
      this.createStyle();
    },
    handleActive: function handleActive() {}
  },
  created: function created() {
    var _this = this;

    var self = this; // Accessible refernces of functions for removing in beforeDestroy

    self.updateWidthHandler = function (width) {
      self.updateWidth(width);
    };

    self.compactHandler = function (layout) {
      self.compact(layout);
    };

    self.setDraggableHandler = function (isDraggable) {
      if (self.isDraggable === null) {
        self.draggable = isDraggable;
      }
    };

    self.setResizableHandler = function (isResizable) {
      if (self.isResizable === null) {
        self.resizable = isResizable;
      }
    };

    self.setRowHeightHandler = function (rowHeight) {
      self.rowHeight = rowHeight;
    };

    self.directionchangeHandler = function () {
      _this.rtl = getDocumentDir() === 'rtl';

      _this.compact();
    };

    self.setColNum = function (colNum) {
      self.cols = parseInt(colNum);
    };

    this.eventBus.$on('updateWidth', self.updateWidthHandler);
    this.eventBus.$on('compact', self.compactHandler);
    this.eventBus.$on('setDraggable', self.setDraggableHandler);
    this.eventBus.$on('setResizable', self.setResizableHandler);
    this.eventBus.$on('setRowHeight', self.setRowHeightHandler);
    this.eventBus.$on('directionchange', self.directionchangeHandler);
    this.eventBus.$on('setColNum', self.setColNum);
    this.rtl = getDocumentDir() === 'rtl';
  },
  beforeDestroy: function beforeDestroy() {
    var self = this; // Remove listeners

    this.eventBus.$off('updateWidth', self.updateWidthHandler);
    this.eventBus.$off('compact', self.compactHandler);
    this.eventBus.$off('setDraggable', self.setDraggableHandler);
    this.eventBus.$off('setResizable', self.setResizableHandler);
    this.eventBus.$off('setRowHeight', self.setRowHeightHandler);
    this.eventBus.$off('directionchange', self.directionchangeHandler);
    this.eventBus.$off('setColNum', self.setColNum);
    this.interactObj.unset(); // destroy interact intance
  },
  mounted: function mounted() {
    this.cols = this.$parent.colNum;
    this.rowHeight = this.$parent.rowHeight;
    this.containerWidth = this.$parent.width !== null ? this.$parent.width : 100;
    this.margin = this.$parent.margin !== undefined ? this.$parent.margin : [10, 10];
    this.maxRows = this.$parent.maxRows;

    if (this.isDraggable === null) {
      this.draggable = this.$parent.isDraggable;
    } else {
      this.draggable = this.isDraggable;
    }

    if (this.isResizable === null) {
      this.resizable = this.$parent.isResizable;
    } else {
      this.resizable = this.isResizable;
    }

    this.useCssTransforms = this.$parent.useCssTransforms;
    this.createStyle();
  },
  methods: {
    createStyle: function createStyle() {
      if (this.x + this.w > this.cols) {
        this.innerX = 0;
        this.innerW = this.w > this.cols ? this.cols : this.w;
      } else {
        this.innerX = this.x;
        this.innerW = this.w;
      }

      var pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);

      if (this.isDragging) {
        pos.top = this.dragging.top; //                    Add rtl support

        if (this.renderRtl) {
          pos.right = this.dragging.left;
        } else {
          pos.left = this.dragging.left;
        }
      }

      if (this.isResizing) {
        pos.width = this.resizing.width;
        pos.height = this.resizing.height;
      }

      var style; // CSS Transforms support (default)

      if (this.useCssTransforms) {
        //                    Add rtl support
        if (this.renderRtl) {
          style = setTransformRtl(pos.top, pos.right, pos.width, pos.height);
        } else {
          style = setTransform(pos.top, pos.left, pos.width, pos.height);
        }
      } else {
        // top,left (slow)
        //                    Add rtl support
        if (this.renderRtl) {
          style = setTopRight(pos.top, pos.right, pos.width, pos.height);
        } else {
          style = setTopLeft(pos.top, pos.left, pos.width, pos.height);
        }
      }

      this.style = style;
    },
    handleResize: function handleResize(event) {
      if (this.static) return;
      var position = getControlPosition(event); // Get the current drag point from the event. This is used as the offset.

      if (position == null) return; // not possible but satisfies flow
      // 相对于父容器的鼠标x,y

      var x = position.x,
          y = position.y; // console.log('position',x,y);

      var newSize = {
        width: 0,
        height: 0
      };
      var pos;

      switch (event.type) {
        case 'resizestart':
          {
            this.previousW = this.innerW;
            this.previousH = this.innerH;
            pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
            newSize.width = pos.width;
            newSize.height = pos.height;
            this.resizing = newSize;
            this.isResizing = true;
            break;
          }

        case 'resizemove':
          {
            // console.log(event.edges);
            var leftOrTop = event.edges.left || event.edges.top;
            var coreEvent = leftOrTop ? createCoreData(this.lastW, this.lastH, x + event.deltaRect.left, y + event.deltaRect.top) : createCoreData(this.lastW, this.lastH, x, y);

            if (this.renderRtl) {
              newSize.width = this.resizing.width - coreEvent.deltaX;
            } else {
              newSize.width = this.resizing.width + coreEvent.deltaX;
            }

            newSize.height = this.resizing.height + coreEvent.deltaY; /// console.log("### resize => " + event.type + ", deltaX=" + coreEvent.deltaX + ", deltaY=" + coreEvent.deltaY);

            this.resizing = newSize;
            break;
          }

        case 'resizeend':
          {
            pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
            newSize.width = pos.width;
            newSize.height = pos.height; //                        console.log("### resize end => " + JSON.stringify(newSize));

            this.resizing = null;
            this.isResizing = false;
            break;
          }
      } // Get new WH


      pos = this.calcWH(newSize.height, newSize.width);

      if (pos.w < this.minW) {
        pos.w = this.minW;
      }

      if (pos.w > this.maxW) {
        pos.w = this.maxW;
      }

      if (pos.h < this.minH) {
        pos.h = this.minH;
      }

      if (pos.h > this.maxH) {
        pos.h = this.maxH;
      }

      if (pos.h < 1) {
        pos.h = 1;
      }

      if (pos.w < 1) {
        pos.w = 1;
      }

      this.lastW = x;
      this.lastH = y;

      if (this.innerW !== pos.w || this.innerH !== pos.h) {
        this.$emit('resize', this.i, pos.h, pos.w, newSize.height, newSize.width);
      }

      if (event.type === 'resizeend' && (this.previousW !== this.innerW || this.previousH !== this.innerH)) {
        this.$emit('resized', this.i, pos.h, pos.w, newSize.height, newSize.width);
      }

      this.eventBus.$emit('resizeEvent', event.type, this.i, this.innerX, this.innerY, pos.h, pos.w);
    },
    handleDrag: function handleDrag(event) {
      if (this.static) return;
      if (this.isResizing) return;
      var position = getControlPosition(event); // Get the current drag point from the event. This is used as the offset.

      if (position === null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // let shouldUpdate = false;

      var newPosition = {
        top: 0,
        left: 0
      };

      switch (event.type) {
        case 'dragstart':
          {
            this.previousX = this.innerX;
            this.previousY = this.innerY;
            var parentRect = event.target.offsetParent.getBoundingClientRect();
            var clientRect = event.target.getBoundingClientRect();

            if (this.renderRtl) {
              newPosition.left = (clientRect.right - parentRect.right) * -1;
            } else {
              newPosition.left = clientRect.left - parentRect.left;
            }

            newPosition.top = clientRect.top - parentRect.top;
            this.dragging = newPosition;
            this.isDragging = true;
            break;
          }

        case 'dragend':
          {
            if (!this.isDragging) return;

            var _parentRect = event.target.offsetParent.getBoundingClientRect();

            var _clientRect = event.target.getBoundingClientRect(); //                        Add rtl support


            if (this.renderRtl) {
              newPosition.left = (_clientRect.right - _parentRect.right) * -1;
            } else {
              newPosition.left = _clientRect.left - _parentRect.left;
            }

            newPosition.top = _clientRect.top - _parentRect.top; //                        console.log("### drag end => " + JSON.stringify(newPosition));
            //                        console.log("### DROP: " + JSON.stringify(newPosition));

            this.dragging = null;
            this.isDragging = false; // shouldUpdate = true;

            break;
          }

        case 'dragmove':
          {
            var coreEvent = createCoreData(this.lastX, this.lastY, x, y); //                        Add rtl support

            if (this.renderRtl) {
              newPosition.left = this.dragging.left - coreEvent.deltaX;
            } else {
              newPosition.left = this.dragging.left + coreEvent.deltaX;
            }

            newPosition.top = this.dragging.top + coreEvent.deltaY; // console.log("### drag => " + event.type + ", x=" + x + ", y=" + y);
            // console.log("### drag => " + event.type + ", deltaX=" + coreEvent.deltaX + ", deltaY=" + coreEvent.deltaY);
            //                        console.log("### drag end => " + JSON.stringify(newPosition));

            this.dragging = newPosition;
            break;
          }
      } // Get new XY


      var pos;
      pos = this.calcXY(newPosition.top, newPosition.left);
      this.lastX = x;
      this.lastY = y;

      if (this.innerX !== pos.x || this.innerY !== pos.y) {
        this.$emit('move', this.i, pos.x, pos.y);
      }

      if (event.type === 'dragend' && (this.previousX !== this.innerX || this.previousY !== this.innerY)) {
        this.$emit('moved', this.i, pos.x, pos.y);
      }

      this.eventBus.$emit('dragEvent', event.type, this.i, pos.x, pos.y, this.innerH, this.innerW);
    },
    calcPosition: function calcPosition(x, y, w, h) {
      var colWidth = this.calcColWidth(); // add rtl support

      var out;

      if (this.renderRtl) {
        out = {
          right: Math.round(colWidth * x + (x + 1) * this.margin[0]),
          top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
          // 0 * Infinity === NaN, which causes problems with resize constriants;
          // Fix this if it occurs.
          // Note we do it here rather than later because Math.round(Infinity) causes deopt
          width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * this.margin[0]),
          height: h === Infinity ? h : Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
        };
      } else {
        out = {
          left: Math.round(colWidth * x + (x + 1) * this.margin[0]),
          top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
          // 0 * Infinity === NaN, which causes problems with resize constriants;
          // Fix this if it occurs.
          // Note we do it here rather than later because Math.round(Infinity) causes deopt
          width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * this.margin[0]),
          height: h === Infinity ? h : Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
        };
      }

      return out;
    },

    /**
     * Translate x and y coordinates from pixels to grid units.
     * @param  {Number} top  Top position (relative to parent) in pixels.
     * @param  {Number} left Left position (relative to parent) in pixels.
     * @return {Object} x and y in grid units.
     */
    // TODO check if this function needs change in order to support rtl.
    calcXY: function calcXY(top, left) {
      var colWidth = this.calcColWidth(); // left = colWidth * x + margin * (x + 1)
      // l = cx + m(x+1)
      // l = cx + mx + m
      // l - m = cx + mx
      // l - m = x(c + m)
      // (l - m) / (c + m) = x
      // x = (left - margin) / (coldWidth + margin)

      var x = Math.round((left - this.margin[0]) / (colWidth + this.margin[0]));
      var y = Math.round((top - this.margin[1]) / (this.rowHeight + this.margin[1])); // Capping

      x = Math.max(Math.min(x, this.cols - this.innerW), 0);
      y = Math.max(Math.min(y, this.maxRows - this.innerH), 0);
      return {
        x: x,
        y: y
      };
    },
    // Helper for generating column width
    calcColWidth: function calcColWidth() {
      var colWidth = (this.containerWidth - this.margin[0] * (this.cols + 1)) / this.cols; // console.log("### COLS=" + this.cols + " COL WIDTH=" + colWidth + " MARGIN " + this.margin[0]);

      return colWidth;
    },

    /**
     * Given a height and width in pixel values, calculate grid units.
     * @param  {Number} height Height in pixels.
     * @param  {Number} width  Width in pixels.
     * @return {Object} w, h as grid units.
     */
    calcWH: function calcWH(height, width) {
      var colWidth = this.calcColWidth(); // width = colWidth * w - (margin * (w - 1))
      // ...
      // w = (width + margin) / (colWidth + margin)

      var w = Math.round((width + this.margin[0]) / (colWidth + this.margin[0]));
      var h = Math.round((height + this.margin[1]) / (this.rowHeight + this.margin[1])); // Capping

      w = Math.max(Math.min(w, this.cols - this.innerX), 0);
      h = Math.max(Math.min(h, this.maxRows - this.innerY), 0);
      return {
        w: w,
        h: h
      };
    },
    updateWidth: function updateWidth(width, colNum) {
      this.containerWidth = width;

      if (colNum !== undefined && colNum !== null) {
        this.cols = colNum;
      }
    },
    compact: function compact() {
      this.createStyle();
    },
    tryMakeDraggable: function tryMakeDraggable() {
      var self = this;

      if (this.interactObj === null || this.interactObj === undefined) {
        this.interactObj = external_interactjs_default()(this.$refs.item);
      }

      if (this.draggable && !this.static) {
        var opts = {
          ignoreFrom: this.dragIgnoreFrom,
          allowFrom: this.dragAllowFrom
        };
        this.interactObj.draggable(opts);
        /* this.interactObj.draggable({allowFrom: '.vue-draggable-handle'}); */

        if (!this.dragEventSet) {
          this.dragEventSet = true;
          this.interactObj.on('dragstart dragmove dragend', function (event) {
            self.handleDrag(event);
          });
        }
      } else {
        this.interactObj.draggable({
          enabled: false
        });
      }
    },
    tryMakeResizable: function tryMakeResizable() {
      var self = this;

      if (this.interactObj === null || this.interactObj === undefined) {
        // debugger;
        this.interactObj = external_interactjs_default()(this.$refs.item);
      }

      if (this.resizable && !this.static) {
        var maximum = this.calcPosition(0, 0, this.maxW, this.maxH);
        var minimum = this.calcPosition(0, 0, this.minW, this.minH); // console.log("### MAX " + JSON.stringify(maximum));
        // console.log("### MIN " + JSON.stringify(minimum));

        var opts = {
          preserveAspectRatio: true,
          // allowFrom: "." + this.resizableHandleClass,
          edges: {
            left: false,
            right: true,
            bottom: true,
            top: false
          },
          ignoreFrom: this.resizeIgnoreFrom,
          restrictSize: {
            min: {
              height: minimum.height,
              width: minimum.width
            },
            max: {
              height: maximum.height,
              width: maximum.width
            }
          }
        };
        this.interactObj.resizable(opts);

        if (!this.resizeEventSet) {
          this.resizeEventSet = true;
          this.interactObj.on('resizestart resizemove resizeend', function (event) {
            self.handleResize(event);
          });
        }
      } else {
        this.interactObj.resizable({
          enabled: false
        });
      }
    },
    autoSize: function autoSize() {
      // ok here we want to calculate if a resize is needed
      this.previousW = this.innerW;
      this.previousH = this.innerH;
      var newSize = this.$slots.default[0].elm.getBoundingClientRect();
      var pos = this.calcWH(newSize.height, newSize.width);

      if (pos.w < this.minW) {
        pos.w = this.minW;
      }

      if (pos.w > this.maxW) {
        pos.w = this.maxW;
      }

      if (pos.h < this.minH) {
        pos.h = this.minH;
      }

      if (pos.h > this.maxH) {
        pos.h = this.maxH;
      }

      if (pos.h < 1) {
        pos.h = 1;
      }

      if (pos.w < 1) {
        pos.w = 1;
      } // this.lastW = x; // basicly, this is copied from resizehandler, but shouldn't be needed
      // this.lastH = y;


      if (this.innerW !== pos.w || this.innerH !== pos.h) {
        this.$emit('resize', this.i, pos.h, pos.w, newSize.height, newSize.width);
      }

      if (this.previousW !== pos.w || this.previousH !== pos.h) {
        this.$emit('resized', this.i, pos.h, pos.w, newSize.height, newSize.width);
        this.eventBus.$emit('resizeEvent', 'resizeend', this.i, this.innerX, this.innerY, pos.h, pos.w);
      }
    },
    focusItem: function focusItem() {
      this.activeResize = true;
      this.$emit('focus');
    },
    blurItem: function blurItem() {
      this.activeResize = false;
      this.$emit('blur');
    }
  }
});
// CONCATENATED MODULE: ./src/components/grid-layout/GridItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var grid_layout_GridItemvue_type_script_lang_js_ = (GridItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/grid-layout/GridItem.vue?vue&type=style&index=0&lang=less&
var GridItemvue_type_style_index_0_lang_less_ = __webpack_require__(106);

// CONCATENATED MODULE: ./src/components/grid-layout/GridItem.vue






/* normalize component */

var GridItem_component = normalizeComponent(
  grid_layout_GridItemvue_type_script_lang_js_,
  GridItemvue_type_template_id_85469632_render,
  GridItemvue_type_template_id_85469632_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var GridItem_api; }
GridItem_component.options.__file = "src/components/grid-layout/GridItem.vue"
/* harmony default export */ var GridItem = (GridItem_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid-layout/GridLayout.vue?vue&type=template&id=95c9db04&
var GridLayoutvue_type_template_id_95c9db04_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "item", staticClass: "vue-grid-layout", style: _vm.mergedStyle },
    [
      _vm.showGridLine
        ? _c("div", {
            staticClass: "vue-grid-layout--mask",
            style: _vm.maskStyle
          })
        : _vm._e(),
      _vm._t("default"),
      _c("grid-item", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isDragging,
            expression: "isDragging"
          }
        ],
        staticClass: "vue-grid-placeholder",
        attrs: {
          isPlaceholder: true,
          x: _vm.placeholder.x,
          y: _vm.placeholder.y,
          w: _vm.placeholder.w,
          h: _vm.placeholder.h,
          i: _vm.placeholder.i
        }
      })
    ],
    2
  )
}
var GridLayoutvue_type_template_id_95c9db04_staticRenderFns = []
GridLayoutvue_type_template_id_95c9db04_render._withStripped = true


// CONCATENATED MODULE: ./src/components/grid-layout/GridLayout.vue?vue&type=template&id=95c9db04&

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(79);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: external "element-resize-detector"
var external_element_resize_detector_ = __webpack_require__(94);
var external_element_resize_detector_default = /*#__PURE__*/__webpack_require__.n(external_element_resize_detector_);

// CONCATENATED MODULE: ./src/helpers/responsiveUtils.ts

function getBreakpointFromWidth(breakpoints, width) {
  var sorted = sortBreakpoints(breakpoints);
  var matching = sorted[0];

  for (var i = 1, len = sorted.length; i < len; i++) {
    var breakpointName = sorted[i];
    if (width > breakpoints[breakpointName]) matching = breakpointName;
  }

  return matching;
}
function getColsFromBreakpoint(breakpoint, cols) {
  if (!cols[breakpoint]) {
    throw new Error('ResponsiveGridLayout: `cols` entry for breakpoint ' + breakpoint + ' is missing!');
  }

  return cols[breakpoint];
}
function findOrGenerateResponsiveLayout(orgLayout, layouts, breakpoints, breakpoint, lastBreakpoint, cols, verticalCompact) {
  if (layouts[breakpoint]) return cloneLayout(layouts[breakpoint]);
  var layout = orgLayout;
  var breakpointsSorted = sortBreakpoints(breakpoints);
  var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));

  for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
    var b = breakpointsAbove[i];

    if (layouts[b]) {
      layout = layouts[b];
      break;
    }
  }

  layout = cloneLayout(layout || []);
  return utils_compact(correctBounds(layout, {
    cols: cols
  }), verticalCompact);
}
function generateResponsiveLayout(layout, breakpoints, breakpoint, lastBreakpoint, cols, verticalCompact) {
  var layoutCloned = cloneLayout(layout || []);
  return utils_compact(correctBounds(layoutCloned, {
    cols: cols
  }), verticalCompact);
}
function sortBreakpoints(breakpoints) {
  var keys = Object.keys(breakpoints);
  return keys.sort(function (a, b) {
    return breakpoints[a] - breakpoints[b];
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid-layout/GridLayout.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // var eventBus = require('./eventBus');


/* harmony default export */ var GridLayoutvue_type_script_lang_js_ = ({
  name: 'GridLayout',
  provide: function provide() {
    return {
      eventBus: null
    };
  },
  components: {
    GridItem: GridItem
  },
  props: {
    // If true, the container height swells and contracts to fit contents
    showGridLine: {
      type: Boolean,
      default: true
    },
    gridLineColor: {
      type: String,
      default: '#F3F5F8'
    },
    gridBlockColor: {
      type: String,
      default: '#E8EAEF'
    },
    autoSize: {
      type: Boolean,
      default: true
    },
    colNum: {
      type: Number,
      default: 12
    },
    rowHeight: {
      type: Number,
      default: 150
    },
    maxRows: {
      type: Number,
      default: Infinity
    },
    margin: {
      type: Array,
      default: function _default() {
        return [10, 10];
      }
    },
    isDraggable: {
      type: Boolean,
      default: true
    },
    isResizable: {
      type: Boolean,
      default: true
    },
    isMirrored: {
      type: Boolean,
      default: false
    },
    useCssTransforms: {
      type: Boolean,
      default: true
    },
    verticalCompact: {
      type: Boolean,
      default: true
    },
    layout: {
      type: Array,
      required: true
    },
    responsive: {
      type: Boolean,
      default: false
    },
    breakpoints: {
      type: Object,
      default: function _default() {
        return {
          lg: 1200,
          md: 996,
          sm: 768,
          xs: 480,
          xxs: 0
        };
      }
    },
    cols: {
      type: Object,
      default: function _default() {
        return {
          lg: 12,
          md: 10,
          sm: 6,
          xs: 4,
          xxs: 2
        };
      }
    },
    reserveHeight: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      width: null,
      mergedStyle: {},
      lastLayoutLength: 0,
      isDragging: false,
      placeholder: {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        i: -1
      },
      layouts: {},
      // array to store all layouts from different breakpoints
      lastBreakpoint: null,
      // store last active breakpoint
      originalLayout: null // store original Layout

    };
  },
  computed: {
    maskStyle: function maskStyle() {
      return {
        right: this.margin[0] + "px",
        background: "" + this.gridBlockColor,
        'background-image': "linear-gradient(" + this.gridLineColor + " " + this.margin[1] + "px, transparent 0),\n                                    linear-gradient(to right," + this.gridLineColor + " " + this.margin[0] + "px, transparent 0)",
        'background-size': (1 / this.colNum * 100).toFixed(2) + "% " + (this.margin[1] + this.rowHeight) + "px"
      };
    }
  },
  watch: {
    width: function width() {
      this.$nextTick(function () {
        // this.$broadcast("updateWidth", this.width);
        this.eventBus.$emit('updateWidth', this.width);
        this.updateHeight();
      });
    },
    layout: function layout() {
      this.layoutUpdate();
    },
    colNum: function colNum(val) {
      this.eventBus.$emit('setColNum', val);
    },
    rowHeight: function rowHeight() {
      this.eventBus.$emit('setRowHeight', this.rowHeight);
    },
    isDraggable: function isDraggable() {
      this.eventBus.$emit('setDraggable', this.isDraggable);
    },
    isResizable: function isResizable() {
      this.eventBus.$emit('setResizable', this.isResizable);
    },
    responsive: function responsive() {
      if (!this.responsive) {
        this.$emit('update:layout', this.originalLayout);
        this.eventBus.$emit('setColNum', this.colNum);
      }

      this.onWindowResize();
    }
  },
  created: function created() {
    var self = this; // Accessible refernces of functions for removing in beforeDestroy

    self.resizeEventHandler = function (eventType, i, x, y, h, w) {
      self.resizeEvent(eventType, i, x, y, h, w);
    };

    self.dragEventHandler = function (eventType, i, x, y, h, w) {
      self.dragEvent(eventType, i, x, y, h, w);
    };

    self._provided.eventBus = new external_vue_default.a();
    self.eventBus = self._provided.eventBus;
    self.eventBus.$on('resizeEvent', self.resizeEventHandler);
    self.eventBus.$on('dragEvent', self.dragEventHandler);
    self.$emit('layout-created', self.layout);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove listeners
    this.eventBus.$off('resizeEvent', this.resizeEventHandler);
    this.eventBus.$off('dragEvent', this.dragEventHandler);
    this.eventBus.$destroy();
    removeWindowEventListener('resize', this.onWindowResize);
    this.erd.uninstall(this.$refs.item);
  },
  beforeMount: function beforeMount() {
    this.$emit('layout-before-mount', this.layout);
  },
  mounted: function mounted() {
    this.$emit('layout-mounted', this.layout);
    this.$nextTick(function () {
      validateLayout(this.layout);
      this.originalLayout = this.layout;
      var self = this;
      this.$nextTick(function () {
        if (self.width === null) {
          self.onWindowResize();
          self.initResponsiveFeatures(); // self.width = self.$el.offsetWidth;

          addWindowEventListener('resize', self.onWindowResize);
        }

        utils_compact(self.layout, self.verticalCompact);

        self.updateHeight();
        self.$nextTick(function () {
          this.erd = external_element_resize_detector_default()({
            strategy: 'scroll' // <- For ultra performance.

          });
          this.erd.listenTo(self.$refs.item, function () {
            self.onWindowResize();
          });
        });
        self.$emit('layout-ready', self.layout);
      });
    });
  },
  methods: {
    compact: function compact() {
      utils_compact(this.layout, this.verticalCompact);
    },
    layoutUpdate: function layoutUpdate() {
      if (this.layout !== undefined && this.originalLayout !== null) {
        if (this.layout.length !== this.originalLayout.length) {
          // console.log("### LAYOUT UPDATE!", this.layout.length, this.originalLayout.length);
          var diff = this.findDifference(this.layout, this.originalLayout);

          if (diff.length > 0) {
            // console.log(diff);
            if (this.layout.length > this.originalLayout.length) {
              this.originalLayout = this.originalLayout.concat(diff);
            } else {
              this.originalLayout = this.originalLayout.filter(function (obj) {
                return !diff.some(function (obj2) {
                  return obj.i === obj2.i;
                });
              });
            }
          }

          this.lastLayoutLength = this.layout.length;
          this.initResponsiveFeatures();
        }

        utils_compact(this.layout, this.verticalCompact);

        this.eventBus.$emit('updateWidth', this.width);
        this.updateHeight();
      }
    },
    updateHeight: function updateHeight() {
      this.mergedStyle = {
        height: this.containerHeight()
      };
    },
    onWindowResize: function onWindowResize() {
      if (this.$refs !== null && this.$refs.item !== null && this.$refs.item !== undefined) {
        this.width = this.$refs.item.offsetWidth;
      }

      this.eventBus.$emit('resizeEvent');
    },
    containerHeight: function containerHeight() {
      if (!this.autoSize) return;
      return bottom(this.layout) * (this.rowHeight + this.margin[1]) + this.margin[1] + this.reserveHeight + 'px';
    },
    dragEvent: function dragEvent(eventName, id, x, y, h, w) {
      // console.log(eventName + " id=" + id + ", x=" + x + ", y=" + y);
      var l = getLayoutItem(this.layout, id); // GetLayoutItem sometimes returns null object

      if (l === undefined || l === null) {
        l = {
          x: 0,
          y: 0
        };
      }

      if (eventName === 'dragmove' || eventName === 'dragstart') {
        this.placeholder.i = id;
        this.placeholder.x = l.x;
        this.placeholder.y = l.y;
        this.placeholder.w = w;
        this.placeholder.h = h;
        this.$nextTick(function () {
          this.isDragging = true;
        }); // this.$broadcast("updateWidth", this.width);

        this.eventBus.$emit('updateWidth', this.width);
      } else {
        this.$nextTick(function () {
          this.isDragging = false;
        });
      } // set layout element coordinates to dragged position


      l.x = x;
      l.y = y; // Move the element to the dragged location.

      this.layout = moveElement(this.layout, l, x, y, true);

      utils_compact(this.layout, this.verticalCompact); // needed because vue can't detect changes on array element properties


      this.eventBus.$emit('compact');
      this.updateHeight();
      if (eventName === 'dragend') this.$emit('layout-updated', this.layout);
    },
    resizeEvent: function resizeEvent(eventName, id, x, y, h, w) {
      if (eventName === 'resizestart' || eventName === 'resizemove') {
        this.placeholder.i = id;
        this.placeholder.x = x;
        this.placeholder.y = y;
        this.placeholder.w = w;
        this.placeholder.h = h;
        this.$nextTick(function () {
          this.isDragging = true;
        }); // this.$broadcast("updateWidth", this.width);

        this.eventBus.$emit('updateWidth', this.width);
      } else {
        this.$nextTick(function () {
          this.isDragging = false;
        });
      }

      var l = getLayoutItem(this.layout, id); // GetLayoutItem sometimes return null object

      if (l === undefined || l === null) {
        l = {
          h: 0,
          w: 0
        };
      }

      l.h = h;
      l.w = w;
      if (this.responsive) this.responsiveGridLayout();

      utils_compact(this.layout, this.verticalCompact);

      this.eventBus.$emit('compact');
      this.updateHeight();
      if (eventName === 'resizeend') this.$emit('layout-updated', this.layout);
    },
    // finds or generates new layouts for set breakpoints
    responsiveGridLayout: function responsiveGridLayout() {
      var newBreakpoint = getBreakpointFromWidth(this.breakpoints, this.width);
      var newCols = getColsFromBreakpoint(newBreakpoint, this.cols); // save actual layout in layouts

      if (this.lastBreakpoint != null && !this.layouts[this.lastBreakpoint]) {
        this.layouts[this.lastBreakpoint] = cloneLayout(this.layout);
      } // Find or generate a new layout.


      var layout = findOrGenerateResponsiveLayout(this.originalLayout, this.layouts, this.breakpoints, newBreakpoint, this.lastBreakpoint, newCols, this.verticalCompact); // Store the new layout.

      this.layouts[newBreakpoint] = layout; // new prop sync

      this.$emit('update:layout', layout);
      this.lastBreakpoint = newBreakpoint;
      this.eventBus.$emit('setColNum', getColsFromBreakpoint(newBreakpoint, this.cols));
    },
    // clear all responsive layouts
    initResponsiveFeatures: function initResponsiveFeatures() {
      // clear layouts
      this.layouts = {};
    },
    // find difference in layouts
    findDifference: function findDifference(layout, originalLayout) {
      // Find values that are in result1 but not in result2
      var uniqueResultOne = layout.filter(function (obj) {
        return !originalLayout.some(function (obj2) {
          return obj.i === obj2.i;
        });
      }); // Find values that are in result2 but not in result1

      var uniqueResultTwo = originalLayout.filter(function (obj) {
        return !layout.some(function (obj2) {
          return obj.i === obj2.i;
        });
      }); // Combine the two arrays of unique entries#

      return uniqueResultOne.concat(uniqueResultTwo);
    },
    // compact(this.layout, this.verticalCompact);
    handleCompact: function handleCompact(layout, verticalCompact) {
      utils_compact(layout, verticalCompact);
    }
  }
});
// CONCATENATED MODULE: ./src/components/grid-layout/GridLayout.vue?vue&type=script&lang=js&
 /* harmony default export */ var grid_layout_GridLayoutvue_type_script_lang_js_ = (GridLayoutvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/grid-layout/GridLayout.vue





/* normalize component */

var GridLayout_component = normalizeComponent(
  grid_layout_GridLayoutvue_type_script_lang_js_,
  GridLayoutvue_type_template_id_95c9db04_render,
  GridLayoutvue_type_template_id_95c9db04_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var GridLayout_api; }
GridLayout_component.options.__file = "src/components/grid-layout/GridLayout.vue"
/* harmony default export */ var GridLayout = (GridLayout_component.exports);
// CONCATENATED MODULE: ./src/components/grid-layout/index.js


GridLayout.Item = GridItem;

GridLayout.install = function (Vue) {
  Vue.component('H3GridLayout', GridLayout);
  Vue.component('H3GridItem', GridItem);
};

/* harmony default export */ var grid_layout = (GridLayout);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/spin/style"
var spin_style_ = __webpack_require__(52);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/spin"
var spin_ = __webpack_require__(15);
var spin_default = /*#__PURE__*/__webpack_require__.n(spin_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading.vue?vue&type=template&id=d960adee&
var loadingvue_type_template_id_d960adee_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h3-loading__content" }, [
    _c("div", { staticClass: "h3-loading__item h3-loading__square" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
            _c("path", {
              attrs: {
                d:
                  "M14.06 48.44l15.88-15.88a1.5 1.5 0 0 0 0-2.12L14.06 14.56a1.5 1.5 0 0 0-2.56 1.061V47.38a1.5 1.5 0 0 0 2.56 1.06z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M35.349 30.651l7.302-7.302a1.2 1.2 0 0 1 1.698 0l7.302 7.302a1.2 1.2 0 0 1 0 1.698L44.35 39.65a1.2 1.2 0 0 1-1.698 0L35.35 32.35a1.2 1.2 0 0 1 0-1.698z",
                fill: "#F37E3B"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M31.468 34.032l-6.26 6.26A1 1 0 0 0 25.913 42H39.49a1 1 0 0 0 .688-1.726l-6.618-6.27a1.5 1.5 0 0 0-2.092.028z",
                fill: "#393299"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M15.914 52h15.672a1 1 0 0 0 .707-.293l6-6A1 1 0 0 0 37.586 44H21.914a1 1 0 0 0-.707.293l-6 6A1 1 0 0 0 15.914 52z",
                fill: "#00CAFD"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M37.914 52H52a1 1 0 0 0 1-1V36.914a1 1 0 0 0-1.707-.707L37.207 50.293A1 1 0 0 0 37.914 52z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M17.19 11h30.62a1.5 1.5 0 0 1 1.046 2.575L33.546 28.48a1.5 1.5 0 0 1-2.092 0l-15.31-14.906A1.5 1.5 0 0 1 17.191 11z",
                fill: "#4338FF"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M53 15.397v10.826a1.2 1.2 0 0 1-2.022.874l-5.577-5.25a1.2 1.2 0 0 1-.026-1.722l5.576-5.576a1.2 1.2 0 0 1 2.049.848z",
                fill: "#FFC522"
              }
            })
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "h3-loading__item h3-loading__sailboat" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
            _c("path", {
              attrs: {
                d:
                  "M9.707 41.793l20.086-20.086a1 1 0 0 1 1.707.707V42.5a1 1 0 0 1-1 1H10.414a1 1 0 0 1-.707-1.707z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M9.69 45.5h7.11a.7.7 0 0 1 .7.7v7.11a.7.7 0 0 1-1.195.495l-7.11-7.11A.7.7 0 0 1 9.69 45.5z",
                fill: "#393299"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M21 45.5h9.5a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z",
                fill: "#F37E3B"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M34.8 45.5h7.269a.8.8 0 0 1 .565 1.366l-7.268 7.268A.8.8 0 0 1 34 53.57V46.3a.8.8 0 0 1 .8-.8z",
                fill: "#FFC522"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M47.414 45.5h7.172a1 1 0 0 1 .707 1.707l-9 9a1 1 0 0 1-.707.293h-7.172a1 1 0 0 1-.707-1.707l9-9a1 1 0 0 1 .707-.293z",
                fill: "#00CAFD"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M35 43.5h19.622a1 1 0 0 0 .715-1.7L35.715 21.753a1 1 0 0 0-1.715.7V42.5a1 1 0 0 0 1 1z",
                fill: "#4338FF"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M35.066 16.434l8.068-8.068a.8.8 0 0 1 1.366.565V25.07a.8.8 0 0 1-1.366.565l-8.068-8.068a.8.8 0 0 1 0-1.132z",
                fill: "#468CFB"
              }
            })
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "h3-loading__item h3-loading__windmill" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
            _c("path", {
              attrs: {
                d:
                  "M37 23.3V5.162a.7.7 0 0 0-1.189-.501l-18.58 18.138A.7.7 0 0 0 17.718 24H36.3a.7.7 0 0 0 .7-.7z",
                fill: "#4338FF"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M15 26h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z",
                fill: "#F37E3B"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M40 37h17.086a1 1 0 0 0 .707-1.707L40.707 18.207a1 1 0 0 0-1.707.707V36a1 1 0 0 0 1 1z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M2.69 26H11a1 1 0 0 1 1 1v8.31a.7.7 0 0 1-1.195.495l-8.61-8.61A.7.7 0 0 1 2.69 26z",
                fill: "#FFC522"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M17.19 39h17.62a.7.7 0 0 1 .495 1.195l-8.598 8.598a1 1 0 0 1-1.414 0l-8.598-8.598A.7.7 0 0 1 17.19 39z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M40 39h7.81a.7.7 0 0 1 .495 1.195l-8.11 8.11A.7.7 0 0 1 39 47.81V40a1 1 0 0 1 1-1z",
                fill: "#393299"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M37 42.745v9.474a.7.7 0 0 1-.194.484l-9.6 10.036A.7.7 0 0 1 26 62.255v-9.474a.7.7 0 0 1 .194-.484l9.6-10.036a.7.7 0 0 1 1.206.484z",
                fill: "#00CAFD"
              }
            })
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "h3-loading__item h3-loading__rocket" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
            _c("path", {
              attrs: {
                d:
                  "M22.3 14h19.955a.7.7 0 0 0 .484-1.206l-9.765-9.34a.7.7 0 0 0-.957-.011l-10.19 9.341A.7.7 0 0 0 22.3 14z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M32.005 44.495l-7.51 7.51a.7.7 0 0 0 0 .99l7.51 7.51a.7.7 0 0 0 .99 0l7.51-7.51a.7.7 0 0 0 0-.99l-7.51-7.51a.7.7 0 0 0-.99 0z",
                fill: "#F37E3B"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M20.2 16.5h22.11a.7.7 0 0 1 .495 1.195l-22.11 22.11a.7.7 0 0 1-1.195-.495V17.2a.7.7 0 0 1 .7-.7z",
                fill: "#4338FF"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M9.995 33.005l5.81-5.81A.7.7 0 0 1 17 27.69v11.62a.7.7 0 0 1-1.195.495l-5.81-5.81a.7.7 0 0 1 0-.99z",
                fill: "#FFC522"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M10.195 37.695l5.793 5.793a.7.7 0 0 1-.018 1.006l-5.792 5.407A.7.7 0 0 1 9 49.389v-11.2a.7.7 0 0 1 1.195-.494z",
                fill: "#393299"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M45.5 41.8V20.19a.7.7 0 0 0-1.195-.495l-21.61 21.61a.7.7 0 0 0 .495 1.195H44.8a.7.7 0 0 0 .7-.7z",
                fill: "#468CFB"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M48 27.19v15.02a.7.7 0 0 0 .205.495l6.6 6.6A.7.7 0 0 0 56 48.81V33.79a.7.7 0 0 0-.205-.495l-6.6-6.6A.7.7 0 0 0 48 27.19z",
                fill: "#00CAFD"
              }
            })
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "h3-loading__shadow" })
  ])
}
var loadingvue_type_template_id_d960adee_staticRenderFns = []
loadingvue_type_template_id_d960adee_render._withStripped = true


// CONCATENATED MODULE: ./src/components/loading/loading.vue?vue&type=template&id=d960adee&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  name: 'H3LoadingContent'
});
// CONCATENATED MODULE: ./src/components/loading/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var loading_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/loading/loading.vue?vue&type=style&index=0&lang=less&
var loadingvue_type_style_index_0_lang_less_ = __webpack_require__(107);

// CONCATENATED MODULE: ./src/components/loading/loading.vue






/* normalize component */

var loading_component = normalizeComponent(
  loading_loadingvue_type_script_lang_js_,
  loadingvue_type_template_id_d960adee_render,
  loadingvue_type_template_id_d960adee_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var loading_api; }
loading_component.options.__file = "src/components/loading/loading.vue"
/* harmony default export */ var loading = (loading_component.exports);
// CONCATENATED MODULE: ./src/components/loading/loading.js



function loading_extends() { loading_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loading_extends.apply(this, arguments); }

// import { convertSlotChildren } from '@authine/awesome-ui/src/utils/vnode';


/* harmony default export */ var loading_loading = ({
  name: 'H3Loading',
  functional: true,
  inheritAttrs: false,
  props: loading_extends({}, spin_default.a.props, {
    loading: {
      type: Boolean,
      default: true
    }
  }),
  render: function render(h, _ref) {
    var data = _ref.data,
        slots = _ref.slots,
        _ref$props = _ref.props,
        props = _ref$props === void 0 ? {} : _ref$props;
    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-loading' : 'h3-loading';

    if ('loading' in props) {
      props.spinning = props.loading;
      delete props.loading;
    }

    if ('tip' in props) {
      props.tip = props.tip || '努力加载中...';
    }

    return h(spin_default.a, loading_extends({
      props: props
    }, data), [slots().default, h(loading, {
      slot: 'indicator'
    })]);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading-icon/loading-icon.vue?vue&type=template&id=8504be08&
var loading_iconvue_type_template_id_8504be08_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var loading_iconvue_type_template_id_8504be08_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "h3-loading-icon" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
loading_iconvue_type_template_id_8504be08_render._withStripped = true


// CONCATENATED MODULE: ./src/components/loading/loading-icon/loading-icon.vue?vue&type=template&id=8504be08&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading-icon/loading-icon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var loading_iconvue_type_script_lang_js_ = ({
  name: 'H3LoadingIcon'
});
// CONCATENATED MODULE: ./src/components/loading/loading-icon/loading-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var loading_icon_loading_iconvue_type_script_lang_js_ = (loading_iconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/loading/loading-icon/loading-icon.vue?vue&type=style&index=0&lang=less&
var loading_iconvue_type_style_index_0_lang_less_ = __webpack_require__(108);

// CONCATENATED MODULE: ./src/components/loading/loading-icon/loading-icon.vue






/* normalize component */

var loading_icon_component = normalizeComponent(
  loading_icon_loading_iconvue_type_script_lang_js_,
  loading_iconvue_type_template_id_8504be08_render,
  loading_iconvue_type_template_id_8504be08_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var loading_icon_api; }
loading_icon_component.options.__file = "src/components/loading/loading-icon/loading-icon.vue"
/* harmony default export */ var loading_icon = (loading_icon_component.exports);
// CONCATENATED MODULE: ./src/components/loading/loading-icon/loading.js



function loading_icon_loading_extends() { loading_icon_loading_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loading_icon_loading_extends.apply(this, arguments); }


/* harmony default export */ var loading_icon_loading = ({
  name: 'H3LoadingIcon',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        slots = _ref.slots,
        props = _ref.props;
    data.staticClass = data.staticClass ? data.staticClass + ' h3-loading' : 'h3-loading';

    if (props) {
      if ('loading' in props) {
        props.spinning = props.loading;
        delete props.loading;
      }

      if ('tip' in props) {
        props.tip = props.tip || '努力加载中...';
      }
    }

    return h(spin_default.a, loading_icon_loading_extends({
      props: props
    }, data), [slots().default, h(loading_icon, {
      slot: 'indicator'
    }, [])]);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading-spin/loading-spin.vue?vue&type=template&id=3e1f00c8&scoped=true&
var loading_spinvue_type_template_id_3e1f00c8_scoped_true_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h3-loading-spin" })
}
var loading_spinvue_type_template_id_3e1f00c8_scoped_true_staticRenderFns = []
loading_spinvue_type_template_id_3e1f00c8_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./src/components/loading/loading-spin/loading-spin.vue?vue&type=template&id=3e1f00c8&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading/loading-spin/loading-spin.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var loading_spinvue_type_script_lang_js_ = ({
  name: 'H3LoadingSpin'
});
// CONCATENATED MODULE: ./src/components/loading/loading-spin/loading-spin.vue?vue&type=script&lang=js&
 /* harmony default export */ var loading_spin_loading_spinvue_type_script_lang_js_ = (loading_spinvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/loading/loading-spin/loading-spin.vue?vue&type=style&index=0&id=3e1f00c8&lang=less&scoped=true&
var loading_spinvue_type_style_index_0_id_3e1f00c8_lang_less_scoped_true_ = __webpack_require__(109);

// CONCATENATED MODULE: ./src/components/loading/loading-spin/loading-spin.vue






/* normalize component */

var loading_spin_component = normalizeComponent(
  loading_spin_loading_spinvue_type_script_lang_js_,
  loading_spinvue_type_template_id_3e1f00c8_scoped_true_render,
  loading_spinvue_type_template_id_3e1f00c8_scoped_true_staticRenderFns,
  false,
  null,
  "3e1f00c8",
  null
  
)

/* hot reload */
if (false) { var loading_spin_api; }
loading_spin_component.options.__file = "src/components/loading/loading-spin/loading-spin.vue"
/* harmony default export */ var loading_spin = (loading_spin_component.exports);
// CONCATENATED MODULE: ./src/components/loading/loading-spin/loading-spin.js



function loading_spin_extends() { loading_spin_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loading_spin_extends.apply(this, arguments); }


/* harmony default export */ var loading_spin_loading_spin = ({
  name: 'H3LoadingSpin',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        slots = _ref.slots,
        props = _ref.props;
    data.staticClass = data.staticClass ? data.staticClass + 'h3-loading h3-spin' : 'h3-loading h3-spin';

    if (props) {
      if ('loading' in props) {
        props.spinning = props.loading;
        delete props.loading;
      }

      if ('tip' in props) {
        props.tip = props.tip || '';
      }
    }

    return h(spin_default.a, loading_spin_extends({
      props: props
    }, data), [slots().default, h(loading_spin, {
      slot: 'indicator'
    }, [])]);
  }
});
// CONCATENATED MODULE: ./src/components/loading/index.js




loading_loading.install = function (Vue) {
  Vue.component(loading_loading.name, loading_loading);
  Vue.component('H3Spin', loading_spin_loading_spin);
  Vue.component('H3LoadingIcon', loading_icon_loading);
};

loading_loading.Spin = loading_spin_loading_spin;
loading_loading.Icon = loading_icon_loading;
/* harmony default export */ var components_loading = (loading_loading);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/list-view/index.vue?vue&type=template&id=266f9417&
var list_viewvue_type_template_id_266f9417_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "viewport",
      staticClass: "h3-list-view",
      on: { scroll: _vm._fireScroll }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visibleData.length > 0,
              expression: "visibleData.length > 0"
            }
          ],
          staticClass: "h3-list-view__phantom",
          style: {
            height: _vm.contentHeight + "px"
          }
        },
        [
          _c(
            "div",
            { ref: "content", staticClass: "h3-list-view__content" },
            _vm._l(_vm.visibleData, function(wrappedItem) {
              return _c(
                "div",
                {
                  key: wrappedItem.key,
                  staticClass: "h3-list-view__item",
                  style: {
                    minHeight: _vm.minHeight + "px"
                  },
                  attrs: { "data-key": wrappedItem.key }
                },
                [
                  _vm._t("item", null, {
                    index: wrappedItem.key,
                    item: wrappedItem.data
                  })
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visibleData.length === 0,
              expression: "visibleData.length === 0"
            }
          ],
          staticClass: "h3-list-view__tips"
        },
        [_vm._t("tips")],
        2
      )
    ]
  )
}
var list_viewvue_type_template_id_266f9417_staticRenderFns = []
list_viewvue_type_template_id_266f9417_render._withStripped = true


// CONCATENATED MODULE: ./src/components/list-view/index.vue?vue&type=template&id=266f9417&

// EXTERNAL MODULE: external "lodash/forEach"
var forEach_ = __webpack_require__(8);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach_);

// EXTERNAL MODULE: external "lodash/map"
var map_ = __webpack_require__(13);
var map_default = /*#__PURE__*/__webpack_require__.n(map_);

// EXTERNAL MODULE: external "lodash/filter"
var filter_ = __webpack_require__(29);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter_);

// EXTERNAL MODULE: external "lodash/reduce"
var reduce_ = __webpack_require__(25);
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce_);

// EXTERNAL MODULE: external "lodash/uniqWith"
var uniqWith_ = __webpack_require__(95);
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith_);

// CONCATENATED MODULE: ./src/components/list-view/avl.ts
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SLIGHTLY_UNBALANCED_RIGHT = -1;
var SLIGHTLY_UNBALANCED_LEFT = 1;
var UNBALANCED_RIGHT = -2;
var UNBALANCED_LEFT = 2;

var AvlNode = /*#__PURE__*/function () {
  function AvlNode(key) {
    this.key = void 0;
    this.left = void 0;
    this.right = void 0;
    this.parent = void 0;
    this._height = void 0;
    this._prevHeight = void 0;
    this.key = key;
    this.left = null;
    this.right = null;
    this.parent = null;
    this._height = 0;
    this._prevHeight = 0;
  }

  var _proto = AvlNode.prototype;

  _proto.updateHeight = function updateHeight() {
    var leftHeight = this.leftHeight,
        rightHeight = this.rightHeight;
    var height = (leftHeight > rightHeight ? leftHeight : rightHeight) + 1 | 0;
    this.height = height;
  };

  _createClass(AvlNode, [{
    key: "prevHeight",
    get: function get() {
      return this._prevHeight | 0;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height | 0;
    },
    set: function set(value) {
      this._prevHeight = this._height | 0;
      this._height = value | 0;
    }
  }, {
    key: "leftHeight",
    get: function get() {
      if (this.left === null) return -1;
      return this.left.height | 0;
    }
  }, {
    key: "rightHeight",
    get: function get() {
      if (this.right === null) return -1;
      return this.right.height | 0;
    }
  }, {
    key: "balanceFactor",
    get: function get() {
      return this.leftHeight - this.rightHeight;
    }
  }]);

  return AvlNode;
}();

var Avl = /*#__PURE__*/function () {
  function Avl() {
    this._root = void 0;
    this._size = void 0;
    this._root = null;
    this._size = 0;
  }

  var _proto2 = Avl.prototype;

  _proto2.insert = function insert(key) {
    var node = new AvlNode(key);

    var insertPoint = this._nodeInsert(node);

    if (insertPoint == null) return;

    this._adjustAfterInsertion(insertPoint);
  };

  _proto2.delete = function _delete(key) {
    var targetNode = this._nodeSearch(key);

    if (targetNode == null) return false;

    var backtracking = this._nodeErase(targetNode);

    var parent = backtracking[0];

    if (parent !== null) {
      this._adjustAfterRemoval(parent);
    }

    return true;
  };

  _proto2.search = function search(key) {
    var node = this._nodeSearch(key);

    if (node !== null) return node.key;
    return null;
  };

  _proto2.searchRange = function searchRange(start, end) {
    var results = [];
    var root = this._root;

    while (root !== null) {
      var result1 = start.compareTo(root.key);
      var result2 = end.compareTo(root.key);

      if (result1 > 0) {
        root = root.right;
        continue;
      }

      if (result2 < 0) {
        root = root.left;
        continue;
      }

      break;
    }

    if (!root) return results;
    var stack = [];
    var current = root;

    while (stack.length || current) {
      while (current) {
        stack.push(current);
        if (start.compareTo(current.key) > 0) break;
        current = current.left;
      }

      if (stack.length) {
        current = stack[stack.length - 1];
        var gteStart = start.compareTo(current.key) <= 0;
        var lteEnd = end.compareTo(current.key) >= 0;

        if (gteStart && lteEnd) {
          results.push(current.key);
        }

        stack.pop();

        if (lteEnd) {
          current = current.right;
        } else {
          current = null;
        }
      }
    }

    return results;
  };

  _proto2._increaseSize = function _increaseSize() {
    this._size += 1;
  };

  _proto2._decreaseSize = function _decreaseSize() {
    this._size -= 1;
  };

  _proto2._setLeft = function _setLeft(node, child) {
    if (node.left !== null) {
      node.left.parent = null;
    }

    if (child !== null) {
      if (child.parent !== null) {
        child.parent.left === child ? child.parent.left = null : child.parent.right = null;
      }

      child.parent = node;
    }

    node.left = child;
  };

  _proto2._setRight = function _setRight(node, child) {
    if (node.right !== null) {
      node.right.parent = null;
    }

    if (child !== null) {
      if (child.parent !== null) {
        child.parent.left === child ? child.parent.left = null : child.parent.right = null;
      }

      child.parent = node;
    }

    node.right = child;
  };

  _proto2._inorderPredecessor = function _inorderPredecessor(node) {
    var _node = node;
    if (_node == null) return null;

    if (_node.left !== null) {
      return this._maximumNode(_node.left);
    }

    var parent = _node.parent;

    while (parent != null) {
      if (_node === parent.right) {
        return parent;
      }

      _node = parent;
      parent = _node.parent;
    }

    return null;
  };

  _proto2._maximumNode = function _maximumNode(subRoot) {
    var current = subRoot;

    while (current.right !== null) {
      current = current.right;
    }

    return current;
  };

  _proto2._setRoot = function _setRoot(node) {
    if (node === null) {
      this._root = null;
      return;
    }

    this._root = node;

    if (node.parent !== null) {
      node.parent.left === node ? node.parent.left = null : node.parent.right = null;
      node.parent = null;
    }
  };

  _proto2._replaceNode = function _replaceNode(node, replacer) {
    if (node === replacer) return node;

    if (node === this._root) {
      this._setRoot(replacer);
    } else {
      var parent = node.parent;
      if (parent.left === node) this._setLeft(parent, replacer);else this._setRight(parent, replacer);
    }

    return node;
  };

  _proto2._rotateLeft = function _rotateLeft(node) {
    var parent = node.parent;
    var isLeft = parent !== null && parent.left === node;
    var pivot = node.right;
    var pivotLeft = pivot.left;

    this._setRight(node, pivotLeft);

    this._setLeft(pivot, node);

    if (parent !== null) {
      if (isLeft) this._setLeft(parent, pivot);else this._setRight(parent, pivot);
    }

    if (node === this._root) {
      this._setRoot(pivot);
    }

    node.updateHeight();
    pivot.updateHeight();
    return pivot;
  };

  _proto2._rotateRight = function _rotateRight(node) {
    var parent = node.parent;
    var isLeft = parent !== null && parent.left === node;
    var pivot = node.left;
    var pivotRight = pivot.right;

    this._setLeft(node, pivotRight);

    this._setRight(pivot, node);

    if (parent !== null) {
      if (isLeft) this._setLeft(parent, pivot);else this._setRight(parent, pivot);
    }

    if (node === this._root) {
      this._setRoot(pivot);
    }

    node.updateHeight();
    pivot.updateHeight();
    return pivot;
  };

  _proto2._nodeSearch = function _nodeSearch(key) {
    var current = this._root;

    while (current !== null) {
      var result = key.compareTo(current.key);
      if (result === 0) return current;
      if (result < 0) current = current.left;else current = current.right;
    }

    return null;
  };

  _proto2._nodeInsert = function _nodeInsert(node) {
    if (this._root === null) {
      this._setRoot(node);

      this._increaseSize();

      return null;
    }

    var key = node.key;
    var current = this._root;

    while (true) {
      var result = key.compareTo(current.key);

      if (result > 0) {
        if (current.right === null) {
          this._setRight(current, node);

          this._increaseSize();

          return current;
        }

        current = current.right;
      } else if (result < 0) {
        if (current.left === null) {
          this._setLeft(current, node);

          this._increaseSize();

          return current;
        }

        current = current.left;
      } else {
        current.key = key;
        return null;
      }
    }
  };

  _proto2._nodeErase = function _nodeErase(node) {
    var _node = node;

    if (_node.left !== null && _node.right !== null) {
      var replacer = this._inorderPredecessor(_node);

      _node.key = replacer.key;
      _node = replacer;
    }

    var parent = _node.parent;
    var child = _node.left || _node.right;

    this._replaceNode(_node, child);

    this._decreaseSize();

    return [parent, child, _node];
  };

  _proto2._adjustAfterInsertion = function _adjustAfterInsertion(backtracking) {
    var current = backtracking;

    while (current !== null) {
      current.updateHeight();
      if (current.height === current.prevHeight) break;

      if (this._isUnbalanced(current)) {
        this._rebalance(current);

        break;
      }

      current = current.parent;
    }
  };

  _proto2._adjustAfterRemoval = function _adjustAfterRemoval(backtracking) {
    var current = backtracking;

    while (current !== null) {
      current.updateHeight();
      if (current.height === current.prevHeight) break;

      if (this._isUnbalanced(current)) {
        this._rebalance(current);
      }

      current = current.parent;
    }
  };

  _proto2._adjustLeftLeft = function _adjustLeftLeft(node) {
    return this._rotateRight(node);
  };

  _proto2._adjustRightRight = function _adjustRightRight(node) {
    return this._rotateLeft(node);
  };

  _proto2._adjustLeftRight = function _adjustLeftRight(node) {
    this._rotateLeft(node.left);

    return this._rotateRight(node);
  };

  _proto2._adjustRightLeft = function _adjustRightLeft(node) {
    this._rotateRight(node.right);

    return this._rotateLeft(node);
  };

  _proto2._isUnbalanced = function _isUnbalanced(node) {
    var factor = node.balanceFactor;
    return factor === UNBALANCED_RIGHT || factor === UNBALANCED_LEFT;
  };

  _proto2._rebalance = function _rebalance(node) {
    var factor = node.balanceFactor;

    if (factor === UNBALANCED_RIGHT) {
      var right = node.right;

      if (right.balanceFactor === SLIGHTLY_UNBALANCED_LEFT) {
        return this._adjustRightLeft(node);
      } else {
        return this._adjustRightRight(node);
      }
    } else if (factor === UNBALANCED_LEFT) {
      var left = node.left;

      if (left.balanceFactor === SLIGHTLY_UNBALANCED_RIGHT) {
        return this._adjustLeftRight(node);
      } else {
        return this._adjustLeftLeft(node);
      }
    }

    return node;
  };

  _createClass(Avl, [{
    key: "size",
    get: function get() {
      return this._size;
    }
  }]);

  return Avl;
}();
function createAvl() {
  return new Avl();
}

var Range = /*#__PURE__*/function () {
  function Range(start, end) {
    this.start = void 0;
    this.end = void 0;
    this.start = start;
    this.end = end || start;
  }

  var _proto3 = Range.prototype;

  _proto3.compareTo = function compareTo(other) {
    if (other.start > this.end) return -1;
    if (other.end < this.start) return 1;
    return 0;
  };

  return Range;
}();

var RangeValue = /*#__PURE__*/function (_Range) {
  _inheritsLoose(RangeValue, _Range);

  function RangeValue(start, end, value) {
    var _this;

    _this = _Range.call(this, start, end) || this;
    _this.value = void 0;
    _this.value = value;
    return _this;
  }

  var _proto4 = RangeValue.prototype;

  _proto4.clone = function clone() {
    return new RangeValue(this.start, this.end, this.value);
  };

  return RangeValue;
}(Range);

var SparseRangeList = /*#__PURE__*/function () {
  function SparseRangeList(size, defaultValue) {
    this._size = void 0;
    this.defaultValue = void 0;
    this.valueTree = void 0;
    this._size = size;
    this.defaultValue = defaultValue;
    this.valueTree = createAvl();
  }

  var _proto5 = SparseRangeList.prototype;

  _proto5.resize = function resize(newSize) {
    var _newSize = newSize | 0;

    if (this._size === _newSize) return;

    if (this._size < _newSize) {
      this._size = _newSize;
      return;
    }

    this.setRangeValue(_newSize - 1, this._size - 1, this.defaultValue);
    this._size = _newSize;
  };

  _proto5.remove = function remove(index, size) {
    var _this2 = this;

    if (size === void 0) {
      size = 1;
    }

    var _size = isNaN(size) || (size | 0) <= 0 ? 1 : size | 0;

    var start = isNaN(index) || index >= this._size ? this._size - 1 : index | 0;
    var end = Math.min(start + _size - 1, this._size - 1);
    _size = end - start + 1;
    var rangeValues = this.treeIntersecting(0, this._size - 1);
    var removeRange = new Range(start, end);
    rangeValues.forEach(function (range) {
      var result = removeRange.compareTo(range);

      if (result > 0) {
        return;
      }

      _this2.valueTree.delete(range);

      if (result < 0) {
        _this2._insert(range.start - _size, range.end - _size, range.value);
      } else {
        if (range.start >= removeRange.start && range.end <= removeRange.end) {
          return;
        }

        var beforeRemoveStart = range.start;
        var beforeRemoveEnd = removeRange.start - 1;
        var before = beforeRemoveEnd >= beforeRemoveStart;
        var afterRemoveStart = removeRange.end + 1 - _size;
        var afterRemoveEnd = range.end - _size;
        var after = afterRemoveEnd >= afterRemoveStart;

        if (before && after) {
          _this2._insert(beforeRemoveStart, afterRemoveEnd, range.value);

          return;
        }

        before && _this2._insert(beforeRemoveStart, beforeRemoveEnd, range.value);
        after && _this2._insert(afterRemoveStart, afterRemoveEnd, range.value);
      }
    });
    this._size = this._size - _size;
  };

  _proto5.add = function add(index, size) {
    var _this3 = this;

    if (size === void 0) {
      size = 1;
    }

    var _size = isNaN(size) || (size | 0) <= 0 ? 1 : size | 0;

    var start = isNaN(index) ? this._size - 1 : index | 0;
    var rangeValues = this.treeIntersecting(0, this._size - 1);
    var addRange = new Range(start, start);
    rangeValues.forEach(function (range) {
      var result = addRange.compareTo(range);

      if (result > 0) {
        return;
      }

      _this3.valueTree.delete(range);

      if (result < 0) {
        _this3._insert(range.start + _size, range.end + _size, range.value);
      } else {
        if (range.start === addRange.start) {
          _this3._insert(range.start + _size, range.end + _size, range.value);

          return;
        }

        _this3._insert(range.start, addRange.start - 1, range.value);

        _this3._insert(addRange.start + _size, range.end + _size, range.value);
      }
    });
    this._size = this._size + _size;
  };

  _proto5.getValueAt = function getValueAt(index) {
    var result = this.valueTree.search(new Range(index));
    if (result) return result.value;
    return this.defaultValue;
  };

  _proto5.setRangeValue = function setRangeValue(start, end, value) {
    if (!this._size) return;
    var _start = start;

    var _end = end >= this._size - 1 ? this._size - 1 : end;

    var prevSiblingEnd = _start - 1;
    var nextSiblingStart = _end + 1;
    var rangeValues = this.treeIntersecting(prevSiblingEnd, nextSiblingStart);

    if (rangeValues.length) {
      var firstRange = rangeValues[0];
      var lastRange = rangeValues[rangeValues.length - 1];

      if (firstRange.end < _start) {
        if (firstRange.value !== value) {
          rangeValues.shift();
        } else {
          _start = firstRange.start;
        }
      }

      if (lastRange.start > _end) {
        if (lastRange.value !== value) {
          rangeValues.pop();
        } else {
          _end = lastRange.end;
        }
      }

      var length = rangeValues.length;
      var index = 0;

      while (index < length) {
        var currentRangeValue = rangeValues[index];
        var currentValue = currentRangeValue.value,
            currentStart = currentRangeValue.start,
            currentEnd = currentRangeValue.end;
        this.valueTree.delete(currentRangeValue);

        if (currentStart >= _start && currentEnd <= _end) {
          index += 1;
          continue;
        }

        if (currentStart < _start) {
          if (currentValue !== value) {
            this._insert(currentStart, _start - 1, currentValue);
          } else {
            _start = currentStart;
          }
        }

        if (currentEnd > _end) {
          if (currentValue !== value) {
            this._insert(_end + 1, currentEnd, currentValue);
          } else {
            _end = currentEnd;
          }
        }

        index += 1;
      }
    }

    this._insert(_start, _end, value);
  };

  _proto5.setValue = function setValue(index, value) {
    this.setRangeValue(index, index, value);
  };

  _proto5.treeIntersecting = function treeIntersecting(start, end) {
    var startRange = new Range(start);
    var endRange = new Range(end);
    return this.valueTree.searchRange(startRange, endRange);
  };

  _proto5.intersecting = function intersecting(start, end) {
    var _start = start;
    var _end = end;
    var ranges = this.treeIntersecting(_start, _end);

    if (!ranges.length) {
      if (!this._size) return [];
      return [new RangeValue(_start, _end, this.defaultValue)];
    }

    var result = [];
    var range;
    var index = 0;
    var length = ranges.length;

    while (index < length) {
      range = ranges[index].clone();

      if (range.start > _start) {
        result.push(new RangeValue(_start, range.start - 1, this.defaultValue));
      }

      result.push(range);
      _start = range.end + 1;
      index += 1;

      if (index === length) {
        if (range.end < _end) {
          result.push(new RangeValue(range.end + 1, _end, this.defaultValue));
        } else if (range.end > _end) {
          range.end = _end;
        }
      }
    }

    return result;
  };

  _proto5.values = function values() {
    if (!this._size) return [];
    return this.intersecting(0, this._size - 1);
  };

  _proto5._insert = function _insert(start, end, value) {
    if (value !== this.defaultValue) {
      var rangeValue = new RangeValue(start, end, value);
      this.valueTree.insert(rangeValue);
    }
  };

  _createClass(SparseRangeList, [{
    key: "size",
    get: function get() {
      return this._size;
    }
  }]);

  return SparseRangeList;
}();


function create(size, value) {
  return new SparseRangeList(size, value);
}
// EXTERNAL MODULE: external "big.js"
var external_big_js_ = __webpack_require__(9);
var external_big_js_default = /*#__PURE__*/__webpack_require__.n(external_big_js_);

// CONCATENATED MODULE: ./src/components/list-view/animation.ts

var AnimateFrame = /*#__PURE__*/function () {
  function AnimateFrame() {
    this.timer = void 0;
  }

  var _proto = AnimateFrame.prototype;

  _proto.start = function start(fn) {
    this.timer = requestAnimationFrame(function (time) {
      fn(time);
    });
  };

  _proto.stop = function stop() {
    if (this.timer) {
      cancelAnimationFrame(this.timer);
      this.timer = null;
    }
  };

  return AnimateFrame;
}();
var animation_CubicBezier = /*#__PURE__*/function () {
  function CubicBezier(a, b, c, d) {
    this.px1 = void 0;
    this.px2 = void 0;
    this.px3 = void 0;
    this.py1 = void 0;
    this.py2 = void 0;
    this.py3 = void 0;
    external_big_js_default.a.DP = 21;
    this.px3 = external_big_js_default()(a).times(3);
    this.px2 = external_big_js_default()(c).minus(a).times(3).minus(this.px3);
    this.px1 = external_big_js_default()(1).minus(this.px3).minus(this.px2);
    this.py3 = external_big_js_default()(b).times(3);
    this.py2 = external_big_js_default()(d).minus(b).times(3).minus(this.py3);
    this.py1 = external_big_js_default()(1).minus(this.py3).minus(this.py2);
  }

  var _proto2 = CubicBezier.prototype;

  _proto2.getX = function getX(t) {
    return this.px1.times(t).plus(this.px2).times(t).plus(this.px3).times(t);
  };

  _proto2.getY = function getY(t) {
    return this.py1.times(t).plus(this.py2).times(t).plus(this.py3).times(t);
  };

  _proto2.solve = function solve(t) {
    if (t === 0 || t === 1) {
      return Number(this.getY(t).toFixed(2));
    }

    var _t = external_big_js_default()(t);

    for (var i = 0; i < 8; i++) {
      var g = this.getX(_t).minus(t);

      if (g.abs().lt(1e-7)) {
        break;
      }

      var d = this.px1.times(3).times(_t).plus(this.px2.times(2)).times(_t).plus(this.px3);

      if (d.abs().lt(1e-6)) {
        break;
      }

      _t = _t.minus(g.div(d));
    }

    return Number(this.getY(_t).toFixed(2));
  };

  return CubicBezier;
}();
// CONCATENATED MODULE: ./src/components/list-view/item-wrapper.ts
var ItemWrapper = function ItemWrapper(data, key, height) {
  this.data = void 0;
  this.key = void 0;
  this.height = void 0;
  this.data = data;
  this.key = key;
  this.height = height >> 0;
};
// EXTERNAL MODULE: external "resize-observer-polyfill"
var external_resize_observer_polyfill_ = __webpack_require__(96);
var external_resize_observer_polyfill_default = /*#__PURE__*/__webpack_require__.n(external_resize_observer_polyfill_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/list-view/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-reserved-keys */










/* harmony default export */ var list_viewvue_type_script_lang_js_ = ({
  name: 'H3ListView',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    minHeight: {
      type: Number,
      default: 30
    },
    estimatedHeight: {
      type: Number
    },
    alias: {
      type: Object,
      default: function _default() {
        return {
          visible: 'visible'
        };
      }
    },
    fixedSize: {
      type: Boolean,
      default: true
    },
    virtual: {
      type: Boolean,
      default: true
    },
    visibleMonitor: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      $content: null,
      _itemHeightStore: null,
      _wrappedData: [],
      _visibleWrappedData: [],
      visibleData: [],
      contentHeight: 0,
      sliceFrom: 0,
      sliceTo: 0,
      animateFrame: null,
      _startTime: 0,
      _animateDistance: 0,
      _progress: 0,
      layoutObserver: null,
      itemsObserver: null,
      layoutVisibleObserver: null,
      childObserver: null
    };
  },
  computed: {
    visibleKey: function visibleKey() {
      return this.alias && this.alias.visible || 'visible';
    },
    innerEstimatedHeight: function innerEstimatedHeight() {
      return this.estimatedHeight || this.minHeight;
    }
  },
  watch: {
    list: {
      handler: function handler(nVal, oVal) {
        if (nVal !== oVal) {
          this._initial(nVal);

          this.redraw();
        }
      },
      deep: false,
      immediate: false
    }
  },
  created: function created() {
    var _this = this;

    this._initial(this.list);

    this.animateFrame = new AnimateFrame();
    this.layoutObserver = new MutationObserver(function () {
      _this.redraw();
    });
    this.itemsObserver = new external_resize_observer_polyfill_default.a(function (entrys) {
      var viewport = _this.$refs.viewport;
      var resizeNodes = entrys.map(function (entry) {
        return entry.target;
      });

      if (!viewport) {
        forEach_default()(resizeNodes, function (removedNode) {
          return _this.itemsObserver.unobserve(removedNode);
        });
        return;
      }

      _this._updateHeightWhenItemInserted(resizeNodes);
    });
    this.childObserver = new MutationObserver(function (mutations) {
      var addedNodes = reduce_default()(map_default()(mutations, function (mutation) {
        return mutation.addedNodes;
      }), function (result, items) {
        result.push.apply(result, items);
        return result;
      }, []);
      var removedNodes = reduce_default()(map_default()(mutations, function (mutation) {
        return mutation.removedNodes;
      }), function (result, items) {
        result.push.apply(result, items);
        return result;
      }, []);
      forEach_default()(addedNodes, function (addedNode) {
        return _this.itemsObserver.observe(addedNode);
      });
      forEach_default()(removedNodes, function (removedNode) {
        return _this.itemsObserver.unobserve(removedNode);
      });

      _this._updateHeightWhenItemInserted(addedNodes);
    });
    this.emitScroll = debounce_default()(function (evt) {
      _this._emitScroll(evt);
    }, 500, {
      leading: false,
      trailing: true
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.redraw();
    this.layoutVisibleObserver = new IntersectionObserver(function () {
      _this2.$nextTick(function () {
        _this2.redraw();
      });
    }, {
      root: this.$el
    });
    this.layoutObserver.observe(this.$el, {
      attributes: true
    }); // 非固定高度场景，监听子元素插入，提取高度

    if (!this.fixedSize) {
      this.childObserver.observe(this.$refs.content, {
        childList: true
      });
    }

    if (this.visibleMonitor) {
      this.layoutVisibleObserver.observe(this.$refs.content);
    }
  },
  beforeDestory: function beforeDestory() {
    this.itemsObserver.disconnect();
    this.layoutObserver.disconnect();
    this.childObserver.disconnect();
    this.layoutVisibleObserver.disconnect();
    this._itemHeightStore = null;
    this.animateFrame.stop();
  },
  methods: {
    redraw: function redraw() {
      var viewport = this.$refs.viewport;

      if (!viewport) {
        return;
      }

      this.viewportWidth = viewport.clientWidth;
      this.viewportHeight = viewport.clientHeight;

      this._updateSliceRange(true);

      this.updateContentHeight();
    },
    getList: function getList() {
      return map_default()(this._wrappedData, function (item) {
        return item.data;
      });
    },
    addItem: function addItem(items, index) {
      if (items === void 0) {
        items = [];
      }

      var start = isNaN(index) ? this._wrappedData.length : index;
      var size = items.length;

      if (!size) {
        return;
      }

      this._itemHeightStore.add(start, size);

      this._pushWrapedData(items, start, size);

      var keys = new Array(size).fill(1).map(function (_, _index) {
        return _index + start;
      });

      this._pushVisibleWrapedData(keys);

      this._updateSliceRange(true);

      if (!this.fixedSize) {
        var end = start + size - 1;
        var needUpdateItemHeight = !(end < this.sliceFrom || start > this.sliceTo);
        needUpdateItemHeight && this._updateHeightWhenItemInserted(Array.from(this.$refs.content.children), true);
      }

      this.updateContentHeight();
    },
    removeItem: function removeItem(index, size) {
      if (size === void 0) {
        size = 1;
      }

      var _index = isNaN(index) ? this._wrappedData.length - 1 : index;

      if (size < 1) {
        return;
      }

      this._itemHeightStore.remove(_index, size);

      var keys = new Array(size).fill(1).map(function (_, __index) {
        return __index + index;
      });

      this._popVisibleWrapedData(keys);

      this._popWrapedData(index, size);

      this._updateSliceRange(true);

      this.updateContentHeight();
    },
    showByKey: function showByKey(key) {
      var wrappedItem = this._wrappedData[key];
      if (!wrappedItem) return;

      if (wrappedItem.height <= 0) {
        var height = -wrappedItem.height || this.innerEstimatedHeight;

        this._updateHeight(wrappedItem, height);

        this._pushVisibleWrapedData([key]);

        this._updateSliceRange(true);

        this.updateContentHeight();
      }
    },
    // 通过数据 key，设置对应条目的显示状态
    hideByKey: function hideByKey(key) {
      var wrappedItem = this._wrappedData[key];
      if (!wrappedItem) return;

      if (wrappedItem.height > 0) {
        var height = -wrappedItem.height;
        wrappedItem.height = height;

        this._updateHeight(wrappedItem, height);

        this._popVisibleWrapedData([key]);

        this._updateSliceRange(true);

        this.updateContentHeight();
      }
    },
    // 通过数据 key 列表，设置对应条目的显示状态
    showByKeys: function showByKeys(keys) {
      var _this3 = this;

      var wrappedItems = filter_default()(map_default()(keys, function (key) {
        return _this3._wrappedData[key];
      }), function (wrappedItem) {
        return wrappedItem && wrappedItem.height <= 0;
      });
      forEach_default()(wrappedItems, function (wrappedItem) {
        var height = -wrappedItem.height || _this3.innerEstimatedHeight;

        _this3._updateHeight(wrappedItem, height);
      });

      this._pushVisibleWrapedData(keys);

      this._updateSliceRange(true);

      this.updateContentHeight();
    },
    // 通过数据 key 列表，设置对应条目的显示状态
    hideByKeys: function hideByKeys(keys) {
      var _this4 = this;

      var wrappedItems = filter_default()(map_default()(keys, function (key) {
        return _this4._wrappedData[key];
      }), function (wrappedItem) {
        return wrappedItem && wrappedItem.height > 0;
      });
      forEach_default()(wrappedItems, function (wrappedItem) {
        // 设置为负数，表示隐藏
        var height = -wrappedItem.height;
        wrappedItem.height = height;

        _this4._updateHeight(wrappedItem, height);
      });

      this._popVisibleWrapedData(keys); // 强制重绘


      this._updateSliceRange(true);

      this.updateContentHeight();
    },
    scrollToTop: function scrollToTop(animate) {
      this.scrollTo(0, animate);
    },
    scrollToBottom: function scrollToBottom(animate) {
      this.scrollTo(this.$refs.viewport.scrollHeight, animate);
    },
    scrollTo: function scrollTo(distance, animate) {
      this.animateFrame.stop();

      var _distance = Math.max(Math.min(this.$refs.viewport.scrollHeight, distance), 0);

      if (animate) {
        this._scrollBeforeAnimate(_distance);
      } else {
        this.$refs.viewport.scrollTop = _distance;
      }
    },
    _scrollBeforeAnimate: function _scrollBeforeAnimate(distance) {
      this._startScrollTop = this.$refs.viewport.scrollTop;
      this._animateDistance = distance - this._startScrollTop;

      if (Math.abs(this._animateDistance) <= 30) {
        this.$refs.viewport.scrollTop = distance;
        return;
      }

      var scrollMaxDistance = this.viewportHeight * 3;

      if (Math.abs(this._animateDistance) > scrollMaxDistance) {
        var direction = this._animateDistance > 0 ? 1 : -1;
        var extraDistance = (Math.abs(this._animateDistance) - scrollMaxDistance) * direction;
        this._startScrollTop = this._startScrollTop + extraDistance;
        this.$refs.viewport.scrollTop = this._startScrollTop;
        this._animateDistance = scrollMaxDistance * direction;
      }

      this._progress = 0;
      this.animateFrame.start(this._scrollAnimate);
    },
    _scrollAnimate: function _scrollAnimate() {
      this._progress = this._progress + 0.1;

      if (this._progress >= 1) {
        this._progress = 1;
      } else {
        this.animateFrame.start(this._scrollAnimate);
      }

      this.$refs.viewport.scrollTop = this._startScrollTop + this._progress * this._animateDistance;
    },
    _initial: function _initial(list) {
      var _list = Array.isArray(list) ? [].concat(list) : [];

      this._itemHeightStore = create(_list.length, this.innerEstimatedHeight);
      this._wrappedData = this._wrapData(_list);
      this._visibleWrappedData = this._filterWrapedData(this._wrappedData);
    },
    _wrapData: function _wrapData(list) {
      var _this5 = this;

      var result = map_default()(list, function (item, index) {
        return _this5._getItemWrapper(item, index);
      });
      return result;
    },
    _filterWrapedData: function _filterWrapedData() {
      return filter_default()(this._wrappedData, function (item) {
        return item.height > 0;
      });
    },
    _getItemWrapper: function _getItemWrapper(item, index) {
      var visible = item[this.visibleKey];
      visible = typeof visible === 'boolean' ? visible : true;
      !visible && this._itemHeightStore.setValue(index, 0);
      return new ItemWrapper(item, index, visible ? this.innerEstimatedHeight : 0);
    },
    _pushWrapedData: function _pushWrapedData(items, index, size) {
      var _this$_wrappedData,
          _this6 = this;

      for (var _index = index, len = this._wrappedData.length; _index < len; _index++) {
        this._wrappedData[_index].key += size;
      }

      (_this$_wrappedData = this._wrappedData).splice.apply(_this$_wrappedData, [index, 0].concat(map_default()(items, function (item, _index) {
        return _this6._getItemWrapper(item, index + _index);
      })));
    },
    _popWrapedData: function _popWrapedData(index, size) {
      for (var _index = index, len = this._wrappedData.length; _index < len; _index++) {
        this._wrappedData[_index].key -= size;
      }

      this._wrappedData.splice(index, size);
    },
    _pushVisibleWrapedData: function _pushVisibleWrapedData(keys) {
      var _this7 = this;

      var _keys = this._groupKeys(keys);

      forEach_default()(_keys, function (key) {
        var _this7$_visibleWrappe;

        var index = key.index,
            size = key.size;
        var items = filter_default()(_this7._wrappedData.slice(index, index + size), function (item) {
          return item.height > 0;
        });

        var _index = _this7._binarySearchIndex(index);

        (_this7$_visibleWrappe = _this7._visibleWrappedData).splice.apply(_this7$_visibleWrappe, [_index, 0].concat(items));
      });
    },
    _popVisibleWrapedData: function _popVisibleWrapedData(keys) {
      var _this8 = this;

      forEach_default()(keys, function (key) {
        var _index = _this8._binarySearchEqualIndex(key);

        _index !== -1 && _this8._visibleWrappedData.splice(_index, 1);
      });
    },
    _binarySearchIndex: function _binarySearchIndex(key) {
      var index;
      var len = this._visibleWrappedData.length;

      if (len === 0) {
        return 0;
      }

      if (len === 1) {
        var item = this._visibleWrappedData[0];
        return key < item.key ? 0 : 1;
      }

      var low = 0;
      var high = len - 1;

      if (this._visibleWrappedData[low].key > key) {
        return low;
      }

      if (this._visibleWrappedData[high].key < key) {
        return len;
      }

      while (low <= high) {
        var middle = Math.floor((low + high) / 2);
        var next = middle + 1;
        var startItem = this._visibleWrappedData[middle];
        var endItem = this._visibleWrappedData[next];

        if (startItem.key < key && endItem.key > key) {
          index = next;
          break;
        } else if (startItem.key > key) {
          high = middle - 1;
        } else {
          low = middle + 1;
        }
      }

      return isNaN(index) ? 0 : index;
    },
    _binarySearchEqualIndex: function _binarySearchEqualIndex(key) {
      var index;
      var len = this._visibleWrappedData.length;

      if (len === 0) {
        return -1;
      }

      if (len === 1) {
        return this._visibleWrappedData[0].key === key ? 0 : -1;
      }

      var low = 0;
      var high = len - 1;

      while (low <= high) {
        var middle = Math.floor((low + high) / 2);
        var middleItem = this._visibleWrappedData[middle];

        if (middleItem.key === key) {
          index = middle;
          break;
        } else if (middleItem.key > key) {
          high = middle - 1;
        } else {
          low = middle + 1;
        }
      }

      return isNaN(index) ? -1 : index;
    },
    _groupKeys: function _groupKeys(keys) {
      var _keys = keys.sort(function (prev, next) {
        return prev - next;
      });

      var keysGroup = reduce_default()(_keys, function (group, key) {
        var item = group[key - 1];

        if (item) {
          item.size += 1;
          group[key] = item;
        } else {
          group[key] = {
            index: key,
            size: 1
          };
        }

        return group;
      }, {});
      return uniqWith_default()(Object.values(keysGroup), function (arrVal, othVal) {
        return arrVal === othVal;
      });
    },
    // 通过 DOM Node 获取对应的数据
    _getDataByNode: function _getDataByNode(node) {
      return this._wrappedData[node.dataset.key];
    },
    // 重绘界面，确保列表渲染正确
    // 刷新列表总高度
    updateContentHeight: function updateContentHeight() {
      var rangeValues = this._itemHeightStore.values();

      if (!rangeValues.length) {
        this.contentHeight = 0;
        return;
      }

      var contentHeight = reduce_default()(rangeValues, function (sum, rangeValue) {
        var span = rangeValue.end - rangeValue.start + 1;
        var height = rangeValue.value * span;
        return sum + height;
      }, 0);
      this.contentHeight = contentHeight;
    },
    // 上下两端预先批量渲染的项目波动量
    // 原理是，每次插入删除都是一个小批量动作，
    // 而不是每次只插入一条、销毁一条
    // 计算出的局部渲染数据范围，跟上一次计算出来的结果，差距
    // 在这个波动量范围内，则不重新切片渲染，用于因频繁插入内容导致性能压力
    _preRenderingCount: function _preRenderingCount() {
      return Math.max(3, Math.ceil(this.viewportHeight / this.innerEstimatedHeight / 2));
    },
    // 刷新局部渲染数据切片范围
    _updateSliceRange: function _updateSliceRange(forceUpdate) {
      var _this$_visibleWrapped2;

      // 计算出准确的切片区间
      var range = this._calcSliceRange(); // 上下方额外多渲染的条目波动量


      var count = this._preRenderingCount(); // 预渲染触发阈值


      var threshold = Math.ceil(count / 2); // 数据总量

      var max = this._visibleWrappedData.length; // 检查计算出来的切片范围，是否被当前已经渲染的切片返回包含了
      // 如果是，无需更新切片，（如果 forceUpdate，则无论如何都需要重新切片）

      var fromThreshold = this._pervReplenish(range.sliceFrom, threshold, 0);

      var toThreshold = this._nextReplenish(range.sliceTo, threshold, max); // 无需强制刷新，且上下两端都没有触达阈值时，无需重新切片


      if (!forceUpdate && this.sliceFrom <= fromThreshold && this.sliceTo >= toThreshold) {
        var _this$_visibleWrapped;

        this.$refs.content.style.transform = "translate3d(0, " + this._itemTop((_this$_visibleWrapped = this._visibleWrappedData[this.sliceFrom]) == null ? void 0 : _this$_visibleWrapped.key) + "px, 0)";
        return;
      } // 更新切片的情况
      // 在切片区间头部、尾部，追加预渲染的条目


      this.sliceFrom = this._pervReplenish(range.sliceFrom, count, 0);
      this.sliceTo = this._nextReplenish(range.sliceTo, count, max);
      this.$refs.content.style.transform = "translate3d(0, " + this._itemTop((_this$_visibleWrapped2 = this._visibleWrappedData[this.sliceFrom]) == null ? void 0 : _this$_visibleWrapped2.key) + "px, 0)";

      this._doSlice();
    },
    _pervReplenish: function _pervReplenish(perv, differ, minLimit) {
      return Math.max(minLimit, perv - differ);
    },
    _nextReplenish: function _nextReplenish(next, differ, maxLimit) {
      return Math.min(maxLimit, next + differ);
    },
    // 当前需要渲染的数据切片
    _doSlice: function _doSlice() {
      var _visibleWrappedData = this._visibleWrappedData,
          sliceFrom = this.sliceFrom,
          sliceTo = this.sliceTo;

      var slice = _visibleWrappedData.slice(sliceFrom, sliceTo);

      this.visibleData = Object.freeze(slice);
    },
    // `index` 数据在 _wrappedData 中的 index
    _itemHeight: function _itemHeight(index) {
      return this._itemHeightStore.getValueAt(index);
    },
    // `index` 数据在 _wrappedData 中的 index
    _itemTop: function _itemTop(index) {
      if (index === void 0) {
        index = 0;
      }

      if (index === 0) return 0; // 0 ～ 上一项的高度累加

      var rangeValues = this._itemHeightStore.intersecting(0, index - 1);

      var sumHeight = reduce_default()(rangeValues, function (sum, rangeValue) {
        var size = rangeValue.end - rangeValue.start + 1;
        return sum + rangeValue.value * size;
      }, 0);
      return sumHeight;
    },
    _binarySearchBoundary: function _binarySearchBoundary(offset, defaultBoundary) {
      var index;
      var low = 0;
      var high = this._visibleWrappedData.length - 1;

      while (low <= high) {
        var middle = Math.floor((low + high) / 2);
        var item = this._visibleWrappedData[middle];

        var itemHeight = this._itemHeight(item.key);

        var itemTopOffset = this._itemTop(item.key);

        var itemBottomOffset = itemTopOffset + itemHeight;

        if (itemTopOffset <= offset && itemBottomOffset >= offset) {
          index = middle;
          break;
        } else if (itemTopOffset >= offset) {
          high = middle - 1;
        } else {
          low = middle + 1;
        }
      }

      return isNaN(index) ? defaultBoundary : index;
    },
    // 内部方法，计算局部渲染数据切片的起止点
    _calcSliceRange: function _calcSliceRange() {
      if (!this.virtual) {
        return {
          sliceFrom: 0,
          sliceTo: this._visibleWrappedData.length - 1
        };
      } // 视口上边界


      var viewportTop = this.$refs.viewport.scrollTop || 0; // 视口下边界

      var viewportBottom = viewportTop + this.viewportHeight;

      var sliceFrom = this._binarySearchBoundary(viewportTop, 0);

      var sliceTo = this._binarySearchBoundary(viewportBottom, this._wrappedData.length - 1);

      return {
        sliceFrom: sliceFrom,
        sliceTo: sliceTo
      };
    },
    // 刷新列表项高度
    _updateHeight: function _updateHeight(wrappedItem, height) {
      var _height = height >> 0; // 更新结点高度缓存


      wrappedItem.height = _height; // 如果 wrappedItem 为当前过滤下的项目，
      // 则同时刷新高度存储 store

      var index = this._wrappedData.indexOf(wrappedItem);

      if (index !== -1) {
        // 小于等于零表示折叠不显示，计算高度为零
        // 负值存在 wrappedItem 中，用于反折叠时恢复
        this._itemHeightStore.setValue(index, _height > 0 ? _height : 0);
      }
    },
    // Dom 插入时候，计算高度，然后
    // 批量刷新高度，避免频繁调整列表高度带来性能问题
    _batchUpdateHeight: function _batchUpdateHeight(records, onlyUpdate) {
      var _this9 = this;

      forEach_default()(records, function (_ref) {
        var wrappedItem = _ref.wrappedItem,
            height = _ref.height;

        _this9._updateHeight(wrappedItem, height);
      });

      if (onlyUpdate) {
        return;
      }

      this._updateSliceRange();

      this.updateContentHeight();
    },
    // 节点插入时，检查是否首次插入，如果是，计算高度并更新对应的 ItemWrapper
    _updateHeightWhenItemInserted: function _updateHeightWhenItemInserted(elemNodes, onlyUpdate) {
      var _this10 = this;

      var batch = [];
      forEach_default()(elemNodes, function (node) {
        var wrappedItem = _this10._getDataByNode(node);

        var height = node.clientHeight; // warppedItem.height < 0 则已经被隐藏

        if (wrappedItem.height >= 0 && wrappedItem.height !== height) {
          batch.push({
            wrappedItem: wrappedItem,
            height: height
          });
        }
      });

      if (batch.length) {
        this._batchUpdateHeight(batch, onlyUpdate);
      }
    },
    // 滚动事件处理器
    _fireScroll: function _fireScroll(evt) {
      this.virtual && this._updateSliceRange();
      var target = evt.target;

      if (target.clientHeight + target.scrollTop + 5 >= target.scrollHeight) {
        this.emitScroll('reachedBottom');
      }

      if (target.scrollTop <= 5) {
        this.emitScroll('reachedTop');
      }
    },
    emitScroll: function emitScroll() {},
    _emitScroll: function _emitScroll(evt) {
      this.$emit(evt);
    }
  }
});
// CONCATENATED MODULE: ./src/components/list-view/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_list_viewvue_type_script_lang_js_ = (list_viewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/list-view/index.vue?vue&type=style&index=0&lang=less&
var list_viewvue_type_style_index_0_lang_less_ = __webpack_require__(110);

// CONCATENATED MODULE: ./src/components/list-view/index.vue






/* normalize component */

var list_view_component = normalizeComponent(
  components_list_viewvue_type_script_lang_js_,
  list_viewvue_type_template_id_266f9417_render,
  list_viewvue_type_template_id_266f9417_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var list_view_api; }
list_view_component.options.__file = "src/components/list-view/index.vue"
/* harmony default export */ var list_view = (list_view_component.exports);
// CONCATENATED MODULE: ./src/components/list-view/index.js


list_view.install = function (Vue) {
  Vue.component('H3ListView', list_view);
};

/* harmony default export */ var components_list_view = (list_view);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/location/index.vue?vue&type=template&id=51db4808&
var locationvue_type_template_id_51db4808_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h3-location" },
    [
      _c(
        "div",
        { staticClass: "h3-location__content", on: { click: _vm.focus } },
        [
          _vm._t("default", [
            _c(
              "h3-combo-box",
              {
                attrs: {
                  placeholder: _vm.placeholder,
                  value: _vm.value.address,
                  allowClear: "",
                  focused: _vm.visible
                },
                on: { change: _vm.clear }
              },
              [
                _c("icon-address-stroke", {
                  attrs: { slot: "suffix" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.focus($event)
                    }
                  },
                  slot: "suffix"
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _c("h3-map-modal", {
        attrs: {
          value: _vm.value,
          showTip: _vm.showTip,
          readonly: _vm.readonly,
          vid: _vm.vid,
          width: 600
        },
        on: { ok: _vm.ok, cancel: _vm.cancel, show: _vm.show, hide: _vm.hide },
        model: {
          value: _vm.visible,
          callback: function($$v) {
            _vm.visible = $$v
          },
          expression: "visible"
        }
      })
    ],
    1
  )
}
var locationvue_type_template_id_51db4808_staticRenderFns = []
locationvue_type_template_id_51db4808_render._withStripped = true


// CONCATENATED MODULE: ./src/components/location/index.vue?vue&type=template&id=51db4808&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map-modal/index.vue?vue&type=template&id=6ab96a9f&
var map_modalvue_type_template_id_6ab96a9f_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.amapManager
    ? _c(
        "a-modal",
        {
          staticClass: "h3-map-modal",
          attrs: {
            visible: _vm.innerVisible,
            bodyStyle: { padding: 0 },
            closable: false,
            footer: null,
            width: _vm.width
          }
        },
        [
          _c(
            "div",
            { staticClass: "h3-map-modal__content" },
            [
              _c(
                "div",
                { staticClass: "h3-map-modal__search-box" },
                [
                  _c(
                    "a-input",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.readonly,
                          expression: "!readonly"
                        }
                      ],
                      ref: "searchInput",
                      on: {
                        focus: _vm.onSearchInputFocus,
                        change: _vm.onSearchInputChange
                      },
                      model: {
                        value: _vm.searchKey,
                        callback: function($$v) {
                          _vm.searchKey = $$v
                        },
                        expression: "searchKey"
                      }
                    },
                    [
                      _c("a-icon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.searchKey.length > 0,
                            expression: "searchKey.length > 0"
                          }
                        ],
                        attrs: {
                          slot: "suffix",
                          theme: "filled",
                          type: "close-circle"
                        },
                        on: { click: _vm.clearSearchInput },
                        slot: "suffix"
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.readonly && _vm.showSearchResult,
                          expression: "!readonly && showSearchResult"
                        }
                      ],
                      staticClass: "h3-map-modal__search-result-box"
                    },
                    [
                      _c("div", {
                        ref: "searchResult",
                        staticClass: "h3-map-modal__search-result"
                      }),
                      _c(
                        "div",
                        { staticClass: "h3-map-modal__search-result-nodata" },
                        [_vm._v("\n          未找到相关地址\n        ")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-amap",
                {
                  staticClass: "amap-instance",
                  attrs: {
                    vid: _vm.vidMap,
                    center: _vm.mapCenter,
                    amapManager: _vm.amapManager,
                    zoom: 12,
                    events: _vm.events
                  },
                  on: { click: _vm.onClickMap }
                },
                [_c("el-amap-marker", { attrs: { position: _vm.marker } })],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "h3-map-modal__rollback-pos",
                  class: { "h3-map-modal__rollback-pos--tip": _vm.hasTip },
                  attrs: { title: "返回标记位置" },
                  on: { click: _vm.posFocus }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1577958108872",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "56260"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M899.54 108.805L80.144 496.94a8 8 0 0 0\n         1.484 14.991l340.353 85.088 85.088 340.353a8 8 0 0 0 14.99\n          1.484L910.196 119.46a8 8 0 0 0-10.655-10.655z",
                          "p-id": "56261"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm.hasTip
                ? _c(
                    "div",
                    { staticClass: "h3-map-modal__content-tip" },
                    [
                      _vm._v(
                        "\n      PC端可能会出现定位偏差，可前往移动端精确定位\n      "
                      ),
                      _c("a-icon", {
                        attrs: { theme: "filled", type: "close-circle" },
                        on: { click: _vm.onCloseTip }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "h3-map-modal__footer" }, [
            _c(
              "div",
              [
                !_vm.readonly
                  ? [
                      _c(
                        "a-button",
                        {
                          staticClass: "h3-map-modal__footer-cancel",
                          attrs: { type: "default" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v("\n          取消\n        ")]
                      ),
                      _c(
                        "a-button",
                        { attrs: { type: "primary" }, on: { click: _vm.ok } },
                        [_vm._v("\n          确定\n        ")]
                      )
                    ]
                  : _c(
                      "a-button",
                      { attrs: { type: "default" }, on: { click: _vm.cancel } },
                      [_vm._v("\n        关闭\n      ")]
                    )
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.address !== "",
                    expression: "address !== ''"
                  }
                ]
              },
              [
                _c("icon-address-stroke", {
                  staticClass: "h3-map-modal__address"
                }),
                _vm._v(_vm._s(_vm.address) + "\n    ")
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var map_modalvue_type_template_id_6ab96a9f_staticRenderFns = []
map_modalvue_type_template_id_6ab96a9f_render._withStripped = true


// CONCATENATED MODULE: ./src/components/map-modal/index.vue?vue&type=template&id=6ab96a9f&

// EXTERNAL MODULE: external "@authine/antd-vue/lib/input/style/index.js"
var index_js_ = __webpack_require__(111);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/modal"
var modal_ = __webpack_require__(4);
var modal_default = /*#__PURE__*/__webpack_require__.n(modal_);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/modal/style/index.js"
var style_index_js_ = __webpack_require__(112);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/button/style/index.js"
var button_style_index_js_ = __webpack_require__(113);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/icon/style/index.js"
var icon_style_index_js_ = __webpack_require__(84);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--1-1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map-modal/index.vue?vue&type=script&lang=ts&









var DEFAULT_CENTER = [113.943555, 22.548344];

function infoHandle(info, def) {
  return info === null || info === undefined ? def || '' : info;
}

/* harmony default export */ var map_modalvue_type_script_lang_ts_ = ({
  name: 'H3MapModal',
  components: {
    AModal: modal_default.a,
    AInput: input_default.a,
    AButton: button_default.a,
    AIcon: icon_default.a,
    IconAddressStroke: basic_["IconAddressStroke"]
  },
  model: {
    prop: 'visible'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function _default() {
        return {
          address: '',
          lng: 0,
          lat: 0
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 600
    },
    vid: {
      type: String,
      default: 'h3-map'
    },
    showTip: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      amapManager: null,
      events: null,
      address: '',
      lng: null,
      lat: null,
      adcode: '',
      innerVisible: false,
      needPanTo: false,
      openTip: true,
      searchKey: '',
      searchOption: {
        city: '',
        citylimit: false
      },
      isInit: true,
      loaded: false,
      timestamp: 0,
      mapCenter: DEFAULT_CENTER,
      marker: DEFAULT_CENTER,
      geolocation: null,
      showSearchResult: false,
      detail: null
    };
  },
  computed: {
    vidMap: function vidMap() {
      return this.vid + "-" + this.timestamp;
    },
    hasTip: function hasTip() {
      return this.showTip && this.openTip && !this.readonly;
    }
  },
  watch: {
    value: {
      handler: function handler(nVal) {
        this.infoChange(nVal);
      },
      immediate: true
    },
    visible: function visible(nVal) {
      this.innerVisible = nVal;
    },
    innerVisible: function innerVisible(nVal) {
      if (nVal) {
        this.afterShow();
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __webpack_require__.e(/* import() */ 1).then(__webpack_require__.bind(null, 171)).then(function (m) {
      _this.amapManager = new m.default.AMapManager();
    });
  },
  mounted: function mounted() {
    this.innerVisible = this.visible;
    this.events = {
      click: this.onClickMap,
      complete: this.onComplete
    };
  },
  methods: {
    afterShow: function afterShow() {
      if (this.isInit) {
        this.isInit = false;
        this.timestamp = Date.now();
      }

      this.initPoiPicker();

      if ((this.lat !== null || this.lng !== null) && this.address !== '') {
        if (!this.amapManager._map) {
          this.needPanTo = true;
        } else {
          this.marker = [this.lng, this.lat];

          this.amapManager._map.panTo([this.lng, this.lat]);
        }
      } else {
        this.initGeolocation();
      }

      this.$emit('show');
    },
    onClickMap: function onClickMap(e) {
      if (this.readonly) {
        return;
      }

      var _e$lnglat = e.lnglat,
          lng = _e$lnglat.lng,
          lat = _e$lnglat.lat;
      this.lng = lng;
      this.lat = lat;
      this.marker = [this.lng, this.lat];
      this.transformLoaction(lng, lat);
    },
    onComplete: function onComplete() {
      if (this.needPanTo) {
        this.marker = [this.lng, this.lat];

        this.amapManager._map.panTo([this.lng, this.lat]);
      }
    },
    onCloseTip: function onCloseTip() {
      this.openTip = false;
    },
    transformLoaction: function transformLoaction(lng, lat) {
      var _this2 = this;

      if (!AMap) {
        return;
      }

      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      });
      geocoder.getAddress([lng, lat], function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            var address = result.regeocode.formattedAddress;
            _this2.address = address;
            _this2.adcode = result.regeocode.addressComponent.adcode;
            _this2.detail = result.regeocode.addressComponent;
          }
        }
      });
    },
    initGeolocation: function initGeolocation() {
      var _this3 = this;

      if (!AMap) {
        return;
      }

      if (!this.geolocation) {
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
          buttonOffset: new AMap.Pixel(10, 20),
          zoomToAccuracy: true,
          buttonPosition: 'RB'
        });
      }

      this.geolocation.getCityInfo(function (status, result) {
        if (status === 'complete' && result.info === 'SUCCESS') {
          _this3.mapCenter = result.center;
          _this3.marker = _this3.mapCenter;
          _this3.address = infoHandle(result.province) + infoHandle(result.city);
          _this3.lng = result.center[0];
          _this3.lat = result.center[1];
          _this3.adcode = result.adcode;
          _this3.detail = result;
        }
      });
      this.geolocation.getCurrentPosition(function (status, result) {
        if (status === 'complete' && result.info === 'SUCCESS') {
          _this3.address = infoHandle(result.formattedAddress, _this3.address);
          _this3.lng = result.position.lng;
          _this3.lat = result.position.lat;
          _this3.adcode = result.addressComponent.adcode;
          _this3.detail = result.addressComponent;
          _this3.mapCenter = [result.position.lng, result.position.lat];
          _this3.marker = _this3.mapCenter;
        }
      });
    },
    initPoiPicker: function initPoiPicker() {
      var _this4 = this;

      if (!AMapUI || this.loaded) {
        return;
      }

      this.loaded = true;
      AMapUI.loadUI(['misc/PoiPicker'], function (PoiPicker) {
        var searchResultEl = _this4.$refs.searchResult;
        var searchInputEl = _this4.$refs.searchInput.$el.firstChild;
        var poiPicker = new PoiPicker({
          input: searchInputEl,
          autocompleteOptions: {
            pageSize: 8
          },
          suggestContainer: searchResultEl
        });
        poiPicker.on('poiPicked', function (poiResult) {
          var poi = poiResult.item;

          if (!poi.location) {
            return;
          }

          _this4.showSearchResult = false;
          _this4.mapCenter = [poi.location.lng, poi.location.lat];
          _this4.marker = _this4.mapCenter;

          if (poi.district) {
            _this4.address = poi.district + poi.address + poi.name;
          } else if (poi.pname) {
            _this4.address = poi.pname + poi.cityname + poi.address + poi.name;
          }

          _this4.lng = poi.location.lng;
          _this4.lat = poi.location.lat;

          _this4.transformLoaction(poi.location.lng, poi.location.lat);
        });
      });
    },
    onSearchInputFocus: function onSearchInputFocus() {
      if (this.searchKey) {
        this.showSearchResult = true;
      }
    },
    onSearchInputChange: function onSearchInputChange() {
      this.showSearchResult = !!this.searchKey;
      this.$refs.searchResult.scrollTop = 0;
    },
    posFocus: function posFocus() {
      this.amapManager._map.panTo(this.marker);
    },
    cancel: function cancel() {
      this.clearSearchInput();

      if (this.$refs.input) {
        this.$refs.input.blur();
      }

      this.infoChange(this.value);
      this.innerVisible = false;
      this.$emit('input', this.innerVisible);
      this.$emit('cancel');
      this.$emit('hide');
    },
    clearSearchInput: function clearSearchInput() {
      this.searchKey = '';
      this.showSearchResult = false;
    },
    ok: function ok() {
      this.clearSearchInput();
      var val = {
        address: this.address,
        lng: this.lng,
        lat: this.lat,
        adcode: this.adcode,
        detail: this.detail
      };

      if (this.$refs.input) {
        this.$refs.input.blur();
      }

      this.innerVisible = false;
      this.$emit('input', this.innerVisible);
      this.$emit('ok', val);
      this.$emit('hide');
    },
    infoChange: function infoChange(val) {
      var _ref = val || {},
          _ref$lng = _ref.lng,
          lng = _ref$lng === void 0 ? null : _ref$lng,
          _ref$lat = _ref.lat,
          lat = _ref$lat === void 0 ? null : _ref$lat,
          _ref$address = _ref.address,
          address = _ref$address === void 0 ? '' : _ref$address;

      this.lng = lng;
      this.lat = lat;
      this.address = address;

      if (lat !== null && lng !== null) {
        this.mapCenter = [this.lat, this.lat];
      } else {
        this.mapCenter = DEFAULT_CENTER;
      }

      this.marker = this.mapCenter;
    }
  }
});
// CONCATENATED MODULE: ./src/components/map-modal/index.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_map_modalvue_type_script_lang_ts_ = (map_modalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/map-modal/index.vue?vue&type=style&index=0&lang=less&
var map_modalvue_type_style_index_0_lang_less_ = __webpack_require__(114);

// CONCATENATED MODULE: ./src/components/map-modal/index.vue






/* normalize component */

var map_modal_component = normalizeComponent(
  components_map_modalvue_type_script_lang_ts_,
  map_modalvue_type_template_id_6ab96a9f_render,
  map_modalvue_type_template_id_6ab96a9f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var map_modal_api; }
map_modal_component.options.__file = "src/components/map-modal/index.vue"
/* harmony default export */ var map_modal = (map_modal_component.exports);
// CONCATENATED MODULE: ./src/components/map-modal/index.js


map_modal.install = function (Vue) {
  Vue.component('H3MapModal', map_modal);
};

/* harmony default export */ var components_map_modal = (map_modal);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--1-1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/location/index.vue?vue&type=script&lang=ts&



/* harmony default export */ var locationvue_type_script_lang_ts_ = ({
  name: 'H3Location',
  components: {
    H3MapModal: components_map_modal,
    H3ComboBox: components_combo_box,
    IconAddressStroke: basic_["IconAddressStroke"]
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          address: '',
          lng: 0,
          lat: 0
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showModel: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: 'h3-location'
    },
    placeholder: {
      type: String,
      default: '点击定位'
    },
    locale: {
      type: String,
      default: 'zh'
    },
    showTip: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      hover: false
    };
  },
  watch: {
    showModel: function showModel(nVal) {
      if (nVal) {
        this.focus();
      }
    }
  },
  methods: {
    focus: function focus() {
      if (this.disabled) {
        return;
      }

      this.visible = true;
    },
    clear: function clear() {
      var val = {};
      this.$emit('input', val);
      this.$emit('ok', val);
    },
    show: function show() {
      this.$emit('show');
    },
    hide: function hide() {
      this.$emit('hide');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    ok: function ok(val) {
      this.$emit('input', val);
      this.$emit('ok', val);
    }
  }
});
// CONCATENATED MODULE: ./src/components/location/index.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_locationvue_type_script_lang_ts_ = (locationvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/location/index.vue?vue&type=style&index=0&lang=less&
var locationvue_type_style_index_0_lang_less_ = __webpack_require__(115);

// CONCATENATED MODULE: ./src/components/location/index.vue






/* normalize component */

var location_component = normalizeComponent(
  components_locationvue_type_script_lang_ts_,
  locationvue_type_template_id_51db4808_render,
  locationvue_type_template_id_51db4808_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var location_api; }
location_component.options.__file = "src/components/location/index.vue"
/* harmony default export */ var components_location = (location_component.exports);
// CONCATENATED MODULE: ./src/components/location/index.js


components_location.install = function (Vue) {
  Vue.component('H3Location', components_location);
};

/* harmony default export */ var src_components_location = (components_location);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/message/style"
var message_style_ = __webpack_require__(116);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/message"
var message_ = __webpack_require__(10);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// CONCATENATED MODULE: ./src/components/message/index.js


var H3Message = {};
H3Message.success = message_default.a.success;
H3Message.error = message_default.a.error;
H3Message.info = message_default.a.info;
H3Message.warning = message_default.a.warning;
H3Message.warn = message_default.a.warn;
H3Message.loading = message_default.a.loading;
H3Message.destroy = message_default.a.destroy;
H3Message.config = message_default.a.config;

H3Message.install = function (Vue) {
  // Vue.component(H3Message.name, H3Message);
  Vue.prototype.$message = H3Message;
};

/* harmony default export */ var message = (H3Message);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/modal/style"
var modal_style_ = __webpack_require__(117);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modal/double-check.vue?vue&type=template&id=c1264984&
var double_checkvue_type_template_id_c1264984_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-checkbox",
    { attrs: { checked: _vm.checked }, on: { change: _vm.onChange } },
    [_vm._t("default")],
    2
  )
}
var double_checkvue_type_template_id_c1264984_staticRenderFns = []
double_checkvue_type_template_id_c1264984_render._withStripped = true


// CONCATENATED MODULE: ./src/components/modal/double-check.vue?vue&type=template&id=c1264984&

// EXTERNAL MODULE: external "@authine/antd-vue/lib/checkbox/style"
var checkbox_style_ = __webpack_require__(87);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/checkbox"
var checkbox_ = __webpack_require__(16);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modal/double-check.vue?vue&type=script&lang=js&


/* harmony default export */ var double_checkvue_type_script_lang_js_ = ({
  name: 'DoubleCheckbox',
  components: {
    ACheckbox: checkbox_default.a
  },
  data: function data() {
    return {
      checked: false
    };
  },
  methods: {
    onChange: function onChange(evt) {
      this.checked = evt.target.checked;
      this.$emit('change', this.checked);
    }
  }
});
// CONCATENATED MODULE: ./src/components/modal/double-check.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_double_checkvue_type_script_lang_js_ = (double_checkvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/modal/double-check.vue





/* normalize component */

var double_check_component = normalizeComponent(
  modal_double_checkvue_type_script_lang_js_,
  double_checkvue_type_template_id_c1264984_render,
  double_checkvue_type_template_id_c1264984_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var double_check_api; }
double_check_component.options.__file = "src/components/modal/double-check.vue"
/* harmony default export */ var double_check = (double_check_component.exports);
// CONCATENATED MODULE: ./src/components/modal/index.js



function modal_extends() { modal_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return modal_extends.apply(this, arguments); }





var H3Modal = {
  name: 'H3Modal',
  functional: true,
  inheritAttrs: false,
  model: modal_default.a.model,
  props: modal_extends({}, modal_default.a.props, {
    size: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    contentTip: String,
    maxContentHeight: Number
  }),
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        slots = _ref.slots;
    // TODO 临时方案，整体做了国际化之后，将此代码删除
    clearUndefined(props);
    var cacheProps = props; // modal组件默认传入静态或者动态class都会重复类名，除非用api设置class。

    data.staticClass = data.staticClass ? data.staticClass + ' h3-modal' : 'h3-modal';

    if (cacheProps) {
      cacheProps.okText = cacheProps.okText || '确定';
      cacheProps.cancelText = cacheProps.cancelText || '取消';
    } else {
      cacheProps = {
        okText: '确定',
        cancelText: '取消'
      };
    }

    if (!cacheProps.width) {
      var sizeMap = {
        sm: 480,
        md: 640,
        lg: 800,
        small: 480,
        medium: 640,
        large: 800
      };

      if (!cacheProps.size || !sizeMap[cacheProps.size]) {
        cacheProps.size = 'sm';
      }

      cacheProps.width = sizeMap[cacheProps.size];
    }

    if (!cacheProps.closeIcon) {
      cacheProps.closeIcon = function () {
        return h(basic_["IconCrossStroke"]);
      };
    }

    if (!cacheProps.cancelButtonProps) {
      cacheProps.cancelButtonProps = {
        props: {
          ghost: true
        },
        class: 'h3-modal__cancel-button-to-text'
      };
    }

    var slotContent = slots(); // 作用域插槽
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['footer', 'title', 'okText', 'cancelText', 'closeIcon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(modal_default.a, modal_extends({
      props: cacheProps
    }, data), children);
  }
};

function h3ModalAdaptor(method, icon) {
  // TODO 临时方案，整体做了国际化之后，将此代码删除
  return function (opts) {
    var options = modal_extends({}, opts);

    var contentDef = options.content;
    options.centered = typeof options.centered === 'boolean' ? options.centered : true;
    options.width = opts.width || 420;
    options.okText = options.okText || '确定';
    options.cancelText = options.cancelText || '取消';
    var wrapClass = 'h3-modal';
    options.class = options.class ? options.class + ' ' + wrapClass : wrapClass;
    options.cancelButtonProps = {
      props: {
        ghost: true
      },
      class: 'h3-modal__cancel-button-to-text'
    };

    options.icon = function (h) {
      return options.hideIcon ? '' : h(icon, {
        class: 'anticon'
      });
    };

    options.content = function (h) {
      var contentVNode = typeof contentDef === 'function' ? contentDef(h) : contentDef;
      var contentTip = options.contentTip;
      var scrollContentVNode = [h('div', {
        staticClass: 'h3-modal-confirm-scroll-content',
        style: {
          'max-height': opts.maxContentHeight + 'px'
        }
      }, [contentVNode])];
      var contentTipVNode = [h('div', {
        staticClass: 'h3-modal-confirm-content-tip'
      }, [contentTip])];
      var res = [scrollContentVNode];

      if (contentTip) {
        res.unshift(contentTipVNode);
      }

      return res;
    };

    return method(options);
  };
} // 信息提示弹窗


H3Modal.info = h3ModalAdaptor(modal_default.a.info, basic_["IconInfoCirlceFill"]); // 成功提示弹窗

H3Modal.success = h3ModalAdaptor(modal_default.a.success, basic_["IconTickCircleFill"]); // 警告提示弹窗

H3Modal.warning = h3ModalAdaptor(modal_default.a.warning, basic_["IconExclamationCircleFill"]); // 警告提示弹窗

H3Modal.warn = H3Modal.warning; // 错误提示弹窗

H3Modal.error = h3ModalAdaptor(modal_default.a.error, basic_["IconCrossCircleFill"]); // 确认提示弹窗

H3Modal.confirm = h3ModalAdaptor(function (options) {
  if (options.doubleCheck) {
    var okButtonProps = {
      props: {
        disabled: true
      }
    };
    options.okButtonProps = okButtonProps;
    var contentDef = options.content;

    options.content = function (h) {
      var contentVNode = typeof contentDef === 'function' ? contentDef(h) : contentDef;
      return [h('div', {
        staticClass: 'h3-margin-bottom-lg h3-modal-confirm-scroll-content'
      }, [contentVNode]), h(double_check, {
        on: {
          change: function change(checked) {
            okButtonProps.props.disabled = !checked;
          }
        }
      }, options.checkContent)];
    };
  }

  options.centered = typeof options.centered === 'boolean' ? options.centered : true;

  var modalController = modal_default.a.confirm(options);

  return modalController;
}, basic_["IconQuestionCircleFill"]);

H3Modal.install = function (Vue) {
  Vue.use(modal_default.a);
  Vue.component(H3Modal.name, H3Modal);
  Vue.prototype.$modal = H3Modal;
  Vue.prototype.$confirm = H3Modal.confirm;
  Vue.prototype.$info = H3Modal.info;
  Vue.prototype.$warn = H3Modal.warn;
  Vue.prototype.$warning = H3Modal.warning;
  Vue.prototype.$error = H3Modal.error;
  Vue.prototype.$success = H3Modal.success;
};

/* harmony default export */ var modal = (H3Modal);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/popconfirm/style"
var popconfirm_style_ = __webpack_require__(118);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/popconfirm"
var popconfirm_ = __webpack_require__(42);
var popconfirm_default = /*#__PURE__*/__webpack_require__.n(popconfirm_);

// CONCATENATED MODULE: ./src/components/popconfirm/index.js



function popconfirm_extends() { popconfirm_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return popconfirm_extends.apply(this, arguments); }



var H3Popconfirm = {
  name: 'H3Popconfirm',
  functional: true,
  inheritAttrs: false,
  model: popconfirm_default.a.model,
  props: popconfirm_extends({}, popconfirm_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-popconfirm' : 'h3-popconfirm';
    props.overlayClassName = props.overlayClassName ? props.overlayClassName + ' h3-popconfirm-wrap' : 'h3-popconfirm-wrap';
    var slotContent = slots(); // 作用域插槽
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['cancelText', 'okText', 'title', 'icon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(popconfirm_default.a, popconfirm_extends({
      props: props
    }, data), children);
  }
};

H3Popconfirm.install = function (Vue) {
  Vue.component(H3Popconfirm.name, H3Popconfirm);
};

/* harmony default export */ var popconfirm = (H3Popconfirm);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/popover/style"
var popover_style_ = __webpack_require__(119);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/popover"
var popover_ = __webpack_require__(43);
var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);

// CONCATENATED MODULE: ./src/components/popover/index.js



function popover_extends() { popover_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return popover_extends.apply(this, arguments); }



var H3Popover = {
  name: 'H3Popover',
  functional: true,
  model: popover_default.a.model,
  props: popover_extends({}, popover_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-popover' : 'h3-popover';
    var slotContent = slots(); // 作用域插槽
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['title', 'content']);
    var children = [slotContent.default].concat(slotChildren);
    return h(popover_default.a, popover_extends({
      props: props
    }, data), children);
  }
};

H3Popover.install = function (Vue) {
  Vue.component(H3Popover.name, H3Popover);
};

/* harmony default export */ var popover = (H3Popover);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/select/style"
var select_style_ = __webpack_require__(120);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/select"
var select_ = __webpack_require__(18);
var select_default = /*#__PURE__*/__webpack_require__.n(select_);

// CONCATENATED MODULE: ./src/utils/custom.js
var changeToString = function changeToString(value) {
  var result = '';
  if (!value) return result;

  if (typeof value === 'string' || typeof value === 'number') {
    result = value;
  } else if (Array.isArray(value)) {
    result = value.join(' ');
  } else if (typeof value === 'object') {
    Object.keys(value).forEach(function (key) {
      if (value[key]) {
        result += key + " ";
      }
    });
  }

  return result;
};
// CONCATENATED MODULE: ./src/components/select/index.js



function select_extends() { select_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return select_extends.apply(this, arguments); }



 // import { IconTrigonBottomFill } from '@h3-icons/basic';

var H3Select = {
  name: 'H3Select',
  functional: true,
  inheritAttrs: false,
  props: select_extends({}, select_default.a.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props,
        scopedSlots = context.scopedSlots; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-select' : 'h3-select') + (data.class ? " " + changeToString(data.class) : ''); // const replacePlaceholder = () => {
    //   return 123;
    // };
    // 最大显示的 tag 文本长度
    // props.maxTagTextLength = props.maxTagTextLength || 12;
    // props.maxTagPlaceholder = props.maxTagPlaceholder || replacePlaceholder;

    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['maxTagPlaceholder', 'notFoundContent', 'suffixIcon', 'removeIcon', 'clearIcon', 'menuItemSelectedIcon', 'dropdownRender']);
    var children = [slotContent.default].concat(slotChildren); // 集成方有用""空值作为值的用法，所以不能把空值换成undefind
    // if ('value' in props) {
    //   props.value = handleEmptyValue(props.value);
    // }
    // if ('defaultValue' in props) {
    //   props.defaultValue = handleEmptyValue(props.defaultValue);
    // }
    // if (!('defaultActiveFirstOption' in props)) {
    //   props.defaultActiveFirstOption = false;
    // }

    if (props.onlyRead) props.disabled = true;
    return h(select_default.a, select_extends({
      props: props
    }, data, {
      scopedSlots: scopedSlots,
      // scopedSlots: {
      // suffixIcon: () => {
      // return <IconTrigonBottomFill style="font-size:14px" />;
      // },
      // },
      class: [{
        'h3-select--onlyread': props.onlyRead
      }]
    }), children);
  }
};

H3Select.install = function (Vue) {
  Vue.component('H3Select', H3Select);
  Vue.component('H3SelectOption', select_default.a.Option);
  Vue.component('H3SelectOptGroup', select_default.a.OptGroup);
};

H3Select.Option = select_default.a.Option;
H3Select.OptGroup = select_default.a.OptGroup;
/* harmony default export */ var components_select = (H3Select);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/title-group/index.vue?vue&type=template&id=5ec2ea26&
var title_groupvue_type_template_id_5ec2ea26_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h3-title-group" }, [
    _c("div", { staticClass: "group-header" }, [
      _c(
        "span",
        {
          staticClass: "gropu-header-left",
          style: { textAlign: _vm.tilteTextAlign },
          on: { click: _vm.handleGroup }
        },
        [_c("span", [_vm._v(_vm._s(_vm.title))])]
      ),
      _c(
        "span",
        { staticClass: "group-header-right", on: { click: _vm.handleGroup } },
        [_c("a-icon", { attrs: { type: _vm.innerShowGroup ? "up" : "down" } })],
        1
      )
    ]),
    _c("div", { staticClass: "group-line" }),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.innerShowGroup,
            expression: "innerShowGroup"
          }
        ],
        staticClass: "group-container"
      },
      [_vm._t("default")],
      2
    )
  ])
}
var title_groupvue_type_template_id_5ec2ea26_staticRenderFns = []
title_groupvue_type_template_id_5ec2ea26_render._withStripped = true


// CONCATENATED MODULE: ./src/components/title-group/index.vue?vue&type=template&id=5ec2ea26&

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__(26);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--1-1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/title-group/index.vue?vue&type=script&lang=ts&
function title_groupvue_type_script_lang_ts_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; title_groupvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function title_groupvue_type_script_lang_ts_setPrototypeOf(o, p) { title_groupvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return title_groupvue_type_script_lang_ts_setPrototypeOf(o, p); }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = undefined && undefined.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var H3TitleGroup = /*#__PURE__*/function (_Vue) {
  title_groupvue_type_script_lang_ts_inheritsLoose(H3TitleGroup, _Vue);

  function H3TitleGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Vue.call.apply(_Vue, [this].concat(args)) || this;
    _this.title = void 0;
    _this.showGroup = void 0;
    _this.tilteTextAlign = void 0;
    _this.innerShowGroup = true;
    return _this;
  }

  var _proto = H3TitleGroup.prototype;

  _proto.mounted = function mounted() {
    this.innerShowGroup = this.showGroup;
  };

  _proto.handleGroup = function handleGroup() {
    this.innerShowGroup = !this.innerShowGroup;
  };

  return H3TitleGroup;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String,
  default: ''
}), __metadata("design:type", String)], H3TitleGroup.prototype, "title", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Boolean,
  default: true
}), __metadata("design:type", Boolean)], H3TitleGroup.prototype, "showGroup", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String,
  default: 'left'
}), __metadata("design:type", String)], H3TitleGroup.prototype, "tilteTextAlign", void 0);

H3TitleGroup = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'H3TitleGroup',
  components: {
    AIcon: icon_default.a
  }
})], H3TitleGroup);
/* harmony default export */ var title_groupvue_type_script_lang_ts_ = (H3TitleGroup);
// CONCATENATED MODULE: ./src/components/title-group/index.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_title_groupvue_type_script_lang_ts_ = (title_groupvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/title-group/index.vue?vue&type=style&index=0&lang=less&
var title_groupvue_type_style_index_0_lang_less_ = __webpack_require__(121);

// CONCATENATED MODULE: ./src/components/title-group/index.vue






/* normalize component */

var title_group_component = normalizeComponent(
  components_title_groupvue_type_script_lang_ts_,
  title_groupvue_type_template_id_5ec2ea26_render,
  title_groupvue_type_template_id_5ec2ea26_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var title_group_api; }
title_group_component.options.__file = "src/components/title-group/index.vue"
/* harmony default export */ var title_group = (title_group_component.exports);
// CONCATENATED MODULE: ./src/components/title-group/index.js


title_group.install = function (Vue) {
  Vue.component('H3TitleGroup', title_group);
};

/* harmony default export */ var components_title_group = (title_group);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/tooltip/style"
var tooltip_style_ = __webpack_require__(122);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tooltip"
var tooltip_ = __webpack_require__(44);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// CONCATENATED MODULE: ./src/components/tooltip/index.js



function tooltip_extends() { tooltip_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tooltip_extends.apply(this, arguments); }



var H3Tooltip = {
  name: 'H3Tooltip',
  functional: true,
  inheritAttrs: false,
  model: tooltip_default.a.model,
  props: tooltip_extends({}, tooltip_default.a.props, {
    holdTip: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-tooltip' : 'h3-tooltip';
    var overlayCls = props.overlayClassName ? [props.overlayClassName, 'h3-tooltip-placement'] : ['h3-tooltip-placement'];

    if (!props.holdTip) {
      overlayCls.push('h3-tooltip-placement--ignore');
    }

    props.overlayClassName = overlayCls.join(' ');
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['title']);
    var children = [slotContent.default].concat(slotChildren);
    return h(tooltip_default.a, tooltip_extends({
      props: props
    }, data), children);
  }
};

H3Tooltip.install = function (Vue) {
  Vue.component(H3Tooltip.name, H3Tooltip);
};

/* harmony default export */ var components_tooltip = (H3Tooltip);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload.vue?vue&type=template&id=7982db22&
var uploadvue_type_template_id_7982db22_render = function() {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "" + _vm.mainCls,
        _vm.mainCls + "--" + _vm.mode,
        ((_obj = {}), (_obj[_vm.mainCls + "--disabled"] = _vm.disabled), _obj)
      ]
    },
    [
      _vm.mode !== "simple"
        ? _c(
            "h3-upload-dragger",
            {
              class: [
                _vm.mainCls + "__wrap",
                _vm.mainCls + "__wrap--border",
                ((_obj$1 = {}),
                (_obj$1[_vm.mainCls + "__wrap--default"] = !_vm.files.length),
                (_obj$1[_vm.mainCls + "__wrap--tirgger"] =
                  _vm.mainActive || _vm.dragActive),
                _obj$1)
              ],
              attrs: { disabled: !_vm.canAdd },
              on: { active: _vm.fireMainActive }
            },
            [
              _c(
                "div",
                { class: _vm.mainCls + "__box" },
                [
                  _vm._t(
                    "list",
                    [
                      _c(
                        "transition-group",
                        {
                          class: _vm.mainCls + "__list",
                          attrs: { tag: "div", name: "h3awesome-fade" }
                        },
                        _vm._l(_vm.files, function(file, index) {
                          return _c(
                            "h3-upload-detail-item",
                            _vm._b(
                              {
                                key: file.uid,
                                attrs: { file: file },
                                on: {
                                  click: function($event) {
                                    return _vm.fileClick(file, index, _vm.files)
                                  },
                                  fireReupload: function($event) {
                                    return _vm.fireReupload(file)
                                  },
                                  showPreview: function(evt) {
                                    return _vm.showPreview(evt, file)
                                  },
                                  hidePreview: _vm.hidePreview,
                                  firePreview: function($event) {
                                    return _vm.firePreview(
                                      file,
                                      index,
                                      _vm.files
                                    )
                                  },
                                  fireDownload: function($event) {
                                    return _vm.fireDownload(
                                      file,
                                      index,
                                      _vm.files
                                    )
                                  },
                                  removeFile: function($event) {
                                    return _vm.removeFile(file, _vm.files)
                                  }
                                }
                              },
                              "h3-upload-detail-item",
                              _vm.itemProps,
                              false
                            )
                          )
                        }),
                        1
                      )
                    ],
                    { files: _vm.files, removeFile: _vm.removeFile }
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.files.length,
                          expression: "files.length"
                        }
                      ],
                      class: _vm.mainCls + "__box-footer"
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.canAdd,
                              expression: "canAdd"
                            }
                          ],
                          class: _vm.mainCls + "__box-footer-left"
                        },
                        [
                          !_vm.customize && !_vm.disabled
                            ? _c(
                                _vm.uploadComponent,
                                _vm._g(
                                  _vm._b(
                                    {
                                      tag: "component",
                                      class: _vm.mainCls + "__input",
                                      attrs: {
                                        multiple: _vm.multiple,
                                        accept: _vm.accept,
                                        capture: _vm.capture,
                                        type: "file",
                                        title: "",
                                        updatedFiles: _vm.files
                                      },
                                      on: { change: _vm.changeHandler }
                                    },
                                    "component",
                                    _vm.uploadComponentProps,
                                    false
                                  ),
                                  _vm.uploadComponentListeners
                                )
                              )
                            : _vm._e(),
                          _c("icon-plus-stroke"),
                          _vm._v(" " + _vm._s(_vm.placeholder))
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { class: _vm.mainCls + "__box-footer-right" },
                        [
                          _vm._v(
                            "\n          共" +
                              _vm._s((_vm.files && _vm.files.length) || 0) +
                              _vm._s(
                                !_vm.innerLimit ? "" : " / " + _vm.innerLimit
                              ) +
                              "个\n        "
                          )
                        ]
                      )
                    ]
                  )
                ],
                2
              ),
              _c(
                "h3-upload-dragger",
                {
                  class: _vm.mainCls + "__trigger",
                  attrs: { disabled: !_vm.canAdd },
                  on: { file: _vm.addFiles, active: _vm.fireDragActive }
                },
                [
                  _c(
                    "div",
                    { class: _vm.mainCls + "__view" },
                    [
                      !_vm.customize && !_vm.disabled
                        ? _c(
                            _vm.uploadComponent,
                            _vm._g(
                              _vm._b(
                                {
                                  tag: "component",
                                  class: _vm.mainCls + "__input",
                                  attrs: {
                                    multiple: _vm.multiple,
                                    accept: _vm.accept,
                                    capture: _vm.capture,
                                    type: "file",
                                    title: "",
                                    updatedFiles: _vm.files
                                  },
                                  on: { change: _vm.changeHandler }
                                },
                                "component",
                                _vm.uploadComponentProps,
                                false
                              ),
                              _vm.uploadComponentListeners
                            )
                          )
                        : _vm._e(),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.files.length,
                            expression: "files.length"
                          }
                        ],
                        class: _vm.mainCls + "__tips-image"
                      }),
                      _c("div", { class: _vm.mainCls + "__tips" }, [
                        _c("span", { class: _vm.mainCls + "__tips-title" }, [
                          _vm._v(
                            _vm._s(_vm.disabled ? "没有文件" : _vm.placeholder)
                          )
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.disabled,
                                expression: "!disabled"
                              }
                            ],
                            class: _vm.mainCls + "__tips-sub-title"
                          },
                          [
                            _vm.innerMaxSize > 0
                              ? [
                                  _vm._v(
                                    "单个文件不超过" +
                                      _vm._s(_vm.formatMaxSize) +
                                      "，"
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(
                              "\n            已上传" +
                                _vm._s((_vm.files && _vm.files.length) || 0) +
                                _vm._s(
                                  !_vm.innerLimit ? "" : " / " + _vm.innerLimit
                                ) +
                                "个文件\n          "
                            )
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.mode === "simple"
        ? _c(
            "h3-upload-dragger",
            {
              class: [
                _vm.mainCls + "__line",
                ((_obj$2 = {}),
                (_obj$2[_vm.mainCls + "__line--tirgger"] =
                  _vm.mainActive || _vm.dragActive),
                _obj$2)
              ],
              attrs: { disabled: !_vm.canAdd },
              on: { active: _vm.fireMainActive }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canAdd,
                      expression: "canAdd"
                    }
                  ],
                  class: _vm.mainCls + "__line-left",
                  style: "height: " + _vm.simpleSize + "px"
                },
                [
                  _c(
                    "div",
                    {
                      class: _vm.mainCls + "__add-box",
                      attrs: { title: _vm.placeholder }
                    },
                    [
                      !_vm.customize && !_vm.disabled
                        ? _c(
                            _vm.uploadComponent,
                            _vm._g(
                              _vm._b(
                                {
                                  tag: "component",
                                  class: _vm.mainCls + "__input",
                                  attrs: {
                                    multiple: _vm.multiple,
                                    accept: _vm.accept,
                                    capture: _vm.capture,
                                    type: "file",
                                    title: _vm.placeholder,
                                    updatedFiles: _vm.files
                                  },
                                  on: { change: _vm.changeHandler }
                                },
                                "component",
                                _vm.uploadComponentProps,
                                false
                              ),
                              _vm.uploadComponentListeners
                            )
                          )
                        : _vm._e(),
                      _c("icon-plus-stroke")
                    ],
                    1
                  )
                ]
              ),
              !_vm.files.length
                ? _c(
                    "div",
                    {
                      class: _vm.mainCls + "__placeholder",
                      style: "height: " + _vm.simpleSize + "px",
                      attrs: {
                        title: _vm.disabled ? "没有文件" : _vm.placeholder
                      }
                    },
                    [
                      _c(
                        "span",
                        { class: _vm.mainCls + "__placeholder-text" },
                        [
                          _vm._v(
                            _vm._s(_vm.disabled ? "没有文件" : _vm.placeholder)
                          )
                        ]
                      )
                    ]
                  )
                : [
                    _c(
                      "transition-group",
                      {
                        class: _vm.mainCls + "__list",
                        attrs: { tag: "div", name: "h3awesome-fade" }
                      },
                      _vm._l(_vm.files, function(file, index) {
                        var _obj
                        return _c(
                          "div",
                          {
                            key: file.uid,
                            class: [
                              _vm.mainCls + "__item",
                              ((_obj = {}),
                              (_obj[_vm.mainCls + "__item--error"] =
                                file.status === _vm.STATUS_ERROR),
                              _obj)
                            ],
                            style:
                              "width: " +
                              _vm.simpleSize +
                              "px; height: " +
                              _vm.simpleSize +
                              "px",
                            on: {
                              click: function($event) {
                                return _vm.fileClick(file, index, _vm.files)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                class: _vm.mainCls + "__target",
                                style:
                                  "width: " +
                                  _vm.simpleSize +
                                  "px; height: " +
                                  _vm.simpleSize +
                                  "px",
                                on: {
                                  click: function($event) {
                                    return _vm.fireSimplePreview(
                                      file,
                                      index,
                                      _vm.files
                                    )
                                  }
                                }
                              },
                              [
                                file.category === _vm.TYPE_IMAGE &&
                                _vm.thumbnail &&
                                !_vm.isExclude(file)
                                  ? _c("div", {
                                      class: _vm.mainCls + "__thumbnail",
                                      style: _vm.getItemStyle(file)
                                    })
                                  : _c(_vm.getItemType(file), {
                                      tag: "component",
                                      class:
                                        _vm.mainCls +
                                        "__icon " +
                                        _vm.mainCls +
                                        "__icon--" +
                                        file.category
                                    }),
                                [
                                  _vm.STATUS_ERROR,
                                  _vm.STATUS_UPLOADING,
                                  _vm.STATUS_READY
                                ].includes(file.status)
                                  ? _c(
                                      "div",
                                      { class: _vm.mainCls + "__unfinish" },
                                      [
                                        [_vm.STATUS_ERROR].includes(file.status)
                                          ? _c("icon-arrow-reload-stroke", {
                                              class:
                                                _vm.mainCls + "__reload-btn",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.fireReupload(file)
                                                }
                                              }
                                            })
                                          : [
                                              _vm.STATUS_UPLOADING,
                                              _vm.STATUS_READY
                                            ].includes(file.status)
                                          ? _c("h3-upload-progress", {
                                              class: _vm.mainCls + "__progress",
                                              attrs: { progress: file.progress }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _c("div", {
                                      class: _vm.mainCls + "__handle",
                                      attrs: { title: file.name },
                                      on: {
                                        mouseover: function($event) {
                                          return _vm.showPreview($event, file)
                                        },
                                        mouseout: function($event) {
                                          return _vm.hidePreview($event, file)
                                        }
                                      }
                                    }),
                                _vm.deletable && !_vm.disabled
                                  ? _c("icon-cross-circle-fill", {
                                      class: _vm.mainCls + "__icon-remove",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removeFile(file, _vm.files)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
              _c("h3-upload-dragger", {
                class: _vm.mainCls + "__trigger",
                attrs: { disabled: !_vm.canAdd },
                on: { file: _vm.addFiles, active: _vm.fireDragActive }
              })
            ],
            2
          )
        : _vm._e(),
      _c("h3-dropdown", {
        ref: "imagePopper",
        class: _vm.mainCls + "__image",
        attrs: {
          controlCls: [_vm.mainCls + "__handle"],
          overlayCls: _vm.mainCls + "__img-popper",
          placement: "top",
          offset: [0, 15],
          zIndex: isNaN(_vm.zIndex) ? _vm.zIndex : Number(_vm.zIndex) + 1,
          arrow: true
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", {
                  class: _vm.mainCls + "__img-detail",
                  style: _vm.getItemStyle(_vm.previewFile, true)
                })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var uploadvue_type_template_id_7982db22_staticRenderFns = []
uploadvue_type_template_id_7982db22_render._withStripped = true


// CONCATENATED MODULE: ./src/components/upload/upload.vue?vue&type=template&id=7982db22&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-dragger.vue?vue&type=template&id=0f75f2c2&
var upload_draggervue_type_template_id_0f75f2c2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["h3-upload-dragger", { "h3-upload-dragger--active": _vm.active }],
      on: {
        drop: function($event) {
          $event.preventDefault()
          return _vm.fireDrop($event)
        },
        dragover: function($event) {
          $event.preventDefault()
        },
        dragenter: function($event) {
          $event.preventDefault()
          return _vm.fireDragenter($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          return _vm.fireDragleave($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var upload_draggervue_type_template_id_0f75f2c2_staticRenderFns = []
upload_draggervue_type_template_id_0f75f2c2_render._withStripped = true


// CONCATENATED MODULE: ./src/components/upload/upload-dragger.vue?vue&type=template&id=0f75f2c2&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-dragger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
  name: 'H3UploadDragger',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: false,
      count: 0
    };
  },
  watch: {
    disabled: function disabled(nVal) {
      if (!nVal) {
        this.fireActive(false);
      }
    }
  },
  created: function created() {},
  methods: {
    fireDragenter: function fireDragenter() {
      if (this.disabled) return;
      this.count++;
      this.fireActive(true);
    },
    fireDragleave: function fireDragleave() {
      if (this.disabled) return;
      this.count--;

      if (this.count === 0) {
        this.fireActive(false);
      }
    },
    fireDrop: function fireDrop(e) {
      if (this.disabled) return;
      this.fireDragleave();
      this.$emit('file', e.dataTransfer.files);
    },
    fireActive: function fireActive(active) {
      if (this.active === active) {
        return;
      }

      this.active = active;
      this.$emit('active', this.active);
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/upload-dragger.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/upload/upload-dragger.vue





/* normalize component */

var upload_dragger_component = normalizeComponent(
  upload_upload_draggervue_type_script_lang_js_,
  upload_draggervue_type_template_id_0f75f2c2_render,
  upload_draggervue_type_template_id_0f75f2c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_dragger_api; }
upload_dragger_component.options.__file = "src/components/upload/upload-dragger.vue"
/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-progress.vue?vue&type=template&id=13adbcfb&
var upload_progressvue_type_template_id_13adbcfb_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "h3-upload-progress",
      attrs: { xmlns: "http://www.w3.org/2000/svg", version: "1.1" }
    },
    [
      _c("circle", {
        staticClass: "h3-upload-progress__bg",
        attrs: { cx: "10", cy: "10", r: "8" }
      }),
      _c("circle", {
        staticClass: "h3-upload-progress__bar",
        attrs: {
          cx: "10",
          cy: "10",
          r: "8",
          "stroke-dasharray": _vm.plan + ", 200"
        }
      })
    ]
  )
}
var upload_progressvue_type_template_id_13adbcfb_staticRenderFns = []
upload_progressvue_type_template_id_13adbcfb_render._withStripped = true


// CONCATENATED MODULE: ./src/components/upload/upload-progress.vue?vue&type=template&id=13adbcfb&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var upload_progressvue_type_script_lang_js_ = ({
  name: 'H3UploadProgress',
  props: {
    progress: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    plan: function plan() {
      var max = 50; // 16 * Math.PI;

      var min = 0;
      var progress = isNaN(this.progress) ? 0 : Number(this.progress);
      var len = Math.floor(max * progress / 100);
      return Math.min(Math.max(min, len), max);
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/upload-progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_upload_progressvue_type_script_lang_js_ = (upload_progressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/upload/upload-progress.vue





/* normalize component */

var upload_progress_component = normalizeComponent(
  upload_upload_progressvue_type_script_lang_js_,
  upload_progressvue_type_template_id_13adbcfb_render,
  upload_progressvue_type_template_id_13adbcfb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_progress_api; }
upload_progress_component.options.__file = "src/components/upload/upload-progress.vue"
/* harmony default export */ var upload_progress = (upload_progress_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-modal.vue?vue&type=template&id=11e65862&
var upload_modalvue_type_template_id_11e65862_render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.mainCls + "__modal", on: { click: _vm.open } },
    [
      _c(
        "h3-modal",
        {
          ref: "modalRef",
          attrs: {
            size: "md",
            visible: _vm.visible,
            footer: null,
            closable: false,
            centered: true,
            bodyStyle: { paddingBottom: 0, paddingTop: 0 },
            wrapClassName: _vm.mainCls + "__modal-wrap",
            afterClose: _vm.afterClose
          },
          on: { cancel: _vm.cancel }
        },
        [
          _c("div", { class: _vm.mainCls + "__modal-head" }, [
            _c("span", { class: _vm.mainCls + "__modal-title" }, [
              _vm._v("上传文件")
            ]),
            _c(
              "span",
              {
                class: _vm.mainCls + "__modal-submit",
                on: { click: _vm.submit }
              },
              [_vm._v("完成")]
            )
          ]),
          _c(
            "div",
            { class: _vm.mainCls + "__modal-body" },
            [
              _c(
                "h3-upload-dragger",
                {
                  class:
                    ((_obj = {}),
                    (_obj[_vm.mainCls + "__modal--tirgger"] =
                      _vm.dragActive && _vm.enableUpdate),
                    _obj),
                  on: { active: _vm.fireDragActive, file: _vm.addFiles }
                },
                [
                  _c("div", { class: _vm.mainCls + "__trigger" }, [
                    _c("div", { class: _vm.mainCls + "__tips-image" }),
                    _c("div", { class: _vm.mainCls + "__tips" }, [
                      _c("span", { class: _vm.mainCls + "__tips-title" }, [
                        _vm._v(_vm._s(_vm.placeholder))
                      ]),
                      _c(
                        "span",
                        { class: _vm.mainCls + "__tips-sub-title" },
                        [
                          _vm.innerMaxSize > 0
                            ? [
                                _vm._v(
                                  "单个文件不超过" +
                                    _vm._s(_vm.formatMaxSize) +
                                    "，"
                                )
                              ]
                            : _vm._e(),
                          _vm._v(
                            "\n              已上传" +
                              _vm._s(_vm.updatedLen) +
                              _vm._s(
                                !_vm.outerLimit ? "" : " / " + _vm.outerLimit
                              ) +
                              "个文件\n            "
                          )
                        ],
                        2
                      )
                    ])
                  ]),
                  _c(
                    "transition-group",
                    {
                      class: _vm.mainCls + "__modal-list",
                      attrs: { tag: "div", name: "h3awesome-fade" }
                    },
                    [
                      _vm._l(_vm.files, function(file, index) {
                        return _c(
                          "h3-upload-detail-item",
                          _vm._b(
                            {
                              key: file.uid,
                              attrs: { file: file },
                              on: {
                                click: function($event) {
                                  return _vm.fileClick(file, index, _vm.files)
                                },
                                fireReupload: function($event) {
                                  return _vm.fireReupload(file)
                                },
                                showPreview: function(evt) {
                                  return _vm.showPreview(evt, file)
                                },
                                hidePreview: _vm.hidePreview,
                                firePreview: function($event) {
                                  return _vm.firePreview(file, index, _vm.files)
                                },
                                fireDownload: function($event) {
                                  return _vm.fireDownload(
                                    file,
                                    index,
                                    _vm.files
                                  )
                                },
                                removeFile: function($event) {
                                  return _vm.removeFile(file, _vm.files)
                                }
                              }
                            },
                            "h3-upload-detail-item",
                            _vm.itemProps,
                            false
                          )
                        )
                      }),
                      _c(
                        "div",
                        {
                          key: "input",
                          class:
                            ((_obj$1 = {}),
                            (_obj$1[_vm.mainCls + "__item"] = true),
                            (_obj$1[_vm.mainCls + "__item-button"] = true),
                            (_obj$1[
                              _vm.mainCls + "__item-button-disabled"
                            ] = !_vm.enableUpdate),
                            _obj$1)
                        },
                        [
                          _c(
                            "div",
                            { class: _vm.mainCls + "__target" },
                            [
                              _vm.enableUpdate
                                ? _c("input", {
                                    class: _vm.mainCls + "__input",
                                    attrs: {
                                      multiple: _vm.multiple,
                                      accept: _vm.accept,
                                      capture: _vm.capture,
                                      type: "file",
                                      title: ""
                                    },
                                    on: { change: _vm.changeHandler }
                                  })
                                : _vm._e(),
                              _c("icon-plus-stroke")
                            ],
                            1
                          ),
                          _c("div", { class: _vm.mainCls + "__name" }, [
                            _c(
                              "span",
                              { class: _vm.mainCls + "__name-content" },
                              [_vm._v("可点击、粘贴或拖拽文件上传")]
                            )
                          ])
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { class: _vm.mainCls + "__modal-footer" },
            [
              _vm.outerLimit > 0
                ? [
                    _c("span", [_vm._v("最多可上传")]),
                    _c("span", [_vm._v(_vm._s(_vm.outerLimit))]),
                    _c("span", [_vm._v("个文件，")])
                  ]
                : _vm._e(),
              _c("span", [_vm._v("已上传")]),
              _c("span", { class: _vm.mainCls + "__modal-highlight" }, [
                _vm._v(_vm._s(_vm.updatedLen))
              ]),
              _c("span", [_vm._v("个")]),
              _vm.innerLimit > 0
                ? [
                    _c("span", [_vm._v("，还剩")]),
                    _c("span", { class: _vm.mainCls + "__modal-highlight" }, [
                      _vm._v(_vm._s(_vm.availableLen))
                    ]),
                    _c("span", [_vm._v("个可上传")])
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm.visible
        ? _c("h3-dropdown", {
            ref: "imagePopper",
            class: _vm.mainCls + "__image",
            attrs: {
              controlCls: [_vm.mainCls + "__handle"],
              overlayCls: _vm.mainCls + "__img-popper",
              placement: "top",
              offset: [0, 15],
              zIndex: isNaN(_vm.zIndex) ? _vm.zIndex : Number(_vm.zIndex) + 1,
              arrow: true
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("div", {
                        class: _vm.mainCls + "__img-detail",
                        style: _vm.getItemStyle(_vm.previewFile, true)
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4003125261
            )
          })
        : _vm._e()
    ],
    1
  )
}
var upload_modalvue_type_template_id_11e65862_staticRenderFns = []
upload_modalvue_type_template_id_11e65862_render._withStripped = true


// CONCATENATED MODULE: ./src/components/upload/upload-modal.vue?vue&type=template&id=11e65862&

// CONCATENATED MODULE: ./src/components/upload/type.js
var _icons;

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable max-len */

var imageExt = /^(bmp|cur|dds|exr|gif|ico|jp(e)?g|pcx|pbm|pfm|pgm|ppm|png|psd|svg|tga|tif|tiff|webp)$/;
var audioExt = /^(aac|aif|ape|flac|oga|opus|m3u|m4a|mid|midi|mp3|ra|wav|wma|weba)$/;
var videoExt = /^(3gp|3g2|asf|avi|f4f|f4i|f4m|f4v|flv|h264|m4v|mkv|mov|mp4|mpg|ogg|ogv|qt|rm|rmvb|ts|vob|webm|wmv)$/;
var documentExt = /^(c|cfg|cpp|cs|css|csv|dat|h|hpp|ini|js|log|m|ps|py|rtf|sh|tex|torrent|txt|doc(x)?|xls(x)?|ppt(x)?|pdf)$/;
var wordExt = /^(doc(x)?)$/;
var excelExt = /^(csv|xls(x)?)$/;
var pptExt = /^(ppt(x)?)$/;
var pdfExt = /^(pdf)$/;
var archiveExt = /^(7z|bin|cbr|cue|deb|dmg|(tar\.)?gz|iso|mdf|pkg|rar|rpm|sitx|vcd|zip)$/;
var exeExt = /^(apk|app|bat|cgi|com|dll|exe|gadget|jar|msi|pif|sys)$/;
var TYPE_IMAGE = 'image';
var TYPE_VIDEO = 'video';
var TYPE_AUDIO = 'audio';
var TYPE_DOCUMENT = 'document';
var TYPE_WORD = 'word';
var TYPE_EXCEL = 'excel';
var TYPE_PPT = 'ppt';
var TYPE_PDF = 'pdf';
var TYPE_ARCHIVE = 'archive';
var TYPE_EXE = 'exe';
var TYPE_UNKNOWN = 'unknown';
var icons = (_icons = {}, _icons[TYPE_IMAGE] = basic_["IconFileTypeImageFill"], _icons[TYPE_VIDEO] = basic_["IconFileTypeVideoFill"], _icons[TYPE_AUDIO] = basic_["IconFileTypeAudioFill"], _icons[TYPE_DOCUMENT] = basic_["IconFileTypeDocumentFill"], _icons[TYPE_WORD] = basic_["IconFileTypeWordFill"], _icons[TYPE_EXCEL] = basic_["IconFileTypeExcelFill"], _icons[TYPE_PPT] = basic_["IconFileTypePptFill"], _icons[TYPE_PDF] = basic_["IconFileTypePdfFill"], _icons[TYPE_ARCHIVE] = basic_["IconFileTypeArchiveFill"], _icons[TYPE_EXE] = basic_["IconFileTypeExeFill"], _icons[TYPE_UNKNOWN] = basic_["IconFileTypeUnknownFill"], _icons);
var types = [{
  type: TYPE_IMAGE,
  regexp: imageExt
}, {
  type: TYPE_VIDEO,
  regexp: videoExt
}, {
  type: TYPE_AUDIO,
  regexp: audioExt
}, {
  type: TYPE_DOCUMENT,
  regexp: documentExt,
  children: [{
    type: TYPE_WORD,
    regexp: wordExt
  }, {
    type: TYPE_EXCEL,
    regexp: excelExt
  }, {
    type: TYPE_PPT,
    regexp: pptExt
  }, {
    type: TYPE_PDF,
    regexp: pdfExt
  }]
}, {
  type: TYPE_ARCHIVE,
  regexp: archiveExt
}, {
  type: TYPE_EXE,
  regexp: exeExt
}];

function getType(ext, _types, def) {
  if (def === void 0) {
    def = TYPE_UNKNOWN;
  }

  for (var _iterator = _createForOfIteratorHelperLoose(_types), _step; !(_step = _iterator()).done;) {
    var item = _step.value;

    if (ext.match(item.regexp)) {
      return item.children ? getType(ext, item.children, item.type) : item.type;
    }
  }

  return def;
}

function getFileType(fileName) {
  if (!fileName || !fileName.includes('.')) {
    return TYPE_UNKNOWN;
  }

  var ext = fileName.split('.').pop().toLocaleLowerCase();
  return !ext ? TYPE_UNKNOWN : getType(ext, types);
}
function getIconByCategory(cotegory) {
  return icons[cotegory] || basic_["IconFileTypeUnknownFill"];
}
// CONCATENATED MODULE: ./src/components/upload/helper.js
var helper_this = undefined;


function toNumber(value, def) {
  if (def === void 0) {
    def = 0;
  }

  var _value = isNaN(value) ? Number(value) : value;

  return isNaN(_value) ? def : _value;
} // status

var STATUS_READY = 'ready';
var STATUS_UPLOADING = 'uploading';
var STATUS_SUCCESS = 'success';
var STATUS_ERROR = 'error';
var STATUS_FINISH = 'finish';
var inBrowser = typeof window !== 'undefined';
var URL = inBrowser ? window.URL || window.webkitURL || window.mozURL : null;
function createURL(file) {
  if (file && URL) {
    return URL.createObjectURL(file);
  }

  return '';
}
function revokeURL(file) {
  if (file && file.url && URL) {
    URL.revokeObjectURL(file.url);
  }
}
var helper_index = 0; // make unique code

var genUID = function genUID() {
  return "uid-" + ("" + Date.now()).substr(-6, 6) + "-" + ++helper_index;
};
var helper_createFile = function createFile(file, status, progress) {
  if (file === void 0) {
    file = null;
  }

  if (status === void 0) {
    status = '';
  }

  if (progress === void 0) {
    progress = 0;
  }

  var uid = file && file.uid || genUID();
  var name = file && file.name || '';
  var category = file && file.category || getFileType(name);
  var categoryIcon = getIconByCategory(category);
  var size = file && file.size || 0;
  var type = file && file.type || '';
  var previewable = file && typeof file.previewable === 'boolean' ? file.previewable : true;
  var downloadable = file && typeof file.downloadable === 'boolean' ? file.downloadable : true;
  var url = file && file.url || (file instanceof Blob ? createURL(file) : '');
  var previewUrl = file && file.previewUrl || '';
  return {
    uid: uid,
    file: file,
    name: name,
    size: size,
    type: type,
    category: category,
    categoryIcon: categoryIcon,
    url: url,
    status: status,
    progress: progress,
    previewUrl: previewUrl,
    previewable: previewable,
    downloadable: downloadable,
    __CREATED__: true
  };
};
var fileToBase64 = function fileToBase64(file) {
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      resolve(this.result);
    };

    reader.onerror = function () {
      resolve(false);
    };
  });
};
var evalOpts = function evalOpts(data) {
  if (typeof data === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return data.apply(helper_this, args);
  }

  return data;
};
/**
 * 获取当前时间字符串 yyyyMMddHHmmss
 */

function getCurrentTimeStr(val) {
  var currentDate = val || new Date();
  var year = currentDate.getFullYear().toString();
  var month = (currentDate.getMonth() + 1).toString();

  if (month.length === 1) {
    month = '0' + month;
  }

  var date = currentDate.getDate().toString();

  if (date.length === 1) {
    date = '0' + date;
  }

  var hour = currentDate.getHours().toString();

  if (hour.length === 1) {
    hour = '0' + hour;
  }

  var minute = currentDate.getMinutes().toString();

  if (minute.length === 1) {
    minute = '0' + minute;
  }

  var second = currentDate.getSeconds().toString();

  if (second.length === 1) {
    second = '0' + second;
  }

  return year + month + date + hour + minute + second;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-detail-item.vue?vue&type=template&id=04d377b1&
var upload_detail_itemvue_type_template_id_04d377b1_render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.mainCls + "__item",
        ((_obj = {}),
        (_obj[_vm.mainCls + "__item--error"] =
          _vm.file.status === _vm.STATUS_ERROR),
        _obj)
      ]
    },
    [
      _c(
        "div",
        { class: _vm.mainCls + "__target" },
        [
          _vm.file.category === _vm.TYPE_IMAGE &&
          _vm.thumbnail &&
          !_vm.isExclude(_vm.file)
            ? _c("div", {
                class: _vm.mainCls + "__thumbnail",
                style: _vm.getItemStyle(_vm.file)
              })
            : _c(_vm.getItemType(_vm.file), {
                tag: "component",
                class:
                  _vm.mainCls +
                  "__icon " +
                  _vm.mainCls +
                  "__icon--" +
                  _vm.file.category
              }),
          [_vm.STATUS_ERROR, _vm.STATUS_UPLOADING, _vm.STATUS_READY].includes(
            _vm.file.status
          )
            ? _c(
                "div",
                { class: _vm.mainCls + "__unfinish" },
                [
                  [_vm.STATUS_ERROR].includes(_vm.file.status)
                    ? _c(
                        "div",
                        { class: _vm.mainCls + "__reload" },
                        [
                          _c("icon-arrow-reload-stroke", {
                            class: _vm.mainCls + "__reload-btn",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.fireReupload(_vm.file)
                              }
                            }
                          }),
                          _c("span", { class: _vm.mainCls + "__reload-text" }, [
                            _vm._v("重试")
                          ])
                        ],
                        1
                      )
                    : [_vm.STATUS_UPLOADING, _vm.STATUS_READY].includes(
                        _vm.file.status
                      )
                    ? _c("h3-upload-progress", {
                        class: _vm.mainCls + "__progress",
                        attrs: { progress: _vm.file.progress }
                      })
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  class: _vm.mainCls + "__handle",
                  on: {
                    mouseover: function($event) {
                      return _vm.showPreview($event, _vm.file)
                    },
                    mouseout: function($event) {
                      return _vm.hidePreview($event, _vm.file)
                    }
                  }
                },
                [
                  (typeof _vm.file.previewable === "boolean"
                  ? _vm.file.previewable && _vm.previewable
                  : _vm.previewable)
                    ? _c("icon-search-stroke", {
                        class: _vm.mainCls + "__preview-btn",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.firePreview(_vm.file)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _c(
            "div",
            { class: _vm.mainCls + "__item-btns" },
            [
              _c(
                "h3-tooltip",
                { attrs: { placement: "top", title: "下载" } },
                [
                  [_vm.STATUS_SUCCESS, _vm.STATUS_FINISH].includes(
                    _vm.file.status
                  ) &&
                  (typeof _vm.file.downloadable === "boolean"
                    ? _vm.file.downloadable && _vm.downloadable
                    : _vm.downloadable)
                    ? _c("icon-download-stroke", {
                        class: _vm.mainCls + "__item-btn",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.fireDownload(_vm.file)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              [_vm.STATUS_SUCCESS, _vm.STATUS_FINISH].includes(
                _vm.file.status
              ) &&
              (typeof _vm.file.downloadable === "boolean"
                ? _vm.file.downloadable && _vm.downloadable
                : _vm.downloadable) &&
              _vm.deletable &&
              !_vm.disabled
                ? _c("em", { class: _vm.mainCls + "__item-btn-line" })
                : _vm._e(),
              _c(
                "h3-tooltip",
                { attrs: { placement: "top", title: "删除" } },
                [
                  _vm.deletable && !_vm.disabled
                    ? _c("icon-cross-stroke", {
                        class: [
                          _vm.mainCls + "__item-btn",
                          ((_obj$1 = {}),
                          (_obj$1[_vm.mainCls + "__item-btn--error"] = [
                            _vm.STATUS_ERROR
                          ].includes(_vm.file.status)),
                          _obj$1)
                        ],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeFile(_vm.file)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { class: _vm.mainCls + "__name" }, [
        _c(
          "span",
          {
            class: _vm.mainCls + "__name-content",
            attrs: { title: _vm.file.name }
          },
          [_vm._v("\n      " + _vm._s(_vm.file.name) + "\n    ")]
        )
      ])
    ]
  )
}
var upload_detail_itemvue_type_template_id_04d377b1_staticRenderFns = []
upload_detail_itemvue_type_template_id_04d377b1_render._withStripped = true


// CONCATENATED MODULE: ./src/components/upload/upload-detail-item.vue?vue&type=template&id=04d377b1&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-detail-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var upload_detail_itemvue_type_script_lang_js_ = ({
  name: 'H3UploadDetailItem',
  components: {
    IconArrowReloadStroke: basic_["IconArrowReloadStroke"],
    IconSearchStroke: basic_["IconSearchStroke"],
    IconPlusStroke: basic_["IconPlusStroke"],
    IconDeleteStroke: basic_["IconDeleteStroke"],
    IconCrossCircleFill: basic_["IconCrossCircleFill"],
    IconDownloadStroke: basic_["IconDownloadStroke"],
    IconCrossStroke: basic_["IconCrossStroke"],
    H3UploadProgress: upload_progress,
    H3Tooltip: components_tooltip
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    thumbnail: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    previewable: {
      type: Boolean,
      default: true
    },
    downloadable: {
      type: Boolean,
      default: true
    },
    isExclude: {
      type: Function
    },
    getItemStyle: {
      type: Function
    },
    getItemType: {
      type: Function
    }
  },
  data: function data() {
    return {
      mainCls: 'h3-upload',
      STATUS_READY: STATUS_READY,
      STATUS_SUCCESS: STATUS_SUCCESS,
      STATUS_FINISH: STATUS_FINISH,
      STATUS_UPLOADING: STATUS_UPLOADING,
      STATUS_ERROR: STATUS_ERROR,
      TYPE_IMAGE: TYPE_IMAGE
    };
  },
  methods: {
    fireReupload: function fireReupload() {
      this.$emit.apply(this, ['fireReupload'].concat(Array.prototype.slice.call(arguments)));
    },
    showPreview: function showPreview() {
      this.$emit.apply(this, ['showPreview'].concat(Array.prototype.slice.call(arguments)));
    },
    hidePreview: function hidePreview() {
      this.$emit.apply(this, ['hidePreview'].concat(Array.prototype.slice.call(arguments)));
    },
    firePreview: function firePreview() {
      this.$emit.apply(this, ['firePreview'].concat(Array.prototype.slice.call(arguments)));
    },
    fireDownload: function fireDownload() {
      this.$emit.apply(this, ['fireDownload'].concat(Array.prototype.slice.call(arguments)));
    },
    removeFile: function removeFile() {
      this.$emit.apply(this, ['removeFile'].concat(Array.prototype.slice.call(arguments)));
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/upload-detail-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_upload_detail_itemvue_type_script_lang_js_ = (upload_detail_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/upload/upload-detail-item.vue





/* normalize component */

var upload_detail_item_component = normalizeComponent(
  upload_upload_detail_itemvue_type_script_lang_js_,
  upload_detail_itemvue_type_template_id_04d377b1_render,
  upload_detail_itemvue_type_template_id_04d377b1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_detail_item_api; }
upload_detail_item_component.options.__file = "src/components/upload/upload-detail-item.vue"
/* harmony default export */ var upload_detail_item = (upload_detail_item_component.exports);
// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(30);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// CONCATENATED MODULE: ./src/components/upload/mixin.js
function mixin_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = mixin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mixin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mixin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mixin_arrayLikeToArray(o, minLen); }

function mixin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




/* harmony default export */ var mixin = ({
  data: function data() {
    return {
      mainCls: 'h3-upload',
      dragActive: false,
      mainActive: false,
      previewFile: '',
      files: [],
      retryTimeStamp: 0,
      paused: false,
      STATUS_READY: STATUS_READY,
      STATUS_SUCCESS: STATUS_SUCCESS,
      STATUS_FINISH: STATUS_FINISH,
      STATUS_UPLOADING: STATUS_UPLOADING,
      STATUS_ERROR: STATUS_ERROR,
      TYPE_IMAGE: TYPE_IMAGE
    };
  },
  created: function created() {
    var _this = this;

    this.paused = !this.auto;
    this.togglePreview = debounce_default()(function (target, file, visible) {
      _this._togglePreview(target, file, visible);
    }, 150);
  },
  computed: {
    innerAction: function innerAction() {
      var action = this.action;

      if (typeof action === 'string') {
        return action ? {
          target: action
        } : null;
      } else {
        return action;
      }
    },
    innerLimit: function innerLimit() {
      return toNumber(this.limit, 0);
    },
    innerMaxSize: function innerMaxSize() {
      return toNumber(this.maxSize, 0);
    },
    formatMaxSize: function formatMaxSize() {
      return this.formatSize(this.innerMaxSize);
    },
    innerFormat: function innerFormat() {
      return this.format instanceof Function ? this.format : (this.format || []).map(function (item) {
        return (item || '').toLocaleLowerCase();
      });
    }
  },
  methods: {
    formatSize: function formatSize(size, level) {
      if (level === void 0) {
        level = 0;
      }

      var unit = ['B', 'K', 'M', 'G', 'T']; // 'B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'BB', 'NB', 'DB'

      return size < 1024 || level + 1 > unit.length ? "" + size + unit[level] : this.formatSize(Math.round(size / 1024), level + 1);
    },
    changeHandler: function changeHandler(e) {
      var fileEle = e.currentTarget;
      var files = fileEle.files;

      if (files) {
        this.addFiles(files);
        fileEle.value = null;
      }
    },
    addFiles: function addFiles(files) {
      var _this2 = this;

      var _allFiles = Array.from(files); // 防止限制了多选但是仍出现多选情况


      if (!this.multiple && _allFiles.length > 1) {
        _allFiles = _allFiles[0];
      } // 转换成内置的 file 对象


      _allFiles = _allFiles.map(function (file) {
        return helper_createFile(file, STATUS_READY, 0);
      });
      var filesLen = this.files.length; // 校验上传数量

      var count;

      if (this.innerLimit && this.innerLimit - filesLen < _allFiles.length) {
        this.$emit('exceed', _allFiles, this.files, this.innerLimit);
        count = this.innerLimit - filesLen;

        if (count <= 0) {
          return;
        }
      }

      var _files = [].concat(_allFiles); // 校验文件大小 及 文件格式


      var checkFormat = this.innerFormat instanceof Function || !!this.innerFormat.length;

      if (checkFormat || this.innerMaxSize) {
        var mismatchFiles = [];
        var oversizeFiles = [];
        _files = _allFiles.filter(function (file) {
          var ext = file.name.split('.').pop().toLocaleLowerCase();
          var mismatch = checkFormat ? !(_this2.innerFormat instanceof Function ? _this2.innerFormat(file.file) : _this2.innerFormat.includes(ext)) : false;
          var oversize = _this2.innerMaxSize ? _this2.innerMaxSize < file.size : false;
          mismatch && mismatchFiles.push(file);
          oversize && oversizeFiles.push(file);
          return !oversize && !mismatch;
        });

        if (mismatchFiles.length) {
          this.$emit('mismatch', mismatchFiles, _allFiles, this.innerFormat);
        }

        if (oversizeFiles.length) {
          this.$emit('oversize', oversizeFiles, _allFiles, this.innerMaxSize);
        }
      }

      if (count) {
        _files = _files.slice(0, count);
      }

      if (!_files.length) {
        return;
      }

      this.pretreatment(_files);
    },
    removeFile: function removeFile(file, files) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _removeFile, confirm;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _removeFile = function _removeFile() {
                  file._xhr && file._xhr.abort && file._xhr.abort();
                  revokeURL(file);

                  var _index = _this3.files.findIndex(function (_file) {
                    return _file.uid === file.uid;
                  });

                  _this3.files.splice(_index, 1);

                  _this3.$emit('input', _this3.files);

                  _this3.$emit('removed', file, files);

                  _this3.upload();
                };

                if (_this3.beforeRemove) {
                  _context.next = 5;
                  break;
                }

                _removeFile();

                _context.next = 15;
                break;

              case 5:
                if (!(typeof _this3.beforeRemove === 'function')) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return _this3.beforeRemove(file, _this3.files);

              case 9:
                confirm = _context.sent;

                if (confirm !== false) {
                  _removeFile();
                }

                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13]]);
      }))();
    },
    selectFile: function selectFile() {
      if (!this.customize || this.disabled) {
        return;
      }

      this.$emit('select');
    },
    pretreatment: function pretreatment(files) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this4$files, _iterator, _step, file, _file;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this4.processFile && (!_this4.base64 || Array.isArray(_this4.base64) && !_this4.base64.length))) {
                  _context2.next = 5;
                  break;
                }

                (_this4$files = _this4.files).push.apply(_this4$files, files);

                _this4.$emit('input', _this4.files);

                _this4.$nextTick(function () {
                  _this4.upload();
                });

                return _context2.abrupt("return");

              case 5:
                _iterator = mixin_createForOfIteratorHelperLoose(files);

              case 6:
                if ((_step = _iterator()).done) {
                  _context2.next = 38;
                  break;
                }

                file = _step.value;
                _context2.prev = 8;
                _file = file;

                if (!_this4.processFile) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 13;
                return _this4.processFile(file);

              case 13:
                _file = _context2.sent;

              case 14:
                if (!_this4.base64) {
                  _context2.next = 30;
                  break;
                }

                if (!Array.isArray(_this4.base64)) {
                  _context2.next = 26;
                  break;
                }

                if (!_this4.base64.includes(file.category)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 19;
                return fileToBase64(file.file);

              case 19:
                _context2.t1 = _context2.sent;
                _context2.next = 23;
                break;

              case 22:
                _context2.t1 = undefined;

              case 23:
                _context2.t0 = _context2.t1;
                _context2.next = 29;
                break;

              case 26:
                _context2.next = 28;
                return fileToBase64(file.file);

              case 28:
                _context2.t0 = _context2.sent;

              case 29:
                _file.base64 = _context2.t0;

              case 30:
                if (_file) {
                  _this4.files.push(_file);
                }

                _context2.next = 36;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t2 = _context2["catch"](8);
                console.log(_context2.t2);

              case 36:
                _context2.next = 6;
                break;

              case 38:
                _this4.$emit('input', _this4.files);

                _this4.$nextTick(function () {
                  _this4.upload();
                });

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 33]]);
      }))();
    },
    upload: function upload(_temp) {
      var _this5 = this;

      var _ref = _temp === void 0 ? {} : _temp,
          retry = _ref.retry,
          file = _ref.file;

      var options = this.innerAction;

      if (this.paused && !file || !options) {
        return;
      }

      var len = this.files.length;
      var uploadingCount = 0;
      var index = 0;
      var target = options.target,
          _options$headers = options.headers,
          headers = _options$headers === void 0 ? {} : _options$headers,
          _options$data = options.data,
          data = _options$data === void 0 ? {} : _options$data,
          _options$fileName = options.fileName,
          fileName = _options$fileName === void 0 ? 'file' : _options$fileName,
          withCredentials = options.withCredentials,
          timeout = options.timeout,
          _options$prop = options.prop,
          prop = _options$prop === void 0 ? 'file' : _options$prop,
          handleResult = options.handleResult;

      var _upload = function _upload(_file) {
        if (status === STATUS_ERROR) {
          _file.progress = 0;
          _file._retryTimeStamp = _this5.retryTimeStamp;
        }

        _file.status = STATUS_UPLOADING;
        _file._xhr = _this5.request(_file, {
          target: evalOpts(target, _file),
          headers: evalOpts(headers, _file),
          data: evalOpts(data, _file),
          fileName: fileName,
          withCredentials: withCredentials,
          timeout: timeout,
          prop: prop,
          handleResult: handleResult
        }, {
          onProgress: function onProgress(percent) {
            if (percent === void 0) {
              percent = 0;
            }

            _this5.handleProgress(percent, _file);
          },
          onError: function onError(error) {
            _this5.handleError(error, _file, retry);

            _this5.fireDone();
          },
          onSuccess: function onSuccess(response) {
            _this5.handleSuccess(response, _file, retry);

            _this5.fireDone();
          }
        });
      };

      if (file) {
        _upload(file);
      } else {
        while (index < len && uploadingCount < this.parallelCount) {
          var _file = this.files[index];
          var _status = _file.status;

          if (_status === STATUS_READY || retry && _status === STATUS_ERROR && _file._retryTimeStamp !== this.retryTimeStamp) {
            _upload(_file);

            uploadingCount++;
          } else if (_status === STATUS_UPLOADING) {
            uploadingCount++;
          }

          index++;
        }
      }
    },
    handleProgress: function handleProgress(percent, file) {
      if (percent === void 0) {
        percent = 0;
      }

      if (file.progress < percent) {
        file.progress = percent;
        this.$emit('progress', percent, file);
      }
    },
    handleSuccess: function handleSuccess(result, file, retry) {
      var _this6 = this;

      var handle = function handle() {
        file.status = STATUS_SUCCESS;

        _this6.$set(file, 'result', result);

        _this6.$emit('success', result, file);

        _this6.upload({
          retry: retry
        });
      };

      if (file.progress === 100) {
        handle();
      } else {
        file.progress = 100;
        setTimeout(handle, 250);
      }
    },
    handleError: function handleError(result, file, retry) {
      file.progress = 0;
      file.status = STATUS_ERROR;
      this.$set(file, 'result', result);
      this.$emit('error', result, file);
      this.upload({
        retry: retry
      });
    },
    fireDone: function fireDone() {
      if (this.files.every(function (file) {
        return ![STATUS_READY, STATUS_UPLOADING].includes(file.status);
      })) {
        this.$emit('done', this.files);
      }
    },
    fileClick: function fileClick(file, index, files) {
      this.$emit('fileClick', file, index, files);
    },
    fireSimplePreview: function fireSimplePreview(file, index, files) {
      if (typeof file.previewable === 'boolean' ? file.previewable && this.previewable : this.previewable) {
        this.$emit('preview', file, index, files);
      }
    },
    firePreview: function firePreview(file, index, files) {
      this.$emit('preview', file, index, files);
    },
    fireDownload: function fireDownload(file, index, files) {
      this.$emit('download', file, index, files);
    },
    fireReupload: function fireReupload(file) {
      this.upload({
        file: file
      });
    },
    fireDragActive: function fireDragActive(active) {
      this.dragActive = active;
    },
    fireMainActive: function fireMainActive(active) {
      this.mainActive = active;
    },
    handleFiles: function handleFiles(files) {
      return files.map(function (file) {
        return !file.__CREATED__ ? helper_createFile(file, file.status || STATUS_FINISH, !isNaN(file.progress) ? file.progress : 100) : file;
      });
    },
    getItemType: function getItemType(file) {
      return file.categoryIcon;
    },
    getItemStyle: function getItemStyle(file, preview) {
      return {
        backgroundImage: "url('" + (preview && file.previewUrl ? file.previewUrl : file.base64 || file.url) + "')"
      };
    },
    isExclude: function isExclude(file) {
      var ext = file.name.split('.').pop().toLocaleLowerCase();
      return this.excludeThumbnail ? this.excludeThumbnail.includes(ext) : false;
    },
    start: function start() {
      this.paused = false;
      this.upload();
    },
    pause: function pause() {
      this.paused = true;
      this.files.forEach(function (file) {
        if (file.status === STATUS_UPLOADING) {
          file._xhr && file._xhr.abort && file._xhr.abort();
          file.status = STATUS_READY;
          file.progress = 0;
        }
      });
    },
    retry: function retry() {
      this.retryTimeStamp = Date.now();
      this.paused = false;
      this.upload({
        retry: true
      });
    },
    showPreview: function showPreview(evt, file) {
      var target = evt.currentTarget;
      this.togglePreview(target, file, true);
    },
    hidePreview: function hidePreview() {
      this.togglePreview(null, null, false);
    },
    togglePreview: function togglePreview() {},
    _togglePreview: function _togglePreview(target, file, visible) {
      var _this7 = this;

      if (visible) {
        if (file.category === TYPE_IMAGE && this.thumbnail && !this.isExclude(file)) {
          if (this.$refs.imagePopper.referenceElm !== target) {
            this.$refs.imagePopper.popperToggle(target, {
              show: function show() {
                _this7.previewFile = file;
              }
            });
          }
        } else {
          this.$refs.imagePopper.popperToggle(null);
        }
      } else {
        this.$refs.imagePopper.popperToggle(null);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/ajax.js
function getError(action, xhr) {
  var msg;

  if (xhr.response) {
    msg = "" + (xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = "" + xhr.responseText;
  } else {
    msg = "fail to post " + action + ", response.status: " + xhr.status;
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;

  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function ajaxUploader(file, options, callbacks) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var target = options.target,
      _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      _options$data = options.data,
      data = _options$data === void 0 ? {} : _options$data,
      _options$fileName = options.fileName,
      fileName = _options$fileName === void 0 ? 'file' : _options$fileName,
      withCredentials = options.withCredentials,
      timeout = options.timeout,
      _options$prop = options.prop,
      prop = _options$prop === void 0 ? 'file' : _options$prop,
      handleResult = options.handleResult;
  var _callbacks$onProgress = callbacks.onProgress,
      onProgress = _callbacks$onProgress === void 0 ? function () {} : _callbacks$onProgress,
      _callbacks$onError = callbacks.onError,
      onError = _callbacks$onError === void 0 ? function () {} : _callbacks$onError,
      _callbacks$onSuccess = callbacks.onSuccess,
      onSuccess = _callbacks$onSuccess === void 0 ? function () {} : _callbacks$onSuccess;
  var xhr = new XMLHttpRequest();

  if (xhr.upload) {
    xhr.upload.onloadstart = function (evt) {
      evt.target._simulationProgress = true;
      evt.target._simulationProgressPercent = 0;

      var simulationProgress = function simulationProgress() {
        if (evt.target._simulationProgress && evt.target._simulationProgressPercent === 99) {
          return;
        }

        evt.target._simulationProgressTimer = setTimeout(function () {
          evt.target._simulationProgressPercent = Math.min(99, evt.target._simulationProgressPercent + Math.floor(Math.random() * 10 + 1));
          onProgress(evt.target._simulationProgressPercent);
          simulationProgress();
        }, 300);
      };

      evt.target._simulationProgressTimer = setTimeout(function () {
        simulationProgress();
      }, 1000);
    };

    xhr.upload.onload = function (evt) {
      if (evt.target._simulationProgress) {
        evt.target._simulationProgress = false;
        clearTimeout(evt.target._simulationProgressTimer);
        evt.target._simulationProgressPercent = 100;
        onProgress(evt.target._simulationProgressPercent);
      }
    };

    xhr.upload.onloadend = function (evt) {
      if (evt.target._simulationProgress) {
        evt.target._simulationProgress = false;
        clearTimeout(evt.target._simulationProgressTimer);
      }
    };

    xhr.upload.onprogress = function (evt) {
      if (evt.target._simulationProgress) {
        evt.target._simulationProgress = false;
        clearTimeout(evt.target._simulationProgressTimer);
      }

      var percent = evt.total > 0 ? Math.floor(evt.loaded / evt.total * 100) : 0;
      onProgress(percent);
    };
  }

  var formData = new FormData();
  Object.keys(data).forEach(function (key) {
    formData.append(key, data[key]);
  });
  formData.append(fileName, file[prop], file.name);

  xhr.onerror = function () {
    onError(handleResult && handleResult(target, xhr) || getError(target, xhr));
  };

  xhr.onload = function () {
    if (xhr.status < 200 || xhr.status >= 300) {
      return onError(handleResult && handleResult(target, xhr) || getError(target, xhr));
    }

    onSuccess(handleResult && handleResult(target, xhr) || getBody(xhr));
  };

  xhr.open('post', target, true);

  if (timeout > 0) {
    xhr.timeout = timeout;
  }

  if (withCredentials) {
    xhr.withCredentials = true;
  }

  Object.keys(headers).forEach(function (key) {
    xhr.setRequestHeader(key, headers[key]);
  });
  xhr.send(formData);
  return xhr;
}
// CONCATENATED MODULE: ./src/components/upload/props.js

/* harmony default export */ var upload_props = ({
  value: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  action: {
    type: [String, Object]
  },
  mode: {
    type: String,
    validator: function validator(value) {
      return ['simple', 'detail'].includes(value);
    },
    default: 'detail'
  },
  simpleSize: {
    type: Number,
    default: 36
  },
  request: {
    type: Function,
    default: ajaxUploader
  },
  accept: {
    type: String,
    default: '*'
  },
  multiple: {
    type: Boolean,
    default: false
  },
  parallelCount: {
    type: Number,
    default: 5
  },
  maxSize: {
    type: [Number, String]
  },
  limit: {
    type: [Number, String]
  },
  disabled: {
    type: Boolean,
    default: false
  },
  deletable: {
    type: Boolean,
    default: true
  },
  processFile: {
    type: Function
  },
  beforeRemove: {
    type: Function
  },
  thumbnail: {
    type: Boolean,
    default: true
  },
  excludeThumbnail: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  base64: {
    type: [Boolean, Array],
    default: false
  },
  customize: {
    type: Boolean,
    default: false
  },
  format: {
    type: [Array, Function],
    default: function _default() {
      return [];
    }
  },
  auto: {
    type: Boolean,
    default: true
  },
  previewable: {
    type: Boolean,
    default: true
  },
  downloadable: {
    type: Boolean,
    default: true
  },
  batch: {
    type: Boolean,
    default: false
  },
  capture: {
    type: String
  },
  zIndex: {
    type: Number
  },
  placeholder: {
    type: String,
    default: '点击或拖拽文件上传'
  },
  uploadType: {
    type: String,
    default: 'default'
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload-modal.vue?vue&type=script&lang=js&
function upload_modalvue_type_script_lang_js_extends() { upload_modalvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return upload_modalvue_type_script_lang_js_extends.apply(this, arguments); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var upload_modalvue_type_script_lang_js_ = ({
  name: 'H3UploadModal',
  components: {
    H3Modal: modal,
    H3UploadDragger: upload_dragger,
    IconPlusStroke: basic_["IconPlusStroke"],
    H3UploadDetailItem: upload_detail_item,
    h3Dropdown: components_dropdown
  },
  mixins: [mixin],
  props: upload_modalvue_type_script_lang_js_extends({}, upload_props, {
    updatedFiles: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }),
  data: function data() {
    return {
      visible: false,
      initFileLen: 0
    };
  },
  computed: {
    itemProps: function itemProps() {
      var _this = this;

      return {
        thumbnail: this.thumbnail,
        deletable: this.deletable,
        disabled: this.disabled,
        previewable: this.previewable,
        downloadable: this.downloadable,
        isExclude: function isExclude(file) {
          return _this.isExclude(file);
        },
        getItemStyle: function getItemStyle(file, preview) {
          return _this.getItemStyle(file, preview);
        },
        getItemType: function getItemType(file) {
          return _this.getItemType(file);
        }
      };
    },
    outerLimit: function outerLimit() {
      return toNumber(this.limit, 0);
    },
    innerLimit: function innerLimit() {
      if (this.outerLimit === 0) {
        return 0;
      }

      return this.outerLimit - this.initFileLen;
    },
    updatedLen: function updatedLen() {
      return this.updatedFiles.length;
    },
    availableLen: function availableLen() {
      return this.innerLimit - this.files.length;
    },
    enableUpdate: function enableUpdate() {
      return this.outerLimit === 0 || this.availableLen > 0;
    }
  },
  created: function created() {
    this.pasteEvent = this.pasteEvent.bind(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.removeEvent();
  },
  methods: {
    open: function open() {
      this.visible = true;
      this.initFileLen = this.updatedFiles.length;
      this.files = [];
      this.addEvent();
      this.$emit('modalVisibleChange', true, this);
    },
    close: function close() {
      this.visible = false;
      this.removeEvent();
      this.$emit('modalVisibleChange', false, this);
    },
    cancel: function cancel() {
      this.close();
    },
    submit: function submit() {
      this.close();
    },
    afterClose: function afterClose() {
      this.files = [];
    },
    pasteEvent: function pasteEvent(event) {
      var items = event.clipboardData && event.clipboardData.items;
      var files = [];

      if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
          var file = items[i].getAsFile();

          if (file instanceof File) {
            files.push(file);
          }
        }
      } // 如果是截图，修改默认截图名称


      if (files.length === 1 && files[0].name.startsWith('image.')) {
        var newName = files[0].name.replace('image.', "\u622A\u56FE" + getCurrentTimeStr(new Date()) + ".");
        files[0] = new File([files[0]], newName, {
          type: files[0].type,
          lastModified: files[0].lastModified
        });
      }

      if (files.length > 0) {
        this.addFiles(files);
      }
    },
    addEvent: function addEvent() {
      window.addEventListener('paste', this.pasteEvent);
    },
    removeEvent: function removeEvent() {
      window.removeEventListener('paste', this.pasteEvent);
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/upload-modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_upload_modalvue_type_script_lang_js_ = (upload_modalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/upload/upload-modal.vue





/* normalize component */

var upload_modal_component = normalizeComponent(
  upload_upload_modalvue_type_script_lang_js_,
  upload_modalvue_type_template_id_11e65862_render,
  upload_modalvue_type_template_id_11e65862_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_modal_api; }
upload_modal_component.options.__file = "src/components/upload/upload-modal.vue"
/* harmony default export */ var upload_modal = (upload_modal_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/upload.vue?vue&type=script&lang=js&
function uploadvue_type_script_lang_js_extends() { uploadvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return uploadvue_type_script_lang_js_extends.apply(this, arguments); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
  name: 'H3Upload',
  components: {
    IconSearchStroke: basic_["IconSearchStroke"],
    IconCrossCircleFill: basic_["IconCrossCircleFill"],
    IconDownloadStroke: basic_["IconDownloadStroke"],
    IconCrossStroke: basic_["IconCrossStroke"],
    IconArrowReloadStroke: basic_["IconArrowReloadStroke"],
    IconPlusStroke: basic_["IconPlusStroke"],
    IconDeleteStroke: basic_["IconDeleteStroke"],
    H3UploadDragger: upload_dragger,
    H3UploadProgress: upload_progress,
    h3Dropdown: components_dropdown,
    H3Tooltip: components_tooltip,
    H3UploadModal: upload_modal,
    H3UploadDetailItem: upload_detail_item
  },
  mixins: [mixin],
  props: upload_props,
  data: function data() {
    return {};
  },
  computed: {
    canAdd: function canAdd() {
      return (!this.innerLimit || this.files.length < this.innerLimit) && !this.disabled;
    },
    uploadComponent: function uploadComponent() {
      return this.uploadType === 'modal' ? upload_modal : 'input';
    },
    uploadComponentProps: function uploadComponentProps() {
      return this.uploadType === 'modal' ? this.$props : {};
    },
    uploadComponentListeners: function uploadComponentListeners() {
      var _this = this;

      return this.uploadType === 'modal' ? uploadvue_type_script_lang_js_extends({}, this.$listeners, {
        done: function done() {
          return _this.fireDone();
        },
        input: function input(files) {
          files.forEach(function (file) {
            if (!_this.files.includes(file)) {
              _this.files.unshift(file);
            }
          });

          _this.$emit('input', _this.files);
        },
        removed: function removed(file, files) {
          var index = _this.files.findIndex(function (item) {
            return item === file;
          });

          if (index > -1) {
            _this.files.splice(index, 1);
          }

          _this.$emit('removed', file, files);
        }
      }) : {};
    },
    itemProps: function itemProps() {
      var _this2 = this;

      return {
        thumbnail: this.thumbnail,
        deletable: this.deletable,
        disabled: this.disabled,
        previewable: this.previewable,
        downloadable: this.downloadable,
        isExclude: function isExclude(file) {
          return _this2.isExclude(file);
        },
        getItemStyle: function getItemStyle(file, preview) {
          return _this2.getItemStyle(file, preview);
        },
        getItemType: function getItemType(file) {
          return _this2.getItemType(file);
        }
      };
    }
  },
  watch: {
    value: function value(nVal) {
      this.files = this.handleFiles(nVal);
    }
  },
  created: function created() {
    this.files = this.handleFiles(this.value);
  },
  beforeDestroy: function beforeDestroy() {
    this.files.forEach(function (file) {
      revokeURL(file);
      file._xhr && file._xhr.abort && file._xhr.abort();
    });
  },
  methods: {
    fireDragActive: function fireDragActive(active) {
      this.dragActive = active;
    },
    fireMainActive: function fireMainActive(active) {
      this.mainActive = active;
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload/upload.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/upload/upload.vue?vue&type=style&index=0&lang=less&
var uploadvue_type_style_index_0_lang_less_ = __webpack_require__(123);

// CONCATENATED MODULE: ./src/components/upload/upload.vue






/* normalize component */

var upload_component = normalizeComponent(
  upload_uploadvue_type_script_lang_js_,
  uploadvue_type_template_id_7982db22_render,
  uploadvue_type_template_id_7982db22_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_api; }
upload_component.options.__file = "src/components/upload/upload.vue"
/* harmony default export */ var upload_upload = (upload_component.exports);
// CONCATENATED MODULE: ./src/components/upload/index.js


upload_upload.install = function (Vue) {
  Vue.component('H3Upload', upload_upload);
};

/* harmony default export */ var components_upload = (upload_upload);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/tree-select/style"
var tree_select_style_ = __webpack_require__(124);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tree-select"
var tree_select_ = __webpack_require__(14);
var tree_select_default = /*#__PURE__*/__webpack_require__.n(tree_select_);

// CONCATENATED MODULE: ./src/components/tree-select/tree.js



function tree_extends() { tree_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tree_extends.apply(this, arguments); }






tree_select_default.a.methods.hide = function () {
  var _this2 = this;

  this.$refs.vcTreeSelect.setOpenState(false);
  window.setTimeout(function () {
    _this2.clearSearchValue();
  }, 200);
};

tree_select_default.a.methods.clearSearchValue = function () {
  this.$refs.vcTreeSelect.setState({
    _searchValue: ''
  });
  this.$emit('search', '');
};

var tempMounted = tree_select_default.a.mounted;

tree_select_default.a.mounted = function () {
  var vcTreeSelect = this.$refs.vcTreeSelect || {};
  var tempSetOpenState = vcTreeSelect.setOpenState; // eslint-disable-next-line @typescript-eslint/no-this-alias

  var _this = this;

  vcTreeSelect.setOpenState = function (open) {
    tempSetOpenState && tempSetOpenState.call(vcTreeSelect, open);

    _this.$emit('dropdownVisibleChange', open);
  };

  tempMounted && tempMounted.call(this);
};

var H3TreeSelect = {
  name: 'H3TreeSelect',
  functional: true,
  inheritAttrs: false,
  props: tree_extends({}, tree_select_default.a.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props,
        scopedSlots = context.scopedSlots; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-tree-select-node' : 'h3-tree-select-node'; // 设置默认最大高度为8条可见数据

    var defaultStyle = {
      maxHeight: '304px',
      overflow: 'auto'
    };
    props.dropdownStyle = props.dropdownStyle ? Object.assign(defaultStyle, props.dropdownStyle) : defaultStyle; // :dropdown-style="{maxHeight: '304px', overflow: 'auto'}"

    var slotContent = slots(); // 获取具名插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['maxTagPlaceholder', 'placeholder', 'searchPlaceholder', 'notFoundContent', 'suffixIcon', 'title']);
    var children = [slotContent.default].concat(slotChildren);

    if ('value' in props) {
      props.value = handleEmptyValue(props.value);
    }

    if ('defaultValue' in props) {
      props.defaultValue = handleEmptyValue(props.defaultValue);
    }

    var isSearching = !!props.searchValue;
    var customDropdown = 'h3-tree-select__dropdown';
    props.dropdownClassName = props.dropdownClassName ? props.dropdownClassName + ' ' + customDropdown : customDropdown;

    if (isSearching && slotContent.filter) {
      var customSearchDropdown = 'h3-tree-select__custom-search-dropdown';
      props.dropdownClassName = props.dropdownClassName ? props.dropdownClassName + ' ' + customSearchDropdown : customSearchDropdown;

      props.filterTreeNode = function (inputValue, treeNode) {
        // 过滤treeNode中的所有树节点
        // return treeNode.fnOptions && treeNode.fnOptions.isTreeNode;
        if (treeNode.componentOptions && treeNode.componentOptions.propsData) {
          var propsData = treeNode.componentOptions.propsData;
          return propsData.dataRef.isSearching;
        }

        return false;
      };

      if (props.treeData) {
        delete props.treeData;
      }

      if (data.attrs.treeData) {
        delete data.attrs.treeData;
      }

      var filterVNode = slotContent.filter;
      var childrenVNodes = vnode_getChildrenVNode(filterVNode, function (node) {
        if (node.componentOptions) {
          // todo 节点匹配规则
          return node.componentOptions.isH3TreeFilterNode || node.componentOptions.tag === 'h3-tree-filter-node';
        }

        return false;
      });
      var filteredTreeData = childrenVNodes.map(function (node) {
        return {
          key: "searching-" + node.key,
          disableCheckbox: true,
          selectable: false,
          value: "searching-" + node.componentOptions.propsData.value,
          title: h('div', {}, [node]),
          isSearching: true
        };
      });
      filteredTreeData = filteredTreeData.concat(childrenVNodes.map(function (node) {
        return {
          key: node.key,
          disableCheckbox: true,
          value: "" + node.componentOptions.propsData.value,
          title: node.componentOptions.propsData.title
        };
      }));
      props.treeData = filteredTreeData;
      children = [].concat(slotChildren);
    }

    if (props.onlyRead) props.disabled = true;
    return h(tree_select_default.a, tree_extends({
      props: props
    }, data, {
      scopedSlots: scopedSlots,
      // scopedSlots: {
      // suffixIcon: () => {
      //   return (
      //     <IconTrigonBottomFill
      //       class="ant-select-arrow-icon"
      //       style="font-size:14px"
      //     />
      //   );
      // },
      // },
      class: ['h3-tree-select', {
        'h3-tree-select--onlyread': props.onlyRead
      }]
    }), children);
  }
};
var H3TreeNode = tree_select_default.a.TreeNode;
// CONCATENATED MODULE: ./src/components/tree-select/filter-node.js
/* harmony default export */ var filter_node = ({
  name: 'H3TreeFilterNode',
  isH3TreeFilterNode: true,
  props: {
    title: String,
    value: String
  },
  methods: {
    clickHandler: function clickHandler() {
      this.$emit('click');
    }
  },
  render: function render(h) {
    var $slots = this.$slots;
    return h('li', {
      on: {
        click: this.clickHandler
      },
      class: 'h3-tree-select__custom-search'
    }, [$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/components/tree-select/index.js


H3TreeSelect.TreeNode = H3TreeNode;
H3TreeSelect.TreeFilterNode = filter_node;

H3TreeSelect.install = function (Vue) {
  Vue.component(H3TreeSelect.name, H3TreeSelect);
  Vue.component('H3TreeSelectNode', H3TreeSelect.TreeNode);
  Vue.component(H3TreeSelect.TreeFilterNode.name, H3TreeSelect.TreeFilterNode);
};

/* harmony default export */ var tree_select = (H3TreeSelect);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/tag/style"
var tag_style_ = __webpack_require__(125);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tag"
var tag_ = __webpack_require__(31);
var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);

// CONCATENATED MODULE: ./src/components/tag/index.js



function tag_extends() { tag_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_extends.apply(this, arguments); }


var H3Tag = {
  name: 'H3Tag',
  functional: true,
  inheritAttrs: false,
  props: tag_extends({}, tag_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-tag' : 'h3-tag';
    var slotContent = slots();
    var children = slotContent.default;
    return h(tag_default.a, tag_extends({
      props: props
    }, data), children);
  }
};
H3Tag.CheckableTag = tag_default.a.CheckableTag;

H3Tag.install = function (Vue) {
  Vue.component(H3Tag.name, H3Tag);
  Vue.component('H3CheckableTag', tag_default.a.CheckableTag);
};

/* harmony default export */ var tag = (H3Tag);
// CONCATENATED MODULE: ./src/components/checkbox/index.js



function checkbox_extends() { checkbox_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkbox_extends.apply(this, arguments); }



var H3Checkbox = {
  name: 'H3Checkbox',
  functional: true,
  inheritAttrs: false,
  props: checkbox_extends({}, checkbox_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-checkbox' : 'h3-checkbox') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots();
    var children = slotContent.default;
    return h(checkbox_default.a, checkbox_extends({
      props: props
    }, data), children);
  }
};
var H3CheckboxGroup = {
  functional: true,
  inheritAttrs: false,
  props: checkbox_extends({}, checkbox_default.a.Group.props),
  render: function render(h, context) {
    var data = context.data,
        props = context.props,
        slots = context.slots;
    data.staticClass = data.staticClass ? data.staticClass + ' h3-checkbox-group' : 'h3-checkbox-group';
    var slotContent = slots();
    var children = slotContent.default;
    return h(checkbox_default.a.Group, checkbox_extends({
      props: props
    }, data), children);
  }
};
H3Checkbox.Group = H3CheckboxGroup;

H3Checkbox.install = function (Vue) {
  Vue.component(H3Checkbox.name, H3Checkbox);
  Vue.component('H3CheckboxGroup', H3CheckboxGroup); // 注册 H3CheckboxGroup 组件
};

/* harmony default export */ var components_checkbox = (H3Checkbox);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/switch/style"
var switch_style_ = __webpack_require__(126);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/switch"
var switch_ = __webpack_require__(55);
var switch_default = /*#__PURE__*/__webpack_require__.n(switch_);

// CONCATENATED MODULE: ./src/components/switch/index.js



function switch_extends() { switch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return switch_extends.apply(this, arguments); }



var H3Switch = {
  name: 'H3Switch',
  functional: true,
  inheritAttrs: false,
  props: switch_extends({}, switch_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-switch' : 'h3-switch';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['checkedChildren', 'unCheckedChildren']);
    var children = [slotContent.default].concat(slotChildren);
    return h(switch_default.a, switch_extends({
      props: props
    }, data), children);
  }
};

H3Switch.install = function (Vue) {
  Vue.component(H3Switch.name, H3Switch);
};

/* harmony default export */ var components_switch = (H3Switch);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/radio/style"
var radio_style_ = __webpack_require__(127);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/radio"
var radio_ = __webpack_require__(19);
var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);

// CONCATENATED MODULE: ./src/components/radio/index.js



function radio_extends() { radio_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return radio_extends.apply(this, arguments); }


var H3Radio = {
  name: 'H3Radio',
  functional: true,
  inheritAttrs: false,
  props: radio_extends({}, radio_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-radio' : 'h3-radio';
    var slotContent = slots();
    var children = slotContent.default;
    return h(radio_default.a, radio_extends({
      props: props
    }, data), children);
  }
};
H3Radio.Group = radio_default.a.Group;
H3Radio.Button = radio_default.a.Button;

H3Radio.install = function (Vue) {
  Vue.component(H3Radio.name, H3Radio);
  Vue.component('H3RadioGroup', radio_default.a.Group);
  Vue.component('H3RadioButton', radio_default.a.Button);
};

/* harmony default export */ var components_radio = (H3Radio);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/date-picker/style"
var date_picker_style_ = __webpack_require__(128);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/date-picker"
var date_picker_ = __webpack_require__(5);
var date_picker_default = /*#__PURE__*/__webpack_require__.n(date_picker_);

// CONCATENATED MODULE: ./src/components/date-picker/index.js



function date_picker_extends() { date_picker_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return date_picker_extends.apply(this, arguments); }




var H3DatePicker = {
  name: 'H3DatePicker',
  functional: true,
  inheritAttrs: false,
  props: date_picker_extends({}, date_picker_default.a.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-date-picker' : 'h3-date-picker') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['suffixIcon', 'unCheckedChildren', 'dateRender', 'renderExtraFooter', 'monthCellContentRender']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(date_picker_default.a, date_picker_extends({
      props: props
    }, data, {
      class: ['h3-date-picker', {
        'h3-date-picker--onlyread': props.onlyRead
      }]
    }), children);
  }
};
var H3RangePicker = {
  name: 'H3RangePicker',
  functional: true,
  inheritAttrs: false,
  props: date_picker_extends({}, date_picker_default.a.props, date_picker_default.a.RangePicker.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-range-picker' : 'h3-range-picker') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['suffixIcon', 'unCheckedChildren', 'dateRender', 'renderExtraFooter', 'monthCellContentRender']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(date_picker_default.a.RangePicker, date_picker_extends({
      props: props
    }, data, {
      class: ['h3-range-picker', {
        'h3-range-picker--onlyread': props.onlyRead
      }]
    }), children);
  }
};
var H3MonthPicker = {
  name: 'H3MonthPicker',
  functional: true,
  inheritAttrs: false,
  props: date_picker_extends({}, date_picker_default.a.props, date_picker_default.a.MonthPicker.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-month-picker' : 'h3-month-picker') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['suffixIcon', 'unCheckedChildren', 'dateRender', 'renderExtraFooter', 'monthCellContentRender']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(date_picker_default.a.MonthPicker, date_picker_extends({
      props: props
    }, data, {
      class: ['h3-month-picker', {
        'h3-month-picker--onlyread': props.onlyRead
      }]
    }), children);
  }
};
var H3WeekPicker = {
  name: 'H3WeekPicker',
  functional: true,
  inheritAttrs: false,
  props: date_picker_extends({}, date_picker_default.a.props, date_picker_default.a.WeekPicker.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-week-picker' : 'h3-week-picker') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['suffixIcon', 'unCheckedChildren', 'dateRender', 'renderExtraFooter', 'monthCellContentRender']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(date_picker_default.a.WeekPicker, date_picker_extends({
      props: props
    }, data, {
      class: ['h3-week-picker', {
        'h3-week-picker--onlyread': props.onlyRead
      }]
    }), children);
  }
};
H3DatePicker.RangePicker = H3RangePicker;
H3DatePicker.MonthPicker = H3MonthPicker;
H3DatePicker.WeekPicker = H3WeekPicker;

H3DatePicker.install = function (Vue) {
  Vue.component(H3DatePicker.name, H3DatePicker);
  Vue.component('H3RangePicker', H3DatePicker.RangePicker);
  Vue.component('H3MonthPicker', H3DatePicker.MonthPicker);
  Vue.component('H3WeekPicker', H3DatePicker.WeekPicker);
};

/* harmony default export */ var date_picker = (H3DatePicker);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/time-picker/style"
var time_picker_style_ = __webpack_require__(129);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/time-picker"
var time_picker_ = __webpack_require__(56);
var time_picker_default = /*#__PURE__*/__webpack_require__.n(time_picker_);

// CONCATENATED MODULE: ./src/components/time-picker/index.js



function time_picker_extends() { time_picker_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time_picker_extends.apply(this, arguments); }




var H3TimePicker = {
  name: 'H3TimePicker',
  functional: true,
  inheritAttrs: false,
  props: time_picker_extends({}, time_picker_default.a.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-time-picker' : 'h3-time-picker') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['addon', 'suffixIcon', 'clearIcon']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(time_picker_default.a, time_picker_extends({
      props: props
    }, data, {
      class: ['h3-time-picker', {
        'h3-time-picker--onlyread': props.onlyRead
      }]
    }), children);
  }
};

H3TimePicker.install = function (Vue) {
  Vue.component(H3TimePicker.name, H3TimePicker);
};

/* harmony default export */ var time_picker = (H3TimePicker);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/drawer/style"
var drawer_style_ = __webpack_require__(130);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/drawer"
var drawer_ = __webpack_require__(57);
var drawer_default = /*#__PURE__*/__webpack_require__.n(drawer_);

// CONCATENATED MODULE: ./src/components/drawer/index.js



function drawer_extends() { drawer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return drawer_extends.apply(this, arguments); }



var H3Drawer = {
  name: 'H3Drawer',
  functional: true,
  inheritAttrs: false,
  props: drawer_extends({}, drawer_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-drawer' : 'h3-drawer';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['title', 'handle']);
    var children = [slotContent.default].concat(slotChildren);
    return h(drawer_default.a, drawer_extends({
      props: props
    }, data), children);
  }
};

H3Drawer.install = function (Vue) {
  Vue.component(H3Drawer.name, H3Drawer);
};

/* harmony default export */ var drawer = (H3Drawer);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/cascader/style"
var cascader_style_ = __webpack_require__(131);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/cascader"
var cascader_ = __webpack_require__(58);
var cascader_default = /*#__PURE__*/__webpack_require__.n(cascader_);

// CONCATENATED MODULE: ./src/components/cascader/index.js



function cascader_extends() { cascader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cascader_extends.apply(this, arguments); }




var H3Cascader = {
  name: 'H3Cascader',
  functional: true,
  inheritAttrs: false,
  props: cascader_extends({}, cascader_default.a.props, {
    onlyRead: {
      type: Boolean,
      default: false
    }
  }),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-cascader' : 'h3-cascader') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['displayRender', 'suffixIcon', 'showSearchRender']);
    var children = [slotContent.default].concat(slotChildren);
    if (props.onlyRead) props.disabled = true;
    return h(cascader_default.a, cascader_extends({
      props: props
    }, data, {
      class: ['h3-cascader', {
        'h3-cascader--onlyread': props.onlyRead
      }]
    }), children);
  }
};

H3Cascader.install = function (Vue) {
  Vue.component(H3Cascader.name, H3Cascader);
};

/* harmony default export */ var cascader = (H3Cascader);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/avatar/style"
var avatar_style_ = __webpack_require__(132);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/avatar"
var avatar_ = __webpack_require__(59);
var avatar_default = /*#__PURE__*/__webpack_require__.n(avatar_);

// CONCATENATED MODULE: ./src/components/avatar/index.js



function avatar_extends() { avatar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return avatar_extends.apply(this, arguments); }



var H3Avatar = {
  name: 'H3Avatar',
  functional: true,
  inheritAttrs: false,
  props: avatar_extends({}, avatar_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-avatar' : 'h3-avatar';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['icon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(avatar_default.a, avatar_extends({
      props: props
    }, data), children);
  }
};

H3Avatar.install = function (Vue) {
  Vue.component(H3Avatar.name, H3Avatar);
};

/* harmony default export */ var avatar = (H3Avatar);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/empty/style"
var empty_style_ = __webpack_require__(133);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/empty"
var empty_ = __webpack_require__(32);
var empty_default = /*#__PURE__*/__webpack_require__.n(empty_);

// CONCATENATED MODULE: ./src/components/empty/index.js



function empty_extends() { empty_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return empty_extends.apply(this, arguments); }



var H3Empty = {
  name: 'H3Empty',
  functional: true,
  inheritAttrs: false,
  props: empty_extends({}, empty_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-empty' : 'h3-empty';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['description']);
    var children = [slotContent.default].concat(slotChildren);
    return h(empty_default.a, empty_extends({
      props: props
    }, data), children);
  }
};
H3Empty.PRESENTED_IMAGE_SIMPLE = empty_default.a.PRESENTED_IMAGE_SIMPLE;
H3Empty.PRESENTED_IMAGE_DEFAULT = empty_default.a.PRESENTED_IMAGE_DEFAULT;

H3Empty.install = function (Vue) {
  Vue.component(H3Empty.name, H3Empty);
};

/* harmony default export */ var empty = (H3Empty);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/form/style"
var form_style_ = __webpack_require__(134);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/form"
var form_ = __webpack_require__(33);
var form_default = /*#__PURE__*/__webpack_require__.n(form_);

// CONCATENATED MODULE: ./src/components/form/index.js



function form_extends() { form_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return form_extends.apply(this, arguments); }



var H3Form = {
  name: 'H3Form',
  functional: true,
  inheritAttrs: false,
  props: form_extends({}, form_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-form' : 'h3-form';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['help', 'label', 'extra']);
    var children = [slotContent.default].concat(slotChildren);
    return h(form_default.a, form_extends({
      props: props
    }, data), children);
  }
};
H3Form.Item = form_default.a.Item;

H3Form.install = function (Vue) {
  Vue.component(H3Form.name, H3Form);
  Vue.component('H3FormItem', form_default.a.Item);
  Vue.prototype.$form = H3Form;
};

/* harmony default export */ var components_form = (H3Form);
// CONCATENATED MODULE: ./src/components/icon/index.js



function icon_extends() { icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_extends.apply(this, arguments); }


var H3Icon = {
  name: 'H3Icon',
  functional: true,
  inheritAttrs: false,
  props: icon_extends({}, icon_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-form' : 'h3-form';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var children = slotContent.default;
    return h(icon_default.a, icon_extends({
      props: props
    }, data), children);
  }
};

H3Icon.createFromIconfontCN = function (options) {
  return icon_default.a.createFromIconfontCN(options);
};

H3Icon.install = function (Vue) {
  Vue.component(H3Icon.name, H3Icon);
};

/* harmony default export */ var icon = (H3Icon);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/input-number/style"
var input_number_style_ = __webpack_require__(135);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/input-number"
var input_number_ = __webpack_require__(60);
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);

// CONCATENATED MODULE: ./src/components/input-number/index.js



function input_number_extends() { input_number_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return input_number_extends.apply(this, arguments); }


var H3InputNumber = {
  name: 'H3InputNumber',
  functional: true,
  inheritAttrs: false,
  props: input_number_extends({}, input_number_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-input-number' : 'h3-input-number';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var children = slotContent.default;
    return h(input_number_default.a, input_number_extends({
      props: props
    }, data), children);
  }
};

H3InputNumber.install = function (Vue) {
  Vue.component(H3InputNumber.name, H3InputNumber);
};

/* harmony default export */ var input_number = (H3InputNumber);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/table/style"
var table_style_ = __webpack_require__(136);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/table"
var table_ = __webpack_require__(61);
var table_default = /*#__PURE__*/__webpack_require__.n(table_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/table/table.vue?vue&type=script&lang=js&




function tablevue_type_script_lang_js_extends() { tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tablevue_type_script_lang_js_extends.apply(this, arguments); }

/* harmony default export */ var tablevue_type_script_lang_js_ = ({
  name: 'H3Table',
  components: {
    ATable: table_default.a
  },
  props: tablevue_type_script_lang_js_extends({}, table_default.a.props),
  data: function data() {
    return {};
  },
  computed: {
    // 组装新的 props
    newProps: function newProps() {
      var attrs = {
        props: tablevue_type_script_lang_js_extends({}, this.$props),
        scopedSlots: this.$scopedSlots,
        on: tablevue_type_script_lang_js_extends({}, this.$listeners)
      };
      return attrs;
    }
  },
  watch: {},
  created: function created() {},
  methods: {},
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("a-table", babel_helper_vue_jsx_merge_props_default()([{
      "class": "h3-table"
    }, this.newProps]), [Object.keys(this.$slots).map(function (name) {
      return h("template", {
        "slot": name
      }, [_this.$slots[name]]);
    })]);
  }
});
// CONCATENATED MODULE: ./src/components/table/table.vue?vue&type=script&lang=js&
 /* harmony default export */ var table_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/table/table.vue
var table_render, table_staticRenderFns




/* normalize component */

var table_component = normalizeComponent(
  table_tablevue_type_script_lang_js_,
  table_render,
  table_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var table_api; }
table_component.options.__file = "src/components/table/table.vue"
/* harmony default export */ var table = (table_component.exports);
// CONCATENATED MODULE: ./src/components/table/index.js


table.install = function (Vue) {
  Vue.component(table.name, table);
};

/* harmony default export */ var components_table = (table);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/carousel/style"
var carousel_style_ = __webpack_require__(137);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/carousel"
var carousel_ = __webpack_require__(62);
var carousel_default = /*#__PURE__*/__webpack_require__.n(carousel_);

// CONCATENATED MODULE: ./src/components/carousel/index.js



function carousel_extends() { carousel_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carousel_extends.apply(this, arguments); }



var H3Carousel = {
  name: 'H3Carousel',
  functional: true,
  inheritAttrs: false,
  props: carousel_extends({}, carousel_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-carousel' : 'h3-carousel';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['customPaging', 'prevArrow', 'nextArrow']);
    var children = [slotContent.default].concat(slotChildren);
    return h(carousel_default.a, carousel_extends({
      props: props
    }, data), children);
  }
};

H3Carousel.install = function (Vue) {
  Vue.component(H3Carousel.name, H3Carousel);
};

/* harmony default export */ var carousel = (H3Carousel);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/timeline/style"
var timeline_style_ = __webpack_require__(138);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/timeline"
var timeline_ = __webpack_require__(34);
var timeline_default = /*#__PURE__*/__webpack_require__.n(timeline_);

// CONCATENATED MODULE: ./src/components/timeline/index.js



function timeline_extends() { timeline_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return timeline_extends.apply(this, arguments); }



var H3Timeline = {
  name: 'H3Timeline',
  functional: true,
  inheritAttrs: false,
  props: timeline_extends({}, timeline_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-timeline' : 'h3-timeline';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['pendingDot', 'dot']);
    var children = [slotContent.default].concat(slotChildren);
    return h(timeline_default.a, timeline_extends({
      props: props
    }, data), children);
  }
};
H3Timeline.Item = timeline_default.a.Item;

H3Timeline.install = function (Vue) {
  Vue.component(H3Timeline.name, H3Timeline);
  Vue.component('H3TimelineItem', timeline_default.a.Item);
};

/* harmony default export */ var timeline = (H3Timeline);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/progress/style"
var progress_style_ = __webpack_require__(139);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/progress"
var progress_ = __webpack_require__(45);
var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);

// CONCATENATED MODULE: ./src/components/progress/index.js



function progress_extends() { progress_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return progress_extends.apply(this, arguments); }



var H3Progress = {
  name: 'H3Progress',
  functional: true,
  inheritAttrs: false,
  model: progress_default.a.model,
  props: progress_extends({}, progress_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-progress' : 'h3-progress';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['format']);
    var children = [slotContent.default].concat(slotChildren);
    return h(progress_default.a, progress_extends({
      props: props
    }, data), children);
  }
};

H3Progress.install = function (Vue) {
  Vue.component(H3Progress.name, H3Progress);
};

/* harmony default export */ var components_progress = (H3Progress);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/tree/style"
var tree_style_ = __webpack_require__(140);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/tree"
var tree_ = __webpack_require__(20);
var tree_default = /*#__PURE__*/__webpack_require__.n(tree_);

// CONCATENATED MODULE: ./src/components/tree/index.js



function components_tree_extends() { components_tree_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return components_tree_extends.apply(this, arguments); }



var H3Tree = {
  name: 'H3Tree',
  functional: true,
  inheritAttrs: false,
  props: components_tree_extends({}, tree_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-tree' : 'h3-tree';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['switcherIcon', 'title', 'icon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(tree_default.a, components_tree_extends({
      props: props
    }, data), children);
  }
};
H3Tree.TreeNode = tree_default.a.TreeNode;
H3Tree.DirectoryTree = tree_default.a.DirectoryTree;

H3Tree.install = function (Vue) {
  Vue.component(H3Tree.name, H3Tree);
  Vue.component('H3TreeTreeNode', tree_default.a.TreeNode);
  Vue.component('H3TreeDirectoryTree', tree_default.a.DirectoryTree);
};

/* harmony default export */ var tree = (H3Tree);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/menu/style"
var menu_style_ = __webpack_require__(141);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/menu"
var menu_ = __webpack_require__(6);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu_);

// CONCATENATED MODULE: ./src/components/menu/index.js



function menu_extends() { menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }



var H3Menu = {
  name: 'H3Menu',
  functional: true,
  inheritAttrs: false,
  model: menu_default.a.model,
  props: menu_extends({}, menu_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-menu' : 'h3-menu';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['title']);
    var children = [slotContent.default].concat(slotChildren);
    return h(menu_default.a, menu_extends({
      props: props
    }, data), children);
  }
};
H3Menu.Item = menu_default.a.Item;
H3Menu.SubMenu = menu_default.a.SubMenu;
H3Menu.Divider = menu_default.a.Divider;
H3Menu.ItemGroup = menu_default.a.ItemGroup;

H3Menu.install = function (Vue) {
  Vue.component(H3Menu.name, H3Menu);
  Vue.component('H3MenuItem', menu_default.a.Item);
  Vue.component('H3SubMenu', menu_default.a.SubMenu);
  Vue.component('H3MenuDivider', menu_default.a.Divider);
  Vue.component('H3MenuItemGroup', menu_default.a.ItemGroup);
};

/* harmony default export */ var menu = (H3Menu);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/form-model/style"
var form_model_style_ = __webpack_require__(142);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/form-model"
var form_model_ = __webpack_require__(35);
var form_model_default = /*#__PURE__*/__webpack_require__.n(form_model_);

// CONCATENATED MODULE: ./src/components/form-model/index.js



function form_model_extends() { form_model_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return form_model_extends.apply(this, arguments); }



var H3FormModel = {
  name: 'H3FormModel',
  functional: true,
  inheritAttrs: false,
  props: form_model_extends({}, form_model_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-form-model' : 'h3-form-model';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['help', 'label', 'extra']);
    var children = [slotContent.default].concat(slotChildren);
    return h(form_model_default.a, form_model_extends({
      props: props
    }, data), children);
  }
};
H3FormModel.Item = form_model_default.a.Item;

H3FormModel.install = function (Vue) {
  Vue.component(H3FormModel.name, H3FormModel);
  Vue.component('H3FormModelItem', form_model_default.a.Item);
};

/* harmony default export */ var form_model = (H3FormModel);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/badge/style"
var badge_style_ = __webpack_require__(143);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/badge"
var badge_ = __webpack_require__(63);
var badge_default = /*#__PURE__*/__webpack_require__.n(badge_);

// CONCATENATED MODULE: ./src/components/badge/index.js



function badge_extends() { badge_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_extends.apply(this, arguments); }



var H3Badge = {
  name: 'H3Badge',
  functional: true,
  inheritAttrs: false,
  props: badge_extends({}, badge_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-badge' : 'h3-badge';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['count']);
    var children = [slotContent.default].concat(slotChildren);
    return h(badge_default.a, badge_extends({
      props: props
    }, data), children);
  }
};

H3Badge.install = function (Vue) {
  Vue.component(H3Badge.name, H3Badge);
};

/* harmony default export */ var badge = (H3Badge);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/collapse/style"
var collapse_style_ = __webpack_require__(144);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/collapse"
var collapse_ = __webpack_require__(27);
var collapse_default = /*#__PURE__*/__webpack_require__.n(collapse_);

// CONCATENATED MODULE: ./src/components/collapse/index.js



function collapse_extends() { collapse_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collapse_extends.apply(this, arguments); }



var H3Collapse = {
  name: 'H3Collapse',
  functional: true,
  inheritAttrs: false,
  model: collapse_default.a.model,
  props: collapse_extends({}, collapse_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-collapse' : 'h3-collapse';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['extra', 'header', 'expandIcon']);
    var children = [slotContent.default].concat(slotChildren);
    return h(collapse_default.a, collapse_extends({
      props: props
    }, data), children);
  }
};
H3Collapse.Panel = collapse_default.a.Panel;

H3Collapse.install = function (Vue) {
  Vue.component(H3Collapse.name, H3Collapse);
  Vue.component('H3CollapsePanel', collapse_default.a.Panel);
};

/* harmony default export */ var collapse = (H3Collapse);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/pagination/style"
var pagination_style_ = __webpack_require__(145);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/pagination"
var pagination_ = __webpack_require__(46);
var pagination_default = /*#__PURE__*/__webpack_require__.n(pagination_);

// CONCATENATED MODULE: ./src/components/pagination/index.js



function pagination_extends() { pagination_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pagination_extends.apply(this, arguments); }



var H3Pagination = {
  name: 'H3Pagination',
  functional: true,
  inheritAttrs: false,
  model: pagination_default.a.model,
  props: pagination_extends({}, pagination_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-pagination' : 'h3-pagination';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, []);
    var children = [slotContent.default].concat(slotChildren);
    return h(pagination_default.a, pagination_extends({
      props: props
    }, data), children);
  }
};

H3Pagination.install = function (Vue) {
  Vue.component(H3Pagination.name, H3Pagination);
};

/* harmony default export */ var pagination = (H3Pagination);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/notification/style"
var notification_style_ = __webpack_require__(146);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/notification"
var notification_ = __webpack_require__(2);
var notification_default = /*#__PURE__*/__webpack_require__.n(notification_);

// CONCATENATED MODULE: ./src/components/notification/index.js



function notification_extends() { notification_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notification_extends.apply(this, arguments); }



var H3Notification = {
  name: 'H3Notification',
  functional: true,
  inheritAttrs: false,
  model: notification_default.a.model,
  props: notification_extends({}, notification_default.a.props, {
    size: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    contentTip: String,
    maxContentHeight: Number
  }),
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        slots = _ref.slots;
    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-notification' : 'h3-notification';
    var slotContent = slots();
    var children = slotContent.default;
    return h(notification_default.a, notification_extends({
      props: props
    }, data), children);
  }
};

function h3NotificationAdaptor(method, icon) {
  // TODO 临时方案，整体做了国际化之后，将此代码删除
  return function (opts) {
    var options = notification_extends({}, opts);

    var wrapClass = 'h3-notification';
    options.class = options.class ? options.class + ' ' + wrapClass : wrapClass;

    options.icon = function (h) {
      return h(icon, {
        class: 'anticon'
      });
    };

    return method(options);
  };
} // 信息提示弹窗


H3Notification.info = h3NotificationAdaptor(notification_default.a.info, basic_["IconInfoCirlceFill"]); // 成功提示弹窗

H3Notification.success = h3NotificationAdaptor(notification_default.a.success, basic_["IconTickCircleFill"]); // 警告提示弹窗

H3Notification.warning = h3NotificationAdaptor(notification_default.a.warning, basic_["IconExclamationCircleFill"]); // 警告提示弹窗

H3Notification.warn = H3Notification.warning; // 错误提示弹窗

H3Notification.error = h3NotificationAdaptor(notification_default.a.error, basic_["IconCrossCircleFill"]); // 确认提示弹窗

H3Notification.confirm = h3NotificationAdaptor(notification_default.a.confirm, basic_["IconQuestionCircleFill"]);

H3Notification.open = function (options) {
  notification_default.a.open(options);
};

H3Notification.close = function (key) {
  notification_default.a.close(key);
};

H3Notification.destroy = function () {
  notification_default.a.destroy();
};

H3Notification.config = function (options) {
  notification_default.a.config(options);
};

H3Notification.install = function (Vue) {
  Vue.prototype.$notification = H3Notification;
  Vue.component(H3Notification.name, H3Notification);
};

/* harmony default export */ var notification = (H3Notification);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/result/style"
var result_style_ = __webpack_require__(147);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/result"
var result_ = __webpack_require__(64);
var result_default = /*#__PURE__*/__webpack_require__.n(result_);

// CONCATENATED MODULE: ./src/components/result/index.js



function result_extends() { result_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return result_extends.apply(this, arguments); }


var H3Result = {
  name: 'H3Result',
  functional: true,
  inheritAttrs: false,
  props: result_extends({}, result_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-result' : 'h3-result';
    var slotContent = slots();
    var children = slotContent.default;
    return h(result_default.a, result_extends({
      props: props
    }, data), children);
  }
};

H3Result.install = function (Vue) {
  Vue.component(H3Result.name, H3Result);
};

/* harmony default export */ var components_result = (H3Result);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/divider/style"
var divider_style_ = __webpack_require__(148);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/divider"
var divider_ = __webpack_require__(65);
var divider_default = /*#__PURE__*/__webpack_require__.n(divider_);

// CONCATENATED MODULE: ./src/components/divider/index.js



function divider_extends() { divider_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return divider_extends.apply(this, arguments); }


var H3Divider = {
  name: 'H3Divider',
  functional: true,
  inheritAttrs: false,
  props: divider_extends({}, divider_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-divider' : 'h3-divider';
    var slotContent = slots();
    var children = slotContent.default;
    return h(divider_default.a, divider_extends({
      props: props
    }, data), children);
  }
};

H3Divider.install = function (Vue) {
  Vue.component(H3Divider.name, H3Divider);
};

/* harmony default export */ var divider = (H3Divider);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/descriptions/style"
var descriptions_style_ = __webpack_require__(149);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/descriptions"
var descriptions_ = __webpack_require__(47);
var descriptions_default = /*#__PURE__*/__webpack_require__.n(descriptions_);

// CONCATENATED MODULE: ./src/components/descriptions/index.js



function descriptions_extends() { descriptions_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return descriptions_extends.apply(this, arguments); }



var H3Descriptions = {
  name: 'H3Descriptions',
  functional: true,
  inheritAttrs: false,
  props: descriptions_extends({}, descriptions_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-descriptions' : 'h3-descriptions';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['title', 'label']);
    var children = [slotContent.default].concat(slotChildren);
    return h(descriptions_default.a, descriptions_extends({
      props: props
    }, data), children);
  }
};
H3Descriptions.Item = descriptions_default.a.Item;

H3Descriptions.install = function (Vue) {
  Vue.component(H3Descriptions.name, H3Descriptions);
  Vue.component('H3DescriptionsItem', H3Descriptions.Item);
};

/* harmony default export */ var descriptions = (H3Descriptions);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/page-header/style"
var page_header_style_ = __webpack_require__(150);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/page-header"
var page_header_ = __webpack_require__(66);
var page_header_default = /*#__PURE__*/__webpack_require__.n(page_header_);

// CONCATENATED MODULE: ./src/components/page-header/index.js



function page_header_extends() { page_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return page_header_extends.apply(this, arguments); }



var H3PageHeader = {
  name: 'H3PageHeader',
  functional: true,
  inheritAttrs: false,
  props: page_header_extends({}, page_header_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-pageHeader' : 'h3-pageHeader';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['title', 'subTitle', 'backIcon', 'extra', 'footer']);
    var children = [slotContent.default].concat(slotChildren);
    return h(page_header_default.a, page_header_extends({
      props: props
    }, data), children);
  }
};

H3PageHeader.install = function (Vue) {
  Vue.component(H3PageHeader.name, H3PageHeader);
};

/* harmony default export */ var page_header = (H3PageHeader);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/list/style"
var list_style_ = __webpack_require__(151);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/list"
var list_ = __webpack_require__(36);
var list_default = /*#__PURE__*/__webpack_require__.n(list_);

// CONCATENATED MODULE: ./src/components/list/index.js



function list_extends() { list_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return list_extends.apply(this, arguments); }



var H3List = {
  name: 'H3List',
  functional: true,
  inheritAttrs: false,
  props: list_extends({}, list_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-list' : 'h3-list';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['footer', 'header', 'loadMore', 'renderItem', 'rowKey']);
    var children = [slotContent.default].concat(slotChildren);
    return h(list_default.a, list_extends({
      props: props
    }, data), children);
  }
};
H3List.Item = list_default.a.Item;
H3List.Item.Meta = list_default.a.Item.Meta;

H3List.install = function (Vue) {
  Vue.component(H3List.name, H3List);
  Vue.component('H3ListItem', H3List.Item);
  Vue.component('H3ListItemMeta', H3List.Item.Meta);
};

/* harmony default export */ var components_list = (H3List);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/card/style"
var card_style_ = __webpack_require__(152);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/card"
var card_ = __webpack_require__(37);
var card_default = /*#__PURE__*/__webpack_require__.n(card_);

// CONCATENATED MODULE: ./src/components/card/index.js



function card_extends() { card_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return card_extends.apply(this, arguments); }



var H3Card = {
  name: 'H3Card',
  functional: true,
  inheritAttrs: false,
  props: card_extends({}, card_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-card' : 'h3-card';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['actions', 'cover', 'extra', 'tabList', 'tabBarExtraContent', 'title', 'avatar', 'description', 'title']);
    var children = [slotContent.default].concat(slotChildren);
    return h(card_default.a, card_extends({
      props: props
    }, data), children);
  }
};
H3Card.Grid = card_default.a.Grid;
H3Card.Meta = card_default.a.Meta;

H3Card.install = function (Vue) {
  Vue.component(H3Card.name, H3Card);
  Vue.component('H3CardGrid', H3Card.Grid);
  Vue.component('H3CardMeta', H3Card.Meta);
};

/* harmony default export */ var card = (H3Card);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/slider/style"
var slider_style_ = __webpack_require__(153);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/slider"
var slider_ = __webpack_require__(67);
var slider_default = /*#__PURE__*/__webpack_require__.n(slider_);

// CONCATENATED MODULE: ./src/components/slider/index.js



function slider_extends() { slider_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return slider_extends.apply(this, arguments); }


var H3Slider = {
  name: 'H3Slider',
  functional: true,
  inheritAttrs: false,
  props: slider_extends({}, slider_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-slider' : 'h3-slider';
    var slotContent = slots();
    var children = slotContent.default;
    return h(slider_default.a, slider_extends({
      props: props
    }, data), children);
  }
};

H3Slider.install = function (Vue) {
  Vue.component(H3Slider.name, H3Slider);
};

/* harmony default export */ var slider = (H3Slider);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/rate/style"
var rate_style_ = __webpack_require__(154);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/rate"
var rate_ = __webpack_require__(68);
var rate_default = /*#__PURE__*/__webpack_require__.n(rate_);

// CONCATENATED MODULE: ./src/components/rate/index.js



function rate_extends() { rate_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rate_extends.apply(this, arguments); }



var H3Rate = {
  name: 'H3Rate',
  functional: true,
  inheritAttrs: false,
  props: rate_extends({}, rate_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-rate' : 'h3-rate';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['character']);
    var children = [slotContent.default].concat(slotChildren);
    return h(rate_default.a, rate_extends({
      props: props
    }, data), children);
  }
};

H3Rate.install = function (Vue) {
  Vue.component(H3Rate.name, H3Rate);
};

/* harmony default export */ var rate = (H3Rate);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/transfer/style"
var transfer_style_ = __webpack_require__(155);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/transfer"
var transfer_ = __webpack_require__(69);
var transfer_default = /*#__PURE__*/__webpack_require__.n(transfer_);

// CONCATENATED MODULE: ./src/components/transfer/index.js



function transfer_extends() { transfer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return transfer_extends.apply(this, arguments); }



var H3Transfer = {
  name: 'H3Transfer',
  functional: true,
  inheritAttrs: false,
  props: transfer_extends({}, transfer_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-transfer' : 'h3-transfer';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['footer', 'children']);
    var children = [slotContent.default].concat(slotChildren);
    return h(transfer_default.a, transfer_extends({
      props: props
    }, data), children);
  }
};

H3Transfer.install = function (Vue) {
  Vue.component(H3Transfer.name, H3Transfer);
};

/* harmony default export */ var transfer = (H3Transfer);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/auto-complete/style"
var auto_complete_style_ = __webpack_require__(156);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/auto-complete"
var auto_complete_ = __webpack_require__(70);
var auto_complete_default = /*#__PURE__*/__webpack_require__.n(auto_complete_);

// CONCATENATED MODULE: ./src/components/auto-complete/index.js



function auto_complete_extends() { auto_complete_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return auto_complete_extends.apply(this, arguments); }



 // import { IconTrigonBottomFill } from '@h3-icons/basic';

var H3AutoComplete = {
  name: 'H3AutoComplete',
  functional: true,
  inheritAttrs: false,
  props: auto_complete_extends({}, auto_complete_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-auto-complete' : 'h3-auto-complete') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['dataSource', 'placeholder']);
    var children = [slotContent.default].concat(slotChildren);
    return h(auto_complete_default.a, auto_complete_extends({
      props: props
    }, data, {
      scopedSlots: {}
    }), children);
  }
};

H3AutoComplete.install = function (Vue) {
  Vue.component('H3AutoComplete', H3AutoComplete);
};

/* harmony default export */ var auto_complete = (H3AutoComplete);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/calendar/style"
var calendar_style_ = __webpack_require__(157);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/calendar"
var calendar_ = __webpack_require__(48);
var calendar_default = /*#__PURE__*/__webpack_require__.n(calendar_);

// CONCATENATED MODULE: ./src/components/calendar/index.js



function calendar_extends() { calendar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }



var H3Calendar = {
  name: 'H3Calendar',
  functional: true,
  inheritAttrs: false,
  model: calendar_default.a.model,
  props: calendar_extends({}, calendar_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-calendar' : 'h3-calendar';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['dateCellRender', 'monthCellRender', 'headerRender']);
    var children = [slotContent.default].concat(slotChildren);
    return h(calendar_default.a, calendar_extends({
      props: props
    }, data), children);
  }
};

H3Calendar.install = function (Vue) {
  Vue.component(H3Calendar.name, H3Calendar);
};

/* harmony default export */ var calendar = (H3Calendar);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/statistic/style"
var statistic_style_ = __webpack_require__(158);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/statistic"
var statistic_ = __webpack_require__(28);
var statistic_default = /*#__PURE__*/__webpack_require__.n(statistic_);

// CONCATENATED MODULE: ./src/components/statistic/index.js



function statistic_extends() { statistic_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return statistic_extends.apply(this, arguments); }



var H3Statistic = {
  name: 'H3Statistic',
  functional: true,
  inheritAttrs: false,
  model: statistic_default.a.model,
  props: statistic_extends({}, statistic_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-statistic' : 'h3-statistic';
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['formatter', 'prefix', 'suffix', 'title', 'value']);
    var children = [slotContent.default].concat(slotChildren);
    return h(statistic_default.a, statistic_extends({
      props: props
    }, data), children);
  }
};
H3Statistic.Countdown = statistic_default.a.Countdown;

H3Statistic.install = function (Vue) {
  Vue.component(H3Statistic.name, H3Statistic);
  Vue.component('H3StatisticCountdown', statistic_default.a.Countdown);
};

/* harmony default export */ var statistic = (H3Statistic);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/affix/style"
var affix_style_ = __webpack_require__(159);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/affix"
var affix_ = __webpack_require__(49);
var affix_default = /*#__PURE__*/__webpack_require__.n(affix_);

// CONCATENATED MODULE: ./src/components/affix/index.js



function affix_extends() { affix_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return affix_extends.apply(this, arguments); }


var H3Affix = {
  name: 'H3Affix',
  functional: true,
  inheritAttrs: false,
  model: affix_default.a.model,
  props: affix_extends({}, affix_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-affix' : 'h3-affix';
    var slotContent = slots();
    var children = slotContent.default;
    return h(affix_default.a, affix_extends({
      props: props
    }, data), children);
  }
};

H3Affix.install = function (Vue) {
  Vue.component(H3Affix.name, H3Affix);
};

/* harmony default export */ var affix = (H3Affix);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/skeleton/style"
var skeleton_style_ = __webpack_require__(160);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/skeleton"
var skeleton_ = __webpack_require__(50);
var skeleton_default = /*#__PURE__*/__webpack_require__.n(skeleton_);

// CONCATENATED MODULE: ./src/components/skeleton/index.js



function skeleton_extends() { skeleton_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return skeleton_extends.apply(this, arguments); }


var H3Skeleton = {
  name: 'H3Skeleton',
  functional: true,
  inheritAttrs: false,
  model: skeleton_default.a.model,
  props: skeleton_extends({}, skeleton_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-skeleton' : 'h3-skeleton';
    var slotContent = slots();
    var children = slotContent.default;
    return h(skeleton_default.a, skeleton_extends({
      props: props
    }, data), children);
  }
};

H3Skeleton.install = function (Vue) {
  Vue.component(H3Skeleton.name, H3Skeleton);
};

/* harmony default export */ var skeleton = (H3Skeleton);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/comment/style"
var comment_style_ = __webpack_require__(161);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/comment"
var comment_ = __webpack_require__(71);
var comment_default = /*#__PURE__*/__webpack_require__.n(comment_);

// CONCATENATED MODULE: ./src/components/comment/index.js



function comment_extends() { comment_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return comment_extends.apply(this, arguments); }



var H3Comment = {
  name: 'H3Comment',
  functional: true,
  inheritAttrs: false,
  props: comment_extends({}, comment_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-comment' : 'h3-comment';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['actions', 'author', 'avatar', 'content', 'datetime']);
    var children = [slotContent.default].concat(slotChildren);
    return h(comment_default.a, comment_extends({
      props: props
    }, data), children);
  }
};

H3Comment.install = function (Vue) {
  Vue.component(H3Comment.name, H3Comment);
};

/* harmony default export */ var comment = (H3Comment);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/steps/style"
var steps_style_ = __webpack_require__(162);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/steps"
var steps_ = __webpack_require__(38);
var steps_default = /*#__PURE__*/__webpack_require__.n(steps_);

// CONCATENATED MODULE: ./src/components/steps/index.js



function steps_extends() { steps_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return steps_extends.apply(this, arguments); }



var H3Steps = {
  name: 'H3Steps',
  functional: true,
  inheritAttrs: false,
  props: steps_extends({}, steps_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-steps' : 'h3-steps';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['progressDot', 'description', 'icon', 'title', 'subTitle']);
    var children = [slotContent.default].concat(slotChildren);
    return h(steps_default.a, steps_extends({
      props: props
    }, data), children);
  }
};
H3Steps.Step = steps_default.a.Step;

H3Steps.install = function (Vue) {
  Vue.component(H3Steps.name, H3Steps);
  Vue.component('H3Step', steps_default.a.Step);
};

/* harmony default export */ var steps = (H3Steps);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/breadcrumb/style"
var breadcrumb_style_ = __webpack_require__(163);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/breadcrumb"
var breadcrumb_ = __webpack_require__(21);
var breadcrumb_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_);

// CONCATENATED MODULE: ./src/components/breadcrumb/index.js



function breadcrumb_extends() { breadcrumb_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return breadcrumb_extends.apply(this, arguments); }



var H3Breadcrumb = {
  name: 'H3Breadcrumb',
  functional: true,
  inheritAttrs: false,
  props: breadcrumb_extends({}, breadcrumb_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-breadcrumb' : 'h3-breadcrumb';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['separator']);
    var children = [slotContent.default].concat(slotChildren);
    return h(breadcrumb_default.a, breadcrumb_extends({
      props: props
    }, data), children);
  }
};
H3Breadcrumb.Item = breadcrumb_default.a.Item;
H3Breadcrumb.Separator = breadcrumb_default.a.Separator;

H3Breadcrumb.install = function (Vue) {
  Vue.component(H3Breadcrumb.name, H3Breadcrumb);
  Vue.component('H3BreadcrumbItem', breadcrumb_default.a.Item);
  Vue.component('H3BreadcrumbSeparator', breadcrumb_default.a.Separator);
};

/* harmony default export */ var breadcrumb = (H3Breadcrumb);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/layout/style"
var layout_style_ = __webpack_require__(164);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/layout"
var layout_ = __webpack_require__(7);
var layout_default = /*#__PURE__*/__webpack_require__.n(layout_);

// CONCATENATED MODULE: ./src/components/layout/index.js



function layout_extends() { layout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return layout_extends.apply(this, arguments); }




var H3Layout = {
  name: 'H3Layout',
  functional: true,
  inheritAttrs: false,
  props: layout_extends({}, layout_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-layout' : 'h3-layout';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var slotChildren = convertSlotChildren(slotContent, h, ['help', 'label', 'extra']);
    var children = [slotContent.default].concat(slotChildren);
    return h(layout_default.a, layout_extends({
      props: props
    }, data), children);
  }
};
var LayoutSider = {
  name: 'LayoutSider',
  functional: true,
  inheritAttrs: false,
  props: layout_extends({}, layout_default.a.Sider.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = (data.staticClass ? data.staticClass + ' h3-layout-sider' : 'h3-layout-sider') + (data.class ? " " + changeToString(data.class) : '');
    var slotContent = slots();
    var slotChildren = convertSlotChildren(slotContent, h, ['trigger']);
    var children = [slotContent.default].concat(slotChildren);
    return h(layout_default.a.Sider, layout_extends({
      props: props
    }, data, {
      class: ['h3-layout-sider']
    }), children);
  }
};
H3Layout.Header = layout_default.a.Header;
H3Layout.Content = layout_default.a.Content;
H3Layout.Footer = layout_default.a.Footer;
H3Layout.Sider = LayoutSider;

H3Layout.install = function (Vue) {
  Vue.component(H3Layout.name, H3Layout);
  Vue.component('H3LayoutHeader', layout_default.a.Header);
  Vue.component('H3LayoutContent', layout_default.a.Content);
  Vue.component('H3LayoutFooter', layout_default.a.Footer);
  Vue.component('H3LayoutSider', LayoutSider);
};

/* harmony default export */ var components_layout = (H3Layout);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/row/style"
var row_style_ = __webpack_require__(165);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/row"
var row_ = __webpack_require__(72);
var row_default = /*#__PURE__*/__webpack_require__.n(row_);

// CONCATENATED MODULE: ./src/components/row/index.js



function row_extends() { row_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return row_extends.apply(this, arguments); }


var H3Row = {
  name: 'H3Row',
  functional: true,
  inheritAttrs: false,
  props: row_extends({}, row_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-row' : 'h3-row';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var children = slotContent.default;
    return h(row_default.a, row_extends({
      props: props
    }, data), children);
  }
};

H3Row.install = function (Vue) {
  Vue.component(H3Row.name, H3Row);
};

/* harmony default export */ var row = (H3Row);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/col/style"
var col_style_ = __webpack_require__(166);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/col"
var col_ = __webpack_require__(73);
var col_default = /*#__PURE__*/__webpack_require__.n(col_);

// CONCATENATED MODULE: ./src/components/col/index.js



function col_extends() { col_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return col_extends.apply(this, arguments); }


var H3Col = {
  name: 'H3Col',
  functional: true,
  inheritAttrs: false,
  props: col_extends({}, col_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-col' : 'h3-col';
    var slotContent = slots(); // 作用域插槽 //dropdownRender
    // 获取具名非作用域插槽

    var children = slotContent.default;
    return h(col_default.a, col_extends({
      props: props
    }, data), children);
  }
};

H3Col.install = function (Vue) {
  Vue.component(H3Col.name, H3Col);
};

/* harmony default export */ var col = (H3Col);
// EXTERNAL MODULE: external "@authine/antd-vue/lib/config-provider/style"
var config_provider_style_ = __webpack_require__(167);

// EXTERNAL MODULE: external "@authine/antd-vue/lib/config-provider"
var config_provider_ = __webpack_require__(74);
var config_provider_default = /*#__PURE__*/__webpack_require__.n(config_provider_);

// CONCATENATED MODULE: ./src/components/config-provider/index.js



function config_provider_extends() { config_provider_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return config_provider_extends.apply(this, arguments); }


var H3ConfigProvider = {
  name: 'H3ConfigProvider',
  functional: true,
  inheritAttrs: false,
  props: config_provider_extends({}, config_provider_default.a.props),
  render: function render(h, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    clearUndefined(props); // data.staticClass = (data.staticClass
    //   ? data.staticClass + ' h3-config-provider'
    //   : 'h3-config-provider');

    var slotContent = slots();
    var children = slotContent.default;
    return h(config_provider_default.a, config_provider_extends({
      props: props
    }, data), children);
  }
};

H3ConfigProvider.install = function (Vue) {
  Vue.component(H3ConfigProvider.name, H3ConfigProvider);
};

/* harmony default export */ var config_provider = (H3ConfigProvider);
// CONCATENATED MODULE: ./src/directives/drag/drop.ts
/* harmony default export */ var drop = (function (el, binding, vnode) {
  var component = vnode.componentInstance;

  el.ondragenter = function (evt) {
    var obj = binding.value;

    if (obj && evt.dataTransfer) {
      if (obj.types && Array.isArray(obj.types)) {
        if (!evt.dataTransfer.types.some(function (t) {
          return obj.types.indexOf(t) > -1;
        })) {
          return;
        }
      }

      if (obj.type) {
        if (!evt.dataTransfer.types.some(function (t) {
          return t === obj.type;
        })) {
          return;
        }
      }
    }

    if (component && component.onDragenter) {
      component.onDragenter(evt);
    }
  };

  el.ondragover = function (evt) {
    if (component && component.onDragover) {
      component.onDragover(evt);
    }
  };

  el.ondragleave = function (evt) {
    if (component && component.onDragleave) {
      component.onDragleave(evt);
    }
  };

  el.ondrop = function (evt) {
    if (component && component.onDrop) {
      component.onDrop(evt);
    }
  };
});
// CONCATENATED MODULE: ./src/directives/drag/drag.ts
/* harmony default export */ var drag = (function (el, binding, vnode) {
  if (el.disabled || el.classList.contains('disabled')) {
    el.draggable = false;
    return;
  }

  el.draggable = true;

  el.ondragstart = function (evt) {
    setTimeout(function () {
      el.classList.add('dragging');
    }, 0);

    if (!evt.dataTransfer) {
      return;
    }

    var obj = binding.value;

    if (obj) {
      if (obj.effect) {
        evt.dataTransfer.effectAllowed = obj.effect;
      }

      if (obj.value) {
        var type = obj.type ? obj.type : 'text';
        evt.dataTransfer.setData(type, obj.value);
      }
    }

    var component = vnode.componentInstance;

    if (component && component.onDragstart) {
      component.onDragstart(evt);
    }
  };

  el.ondragend = function (evt) {
    var component = vnode.componentInstance;

    if (component && component.onDragend) {
      component.onDragend(evt);
    }

    el.classList.remove('dragging');
    el.removeAttribute('style');
  };

  el.ondrag = function (evt) {
    var component = vnode.componentInstance;

    if (component && component.onDrag) {
      component.onDrag(evt);
    }
  };
});
// CONCATENATED MODULE: ./src/directives/drag/index.js


drag.Drop = drop;

drag.install = function (Vue) {
  Vue.directive('H3Drag', drag);
  Vue.directive('H3Drop', drop);
};

/* harmony default export */ var directives_drag = (drag);
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/defaults.js
/* harmony default export */ var defaults = ({
  /**
   * Enable a modal backdrop, specify `static` for a backdrop
   * which doesn't close the modal on click.
   * @type {boolean}
   */
  backdrop: true,

  /**
   * Show the button on the top-right of the viewer.
   * @type {boolean}
   */
  button: true,

  /**
   * Show the navbar.
   * @type {boolean | number}
   */
  navbar: true,

  /**
   * images length limit dot show
   * @type {number}
   */
  dotLimit: 10,

  /**
   * Specify the visibility and the content of the title.
   * @type {boolean | number | Function | Array}
   */
  title: true,

  /**
   * Show the toolbar.
   * @type {boolean | number | Object}
   */
  toolbar: true,

  /**
   * Custom class name(s) to add to the viewer's root element.
   * @type {string}
   */
  className: '',

  /**
   * Define where to put the viewer in modal mode.
   * @type {string | Element}
   */
  container: 'body',

  /**
   * Filter the images for viewing. Return true if the image is viewable.
   * @type {Function}
   */
  filter: null,

  /**
   * Enable to request fullscreen when play.
   * @type {boolean}
   */
  fullscreen: true,

  /**
   * Define the initial index of image for viewing.
   * @type {number}
   */
  initialViewIndex: 0,

  /**
   * Enable inline mode.
   * @type {boolean}
   */
  inline: false,

  /**
   * The amount of time to delay between automatically cycling an image when playing.
   * @type {number}
   */
  interval: 5000,

  /**
   * Enable keyboard support.
   * @type {boolean}
   */
  keyboard: true,

  /**
   * Indicate if show a loading spinner when load image or not.
   * @type {boolean}
   */
  loading: true,

  /**
   * Indicate if enable loop viewing or not.
   * @type {boolean}
   */
  loop: true,

  /**
   * Min width of the viewer in inline mode.
   * @type {number}
   */
  minWidth: 200,

  /**
   * Min height of the viewer in inline mode.
   * @type {number}
   */
  minHeight: 100,

  /**
   * Enable to move the image.
   * @type {boolean}
   */
  movable: true,

  /**
   * Enable to download the image.
   * @type {boolean}
   */
  downloadable: true,

  /**
   * download handle
   * @type {Function}
   */
  handleDownload: null,

  /**
   * default alt
   * @type {string}
   */
  defaultAlt: '暂无名称',

  /**
   * Enable to zoom the image.
   * @type {boolean}
   */
  zoomable: true,

  /**
   * Enable to rotate the image.
   * @type {boolean}
   */
  rotatable: true,

  /**
   * Enable to scale the image.
   * @type {boolean}
   */
  scalable: true,

  /**
   * Indicate if toggle the image size between its natural size
   * and initial size when double click on the image or not.
   * @type {boolean}
   */
  toggleOnDblclick: true,

  /**
   * Show the tooltip with image ratio (percentage) when zoom in or zoom out.
   * @type {boolean}
   */
  tooltip: true,

  /**
   * Enable CSS3 Transition for some special elements.
   * @type {boolean}
   */
  transition: true,

  /**
   * Define the CSS `z-index` value of viewer in modal mode.
   * @type {number}
   */
  zIndex: 2015,

  /**
   * Define the CSS `z-index` value of viewer in inline mode.
   * @type {number}
   */
  zIndexInline: 0,

  /**
   * Define the ratio when zoom the image by wheeling mouse.
   * @type {number}
   */
  zoomRatio: 0.1,

  /**
   * Define the min ratio of the image when zoom out.
   * @type {number}
   */
  minZoomRatio: 0.01,

  /**
   * Define the max ratio of the image when zoom in.
   * @type {number}
   */
  maxZoomRatio: 100,

  /**
   * Define where to get the original image URL for viewing.
   * @type {string | Function}
   */
  url: 'src',

  /**
   * Event shortcuts.
   * @type {Function}
   */
  ready: null,
  show: null,
  shown: null,
  hide: null,
  hidden: null,
  view: null,
  viewed: null,
  zoom: null,
  zoomed: null
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/template.js
/* eslint-disable max-len */
/* harmony default export */ var js_template = ('<div class="h3-viewer-container" touch-action="none">' + '<div class="h3-viewer-canvas"></div>' + '<div class="h3-viewer-header">' + '<div class="h3-viewer-bar">' + '<div class="h3-viewer-title"></div>' + '<div role="button" class="h3-viewer-other h3-viewer-download" title="下载" data-h3viewer-action="download"></div>' + '<div role="button" class="h3-viewer-button" data-h3viewer-action="mix"></div>' + '</div>' + '</div>' + '<div role="button" class="h3-viewer-swiper h3-viewer-prev" data-h3viewer-action="prev"></div>' + '<div role="button" class="h3-viewer-swiper h3-viewer-next" data-h3viewer-action="next"></div>' + '<div class="h3-viewer-footer">' + '<div class="h3-viewer-navbar">' + '<div class="h3-viewer-thumbnail">' + '<ul class="h3-viewer-list"></ul>' + '</div>' + '<div role="button" class="h3-viewer-swiper h3-viewer-nav-prev" data-h3viewer-action="nav-prev"></div>' + '<div role="button" class="h3-viewer-swiper h3-viewer-nav-next" data-h3viewer-action="nav-next"></div>' + '<ul class="h3-viewer-spot"></ul>' + '</div>' + '<div class="h3-viewer-control">' + '<div class="h3-viewer-toolbar"></div>' + '</div>' + '</div>' + '<div class="h3-viewer-tooltip"></div>' + '<div class="h3-viewer-player"></div>' + '</div>');
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/constants.js
var IS_BROWSER = typeof window !== 'undefined';
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
var NAMESPACE = 'h3-viewer';
var PREFIX = 'h3viewer'; // Actions

var ACTION_MOVE = 'move';
var ACTION_SWITCH = 'switch';
var ACTION_ZOOM = 'zoom'; // Classes

var CLASS_ACTIVE = NAMESPACE + "-active";
var CLASS_CLOSE = NAMESPACE + "-close";
var CLASS_FADE = NAMESPACE + "-fade";
var CLASS_FIXED = NAMESPACE + "-fixed";
var CLASS_FULLSCREEN = NAMESPACE + "-fullscreen";
var CLASS_FULLSCREEN_EXIT = NAMESPACE + "-fullscreen-exit";
var CLASS_HIDE = NAMESPACE + "-hide";
var CLASS_HIDE_MD_DOWN = NAMESPACE + "-hide-md-down";
var CLASS_HIDE_SM_DOWN = NAMESPACE + "-hide-sm-down";
var CLASS_HIDE_XS_DOWN = NAMESPACE + "-hide-xs-down";
var CLASS_IN = NAMESPACE + "-in";
var CLASS_INVISIBLE = NAMESPACE + "-invisible";
var CLASS_LOADING = NAMESPACE + "-loading";
var CLASS_PREV = NAMESPACE + "-prev";
var CLASS_NEXT = NAMESPACE + "-next";
var CLASS_MOVE = NAMESPACE + "-move";
var CLASS_OPEN = NAMESPACE + "-open";
var CLASS_SHOW = NAMESPACE + "-show";
var CLASS_TRANSITION = NAMESPACE + "-transition"; // Events

var EVENT_CLICK = 'click';
var EVENT_DBLCLICK = 'dblclick';
var EVENT_DRAG_START = 'dragstart';
var EVENT_HIDDEN = 'hidden';
var EVENT_HIDE = 'hide';
var EVENT_KEY_DOWN = 'keydown';
var EVENT_LOAD = 'load';
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
var EVENT_READY = 'ready';
var EVENT_RESIZE = 'resize';
var EVENT_SHOW = 'show';
var EVENT_SHOWN = 'shown';
var EVENT_TRANSITION_END = 'transitionend';
var EVENT_VIEW = 'view';
var EVENT_VIEWED = 'viewed';
var EVENT_WHEEL = 'wheel';
var EVENT_ZOOM = 'zoom';
var EVENT_ZOOMED = 'zoomed'; // Data keys

var DATA_ACTION = PREFIX + "Action"; // RegExps

var REGEXP_SPACES = /\s\s*/; // Misc

var BUTTONS = ['prev', 'play', 'next', 'download', 'rotate-left', 'rotate-right', 'flip-horizontal', 'flip-vertical', 'zoom-in', 'zoom-out', 'one-to-one', 'reset']; // Misc map

var BUTTONSMAP = {
  prev: {
    title: '上一张'
  },
  play: {
    title: '幻灯片播放'
  },
  next: {
    title: '下一张'
  },
  download: {
    title: '下载'
  },
  'rotate-left': {
    title: '向左旋转'
  },
  'rotate-right': {
    title: '向右旋转'
  },
  'flip-horizontal': {
    title: '水平翻转'
  },
  'flip-vertical': {
    title: '垂直翻转'
  },
  'zoom-in': {
    title: '放大'
  },
  'zoom-out': {
    title: '缩小'
  },
  'one-to-one': {
    title: '原图缩放'
  },
  reset: {
    title: '还原'
  }
};
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/utilities.js

/**
 * Check if the given value is a string.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a string, else `false`.
 */

function utilities_isString(value) {
  return typeof value === 'string';
}
/**
 * Check if the given value is not a number.
 */

var utilities_isNaN = Number.isNaN || WINDOW.isNaN;
/**
 * Check if the given value is a number.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a number, else `false`.
 */

function isNumber(value) {
  return typeof value === 'number' && !utilities_isNaN(value);
}
/**
 * Check if the given value is undefined.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
 */

function isUndefined(value) {
  return typeof value === 'undefined';
}
/**
 * Check if the given value is an object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an object, else `false`.
 */

function utilities_isObject(value) {
  return typeof value === 'object' && value !== null;
}
var utilities_hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check if the given value is a plain object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
 */

function isPlainObject(value) {
  if (!utilities_isObject(value)) {
    return false;
  }

  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    return _constructor && prototype && utilities_hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (error) {
    return false;
  }
}
/**
 * Check if the given value is a function.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */

function utilities_isFunction(value) {
  return typeof value === 'function';
}
/**
 * Iterate the given data.
 * @param {*} data - The data to iterate.
 * @param {Function} callback - The process function for each element.
 * @returns {*} The original data.
 */

function forEach(data, callback) {
  if (data && utilities_isFunction(callback)) {
    if (Array.isArray(data) || isNumber(data.length)
    /* array-like */
    ) {
        var length = data.length;
        var i;

        for (i = 0; i < length; i += 1) {
          if (callback.call(data, data[i], i, data) === false) {
            break;
          }
        }
      } else if (utilities_isObject(data)) {
      Object.keys(data).forEach(function (key) {
        callback.call(data, data[key], key, data);
      });
    }
  }

  return data;
}
/**
 * Extend the given object.
 * @param {*} obj - The object to be extended.
 * @param {*} args - The rest objects which will be merged to the first object.
 * @returns {Object} The extended object.
 */

var utilities_assign = Object.assign || function assign(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (utilities_isObject(obj) && args.length > 0) {
    args.forEach(function (arg) {
      if (utilities_isObject(arg)) {
        Object.keys(arg).forEach(function (key) {
          obj[key] = arg[key];
        });
      }
    });
  }

  return obj;
};
var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;
/**
 * Apply styles to the given element.
 * @param {Element} element - The target element.
 * @param {Object} styles - The styles for applying.
 */

function setStyle(element, styles) {
  var style = element.style;
  forEach(styles, function (value, property) {
    var _value = value;

    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      _value += 'px';
    }

    style[property] = _value;
  });
}
/**
 * Escape a string for using in HTML.
 * @param {String} value - The string to escape.
 * @returns {String} Returns the escaped string.
 */

function escapeHTMLEntities(value) {
  return utilities_isString(value) ? value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : value;
}
/**
 * Check if the given element has a special class.
 * @param {Element} element - The element to check.
 * @param {string} value - The class to search.
 * @returns {boolean} Returns `true` if the special class was found.
 */

function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}
/**
 * Add classes to the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be added.
 */

function addClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      addClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.add(value);
    return;
  }

  var className = element.className.trim();

  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = className + " " + value;
  }
}
/**
 * Remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be removed.
 */

function removeClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      removeClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.remove(value);
    return;
  }

  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, '');
  }
}
/**
 * Add or remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be toggled.
 * @param {boolean} added - Add only.
 */

function toggleClass(element, value, added) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      toggleClass(elem, value, added);
    });
    return;
  } // IE10-11 doesn't support the second parameter of `classList.toggle`


  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}
var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;
/**
 * Transform the given string from camelCase to kebab-case
 * @param {string} value - The value to transform.
 * @returns {string} The transformed value.
 */

function utilities_hyphenate(value) {
  return value.replace(REGEXP_HYPHENATE, '$1-$2').toLowerCase();
}
/**
 * Get data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to get.
 * @returns {string} The data value.
 */

function utilities_getData(element, name) {
  if (utilities_isObject(element[name])) {
    return element[name];
  }

  if (element.dataset) {
    return element.dataset[name];
  }

  return element.getAttribute("data-" + utilities_hyphenate(name));
}
/**
 * Set data to the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to set.
 * @param {string} data - The data value.
 */

function setData(element, name, data) {
  if (utilities_isObject(data)) {
    element[name] = data;
  } else if (element.dataset) {
    element.dataset[name] = data;
  } else {
    element.setAttribute("data-" + utilities_hyphenate(name), data);
  }
}
/**
 * Remove data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to remove.
 */

function removeData(element, name) {
  if (utilities_isObject(element[name])) {
    try {
      delete element[name];
    } catch (error) {
      element[name] = undefined;
    }
  } else if (element.dataset) {
    // #128 Safari not allows to delete dataset property
    try {
      delete element.dataset[name];
    } catch (error) {
      element.dataset[name] = undefined;
    }
  } else {
    element.removeAttribute("data-" + utilities_hyphenate(name));
  }
}

var onceSupported = function () {
  var supported = false;

  if (IS_BROWSER) {
    var once = false;

    var listener = function listener() {};

    var options = Object.defineProperty({}, 'once', {
      get: function get() {
        supported = true;
        return once;
      },

      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set(value) {
        once = value;
      }
    });
    WINDOW.addEventListener('test', listener, options);
    WINDOW.removeEventListener('test', listener, options);
  }

  return supported;
}();
/**
 * Remove event listener from the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */


function removeListener(element, type, listener, options) {
  if (options === void 0) {
    options = {};
  }

  var handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (!onceSupported) {
      var listeners = element.listeners;

      if (listeners && listeners[event] && listeners[event][listener]) {
        handler = listeners[event][listener];
        delete listeners[event][listener];

        if (Object.keys(listeners[event]).length === 0) {
          delete listeners[event];
        }

        if (Object.keys(listeners).length === 0) {
          delete element.listeners;
        }
      }
    }

    element.removeEventListener(event, handler, options);
  });
}
/**
 * Add event listener to the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */

function addListener(element, type, listener, options) {
  if (options === void 0) {
    options = {};
  }

  var _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners,
          listeners = _element$listeners === void 0 ? {} : _element$listeners;

      _handler = function handler() {
        delete listeners[event][listener];
        element.removeEventListener(event, _handler, options);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        listener.apply(element, args);
      };

      if (!listeners[event]) {
        listeners[event] = {};
      }

      if (listeners[event][listener]) {
        element.removeEventListener(event, listeners[event][listener], options);
      }

      listeners[event][listener] = _handler;
      element.listeners = listeners;
    }

    element.addEventListener(event, _handler, options);
  });
}
/**
 * Dispatch event on the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Object} data - The additional event data.
 * @returns {boolean} Indicate if the event is default prevented or not.
 */

function dispatchEvent(element, type, data) {
  var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

  if (utilities_isFunction(Event) && utilities_isFunction(CustomEvent)) {
    event = new CustomEvent(type, {
      detail: data,
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(type, true, true, data);
  }

  return element.dispatchEvent(event);
}
/**
 * Get the offset base on the document.
 * @param {Element} element - The target element.
 * @returns {Object} The offset data.
 */

function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
/**
 * Get transforms base on the given object.
 * @param {Object} obj - The target object.
 * @returns {string} A string contains transform values.
 */

function getTransforms(_ref) {
  var rotate = _ref.rotate,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      translateX = _ref.translateX,
      translateY = _ref.translateY;
  var values = [];

  if (isNumber(translateX) && translateX !== 0) {
    values.push("translateX(" + translateX + "px)");
  }

  if (isNumber(translateY) && translateY !== 0) {
    values.push("translateY(" + translateY + "px)");
  } // Rotate should come first before scale to match orientation transform


  if (isNumber(rotate) && rotate !== 0) {
    values.push("rotate(" + rotate + "deg)");
  }

  if (isNumber(scaleX) && scaleX !== 1) {
    values.push("scaleX(" + scaleX + ")");
  }

  if (isNumber(scaleY) && scaleY !== 1) {
    values.push("scaleY(" + scaleY + ")");
  }

  var transform = values.length ? values.join(' ') : 'none';
  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform: transform
  };
}
/**
 * Get an image name from an image url.
 * @param {string} url - The target url.
 * @example
 * // picture.jpg
 * getImageNameFromURL('http://domain.com/path/to/picture.jpg?size=1280×960')
 * @returns {string} A string contains the image name.
 */

function getImageNameFromURL(url) {
  return utilities_isString(url) ? decodeURIComponent(url.replace(/^.*\//, '').replace(/[?&#].*$/, '')) : '';
}
var IS_SAFARI = WINDOW.navigator && /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i.test(WINDOW.navigator.userAgent);
/**
 * Get an image's natural sizes.
 * @param {string} image - The target image.
 * @param {Function} callback - The callback function.
 * @returns {HTMLImageElement} The new image.
 */

function getImageNaturalSizes(image, callback) {
  var newImage = document.createElement('img'); // Modern browsers (except Safari)

  if (image.naturalWidth && !IS_SAFARI) {
    callback(image.naturalWidth, image.naturalHeight);
    return newImage;
  }

  var body = document.body || document.documentElement;

  newImage.onload = function () {
    callback(newImage.width, newImage.height);

    if (!IS_SAFARI) {
      body.removeChild(newImage);
    }
  };

  newImage.src = image.src; // iOS Safari will convert the image automatically
  // with its orientation once append it into DOM

  if (!IS_SAFARI) {
    newImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
    body.appendChild(newImage);
  }

  return newImage;
}
/**
 * Get the related class name of a responsive type number.
 * @param {string} type - The responsive type.
 * @returns {string} The related class name.
 */

function getResponsiveClass(type) {
  switch (type) {
    case 2:
      return CLASS_HIDE_XS_DOWN;

    case 3:
      return CLASS_HIDE_SM_DOWN;

    case 4:
      return CLASS_HIDE_MD_DOWN;

    default:
      return '';
  }
}
/**
 * Get the max ratio of a group of pointers.
 * @param {string} pointers - The target pointers.
 * @returns {number} The result ratio.
 */

function getMaxZoomRatio(pointers) {
  var pointers2 = utilities_assign({}, pointers);
  var ratios = [];
  forEach(pointers, function (pointer, pointerId) {
    delete pointers2[pointerId];
    forEach(pointers2, function (pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      ratios.push(ratio);
    });
  });
  ratios.sort(function (a, b) {
    return Math.abs(a) < Math.abs(b);
  });
  return ratios[0];
}
/**
 * Get a pointer from an event object.
 * @param {Object} event - The target event object.
 * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
 * @returns {Object} The result pointer contains start and/or end point coordinates.
 */

function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX,
      pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : utilities_assign({
    timeStamp: Date.now(),
    startX: pageX,
    startY: pageY
  }, end);
}
/**
 * Get the center point coordinate of a group of pointers.
 * @param {Object} pointers - The target pointers.
 * @returns {Object} The center point coordinate.
 */

function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;
  forEach(pointers, function (_ref3) {
    var startX = _ref3.startX,
        startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count += 1;
  });
  pageX /= count;
  pageY /= count;
  return {
    pageX: pageX,
    pageY: pageY
  };
}
function isElement(obj) {
  return typeof HTMLElement === 'object' ? obj instanceof HTMLElement : !!(obj && typeof obj === 'object' && (obj.nodeType === 1 || obj.nodeType === 9) && typeof obj.nodeName === 'string');
}
function linkDownload(content, filename) {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a');
  eleLink.download = filename;
  eleLink.target = '_self';
  eleLink.href = content;
  eleLink.click();
}
;
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/render.js


/* harmony default export */ var js_render = ({
  render: function render() {
    this.initContainer();
    this.initViewer();
    this.initList();
    this.renderViewer();
  },
  initContainer: function initContainer() {
    this.containerData = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  initViewer: function initViewer() {
    var options = this.options,
        parent = this.parent;
    var viewerData;

    if (options.inline) {
      viewerData = {
        width: Math.max(parent.offsetWidth, options.minWidth),
        height: Math.max(parent.offsetHeight, options.minHeight)
      };
      this.parentData = viewerData;
    }

    if (this.fulled || !viewerData) {
      viewerData = this.containerData;
    }

    this.viewerData = utilities_assign({}, viewerData);
  },
  renderViewer: function renderViewer() {
    if (this.options.inline && !this.fulled) {
      setStyle(this.viewer, this.viewerData);
    }
  },
  initList: function initList() {
    var _this = this;

    var element = this.element,
        options = this.options,
        list = this.list,
        spot = this.spot;
    var items = [];
    var dots = [];
    list.innerHTML = '';
    spot.innerHTML = '';
    var url = options.url,
        lazyLoad = options.lazyLoad;
    forEach(this.images, function (image, index) {
      var src = '';
      var alt = '';
      var dlurl = '';

      if (isElement(image)) {
        src = image.src;
        alt = image.alt || getImageNameFromURL(src);

        if (utilities_isString(url)) {
          url = image.getAttribute(url);
        } else if (utilities_isFunction(url)) {
          url = url.call(_this, image);
        }
      } else if (utilities_isObject(image)) {
        url = image.source;
        dlurl = image.downloadUrl;
        alt = image.name || '';
      } else {
        url = image;
        dlurl = image;
        alt = getImageNameFromURL(image);
      }

      if (src || url) {
        var item = document.createElement('li');
        var img = document.createElement('img');
        item.setAttribute('data-index', index);
        item.setAttribute('data-h3viewer-action', 'view');
        item.setAttribute('role', 'button');

        if (!lazyLoad) {
          img.src = src || url;
        }

        img.alt = alt || options.defaultAlt;
        img.setAttribute('data-index', index);
        img.setAttribute('data-original-url', url || src);
        img.setAttribute('data-download-url', dlurl || url || src);
        img.setAttribute('data-h3viewer-action', 'view');
        img.setAttribute('role', 'button');
        item.appendChild(img);
        list.appendChild(item);
        items.push(item);
        var spotItem = document.createElement('li');
        spotItem.setAttribute('data-index', index);
        spotItem.setAttribute('data-h3viewer-action', 'view');
        spotItem.setAttribute('role', 'button');
        spot.appendChild(spotItem);
        dots.push(spotItem);
      }
    });
    this.items = items;
    this.page = Math.max(Math.ceil(this.length / this.options.dotLimit), 1);
    this.pageIndex = 0;
    this.dots = dots;
    forEach(this.items, function (item) {
      // const image = item.firstElementChild;
      var image = item.querySelector('img');
      setData(image, 'filled', true);

      if (options.loading) {
        addClass(item, CLASS_LOADING);
      }

      image.__loadOnce__ = true;
      addListener(image, EVENT_LOAD, function (event) {
        event.target.__loadOnce__ = false;

        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }

        _this.loadImage(event);
      }, {
        once: true
      });
    });

    if (options.transition) {
      addListener(element, EVENT_VIEWED, function () {
        addClass(list, CLASS_TRANSITION);
      }, {
        once: true
      });
    }
  },
  renderList: function renderList(index, pageIndex) {
    var _index = index || this.index; // 居中显示

    /*
    const navbarWidth = this.navbar.offsetWidth || (40 + 8) * 12 - 8; // 最多只显示12缩略图
    const width = this.getTarget(this.items, _index).offsetWidth || 40;
    const outerWidth = width + 8; // 1 pixel of `margin-left` width
    // Place the active item in the center of the screen
    setStyle(this.list, assign({
      width: outerWidth * this.length,
    }, getTransforms({
      // translateX: ((this.viewerData.width - width) / 2) - (outerWidth * _index),
      translateX: ((navbarWidth - width) / 2) - (outerWidth * _index),
    }))); */
    // 分页显示


    var navbarWidth = this.navbar.offsetWidth;

    if (this.page === 1) {
      var width = this.getTarget(this.items, _index).offsetWidth + 4 || 48;
      var outerWidth = this.length * width + (this.length === 10 ? 4 : 0);
      setStyle(this.list, utilities_assign({
        width: outerWidth
      }, getTransforms({
        translateX: (navbarWidth - outerWidth) / 2
      })));
    } else {
      var _pageIndex = pageIndex;

      if (isNaN(_pageIndex)) {
        _pageIndex = Math.ceil((_index + 1) / this.options.dotLimit);
      }

      this.pageIndex = _pageIndex;

      var _width = this.getTarget(this.items, _index).offsetWidth + 4 || 48;

      var _outerWidth = this.length * _width + Math.floor(this.length / this.options.dotLimit) * 4;

      setStyle(this.list, utilities_assign({
        width: _outerWidth
      }, getTransforms({
        translateX: -navbarWidth * (_pageIndex - 1)
      })));
      toggleClass(this.navPrev, CLASS_HIDE, this.pageIndex === 1);
      toggleClass(this.navNext, CLASS_HIDE, this.pageIndex === this.page);
    }
  },
  resetList: function resetList() {
    var list = this.list;
    list.innerHTML = '';
    removeClass(list, CLASS_TRANSITION);
    setStyle(list, getTransforms({
      translateX: 0
    }));
  },
  initImage: function initImage(done) {
    var _this2 = this;

    var options = this.options,
        image = this.image,
        viewerData = this.viewerData;
    var headerHeight = this.header.offsetHeight;
    var footerHeight = this.footer.offsetHeight;
    var viewerWidth = viewerData.width;
    var viewerHeight = Math.max(viewerData.height - footerHeight - headerHeight, footerHeight + headerHeight);
    var oldImageData = this.imageData || {}; // eslint-disable-next-line prefer-const

    var sizingImage;
    this.imageInitializing = {
      abort: function abort() {
        sizingImage.onload = null;
      }
    };
    sizingImage = getImageNaturalSizes(image, function (naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = viewerWidth;
      var height = viewerHeight;
      _this2.imageInitializing = false;

      if (viewerHeight * aspectRatio > viewerWidth) {
        height = viewerWidth / aspectRatio;
      } else {
        width = viewerHeight * aspectRatio;
      }

      width = Math.min(width * 0.9, naturalWidth);
      height = Math.min(height * 0.9, naturalHeight);
      var imageData = {
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        aspectRatio: aspectRatio,
        ratio: width / naturalWidth,
        width: width,
        height: height,
        left: (viewerWidth - width) / 2,
        // 与 header 高度 比较
        top: Math.max((viewerHeight - height) / 2, headerHeight + 20)
      };
      var initialImageData = utilities_assign({}, imageData);

      if (options.rotatable) {
        imageData.rotate = oldImageData.rotate || 0;
        initialImageData.rotate = 0;
      }

      if (options.scalable) {
        imageData.scaleX = oldImageData.scaleX || 1;
        imageData.scaleY = oldImageData.scaleY || 1;
        initialImageData.scaleX = 1;
        initialImageData.scaleY = 1;
      }

      _this2.imageData = imageData;
      _this2.initialImageData = initialImageData;

      if (done) {
        done();
      }
    });
  },
  renderImage: function renderImage(done) {
    var _this3 = this;

    var image = this.image,
        imageData = this.imageData;
    setStyle(image, utilities_assign({
      width: imageData.width,
      height: imageData.height,
      // XXX: Not to use translateX/Y to avoid image shaking when zooming
      marginLeft: imageData.left,
      marginTop: imageData.top
    }, getTransforms(imageData)));

    if (done) {
      if ((this.viewing || this.zooming) && this.options.transition) {
        var onTransitionEnd = function onTransitionEnd() {
          _this3.imageRendering = false;
          done();
        };

        this.imageRendering = {
          abort: function abort() {
            removeListener(image, EVENT_TRANSITION_END, onTransitionEnd);
          }
        };
        addListener(image, EVENT_TRANSITION_END, onTransitionEnd, {
          once: true
        });
      } else {
        done();
      }
    }
  },
  resetImage: function resetImage() {
    // this.image only defined after viewed
    if (this.viewing || this.viewed) {
      var image = this.image;

      if (this.viewing) {
        this.viewing.abort();
      }

      image.parentNode.removeChild(image);
      this.image = null;
    }
  }
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/events.js


/* harmony default export */ var events = ({
  bind: function bind() {
    var options = this.options,
        viewer = this.viewer,
        canvas = this.canvas;
    var document = this.element.ownerDocument;
    addListener(viewer, EVENT_CLICK, this.onClick = this.click.bind(this));
    addListener(viewer, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
      passive: false,
      capture: true
    });
    addListener(viewer, EVENT_DRAG_START, this.onDragStart = this.dragstart.bind(this));
    addListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown = this.pointerdown.bind(this));
    addListener(document, EVENT_POINTER_MOVE, this.onPointerMove = this.pointermove.bind(this));
    addListener(document, EVENT_POINTER_UP, this.onPointerUp = this.pointerup.bind(this));
    addListener(document, EVENT_KEY_DOWN, this.onKeyDown = this.keydown.bind(this));
    addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));

    if (options.toggleOnDblclick) {
      addListener(canvas, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }
  },
  unbind: function unbind() {
    var options = this.options,
        viewer = this.viewer,
        canvas = this.canvas;
    var document = this.element.ownerDocument;
    removeListener(viewer, EVENT_CLICK, this.onClick);
    removeListener(viewer, EVENT_WHEEL, this.onWheel, {
      passive: false,
      capture: true
    });
    removeListener(viewer, EVENT_DRAG_START, this.onDragStart);
    removeListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown);
    removeListener(document, EVENT_POINTER_MOVE, this.onPointerMove);
    removeListener(document, EVENT_POINTER_UP, this.onPointerUp);
    removeListener(document, EVENT_KEY_DOWN, this.onKeyDown);
    removeListener(window, EVENT_RESIZE, this.onResize);

    if (options.toggleOnDblclick) {
      removeListener(canvas, EVENT_DBLCLICK, this.onDblclick);
    }
  }
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/handlers.js


/* harmony default export */ var handlers = ({
  click: function click(event) {
    var target = event.target;
    var options = this.options,
        imageData = this.imageData;
    var action = utilities_getData(target, DATA_ACTION); // Cancel the emulated click when the native click event was triggered.

    if (IS_TOUCH_DEVICE && event.isTrusted && target === this.canvas) {
      clearTimeout(this.clickCanvasTimeout);
    }

    switch (action) {
      case 'mix':
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          } else {
            this.full();
          }
        } else {
          this.hide();
        }

        break;

      case 'hide':
        this.hide();
        break;

      case 'view':
        this.view(utilities_getData(target, 'index'));
        break;

      case 'zoom-in':
        this.zoom(0.1, true);
        break;

      case 'zoom-out':
        this.zoom(-0.1, true);
        break;

      case 'one-to-one':
        this.toggle();
        break;

      case 'reset':
        this.reset();
        break;

      case 'prev':
        this.prev(options.loop);
        break;

      case 'play':
        this.play(options.fullscreen);
        break;

      case 'next':
        this.next(options.loop);
        break;

      case 'nav-prev':
        this.navToPrev();
        break;

      case 'nav-next':
        this.navToNext();
        break;

      case 'rotate-left':
        this.rotate(-90);
        break;

      case 'rotate-right':
        this.rotate(90);
        break;

      case 'flip-horizontal':
        this.scaleX(-imageData.scaleX || -1);
        break;

      case 'flip-vertical':
        this.scaleY(-imageData.scaleY || -1);
        break;

      case 'download':
        this.download();
        break;

      default:
        if (this.played) {
          this.stop();
        }

    }
  },
  dblclick: function dblclick(event) {
    event.preventDefault();

    if (this.viewed && event.target === this.image) {
      // Cancel the emulated double click when the native dblclick event was triggered.
      if (IS_TOUCH_DEVICE && event.isTrusted) {
        clearTimeout(this.doubleClickImageTimeout);
      }

      this.toggle();
    }
  },
  load: function load() {
    var _this = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }

    var element = this.element,
        options = this.options,
        image = this.image,
        index = this.index,
        viewerData = this.viewerData;
    removeClass(image, CLASS_INVISIBLE);

    if (options.loading) {
      removeClass(this.canvas, CLASS_LOADING);
    }

    image.style.cssText = 'height:0;' + ("margin-left:" + viewerData.width / 2 + "px;") + ("margin-top:" + viewerData.height / 2 + "px;") + 'max-width:none!important;' + 'position:absolute;' + 'width:0;';
    this.initImage(function () {
      toggleClass(image, CLASS_MOVE, options.movable);
      toggleClass(image, CLASS_TRANSITION, options.transition);

      _this.renderImage(function () {
        _this.viewed = true;
        _this.viewing = false;

        if (utilities_isFunction(options.viewed)) {
          addListener(element, EVENT_VIEWED, options.viewed, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_VIEWED, {
          originalImage: _this.images[index],
          index: index,
          image: image
        });
      });
    });
  },
  loadImage: function loadImage(event) {
    var image = event.target;
    getImageNaturalSizes(image, function (naturalWidth, naturalHeight) {
      var parent = image.parentNode;
      var parentWidth = parent.offsetWidth || 30;
      var parentHeight = parent.offsetHeight || 50;
      var filled = !!utilities_getData(image, 'filled');
      var aspectRatio = naturalWidth / naturalHeight;
      var width = parentWidth;
      var height = parentHeight;

      if (parentHeight * aspectRatio > parentWidth) {
        if (filled) {
          width = parentHeight * aspectRatio;
        } else {
          height = parentWidth / aspectRatio;
        }
      } else if (filled) {
        height = parentWidth / aspectRatio;
      } else {
        width = parentHeight * aspectRatio;
      }

      setStyle(image, utilities_assign({
        width: width,
        height: height
      }, getTransforms({
        translateX: (parentWidth - width) / 2,
        translateY: (parentHeight - height) / 2
      })));
    });
  },
  keydown: function keydown(event) {
    var options = this.options;

    if (!this.fulled || !options.keyboard) {
      return;
    }

    switch (event.keyCode || event.which || event.charCode) {
      // Escape
      case 27:
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          }
        } else {
          this.hide();
        }

        break;
      // Space

      case 32:
        if (this.played) {
          this.stop();
        }

        break;
      // ArrowLeft

      case 37:
        this.prev(options.loop);
        break;
      // ArrowUp

      case 38:
        // Prevent scroll on Firefox
        event.preventDefault(); // Zoom in

        this.zoom(options.zoomRatio, true);
        break;
      // ArrowRight

      case 39:
        this.next(options.loop);
        break;
      // ArrowDown

      case 40:
        // Prevent scroll on Firefox
        event.preventDefault(); // Zoom out

        this.zoom(-options.zoomRatio, true);
        break;
      // Ctrl + 0

      case 48: // Fall through
      // Ctrl + 1
      // eslint-disable-next-line no-fallthrough

      case 49:
        if (event.ctrlKey) {
          event.preventDefault();
          this.toggle();
        }

        break;

      default:
    }
  },
  dragstart: function dragstart(event) {
    if (event.target.tagName.toLowerCase() === 'img') {
      event.preventDefault();
    }
  },
  pointerdown: function pointerdown(event) {
    var options = this.options,
        pointers = this.pointers;
    var buttons = event.buttons,
        button = event.button;

    if (!this.viewed || this.showing || this.viewing || this.hiding || // No primary button (Usually the left button)
    // Note that touch events have no `buttons` or `button` property
    isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || // Open context menu
    event.ctrlKey) {
      return;
    } // Prevent default behaviours as page zooming in touch devices.


    event.preventDefault();

    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[event.pointerId || 0] = getPointer(event);
    }

    var action = options.movable ? ACTION_MOVE : false;

    if (Object.keys(pointers).length > 1) {
      action = ACTION_ZOOM;
    } else if ((event.pointerType === 'touch' || event.type === 'touchstart') && this.isSwitchable()) {
      action = ACTION_SWITCH;
    }

    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      removeClass(this.image, CLASS_TRANSITION);
    }

    this.action = action;
  },
  pointermove: function pointermove(event) {
    var pointers = this.pointers,
        action = this.action;

    if (!this.viewed || !action) {
      return;
    }

    event.preventDefault();

    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        utilities_assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      utilities_assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }

    this.change(event);
  },
  pointerup: function pointerup(event) {
    var _this2 = this;

    var options = this.options,
        action = this.action,
        pointers = this.pointers;
    var pointer;

    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        pointer = pointers[touch.identifier];
        delete pointers[touch.identifier];
      });
    } else {
      pointer = pointers[event.pointerId || 0];
      delete pointers[event.pointerId || 0];
    }

    if (!action) {
      return;
    }

    event.preventDefault();

    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      addClass(this.image, CLASS_TRANSITION);
    }

    this.action = false; // Emulate click and double click in touch devices to support backdrop and image zooming (#210).

    if (IS_TOUCH_DEVICE && action !== ACTION_ZOOM && pointer && Date.now() - pointer.timeStamp < 500) {
      clearTimeout(this.clickCanvasTimeout);
      clearTimeout(this.doubleClickImageTimeout);

      if (options.toggleOnDblclick && this.viewed && event.target === this.image) {
        if (this.imageClicked) {
          this.imageClicked = false; // This timeout will be cleared later when a native dblclick event is triggering

          this.doubleClickImageTimeout = setTimeout(function () {
            dispatchEvent(_this2.image, EVENT_DBLCLICK);
          }, 50);
        } else {
          this.imageClicked = true; // The default timing of a double click in Windows is 500 ms

          this.doubleClickImageTimeout = setTimeout(function () {
            _this2.imageClicked = false;
          }, 500);
        }
      } else {
        this.imageClicked = false;

        if (options.backdrop && options.backdrop !== 'static' && event.target === this.canvas) {
          // This timeout will be cleared later when a native click event is triggering
          this.clickCanvasTimeout = setTimeout(function () {
            dispatchEvent(_this2.canvas, EVENT_CLICK);
          }, 50);
        }
      }
    }
  },
  resize: function resize() {
    var _this3 = this;

    if (!this.isShown || this.hiding) {
      return;
    }

    this.initContainer();
    this.initViewer();
    this.renderViewer();
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this3.renderImage();
      });
    }

    if (this.played) {
      if (this.options.fullscreen && this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        this.stop();
        return;
      }

      forEach(this.player.getElementsByTagName('img'), function (image) {
        addListener(image, EVENT_LOAD, _this3.loadImage.bind(_this3), {
          once: true
        });
        dispatchEvent(image, EVENT_LOAD);
      });
    }
  },
  wheel: function wheel(event) {
    var _this4 = this;

    if (!this.viewed) {
      return;
    }

    event.preventDefault(); // Limit wheel speed to prevent zoom too fast

    if (this.wheeling) {
      return;
    }

    this.wheeling = true;
    setTimeout(function () {
      _this4.wheeling = false;
    }, 50);
    var ratio = Number(this.options.zoomRatio) || 0.1;
    var delta = 1;

    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }

    this.zoom(-delta * ratio, true, event);
  }
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/methods.js



/* harmony default export */ var methods = ({
  reinitial: function reinitial(options) {
    this.viewer.parentNode.removeChild(this.viewer);
    this.options = utilities_assign({}, defaults, isPlainObject(options) && options);
    this.action = false;
    this.fading = false;
    this.fulled = false;
    this.hiding = false;
    this.imageClicked = false;
    this.imageData = {};
    this.images = this.options.images;
    this.index = this.options.initialViewIndex;
    this.isImg = false;
    this.isShown = false;
    this.length = 0;
    this.played = false;
    this.playing = false;
    this.pointers = {};
    this.ready = false;
    this.showing = false;
    this.timeout = false;
    this.tooltipping = false;
    this.viewed = false;
    this.viewing = false;
    this.wheeling = false;
    this.zooming = false; // 初始化

    this.length = this.images.length;
    this.build();
  },

  /** Show the viewer (only available in modal mode)
   * @param {boolean} [immediate=false] - Indicates if show the viewer immediately or not.
   * @returns {Viewer} this
   */
  show: function show(immediate) {
    if (immediate === void 0) {
      immediate = false;
    }

    var element = this.element,
        options = this.options;

    if (options.inline || this.showing || this.isShown) {
      return this;
    }

    if (!this.ready) {
      this.build();

      if (this.ready) {
        this.show(immediate);
      }

      return this;
    }

    if (utilities_isFunction(options.show)) {
      addListener(element, EVENT_SHOW, options.show, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_SHOW) === false || !this.ready) {
      return this;
    }

    if (this.hiding) {
      this.transitioning.abort();
    }

    this.showing = true;
    this.open();
    var viewer = this.viewer;
    removeClass(viewer, CLASS_HIDE);

    if (options.transition && !immediate) {
      var shown = this.shown.bind(this);
      this.transitioning = {
        abort: function abort() {
          removeListener(viewer, EVENT_TRANSITION_END, shown);
          removeClass(viewer, CLASS_IN);
        }
      };
      addClass(viewer, CLASS_TRANSITION); // Force reflow to enable CSS3 transition
      // eslint-disable-next-line

      addListener(viewer, EVENT_TRANSITION_END, shown, {
        once: true
      });
      addClass(viewer, CLASS_IN);
    } else {
      addClass(viewer, CLASS_IN);
      this.shown();
    }

    return this;
  },

  /**
   * Hide the viewer (only available in modal mode)
   * @param {boolean} [immediate=false] - Indicates if hide the viewer immediately or not.
   * @returns {Viewer} this
   */
  hide: function hide(immediate) {
    if (immediate === void 0) {
      immediate = false;
    }

    var element = this.element,
        options = this.options;

    if (options.inline || this.hiding || !(this.isShown || this.showing)) {
      return this;
    }

    if (utilities_isFunction(options.hide)) {
      addListener(element, EVENT_HIDE, options.hide, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_HIDE) === false) {
      return this;
    }

    if (this.showing) {
      this.transitioning.abort();
    }

    this.hiding = true;

    if (this.played) {
      this.stop();
    } else if (this.viewing) {
      this.viewing.abort();
    }

    var viewer = this.viewer;

    if (options.transition && !immediate) {
      var hidden = this.hidden.bind(this);

      var hide = function hide() {
        // XXX: It seems the `event.stopPropagation()` method does not work here
        setTimeout(function () {
          addListener(viewer, EVENT_TRANSITION_END, hidden, {
            once: true
          });
          removeClass(viewer, CLASS_IN);
        }, 0);
      };

      this.transitioning = {
        abort: function abort() {
          if (this.viewed) {
            removeListener(this.image, EVENT_TRANSITION_END, hide);
          } else {
            removeListener(viewer, EVENT_TRANSITION_END, hidden);
          }
        }
      }; // Note that the `CLASS_TRANSITION` class will be removed on pointer down (#255)

      if (this.viewed && hasClass(this.image, CLASS_TRANSITION)) {
        addListener(this.image, EVENT_TRANSITION_END, hide, {
          once: true
        });
        this.zoomTo(0, false, false, true);
      } else {
        hide();
      }
    } else {
      removeClass(viewer, CLASS_IN);
      this.hidden();
    }

    return this;
  },

  /**
   * View one of the images with image's index
   * @param {number} index - The index of the image to view.
   * @returns {Viewer} this
   */
  view: function view(index, immediate) {
    var _this = this;

    if (index === void 0) {
      index = this.options.initialViewIndex;
    }

    if (immediate === void 0) {
      immediate = false;
    }

    var _index = Number(index) || 0;

    if (!this.isShown) {
      this.index = _index;
      return this.show(immediate);
    }

    if (this.hiding || this.played || _index < 0 || _index >= this.length || this.viewed && _index === this.index) {
      return this;
    }

    if (this.viewing) {
      this.viewing.abort();
    }

    var element = this.element,
        options = this.options,
        title = this.title,
        canvas = this.canvas;
    var item = this.getTarget(this.items, index);
    var img = item.querySelector('img');
    var url = utilities_getData(img, 'originalUrl');
    var alt = img.getAttribute('alt');
    var image = document.createElement('img');
    image.src = url;
    image.alt = alt;

    if (utilities_isFunction(options.view)) {
      addListener(element, EVENT_VIEW, options.view, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_VIEW, {
      originalImage: this.images[_index],
      _index: _index,
      image: image
    }) === false || !this.isShown || this.hiding || this.played) {
      return this;
    }

    this.image = image;
    removeClass(this.getTarget(this.items, this.index), CLASS_ACTIVE);
    removeClass(this.getTarget(this.dots, this.index), CLASS_ACTIVE);
    addClass(item, CLASS_ACTIVE);
    addClass(this.getTarget(this.dots, _index), CLASS_ACTIVE);
    this.viewed = false;
    this.index = _index;
    this.imageData = {};
    addClass(image, CLASS_INVISIBLE);

    if (options.loading) {
      addClass(canvas, CLASS_LOADING);
    }

    canvas.innerHTML = '';
    canvas.appendChild(image); // Center current item

    this.renderList(); // Clear title

    title.innerHTML = ''; // Generate title after viewed

    var onViewed = function onViewed() {
      var imageData = _this.imageData;
      var render = Array.isArray(options.title) ? options.title[1] : options.title;
      var titleStr = escapeHTMLEntities(utilities_isFunction(render) ? render.call(_this, image, imageData) : alt + " (" + imageData.naturalWidth + " \xD7 " + imageData.naturalHeight + ")");
      title.innerHTML = "<span title=\"" + titleStr + "\">" + titleStr + "</span>";
    };

    var onLoad;
    addListener(element, EVENT_VIEWED, onViewed, {
      once: true
    });
    this.viewing = {
      abort: function abort() {
        removeListener(element, EVENT_VIEWED, onViewed);

        if (image.complete) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        } else {
          // Cancel download to save bandwidth.
          image.src = '';
          removeListener(image, EVENT_LOAD, onLoad);

          if (this.timeout) {
            clearTimeout(this.timeout);
          }
        }
      }
    };

    if (image.complete) {
      this.load();
    } else {
      addListener(image, EVENT_LOAD, onLoad = this.load.bind(this), {
        once: true
      });

      if (this.timeout) {
        clearTimeout(this.timeout);
      } // Make the image visible if it fails to load within 1s


      this.timeout = setTimeout(function () {
        removeClass(image, CLASS_INVISIBLE);
        _this.timeout = false;
      }, 1000);
    }

    return this;
  },

  /**
   * Download the previous image
   */
  download: function download() {
    var downloadUrl = '';
    var filename = '';
    var image = this.images[this.index];

    if (isElement(image)) {
      downloadUrl = utilities_getData(image, 'downloadUrl') || image.src;
      filename = image.alt;
      image = {
        name: filename,
        source: image.src,
        downloadUrl: downloadUrl
      };
    } else if (utilities_isObject(image)) {
      downloadUrl = image.downloadUrl || image.source;
      filename = image.name || getImageNameFromURL(downloadUrl);
    } else {
      downloadUrl = image;
      filename = getImageNameFromURL(downloadUrl);
    }

    if (this.options.handleDownload) {
      this.options.handleDownload(image);
      return;
    }

    linkDownload(downloadUrl, filename || "image-" + Date.now());
    return this;
  },

  /**
   * View the previous image
   * @param {boolean} [loop=false] - Indicate if view the last one
   * when it is the first one at present.
   * @returns {Viewer} this
   */
  prev: function prev(loop) {
    if (loop === void 0) {
      loop = false;
    }

    var index = this.index - 1;

    if (index < 0) {
      index = loop ? this.length - 1 : 0;
    }

    this.view(index);
    return this;
  },

  /**
   * View the next image
   * @param {boolean} [loop=false] - Indicate if view the first one
   * when it is the last one at present.
   * @returns {Viewer} this
   */
  next: function next(loop) {
    if (loop === void 0) {
      loop = false;
    }

    var maxIndex = this.length - 1;
    var index = this.index + 1;

    if (index > maxIndex) {
      index = loop ? 0 : maxIndex;
    }

    this.view(index);
    return this;
  },

  /**
   * nav the previous page
   * @returns {Viewer} this
   */
  navToPrev: function navToPrev() {
    if (this.pageIndex <= 1) {
      return;
    }

    this.renderList(this.index, Math.max(this.pageIndex - 1, 1));
    return this;
  },

  /**
   * nav the next page
   * @returns {Viewer} this
   */
  navToNext: function navToNext() {
    if (this.pageIndex >= this.page) {
      return;
    }

    this.renderList(this.index, Math.min(this.pageIndex + 1, this.page));
    return this;
  },

  /**
   * Move the image with relative offsets.
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} offsetY - The relative offset distance on the y-axis.
   * @returns {Viewer} this
   */
  move: function move(offsetX, offsetY) {
    var imageData = this.imageData;
    this.moveTo(isUndefined(offsetX) ? offsetX : imageData.left + Number(offsetX), isUndefined(offsetY) ? offsetY : imageData.top + Number(offsetY));
    return this;
  },

  /**
   * Move the image to an absolute point.
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Viewer} this
   */
  moveTo: function moveTo(x, y) {
    if (y === void 0) {
      y = x;
    }

    var imageData = this.imageData;

    var _x = Number(x);

    var _y = Number(y);

    if (this.viewed && !this.played && this.options.movable) {
      var changed = false;

      if (isNumber(_x)) {
        imageData.left = _x;
        changed = true;
      }

      if (isNumber(_y)) {
        imageData.top = _y;
        changed = true;
      }

      if (changed) {
        this.renderImage();
      }
    }

    return this;
  },

  /**
   * Zoom the image with a relative ratio.
   * @param {number} ratio - The target ratio.
   * @param {boolean} [hasTooltip=false] - Indicates if it has a tooltip or not.
   * @param {Event} [_originalEvent=null] - The original event if any.
   * @returns {Viewer} this
   */
  zoom: function zoom(ratio, hasTooltip, _originalEvent) {
    if (hasTooltip === void 0) {
      hasTooltip = false;
    }

    if (_originalEvent === void 0) {
      _originalEvent = null;
    }

    var imageData = this.imageData;

    var _ratio = Number(ratio);

    if (_ratio < 0) {
      _ratio = 1 / (1 - _ratio);
    } else {
      _ratio = 1 + _ratio;
    }

    this.zoomTo(imageData.width * _ratio / imageData.naturalWidth, hasTooltip, _originalEvent);
    return this;
  },

  /**
   * Zoom the image to an absolute ratio.
   * @param {number} ratio - The target ratio.
   * @param {boolean} [hasTooltip=false] - Indicates if it has a tooltip or not.
   * @param {Event} [_originalEvent=null] - The original event if any.
   * @param {Event} [_zoomable=false] - Indicates if the current zoom is available or not.
   * @returns {Viewer} this
   */
  zoomTo: function zoomTo(ratio, hasTooltip, _originalEvent, _zoomable) {
    var _this2 = this;

    if (hasTooltip === void 0) {
      hasTooltip = false;
    }

    if (_originalEvent === void 0) {
      _originalEvent = null;
    }

    if (_zoomable === void 0) {
      _zoomable = false;
    }

    var element = this.element,
        options = this.options,
        pointers = this.pointers,
        imageData = this.imageData;
    var width = imageData.width,
        height = imageData.height,
        left = imageData.left,
        top = imageData.top,
        naturalWidth = imageData.naturalWidth,
        naturalHeight = imageData.naturalHeight;

    var _ratio = Math.max(0, ratio);

    if (isNumber(_ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
      if (!_zoomable) {
        var minZoomRatio = Math.max(0.01, options.minZoomRatio);
        var maxZoomRatio = Math.min(100, options.maxZoomRatio);
        _ratio = Math.min(Math.max(_ratio, minZoomRatio), maxZoomRatio);
      }

      if (_originalEvent && _ratio > 0.95 && _ratio < 1.05) {
        _ratio = 1;
      }

      var newWidth = naturalWidth * _ratio;
      var newHeight = naturalHeight * _ratio;
      var offsetWidth = newWidth - width;
      var offsetHeight = newHeight - height;
      var oldRatio = width / naturalWidth;

      if (utilities_isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom, {
          once: true
        });
      }

      if (dispatchEvent(element, EVENT_ZOOM, {
        _ratio: _ratio,
        oldRatio: oldRatio,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }

      this.zooming = true;

      if (_originalEvent) {
        var offset = getOffset(this.viewer);
        var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        }; // Zoom from the triggering point of the event

        imageData.left -= offsetWidth * ((center.pageX - offset.left - left) / width);
        imageData.top -= offsetHeight * ((center.pageY - offset.top - top) / height);
      } else {
        // Zoom from the center of the image
        imageData.left -= offsetWidth / 2;
        imageData.top -= offsetHeight / 2;
      }

      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.ratio = _ratio;
      this.renderImage(function () {
        _this2.zooming = false;

        if (utilities_isFunction(options.zoomed)) {
          addListener(element, EVENT_ZOOMED, options.zoomed, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_ZOOMED, {
          _ratio: _ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        });
      });

      if (hasTooltip) {
        this.tooltip();
      }
    }

    return this;
  },

  /**
   * Rotate the image with a relative degree.
   * @param {number} degree - The rotate degree.
   * @returns {Viewer} this
   */
  rotate: function rotate(degree) {
    this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    return this;
  },

  /**
   * Rotate the image to an absolute degree.
   * @param {number} degree - The rotate degree.
   * @returns {Viewer} this
   */
  rotateTo: function rotateTo(degree) {
    var imageData = this.imageData;

    var _degree = Number(degree);

    if (isNumber(_degree) && this.viewed && !this.played && this.options.rotatable) {
      imageData.rotate = _degree;
      this.renderImage();
    }

    return this;
  },

  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Viewer} this
   */
  scaleX: function scaleX(_scaleX2) {
    this.scale(_scaleX2, this.imageData.scaleY);
    return this;
  },

  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Viewer} this
   */
  scaleY: function scaleY(_scaleY2) {
    this.scale(this.imageData.scaleX, _scaleY2);
    return this;
  },

  /**
   * Scale the image.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Viewer} this
   */
  scale: function scale(scaleX, scaleY) {
    if (scaleY === void 0) {
      scaleY = scaleX;
    }

    var imageData = this.imageData;

    var _scaleX = Number(scaleX);

    var _scaleY = Number(scaleY);

    if (this.viewed && !this.played && this.options.scalable) {
      var changed = false;

      if (isNumber(_scaleX)) {
        imageData.scaleX = _scaleX;
        changed = true;
      }

      if (isNumber(_scaleY)) {
        imageData.scaleY = _scaleY;
        changed = true;
      }

      if (changed) {
        this.renderImage();
      }
    }

    return this;
  },

  /**
   * Play the images
   * @param {boolean} [fullscreen=false] - Indicate if request fullscreen or not.
   * @returns {Viewer} this
   */
  play: function play(fullscreen) {
    var _this3 = this;

    if (fullscreen === void 0) {
      fullscreen = false;
    }

    if (!this.isShown || this.played) {
      return this;
    }

    var options = this.options,
        player = this.player;
    var onLoad = this.loadImage.bind(this);
    var list = [];
    var total = 0;
    var index = 0;
    this.played = true;
    this.onLoadWhenPlay = onLoad;

    if (fullscreen) {
      this.requestFullscreen();
    }

    addClass(player, CLASS_SHOW);
    forEach(this.items, function (item, i) {
      var img = item.querySelector('img');
      var image = document.createElement('img');
      image.src = utilities_getData(img, 'originalUrl');
      image.alt = img.getAttribute('alt');
      total += 1;
      addClass(image, CLASS_FADE);
      toggleClass(image, CLASS_TRANSITION, options.transition);

      if (hasClass(item, CLASS_ACTIVE)) {
        addClass(image, CLASS_IN);
        index = i;
      }

      list.push(image);
      addListener(image, EVENT_LOAD, onLoad, {
        once: true
      });
      player.appendChild(image);
    });

    if (isNumber(options.interval) && options.interval > 0) {
      var play = function play() {
        _this3.playing = setTimeout(function () {
          removeClass(list[index], CLASS_IN);
          index += 1;
          index = index < total ? index : 0;
          addClass(list[index], CLASS_IN);
          play();
        }, options.interval);
      };

      if (total > 1) {
        play();
      }
    }

    return this;
  },
  // Stop play
  stop: function stop() {
    var _this4 = this;

    if (!this.played) {
      return this;
    }

    var player = this.player;
    this.played = false;
    clearTimeout(this.playing);
    forEach(player.getElementsByTagName('img'), function (image) {
      removeListener(image, EVENT_LOAD, _this4.onLoadWhenPlay);
    });
    removeClass(player, CLASS_SHOW);
    player.innerHTML = '';
    this.exitFullscreen();
    return this;
  },
  // Enter modal mode (only available in inline mode)
  full: function full() {
    var _this5 = this;

    var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;

    if (!this.isShown || this.played || this.fulled || !options.inline) {
      return this;
    }

    this.fulled = true;
    this.open();
    addClass(this.button, CLASS_FULLSCREEN_EXIT);

    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);

      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }

    addClass(viewer, CLASS_FIXED);
    viewer.setAttribute('style', '');
    setStyle(viewer, {
      zIndex: options.zIndex
    });
    this.initContainer();
    this.viewerData = utilities_assign({}, this.containerData);
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this5.renderImage(function () {
          if (options.transition) {
            setTimeout(function () {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }

    return this;
  },
  // Exit modal mode (only available in inline mode)
  exit: function exit() {
    var _this6 = this;

    var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;

    if (!this.isShown || this.played || !this.fulled || !options.inline) {
      return this;
    }

    this.fulled = false;
    this.close();
    removeClass(this.button, CLASS_FULLSCREEN_EXIT);

    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);

      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }

    removeClass(viewer, CLASS_FIXED);
    setStyle(viewer, {
      zIndex: options.zIndexInline
    });
    this.viewerData = utilities_assign({}, this.parentData);
    this.renderViewer();
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this6.renderImage(function () {
          if (options.transition) {
            setTimeout(function () {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }

    return this;
  },
  // Show the current ratio of the image with percentage
  tooltip: function tooltip() {
    var _this7 = this;

    var options = this.options,
        tooltipBox = this.tooltipBox,
        imageData = this.imageData;

    if (!this.viewed || this.played || !options.tooltip) {
      return this;
    }

    tooltipBox.textContent = Math.round(imageData.ratio * 100) + "%";

    if (!this.tooltipping) {
      if (options.transition) {
        if (this.fading) {
          dispatchEvent(tooltipBox, EVENT_TRANSITION_END);
        }

        addClass(tooltipBox, CLASS_SHOW);
        addClass(tooltipBox, CLASS_FADE);
        addClass(tooltipBox, CLASS_TRANSITION); // Force reflow to enable CSS3 transition
        // eslint-disable-next-line

        addClass(tooltipBox, CLASS_IN);
      } else {
        addClass(tooltipBox, CLASS_SHOW);
      }
    } else {
      clearTimeout(this.tooltipping);
    }

    this.tooltipping = setTimeout(function () {
      if (options.transition) {
        addListener(tooltipBox, EVENT_TRANSITION_END, function () {
          removeClass(tooltipBox, CLASS_SHOW);
          removeClass(tooltipBox, CLASS_FADE);
          removeClass(tooltipBox, CLASS_TRANSITION);
          _this7.fading = false;
        }, {
          once: true
        });
        removeClass(tooltipBox, CLASS_IN);
        _this7.fading = true;
      } else {
        removeClass(tooltipBox, CLASS_SHOW);
      }

      _this7.tooltipping = false;
    }, 1000);
    return this;
  },
  // Toggle the image size between its natural size and initial size
  toggle: function toggle() {
    if (this.imageData.ratio === 1) {
      this.zoomTo(this.initialImageData.ratio, true);
    } else {
      this.zoomTo(1, true);
    }

    return this;
  },
  // Reset the image to its initial state
  reset: function reset() {
    if (this.viewed && !this.played) {
      this.imageData = utilities_assign({}, this.initialImageData);
      this.renderImage();
    }

    return this;
  },
  // Update viewer when images changed
  update: function update() {
    var element = this.element,
        options = this.options,
        isImg = this.isImg; // Destroy viewer if the target image was deleted

    if (isImg && !element.parentNode) {
      return this.destroy();
    }

    var images = [];
    forEach(isImg ? [element] : element.querySelectorAll('img'), function (image) {
      if (options.filter) {
        if (options.filter(image)) {
          images.push(image);
        }
      } else {
        images.push(image);
      }
    });

    if (!images.length) {
      return this;
    }

    this.images = images;
    this.length = images.length;

    if (this.ready) {
      var indexes = [];
      forEach(this.items, function (item, i) {
        var img = item.querySelector('img');
        var image = images[i];

        if (image) {
          if (image.src !== img.src) {
            indexes.push(i);
          }
        } else {
          indexes.push(i);
        }
      });
      setStyle(this.list, {
        width: 'auto'
      });
      this.initList();

      if (this.isShown) {
        if (this.length) {
          if (this.viewed) {
            var index = indexes.indexOf(this.index);

            if (index >= 0) {
              this.viewed = false;
              this.view(Math.max(this.index - (index + 1), 0));
            } else {
              addClass(this.getTarget(this.items, this.index), CLASS_ACTIVE);
              addClass(this.getTarget(this.this.dots, this.index), CLASS_ACTIVE);
            }
          }
        } else {
          this.image = null;
          this.viewed = false;
          this.index = 0;
          this.imageData = {};
          this.canvas.innerHTML = '';
          this.title.innerHTML = '';
        }
      }
    } else {
      this.build();
    }

    return this;
  },
  // Destroy the viewer
  destroy: function destroy() {
    var element = this.element,
        options = this.options;

    if (!element[NAMESPACE]) {
      return this;
    }

    this.destroyed = true;

    if (this.ready) {
      if (this.played) {
        this.stop();
      }

      if (options.inline) {
        if (this.fulled) {
          this.exit();
        }

        this.unbind();
      } else if (this.isShown) {
        if (this.viewing) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        }

        if (this.hiding) {
          this.transitioning.abort();
        }

        this.hidden();
      } else if (this.showing) {
        this.transitioning.abort();
        this.hidden();
      }

      this.ready = false;
      this.viewer.parentNode.removeChild(this.viewer);
    } else if (options.inline) {
      if (this.delaying) {
        this.delaying.abort();
      } else if (this.initializing) {
        this.initializing.abort();
      }
    }

    if (!options.inline) {
      removeListener(element, EVENT_CLICK, this.onStart);
    }

    element[NAMESPACE] = undefined;
    return this;
  }
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/others.js


/* harmony default export */ var others = ({
  open: function open() {
    var body = this.body;
    addClass(body, CLASS_OPEN);
    body.style.paddingRight = this.scrollbarWidth + (parseFloat(this.initialBodyPaddingRight) || 0) + "px";
  },
  close: function close() {
    var body = this.body;
    removeClass(body, CLASS_OPEN);
    body.style.paddingRight = this.initialBodyPaddingRight;
  },
  shown: function shown() {
    var element = this.element,
        options = this.options;
    this.fulled = true;
    this.isShown = true;
    this.render();
    this.bind();
    this.showing = false;

    if (utilities_isFunction(options.shown)) {
      addListener(element, EVENT_SHOWN, options.shown, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_SHOWN) === false) {
      return;
    }

    if (this.ready && this.isShown && !this.hiding) {
      this.view(this.index);
    }
  },
  hidden: function hidden() {
    var element = this.element,
        options = this.options;
    this.fulled = false;
    this.viewed = false;
    this.isShown = false;
    this.close();
    this.unbind();
    addClass(this.viewer, CLASS_HIDE);
    this.resetList();
    this.resetImage();
    this.hiding = false;

    if (!this.destroyed) {
      if (utilities_isFunction(options.hidden)) {
        addListener(element, EVENT_HIDDEN, options.hidden, {
          once: true
        });
      }

      dispatchEvent(element, EVENT_HIDDEN);
    }
  },
  requestFullscreen: function requestFullscreen() {
    var document = this.element.ownerDocument;

    if (this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
      var documentElement = document.documentElement; // Element.requestFullscreen()

      if (documentElement.requestFullscreen) {
        documentElement.requestFullscreen();
      } else if (documentElement.webkitRequestFullscreen) {
        documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (documentElement.mozRequestFullScreen) {
        documentElement.mozRequestFullScreen();
      } else if (documentElement.msRequestFullscreen) {
        documentElement.msRequestFullscreen();
      }
    }
  },
  exitFullscreen: function exitFullscreen() {
    var document = this.element.ownerDocument;

    if (this.fulled && (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
      // Document.exitFullscreen()
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  },
  change: function change(event) {
    var options = this.options,
        pointers = this.pointers;
    var pointer = pointers[Object.keys(pointers)[0]];
    var offsetX = pointer.endX - pointer.startX;
    var offsetY = pointer.endY - pointer.startY;

    switch (this.action) {
      // Move the current image
      case ACTION_MOVE:
        this.move(offsetX, offsetY);
        break;
      // Zoom the current image

      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), false, event);
        break;

      case ACTION_SWITCH:
        {
          this.action = 'switched';
          var absoluteOffsetX = Math.abs(offsetX);

          if (absoluteOffsetX > 1 && absoluteOffsetX > Math.abs(offsetY)) {
            // Empty `pointers` as `touchend` event will not be fired after swiped in iOS browsers.
            this.pointers = {};

            if (offsetX > 1) {
              this.prev(options.loop);
            } else if (offsetX < -1) {
              this.next(options.loop);
            }
          }

          break;
        }

      default:
    } // Override


    forEach(pointers, function (p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  },
  isSwitchable: function isSwitchable() {
    var imageData = this.imageData,
        viewerData = this.viewerData;
    return this.length > 1 && imageData.left >= 0 && imageData.top >= 0 && imageData.width <= viewerData.width && imageData.height <= viewerData.height;
  },
  getTarget: function getTarget(items, index) {
    if (index === void 0) {
      index = 0;
    }

    var _index = Number(index);

    return items.find(function (item) {
      return Number(utilities_getData(item, 'index')) === _index;
    });
  }
});
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/js/viewer.js









var AnotherViewer = WINDOW.Viewer;

var viewer_Viewer = /*#__PURE__*/function () {
  /**
   * Create a new Viewer.
   * @param {Element} element - The target element for viewing.
   * @param {Object} [options={}] - The configuration options.
   */
  function Viewer(element, options) {
    if (options === void 0) {
      options = {};
    }

    if (!element || element.nodeType !== 1) {
      throw new Error('The first argument is required and must be an element.');
    }

    this.element = element;
    this.options = utilities_assign({}, defaults, isPlainObject(options) && options);
    this.action = false;
    this.fading = false;
    this.fulled = false;
    this.hiding = false;
    this.imageClicked = false;
    this.imageData = {};
    this.images = this.options.images;
    this.index = this.options.initialViewIndex;
    this.isImg = false;
    this.isShown = false;
    this.length = 0;
    this.played = false;
    this.playing = false;
    this.pointers = {};
    this.ready = false;
    this.showing = false;
    this.timeout = false;
    this.tooltipping = false;
    this.viewed = false;
    this.viewing = false;
    this.wheeling = false;
    this.zooming = false;
    this.init();
  }

  var _proto = Viewer.prototype;

  _proto.init = function init() {
    var _this = this;

    var element = this.element,
        options = this.options;

    if (element[NAMESPACE]) {
      return;
    }

    element[NAMESPACE] = this;
    var isImg = element.tagName.toLowerCase() === 'img';
    var images = [];
    forEach(isImg ? [element] : this.images ? this.images : element.querySelectorAll('img'), function (image) {
      if (utilities_isFunction(options.filter)) {
        if (options.filter.call(_this, image)) {
          images.push(image);
        }
      } else {
        images.push(image);
      }
    });
    this.isImg = isImg;
    this.length = images.length;
    this.images = images;
    var ownerDocument = element.ownerDocument;
    var body = ownerDocument.body || ownerDocument.documentElement;
    this.body = body;
    this.scrollbarWidth = window.innerWidth - ownerDocument.documentElement.clientWidth;
    this.initialBodyPaddingRight = window.getComputedStyle(body).paddingRight; // Override `transition` option if it is not supported

    if (isUndefined(document.createElement(NAMESPACE).style.transition)) {
      options.transition = false;
    }

    if (options.inline) {
      var count = 0;

      var progress = function progress() {
        count += 1;

        if (count === _this.length) {
          // eslint-disable-next-line prefer-const
          var timeout;
          _this.initializing = false;
          _this.delaying = {
            abort: function abort() {
              clearTimeout(timeout);
            }
          }; // build asynchronously to keep `this.viewer` is accessible in `ready` event handler.

          timeout = setTimeout(function () {
            _this.delaying = false;

            _this.build();
          }, 0);
        }
      };

      this.initializing = {
        abort: function abort() {
          forEach(images, function (image) {
            if (!image.complete) {
              removeListener(image, EVENT_LOAD, progress);
            }
          });
        }
      };
      forEach(images, function (image) {
        if (image.complete) {
          progress();
        } else {
          addListener(image, EVENT_LOAD, progress, {
            once: true
          });
        }
      });
    } else {
      addListener(element, EVENT_CLICK, this.onStart = function (_ref) {
        var target = _ref.target;

        if (target.tagName.toLowerCase() === 'img' && (!utilities_isFunction(options.filter) || options.filter.call(_this, target))) {
          _this.view(_this.images.indexOf(target));
        }
      });
    }

    if (typeof options.index === 'number') {
      this.view(options.index, true);
    }
  };

  _proto.build = function build() {
    if (this.ready) {
      return;
    }

    var element = this.element,
        options = this.options;
    var parent = element.parentNode;
    var template = document.createElement('div');
    template.innerHTML = js_template;
    var viewer = template.querySelector("." + NAMESPACE + "-container");
    var title = viewer.querySelector("." + NAMESPACE + "-title");
    var toolbar = viewer.querySelector("." + NAMESPACE + "-toolbar");
    var downloadBtn = viewer.querySelector("." + NAMESPACE + "-download");
    var header = viewer.querySelector("." + NAMESPACE + "-header");
    var navbar = viewer.querySelector("." + NAMESPACE + "-navbar");
    var button = viewer.querySelector("." + NAMESPACE + "-button");
    var canvas = viewer.querySelector("." + NAMESPACE + "-canvas");
    var swiper = viewer.querySelector("." + NAMESPACE + "-swiper");
    this.parent = parent;
    this.viewer = viewer;
    this.title = title;
    this.toolbar = toolbar;
    this.header = header;
    this.downloadBtn = downloadBtn;
    this.navbar = navbar;
    this.button = button;
    this.canvas = canvas;
    this.swiper = swiper;
    this.swiperPrev = viewer.querySelector("." + NAMESPACE + "-prev");
    this.swiperNext = viewer.querySelector("." + NAMESPACE + "-next");
    this.footer = viewer.querySelector("." + NAMESPACE + "-footer");
    this.tooltipBox = viewer.querySelector("." + NAMESPACE + "-tooltip");
    this.player = viewer.querySelector("." + NAMESPACE + "-player");
    this.list = viewer.querySelector("." + NAMESPACE + "-list");
    this.navPrev = viewer.querySelector("." + NAMESPACE + "-nav-prev");
    this.navNext = viewer.querySelector("." + NAMESPACE + "-nav-next");
    this.spot = viewer.querySelector("." + NAMESPACE + "-spot"); // addClass(title, !options.title ? CLASS_HIDE : getResponsiveClass(Array.isArray(options.title)
    //   ? options.title[0]
    //   : options.title));
    // addClass(navbar, !options.navbar ? CLASS_HIDE : getResponsiveClass(options.navbar));

    if (!options.navbar) {
      addClass(navbar, CLASS_HIDE);
    } else {
      addClass(this.navPrev, CLASS_HIDE);
      addClass(this.navNext, CLASS_HIDE);

      if (options.navbar === 2 && this.length <= options.dotLimit) {
        addClass(this.list, CLASS_HIDE);
      } else {
        addClass(this.spot, CLASS_HIDE);
      }
    }

    var needPrevNext = this.length > 1;
    toggleClass(this.swiperPrev, CLASS_HIDE, !needPrevNext);
    toggleClass(this.swiperNext, CLASS_HIDE, !needPrevNext);
    toggleClass(button, CLASS_HIDE, !options.button);

    if (options.backdrop) {
      addClass(viewer, NAMESPACE + "-backdrop");

      if (!options.inline && options.backdrop !== 'static') {
        setData(canvas, DATA_ACTION, 'hide');
      }
    }

    if (utilities_isString(options.className) && options.className) {
      // In case there are multiple class names
      options.className.split(REGEXP_SPACES).forEach(function (className) {
        addClass(viewer, className);
      });
    }

    if (this.images.length === 1) {
      addClass(this.swiper, NAMESPACE + "-hide");
    } else {
      removeClass(this.swiper, NAMESPACE + "-hide");
    }

    if (options.toolbar) {
      var list = document.createElement('ul');
      var custom = isPlainObject(options.toolbar);
      var downloadButtons = BUTTONS.slice(3, 4);
      var rotateButtons = BUTTONS.slice(4, 6);
      var scaleButtons = BUTTONS.slice(6, 8);
      var zoomButtons = BUTTONS.slice(8, 11);

      if (!custom) {
        addClass(toolbar, getResponsiveClass(options.toolbar));
      } // 下载


      if (!options.downloadable) {
        addClass(downloadBtn, NAMESPACE + "-hide");
      } else {
        removeClass(downloadBtn, NAMESPACE + "-hide");
      }

      forEach(custom ? options.toolbar : BUTTONS, function (value, index) {
        var deep = custom && isPlainObject(value);
        var name = custom ? utilities_hyphenate(index) : value;
        var show = deep && !isUndefined(value.show) ? value.show : value;

        if (!show || // || (!options.downloadable && downloadButtons.indexOf(name) !== -1)
        downloadButtons.includes(name) || // 忽略下载
        !options.zoomable && zoomButtons.indexOf(name) !== -1 || !options.rotatable && rotateButtons.indexOf(name) !== -1 || !options.scalable && scaleButtons.indexOf(name) !== -1) {
          return;
        }

        var size = deep && !isUndefined(value.size) ? value.size : value;
        var click = deep && !isUndefined(value.click) ? value.click : value;
        var item = document.createElement('li');
        item.setAttribute('role', 'button');
        addClass(item, NAMESPACE + "-" + name);

        if (BUTTONSMAP[name]) {
          item.setAttribute('title', BUTTONSMAP[name].title);
        }

        if (!utilities_isFunction(click)) {
          setData(item, DATA_ACTION, name);
        }

        if (isNumber(show)) {
          addClass(item, getResponsiveClass(show));
        }

        if (['small', 'large'].indexOf(size) !== -1) {
          addClass(item, NAMESPACE + "-" + size);
        } else if (name === 'play') {
          addClass(item, NAMESPACE + "-large");
        }

        if (utilities_isFunction(click)) {
          addListener(item, EVENT_CLICK, function (evt) {
            click(evt);
          });
        }

        list.appendChild(item);
      });
      toolbar.appendChild(list);
    } else {
      addClass(toolbar, CLASS_HIDE);
    }

    if (!options.rotatable) {
      var rotates = toolbar.querySelectorAll('li[class*="rotate"]');
      addClass(rotates, CLASS_INVISIBLE);
      forEach(rotates, function (rotate) {
        toolbar.appendChild(rotate);
      });
    }

    if (options.inline) {
      addClass(button, CLASS_FULLSCREEN);
      setStyle(viewer, {
        zIndex: options.zIndexInline
      });

      if (window.getComputedStyle(parent).position === 'static') {
        setStyle(parent, {
          position: 'relative'
        });
      }

      parent.insertBefore(viewer, element.nextSibling);
    } else {
      addClass(button, CLASS_CLOSE);
      addClass(viewer, CLASS_FIXED);
      addClass(viewer, CLASS_FADE);
      addClass(viewer, CLASS_HIDE);
      setStyle(viewer, {
        zIndex: options.zIndex
      });
      var container = options.container;

      if (utilities_isString(container)) {
        container = element.ownerDocument.querySelector(container);
      }

      if (!container) {
        container = this.body;
      }

      container.appendChild(viewer);
    }

    if (options.inline) {
      this.render();
      this.bind();
      this.isShown = true;
    }

    this.ready = true;

    if (utilities_isFunction(options.ready)) {
      addListener(element, EVENT_READY, options.ready, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_READY) === false) {
      this.ready = false;
      return;
    }

    if (this.ready && options.inline) {
      this.view(this.index);
    }
  }
  /**
   * Get the no conflict viewer class.
   * @returns {Viewer} The viewer class.
   */
  ;

  Viewer.noConflict = function noConflict() {
    window.Viewer = AnotherViewer;
    return Viewer;
  }
  /**
   * Change the default options.
   * @param {Object} options - The new default options.
   */
  ;

  Viewer.setDefaults = function setDefaults(options) {
    utilities_assign(defaults, isPlainObject(options) && options);
  };

  return Viewer;
}();

utilities_assign(viewer_Viewer.prototype, js_render, events, handlers, methods, others);
/* harmony default export */ var js_viewer = (viewer_Viewer);
// CONCATENATED MODULE: ./src/plugins/image-preview/lib/index.js

/* harmony default export */ var lib = (js_viewer);
// EXTERNAL MODULE: ./src/plugins/image-preview/style/index.less
var image_preview_style = __webpack_require__(168);

// CONCATENATED MODULE: ./src/plugins/image-preview/index.js


var defaultOptions = {
  zIndex: 2999,
  toolbar: {
    download: 1,
    rotateLeft: 1,
    rotateRight: 1,
    flipHorizontal: 1,
    flipVertical: 1,
    zoomIn: 1,
    zoomOut: 1,
    oneToOne: 1,
    reset: 1
  },
  lazyLoad: 0,
  navbar: 0,
  dotLimit: 10,
  backdrop: 'static',
  url: 'data-source'
}; // setDefault Options

lib.setDefaults(defaultOptions);
var imagePreviewInstance = null;

var image_preview_H3ImagePreview = function H3ImagePreview(options) {
  if (options.lazyLoad) {
    options.navbar = 0;
  }

  if (!imagePreviewInstance) {
    imagePreviewInstance = new lib(document.createElement('div'), options);
    var destroy = imagePreviewInstance.destroy;

    imagePreviewInstance.destroy = function () {
      destroy.call(imagePreviewInstance);
      imagePreviewInstance = null;
    };
  } else {
    imagePreviewInstance.reinitial(options);
  }

  return imagePreviewInstance.show();
};

image_preview_H3ImagePreview.install = function (Vue) {
  Vue.prototype.$imagePreview = image_preview_H3ImagePreview;
};

/* harmony default export */ var image_preview = (image_preview_H3ImagePreview);
// CONCATENATED MODULE: ./src/index.js
// components






























































 // 导航


 // 布局



 // 其它

 // directives

 // plugins


var src_items = [components_alert, components_area_select, components_button, components_combo_box, directives_drag, components_dropdown, grid_layout, components_high_light, input, image_preview, components_layout, components_list_view, components_loading, src_components_location, components_map_modal, message, modal, popconfirm, popover, components_select, tabs, components_title_group, components_tooltip, tree_select, components_upload, tag, components_checkbox, components_switch, components_radio, config_provider, date_picker, time_picker, drawer, cascader, steps, row, col, breadcrumb, avatar, empty, components_form, icon, input_number, components_table, carousel, timeline, components_progress, tree, menu, form_model, badge, collapse, pagination, a_dropdown, a_upload, notification, components_result, divider, descriptions, page_header, components_list, card, slider, transfer, rate, auto_complete, calendar, statistic, affix, skeleton, comment];

var install = function install(Vue) {
  src_items.forEach(function (item) {
    item.install(Vue);
  });
};
/* istanbul ignore if */


if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}


/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
  install: install
});

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = require("vue-amap");

/***/ })
/******/ ]);